
import { Component, ComponentRef, ElementRef, ComponentFactoryResolver, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef, ViewEncapsulation, inject, AfterViewInit, HostListener } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { StepperOrientation } from '@angular/material/stepper';
import { SearchService } from 'src/app/core/services/search.service';
import { BehaviorSubject, ObjectUnsubscribedError, observable, Observable, Subject, Subscription, throwError } from 'rxjs';
import { catchError, debounceTime, last, map, startWith, timeout } from 'rxjs/operators';
import { AbstractControl, FormGroup, RequiredValidator, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { HelperService } from 'src/app/core/services/helper.service';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { Router } from '@angular/router';
import { COMMA, ENTER, I } from '@angular/cdk/keycodes';
import { CdkDragDrop, copyArrayItem, CdkDragEnter } from '@angular/cdk/drag-drop';
import remove from 'lodash-es/remove';
import _ from 'lodash';
import { ops_restapi } from '../../core/db/operations';
import { AlertController, IonRouterOutlet, IonSlides, ModalController, } from '@ionic/angular';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { environment } from '../../../environments/environment';
import { MonacoEditorComponent, MonacoEditorConstructionOptions, MonacoEditorLoaderService, MonacoStandaloneCodeEditor, MonacoEditorModule } from '@materia-ui/ngx-monaco-editor';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SchedularComponent } from 'src/app/shared/modals/scheduler/schedular.component';
import { MatDialog } from '@angular/material/dialog';
import { EnvironmentListPage } from 'src/app/shared/modals/environment-list/environment-list.page';
// import { BehaviorSubject } from 'rxjs';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { FormArray } from '@angular/forms';
// import { SmartTabItemComponent } from 'path/to/smart-tab-item.component';
import { CodemirrorComponent } from '@ctrl/ngx-codemirror';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { MatChipEditedEvent, MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatFormField } from '@angular/material/form-field';
import { CartListPage } from 'src/app/shared/modals/cart-list/cart-list.page';
import { PostmanConsoleComponent } from 'src/app/shared/components/postman-console/postman-console.component';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { FreeTrialAuthService } from 'src/app/core/services/free-trial-auth-guard.service';
import { WebSocketSourceService } from 'src/app/core/services/websocket-source.service';
import { getWebSocketSource } from 'src/streaminglogs.js';
import { Console } from 'console';
import { MatSnackBar } from '@angular/material/snack-bar';
import 'codemirror/addon/display/placeholder';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import 'codemirror/mode/python/python';
import { PostmanuiComponent } from 'src/app/shared/components/postmanui/postmanui.component';

enum ops_name {
  bizdata_ops_jdbcoutput = 'Database',
  bizdata_ops_singletomultiline = 'Single Line to Multiline',
  bizdata_ops_eliminate = 'Eliminate',
  bizdata_ops_rename = 'Rename',
  bizdata_ops_append = 'Append',
  bizdata_ops_uppercase = 'Uppercase',
  bizdata_ops_titlecase = 'Titlecase',
  bizdata_ops_lowercase = 'Lowercase',
  bizdata_ops_dropeventsstartswith = 'Drop all events to start with',
  bizdata_ops_calculater = 'Calculator',
  bizdata_ops_dateanalytics = 'Date Analytics',
  bizdata_ops_substitute = 'Substitute',
  bizdata_ops_strip = 'Strip',
  bizdata_ops_substring = 'Substring',
  bizdata_ops_dropalleventvalues = 'Drop all events for value',
  bizdata_ops_generatesequence = 'Generate Array Sequence Number',
  bizdata_ops_json2string = 'JSON to String',
  bizdata_ops_string2json = 'String to JSON',
  bizdata_ops_toplevel = 'Send Keys Top of Root',
  bizdata_ops_datetimestamp = 'Today Timestamp',
  bizdata_ops_dataaggregation = 'Data aggregation',
  bizdata_ops_datatypes = 'Data types',
  bizdata_ops_round = 'Round',
  bizdata_ops_pivot = 'Pivot',
  bizdata_ops_unpivot = 'Unpivot',
  bizdata_ops_singleline2tuple = 'Single Line to Tuple',
  bizdata_ops_tuple2singleline = 'Tuple to Single Line',
  bizdata_ops_postgres = 'Postgres',
  bizdata_ops_replacinganyvalue = 'Replacing any value',
  bizdata_ops_trim = 'Trim',
  bizdata_ops_base64decoding = 'Base64 decoding',
  bizdata_ops_base64encoding = 'Base64 encoding',
  bizdata_ops_bodmascal = 'Bodmascal',
  bizdata_ops_json2dl = 'JSON to delimiter',
  bizdata_ops_dl2json = 'Delimiter to JSON',
  bizdata_ops_sleeptime = 'Sleep time',
  bizdata_ops_pycode = 'Python',
  bizdata_ops_aiops="AI Operation",
  bizdata_ops_jsontoxml = 'JSON to XML',
  bizdata_ops_xmltojson = 'XML to JSON',
  bizdata_ops_restapitarget = 'API',
  bizdata_ops_email = 'Email',
  bizdata_ops_analytics = 'Analytics',
  bizdata_ops_dataextractor = 'Data extractor',
  // bizdata_ops_file = 'File',
  bizdata_ops_repeatfirstrow = 'Repeat First Row Values',
  bizdata_ops_dlakeingestion = 'DL Ingestion',
  bizdata_ops_dlsearch = 'DataLake Search',
  bizdata_ops_filter = 'Filter',
  bizdata_ops_encodedecode = 'Encode Decode',
  bizdata_ops_zipfileinbase64 = 'Zipfile in Base64',
  bizdata_ops_arraycount = 'Array Count',
  bizdata_ops_dl2array = 'Delimiter to Array',
  bizdata_ops_pdfextractor = 'PDF Extractor',
  bizdata_ops_fileextractor = 'File Extractor',
  bizdata_ops_docunderstanding = 'Document Understanding',
  bizdata_ops_grokpattern = 'Grok Pattern',
  bizdata_ops_imgunderstanding = 'Image Understanding',
  bizdata_ops_filterends = 'Filter Ends',
  bizdata_ops_rawsentencegenerator = 'Raw Sentence Generator',
  bizdata_ops_timeunits = 'Time Units',
  bizdata_ops_datachunking = 'Data Chunking',
  bizdata_ops_htmlextractor = 'HTML Extractor',
  bizdata_ops_json2avro = 'JSON to AVRO',
  bizdata_ops_avrojson = 'AVRO to JSON',
  bizdata_ops_extract2array = 'Extract to Array',
};

// export interface SourceElement {
//   key: string;
//   value: string;
// }

// const SOURCE_ELEMENT_DATA: SourceElement[] = [
//   {source: 'city'},
//   {source: 'country'},
//   {source: 'location_type'},
//   {source: 'region'},
//   {source: 'views'},
//   {source: 'networkd'}
// ];

// export interface TargetElement {
//   target: string;
//   mapping: string;
//   isMappingCancelled: boolean;
// }

// const TARGET_ELEMENT_DATA: TargetElement[] = [
//   {target: 'Account Number', mapping: "city", isMappingCancelled: false},
//   {target: 'Network', mapping: "views", isMappingCancelled: false},
//   {target: 'Campain Id', mapping: "", isMappingCancelled: false},
//   {target: 'clicks', mapping: "", isMappingCancelled: false},
//   {target: 'Campaign State', mapping: "", isMappingCancelled: false},
//   {target: 'avarage position', mapping: "", isMappingCancelled: false}
// ];

export class MyErrorStateMatcher implements ErrorStateMatcher {


  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
export interface ProductGroup {
  brand_name: string;
  products: string[];
}

export interface Target {
  product_name: string
}

export interface BusinessObject {
  id: number;
  business_obj: string;
}

export interface TimeZone {
  timezone: string;
}

export interface HeaderKey {
  header_key: string;
}

export interface HeaderValue {
  header_value: string;
}



export const filterSource = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.toLowerCase().includes(filterValue));
}

@Component({
  selector: 'app-integration-create',
  templateUrl: './integration-create.component.html',
  styleUrls: ['./integration-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IntegrationCreateComponent implements OnInit, AfterViewInit {

  sourceCatalogueId: any;
  targetCatalogueId: any;
  apiCatalogFormType: any;
  transformationData: string = '';
  expectedData: string = '';
  selectedSegment: string = 'first';
  operationIndex:any;
  templates: string[] = [];
  selectedTemplates: string[] = [];
  apiResponse;
  operationResponses: any[]=[];
  operationStatus: { [key: number]: string } = {};
  operationResponseTime: { [key: number]: string } = {};
  operationResponse_err: { [key: number]: string } = {};
  // templates = ['Template 1', 'Template 2', 'Template 3'];
  opsData=[];
  operationCatalogId;
  // @ViewChild(PostmanuiComponent) postmanComponent!: PostmanuiComponent;
  @ViewChildren(PostmanuiComponent) postmanuiComponents!: QueryList<PostmanuiComponent>;
  // Array to hold references to dynamically created components
  dynamicChildren: Array<any> = [];
  showAdvancedSettings: boolean = false; // Initial value, can be true or false based on your requirement
  streamingBatchSize: number; // Define the property
  sourceResponseWaitTime: number; // Define the property
  selectedNumberOfWorkers: string = '1'; // Set default value

  private incomingSearchText$ = new BehaviorSubject('');
  isFirstSourceBusinessObjectChange: boolean = true;
  isFirstTargetBusinessObjectChange: boolean = true;
  private parentNavigationHelpSubscription: Subscription | undefined;
  private sourcePostmanPreviewSubscription: Subscription | undefined;
  private targetPostmanPreviewSubscription: Subscription | undefined;
  @ViewChild(JsonEditorComponent, { static: false }) editor: JsonEditorComponent;
  @ViewChild("c1") clearDataSourceAction;

  @ViewChild('ionContent', { static: true }) ionContent!: any;
  @ViewChild('sourceApiTypeDropdown') sourceApiTypeDropdown: MatSelect;
  @ViewChild('sourceProductNameDropdown') sourceProductNameDropdown: MatAutocompleteTrigger;
  @ViewChild('sourceBusinessObjectDropdown') sourceBusinessObjectDropdown: MatSelect;
  @ViewChild('sourceStorageNameDropdown') sourceStorageNameDropdown: MatSelect;
  @ViewChild('sourceStorageVersionDropdown') sourceStorageVersionDropdown: MatSelect;
  @ViewChild('sourceDlVersionDropdown') sourceDlVersionDropdown: MatSelect;
  @ViewChild('sourceEmailOutputTypeDropdown') sourceEmailOutputTypeDropdown: MatSelect;
  @ViewChild('opsProductNameDropdown') opsProductNameDropdown: MatAutocompleteTrigger;
  @ViewChild('opsBusinessObjectDropdown') opsBusinessObjectDropdown: MatSelect;
  @ViewChild('opsStorageNameDropdown') opsStorageNameDropdown: MatSelect;
  @ViewChild('opsStorageVersionDropdown') opsStorageVersionDropdown: MatSelect;
  @ViewChild('targetApiTypeDropdown') targetTypeDropdown: MatSelect;
  @ViewChild('targetProductNameDropdown') targetProductNameDropdown: MatAutocompleteTrigger;
  @ViewChild('targetBusinessObjectDropdown') targetBusinessObjectDropdown: MatSelect;
  @ViewChild('targetStorageNameDropdown') targetStorageNameDropdown: MatSelect;
  @ViewChild('targetStorageVersionDropdown') targetStorageVersionDropdown: MatSelect;
  @ViewChild('targetDlVersionDropdown') targetDlVersionDropdown: MatSelect;
  @ViewChild('targetDlActionTypeDropdown') targetDlActionTypeDropdown: MatSelect;
  @ViewChild('targetDlIngestionTypeDropdown') targetDlIngestionTypeDropdown: MatSelect;
  @ViewChild('slides', { static: false }) slides: IonSlides;
  @ViewChild('chatInputAiops') chatInputAiops!: ElementRef<HTMLTextAreaElement>;
  // @ViewChild('chatContainers') chatContainer!: ElementRef;

  @ViewChild('chatContainers') chatContainer!: ElementRef;
  @ViewChildren('chatMessage') chatMessages!: QueryList<ElementRef>;
  @ViewChild('chatInput') chatInput!: ElementRef<HTMLTextAreaElement>;
  @ViewChild('chatInputContainer') chatInputContainer!: ElementRef<HTMLDivElement>;
  
  // selectedSegment: string = 'first';

  // Slide options (optional)
  slideOpts = {
    initialSlide: 0,
    speed: 400
  };
  editorSourceOptions: JsonEditorOptions;
  editorTargetOptions: JsonEditorOptions;
  appendoptions = new JsonEditorOptions();
  renameoptions = new JsonEditorOptions();
  singletomultioptions = new JsonEditorOptions();

  editor2Options: JsonEditorOptions;
  dataStructure: any;
  dlsearch_body_ops_hint = '"""{"query": { "match_all": {} } }"""';

  //options: string[] = ['Option1', 'Option2', 'Option3', 'Another Option'];
  divs: { content: string }[] = [{ content: '' }];
  filteredHeaderKey: any[][] = [[]];
  filteredHeaderValue: any[][] = [[]];
  filteredDataTargetHeaderKey: any[][] = [[]];
  filteredDataTargetHeaderValue: any[][] = [[]];
  
  // dropdownKeyVisible: any;
  // dropdownValueVisible: any;
  sqlhint= '"""Insert into SALES_ITEMS(ITEM_NUMBER,BACKORDER,BRAND,CATEGORY,CREATED_DATE,SUPPLIER,LOCATION,ITEM_NAME) values (?,?,?,?,?,?,?,?)""","ITEM_NUMBER","BACKORDER","BRAND","CATEGORY","CREATED_DATE","SUPPLIER","LOCATION","ITEM_NAME"';
  sqlhint_source="select * from table where table.column ='pending'";
 

  // editorSourceOptions2 = {
  //   language: 'text',
  //   minimap: {
  //     enabled: false
  //   },
  // };
  codeMirrorEditorOptions_python = {
    mode: 'python',    // Set the language mode to Python
    theme: 'material', // CodeMirror theme (optional)
    tabSize: 4,        // Set tab size
    indentWithTabs: false, // Use spaces for indentation
    lineWrapping: true, // Enable line wrapping
    lineNumbers: true, 
  }
  // };
  // editorPycodeOption = {
  //   language: 'text',
  //   minimap: {
  //     enabled: false
  //   },
  // };

  @ViewChild("dlSearchEditor") _dlSearchEditor: CodemirrorComponent;
  @ViewChild("dlSearchSourceEditor") _dlSearchSourceEditor: CodemirrorComponent;
  @ViewChild("pycodeEditor") _pycodeEditor: CodemirrorComponent;
  @ViewChild("pyresponseEditor") _pyresponseEditor: CodemirrorComponent;
  @ViewChild("queryEditor") _queryEditor: CodemirrorComponent;
  @ViewChild("bodySourceEditor") _bodySourceEditor: CodemirrorComponent;
  @ViewChild("bodyTargetEditor") _bodyTargetEditor: CodemirrorComponent;
  @ViewChild("bodyRestAPIEditor") _bodyRestAPIEditor: CodemirrorComponent;
  @ViewChild("queryresponseEditor") _queryresponseEditor: CodemirrorComponent;
  @ViewChild("sourcePreRequestScriptEditor") _sourcePreRequestScriptEditor: CodemirrorComponent;
  @ViewChild("sourceMessageEditor") _sourceMessageEditor: CodemirrorComponent;
  @ViewChild("targetPreRequestScriptEditor") _targetPreRequestScriptEditor: CodemirrorComponent;
  @ViewChild("preRequestScriptEditorROA") _preRequestScriptEditorROA: CodemirrorComponent;
  @ViewChild("sourcerefreshTokenHeaderScriptEditor") _sourcerefreshTokenHeaderScriptEditor: CodemirrorComponent;
  @ViewChild("sourcerefreshTokenParamScriptEditor") _sourcerefreshTokenParamScriptEditor: CodemirrorComponent;
  @ViewChild("sourcerefreshTokenBodyScriptEditor") _sourcerefreshTokenBodyScriptEditor: CodemirrorComponent;
  @ViewChild("targetrefreshTokenHeaderScriptEditor") _targetrefreshTokenHeaderScriptEditor: CodemirrorComponent;
  @ViewChild("targetrefreshTokenParamScriptEditor") _targetrefreshTokenParamScriptEditor: CodemirrorComponent;
  @ViewChild("targetrefreshTokenBodyScriptEditor") _targetrefreshTokenBodyScriptEditor: CodemirrorComponent;
  @ViewChild("refreshTokenHeaderScriptEditorROA") _refreshTokenHeaderScriptEditorROA: CodemirrorComponent;
  @ViewChild("refreshTokenParamScriptEditorROA") _refreshTokenParamScriptEditorROA: CodemirrorComponent;
  @ViewChild("refreshTokenBodyScriptEditorROA") _refreshTokenBodyScriptEditorROA: CodemirrorComponent;
  @ViewChild("appendScriptEditor") _appendScriptEditor: CodemirrorComponent;
  @ViewChild("formField") autoCompleteFormField: MatFormField;
  @ViewChild("formFieldTarget") autoCompleteFormFieldTarget: MatFormField;
  @ViewChild("sourceCustomPaginationScriptEditor") _sourceCustomPaginationScriptEditor: CodemirrorComponent;
  @ViewChild("previewPostmanEditor") _previewPostmanEditor: CodemirrorComponent;
  @ViewChildren('contentEditableHeaderKey') contentEditableHeaderKeys!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('contentEditableHeaderValue') contentEditableHeaderValues!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('contentEditableDataTargetHeaderKey') contentEditableDataTargetHeaderKeys!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('contentEditableDataTargetHeaderValue') contentEditableDataTargetHeaderValues!: QueryList<ElementRef<HTMLDivElement>>;
  
 

 // @ViewChildren('autocompleteHeaderKey') autocompleteHeaderKeys!: QueryList<ElementRef<HTMLDivElement>>;
 // @ViewChildren('autocompleteHeaderValue') autocompleteHeaderValues!: QueryList<ElementRef<HTMLDivElement>>;

  preRequestScriptEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    autoRefresh: true,
    theme: "default",
    mode: { name: "javascript" }
  };
  codeMirrorEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" },

  };
  codeMirrorEditorOptions_sql: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" },
    placeholder:'"""Insert into SALES_ITEMS(ITEM_NUMBER,BACKORDER,BRAND,CATEGORY,CREATED_DATE,SUPPLIER,LOCATION,ITEM_NAME) values (?,?,?,?,?,?,?,?)""","ITEM_NUMBER","BACKORDER","BRAND","CATEGORY","CREATED_DATE","SUPPLIER","LOCATION","ITEM_NAME"',
    
  };
  codeMirrorEditorOptions_sql_Source: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" },
    placeholder: "select * from table where table.column ='pending'",
    
  };
  previewPostmanCodeMirrorEditor: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" },
    readOnly: 'nocursor'
  };
  bodyTypeOptions: Array<any> = [
    { id: 1, type: 'JSON' },
    { id: 2, type: 'XML' },
    { id: 3, type: 'TEXT' }
  ]
  authorizationScriptEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "javascript", json: true }
  };
  appendEditorOption: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "javascript", json: true }
  };
  messageEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" }
  };

  // private incomingSearchText$ = new BehaviorSubject('');
  isOpsFromEnabled1: boolean = false;
  stepperOrientation: Observable<StepperOrientation>;

  sourceColoumns: any;
  targetColoumns: any;
  color: ThemePalette = 'primary';
  checked = false;
  disabled = false;
  isLinear = true;
  dataSource: UntypedFormGroup = new UntypedFormGroup({});
  dataTarget: UntypedFormGroup = new UntypedFormGroup({});
  dataOperations: UntypedFormGroup;

  //--------Transformation Form Init----------
  bizdata_ops_datatypes_fb: UntypedFormGroup;
  bizdata_ops_append_formArray: UntypedFormGroup
  bizdata_ops_append_fb: UntypedFormGroup;
  bizdata_ops_titlecase_fb: UntypedFormGroup;
  bizdata_ops_uppercase_fb: UntypedFormGroup;
  bizdata_ops_lowercase_fb: UntypedFormGroup;
  bizdata_ops_dataextractor_fb: UntypedFormGroup;
  bizdata_ops_trim_fb: UntypedFormGroup;
  bizdata_ops_base64decoding_fb: UntypedFormGroup;
  bizdata_ops_base64encoding_fb: UntypedFormGroup;
  bizdata_ops_jsontoxml_fb: UntypedFormGroup;
  bizdata_ops_xmltojson_fb: UntypedFormGroup;
  bizdata_ops_generatesequence_fb: UntypedFormGroup;
  bizdata_ops_json2string_fb: UntypedFormGroup;
  bizdata_ops_string2json_fb: UntypedFormGroup;
  bizdata_ops_toplevel_fb: UntypedFormGroup;
  bizdata_ops_datetimestamp_fb: UntypedFormGroup;
  bizdata_ops_repeatfirstrow_fb: UntypedFormGroup;
  bizdata_ops_encodedecode_fb: UntypedFormGroup;
  bizdata_ops_zipfileinbase64_fb: UntypedFormGroup;
  bizdata_ops_arraycount_fb: UntypedFormGroup;
  bizdata_ops_pdfextractor_fb: UntypedFormGroup;
  bizdata_ops_fileextractor_fb: UntypedFormGroup;
  bizdata_ops_grokpattern_fb: UntypedFormGroup;
  bizdata_ops_rawsentencegenerator_fb: UntypedFormGroup;
  bizdata_ops_timeunits_fb: UntypedFormGroup;
  bizdata_ops_datachunking_fb: UntypedFormGroup;
  bizdata_ops_jason2avro_fb: UntypedFormGroup;
  bizdata_ops_htmlextractor_fb: UntypedFormGroup;
  bizdata_ops_avro2json_fb: UntypedFormGroup;
  bizdata_ops_extract2array_fb: UntypedFormGroup;
  //--------------------------------------
  //--------------Wrangling Form Init-------------
  bizdata_ops_json2dl_fb: UntypedFormGroup;
  bizdata_ops_dl2json_fb: UntypedFormGroup;
  bizdata_ops_dataaggregation_fb: UntypedFormGroup;
  bizdata_ops_pivot_fb: UntypedFormGroup;
  bizdata_ops_singleline2tuple_fb: UntypedFormGroup;
  bizdata_ops_tuple2singleline_fb: UntypedFormGroup;
  bizdata_ops_unpivot_fb: UntypedFormGroup;
  bizdata_ops_singletomultiline_fb: UntypedFormGroup;
  bizdata_ops_dl2array_fb: UntypedFormGroup;
  //-----------------------------------------
  //--------------Orchestration Form Init---------------
  // bizdata_ops_file_fb: FormGroup;
  bizdata_ops_email_fb: UntypedFormGroup;
  bizdata_ops_restapi_fb: UntypedFormGroup;
  bizdata_ops_dlakeingestion_fb: UntypedFormGroup;
  bizdata_ops_dlsearch_fb: UntypedFormGroup;
  bizdata_ops_json_fb: UntypedFormGroup;
  //-----------------------------------------
  //--------------Cleaning Form Init-----------------
  bizdata_ops_dropeventsstartswith_fb: UntypedFormGroup;
  bizdata_ops_dropalleventvalues_fb: UntypedFormGroup;
  bizdata_ops_eliminate_fb: UntypedFormGroup;
  bizdata_ops_rename_fb: UntypedFormGroup;
  bizdata_ops_calculater_fb: UntypedFormGroup;
  bizdata_ops_dateanalytics_fb: UntypedFormGroup;
  bizdata_ops_substitute_fb: UntypedFormGroup;
  bizdata_ops_strip_fb: UntypedFormGroup;
  bizdata_ops_substring_fb: UntypedFormGroup;
  bizdata_ops_round_fb: UntypedFormGroup;
  //-----------------------------------------
  //--------------Pipeline Controls Form Init-----------------
  bizdata_ops_sleeptime_fb: UntypedFormGroup;
  bizdata_ops_pycode_fb: UntypedFormGroup;
  bizdata_ops_aiops_fb: UntypedFormGroup;
  bizdata_ops_filter_fb: UntypedFormGroup;
  bizdata_ops_filterends_fb: UntypedFormGroup;
  //-----------------------------------------
  //=------------Deep Learning---------------
  bizdata_ops_docunderstanding_fb: UntypedFormGroup;
  bizdata_ops_imgunderstanding_fb: UntypedFormGroup;


  bizdata_ops_jdbcoutput_fb: UntypedFormGroup;
  bizdata_ops_postgres_fb: UntypedFormGroup;
  bizdata_ops_replacinganyvalue_fb: UntypedFormGroup;
  bizdata_ops_restapitarget_fb: UntypedFormGroup;
  bizdata_ops_analytics_fb: UntypedFormGroup;
  multilineObj = [{ id: 1, value: "yes" }, { id: 2, value: "no" }];
  bridgeSourceType = [{ id: 1, value: "API ( HTTPS, FTP, SFTP, SOAP/REST/ GraphQL)" }, { id: 2, value: "Database" }, { id: 3, value: "Bizintel360 Data Lake Source" }, { id: 4, value: "Websocket" }, { id: 5, value: "Email" }]; //
  bridgeTargetType = [{ id: 1, value: "API ( HTTPS, FTP, SFTP, SOAP/REST/ GraphQL)" }, { id: 2, value: "Database" }, { id: 3, value: "Bizintel360 Data Lake Ingestion" }, { id: 4, value: "Email" }, { id: 5, value: "No Target" }];//
  bridge_source_type = 1;
  bridge_target_type = 1;
  bridge_summary_source_name;
  bridge_summary_source_bobj;
  bridge_summary_target_name;
  bridge_summary_target_bobj;
  data_target_status;
  data_source_status;
  datatarget_action_type = "upsert";
  datasource_action_type = "upsert";
  dataTargetDLIngestion: any;
  dataSourceDLIngestion: any;
  mapping: UntypedFormGroup;
  summary: UntypedFormGroup;
  loader=false;
  displayedSourceColumns: string[] = ['source',];
  // sourceTable = SOURCE_ELEMENT_DATA;
  displayedTargetColumns: string[] = ['target', 'mapping'];
  // targetTable = TARGET_ELEMENT_DATA;
  matChipColor = "#87c4f3";
  hide1024 = false;
  operationParam: any;
  userIp;
  breadcrumbList = [
    {
      label: 'Integration',
      embedurl: true,
      url: '/baseapp/integration/list'
    },
    {
      label: 'Create',
      embedurl: false,
      url: ''
    }
  ];

  dataArray = []

  loading = true;

  bridgeSourceList: ProductGroup[] = [];
  bridgeSourceProduct$: Observable<ProductGroup[]>;
  bridgeSourceBusinessObjectList = [];
  bridgeSourceHeaderValueList = [];
  bridgeSourceBusinessObject$: Observable<BusinessObject[]>;


  timezoneList = [];
  timezones$: Observable<TimeZone[]>;

  sourceHeaderKeyList: any[] = [];
  filteredOptions: Observable<any>;
  sourceHeaderKeys$: Observable<HeaderKey[]>[] = [];

  sourceHeaderValueList = [];
  sourceHeaderValues$: Observable<HeaderValue[]>[] = [];


  targetHeaderKeyList = [];
  targetHeaderKeys$: Observable<HeaderKey[]>[] = [];

  targetHeaderValueList = [];
  targetHeaderValues$: Observable<HeaderValue[]>[] = [];

  apiOperationHeaderKeyList = [];
  apiOperationHeaderKeys$: Observable<HeaderKey[]>[] = [];

  apiOperationHeaderValueList = [];
  apiOperationHeaderValues$: Observable<HeaderValue[]>[] = [];
  // RAO - Rest Api Operation
  bridgeTargetListRAO: ProductGroup[] = [];
  verisonListDLO = []
  verisonListDLS = []
  targetVerisonListDL = []
  sourceVerisonListDL = []
  sourceDLListOpName;
  actionTypeListDLO = [
    {
      actionTypeTitle: 'Upsert',
      actionTypevalue: 'upsert',
    },
    {
      actionTypeTitle: 'Update',
      actionTypevalue: 'update'
    },
    {
      actionTypeTitle: 'Delete',
      actionTypevalue: 'delete',
    },
    {
      actionTypeTitle: 'Create',
      actionTypevalue: 'create'
    },
    {
      actionTypeTitle: 'Insert',
      actionTypevalue: 'index'
    }
  ];
  indexingTypeListDLO = [
    {
      indexTypeTitle: 'Parallel Computing',
      indexTypevalue: 'parallel_bulk'
    },
    {
      indexTypeTitle: 'Streaming Computing',
      indexTypevalue: 'streaming_bulk'
    },
    {
      indexTypeTitle: 'Bump Computing',
      indexTypevalue: 'bulk'
    }
  ];
  processEDOList = [
    {
      process: 'encode',
    },
    {
      process: 'decode',
    }
  ];
  bridgeTargetRAO$: Observable<ProductGroup[]>;
  bridgeTargetBusinessObjectRAO = [];
  enableDataTargetRAOClearIcon = false;
  // *******
  selectedIndex = 0;

changeTab(index: number) {
  this.selectedIndex = index;
}

  bridgeTargetList: ProductGroup[] = [];
  bridgeTarget$: Observable<ProductGroup[]>;
  bridgeTargetBusinessObjectList = [];
  bridgeTargetBusinessObject$: Observable<BusinessObject[]>;

  bridgeTargetBusinessObjectListRAO = [];
  bridgeTargetBusinessObjectRAO$: Observable<BusinessObject[]>;

  storageNameJDBCOList = [];

  methodList: any;
  authenticationSourceTypeOptions: any;
  authenticationTargetTypeOptions: any;
  selectSourceType: number;
  selectPaginationType: number = 1;
  selectTargetType: number;
  selectTargetRestApiType: number;
  bridgeSourceResponse;
  bridgeTargetResponse;

  bridgeSourceResponseMapping = [];
  bridgeTargetResponseMapping = [];
  isMappingActive = false;

  bubblecross = false;
  bubbleshow: boolean = false;
  sorcename: boolean = false;
  businessobjectname: boolean = false;
  businessname: boolean = false;
  businessobject: boolean = false;
  methodopt: boolean = false;
  requesturl: boolean = false;
  params: boolean = false;
  authorization: boolean = false;
  headers: boolean = false;
  requestbody: boolean = false;
  script: boolean = false;
  testurl: boolean = false;
  shownext: boolean = false;
  bubbleshowoperation: boolean = false;
  shownextoperation: boolean = false;
  bubbleshowtarget: boolean = false;
  targetname: boolean = false;
  businessobjecttargetname: boolean = false;
  businessobjecttarget: boolean = false;
  methodopttarget: boolean = false;
  requesturltarget: boolean = false;
  paramstarget: boolean = false;
  authorizationtarget: boolean = false;
  headerstarget: boolean = false;
  requestbodytarget: boolean = false;
  scripttarget: boolean = false;
  testurltarget: boolean = false;
  bubbly: number;
  shownexttarget: boolean = false;
  bridgename: boolean = false;
  schedule: boolean = false;
  submitib: boolean = false;
  shownOpNext:boolean = false;
  emails: string[] = [];
  emailsTarTo: string[] = [];
  emailsTarCc: string[] = [];
  emailsTarBcc: string[] = [];
  emailsOpsToMain: any = [];
  emailsOpsTo: string[][] = [];
  emailsOpsCc: string[][] = [];
  emailsOpsBcc: string[][] = [];

  announcer = inject(LiveAnnouncer);
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  readonly separatorKeysCodesTarTo = [ENTER, COMMA] as const;
  readonly separatorKeysCodesTarCc = [ENTER, COMMA] as const;
  readonly separatorKeysCodesTarBcc = [ENTER, COMMA] as const;
  readonly separatorKeysCodesOpsTo = [ENTER, COMMA] as const;
  readonly separatorKeysCodesOpsCc = [ENTER, COMMA] as const;
  readonly separatorKeysCodesOpsBcc = [ENTER, COMMA] as const;

  selectable = true;
  removable = true;
  type: string = 'data_source'
  type1: string = "data_source";
  consoleType: string = ''

  selectedSourceColumn = { "source_column": "", "source_value": "", "selected": false, "type": "" };
  isSourceColumnSelected = false;
  sourceColumnIndex = 0;
  mapdata: boolean = false;
  indexSelection: number = 0;
  indexSelectionTarget: number = 0;
  indexSelectionEmail: number = 0;
  indexSelectionEmailTarget: number = 0;
  indexSelectionWebsocket: number = 0;
  indexSelectionAIOps: number = 0;
  pythonTokenForDataSource: string;
  pythonTokenForDataOperation: string;
  pythonTokenForJdbcOperation: string;
  pythonTokenForEmailOperation: string;
  pythonTokenForPycodeOperation: string;
  consoleDataTokenForMilestoneAPI: string;

  noAbout = false;
  selectedOperationId;
  createNew = "Create New";
  enableDataSourceClearIcon = false;
  enableDataTargetClearIcon = false;

  enableSourceBusinessObjectClearIcon = false;
  enableTargetBusinessObjectClearIcon = false;
  enableTargetRAOBusinessObjectClearIcon = false;


  enableTimeZoneClearIcon: boolean;

  operationsArr: Array<any> = [
    {
      label: "Transformation",
      code: "TRSFR",
      color: '#767171',
      blocks: []
    },
    {
      label: "Wrangling",
      code: "WRGL",
      color: '#ea2127',
      blocks: []
    },
    {
      label: "Orchestration",
      code: "ORCSTR",
      color: '#363a94',
      blocks: []
    },
    {
      label: "Cleaning",
      code: "CLENG",
      color: '#069a67',
      blocks: []
    },
    {
      label: "Pipeline Controls",
      code: "PIPECTRL",
      color: '#684099',
      blocks: []
    },
    {
      label: "Deep Learning",
      code: "DEEPLRG",
      color: '#de2321',
      blocks: []
    }
  ]
  operationsArrSearch: Array<any> = [];

  paginationTypeOptions: Array<any> = [
    {
      id: 1,
      type: "No Pagination",
      type_value: "no_pagination"
    },
    {
      id: 2,
      type: "Next URL Pagination",
      type_value: "next_url_pagination"
    },
    {
      id: 3,
      type: "Offset Pagination",
      type_value: "offset_pagination"
    },
    {
      id: 4,
      type: "Total Page Count",
      type_value: "total_pages"
    },
    {
      id: 5,
      type: "Pagination with Body",
      type_value: "pagination_with_body"
    },
    {
      id: 6,
      type: "Cursor Pagination",
      type_value: "cursor_pagination"
    },
    {
      id: 7,
      type: "Encoded Next Token",
      type_value: "encoded_next_token_pagination"
    },
    {
      id: 8,
      type: "Custom Pagination",
      type_value: "custom_pagination"
    }
  ]
  // bizdata_ops_jdbcoutput_obj=[
  //   "jdbc_driver",
  //   "jdbc_string",
  //   "jdbc_jar_file",
  //   "username",
  //   "password",
  //   "unique_key",
  //   "query",
  //   "response_parameter",
  //   "timer_type",
  //   "schedule",
  //   "interval_in_seconds",
  //   "multiline",
  //   "target"
  // ]

  activeTab = 0;
  
  tabs = [
    { label: "Instructions", icon: 'fas fa-info-circle', placeholder: "Enter Instructions...",formControl:"aiops",},
    { label: "Do's", icon: 'fas fa-check-circle', placeholder: "Enter Do's..." ,formControl:"dos",},
    { label: "Don'ts", icon: 'fas fa-times-circle', placeholder: "Enter Don'ts...",formControl:"donts",}
  ];

  selectTab(index: number) {
    this.activeTab = index;
  }

  isGenerating: boolean = false;
  showGeneratedContent: boolean = false;
  Generate_txt="Generate";
  isGenerated=false;


  //--Transformation Array Declearation--
  bizdata_ops_datatypes_obj = []
  bizdata_ops_append_obj = []
  bizdata_ops_titlecase_obj = []
  bizdata_ops_uppercase_obj = []
  bizdata_ops_lowercase_obj = []
  bizdata_ops_dataextractor_obj = []
  bizdata_ops_trim_obj = []
  bizdata_ops_base64decoding_obj = []
  bizdata_ops_base64encoding_obj = []
  bizdata_ops_jsontoxml_obj = []
  bizdata_ops_xmltojson_obj = []
  bizdata_ops_generatesequence_obj = []
  bizdata_ops_json2string_obj = []
  bizdata_ops_string2json_obj = []
  bizdata_ops_toplevel_obj = []
  bizdata_ops_datetimestamp_obj = []
  bizdata_ops_repeatfirstrow_obj = []
  bizdata_ops_encodedecode_obj = []
  bizdata_ops_zipfileinbase64_obj = []
  bizdata_ops_arraycount_obj = []
  bizdata_ops_pdfextractor_obj = []
  bizdata_ops_fileextractor_obj = []
  bizdata_ops_grokpattern_obj = []
  bizdata_ops_rawsentencegenerator_obj = []
  bizdata_ops_timeunits_obj = []
  bizdata_ops_datachunking_obj = []
  bizdata_ops_json2avro_obj = []
  bizdata_ops_avro2json_obj = []
  bizdata_ops_extract2array_obj = []


  bizdata_ops_htmlextractor_obj = []
  //--------------------------------------
  //--------------Waringling-------------
  bizdata_ops_json2dl_obj = []
  bizdata_ops_dl2json_obj = []
  bizdata_ops_dataaggregation_obj = []
  bizdata_ops_pivot_obj = []
  bizdata_ops_unpivot_obj = []
  bizdata_ops_singletomultiline_obj = []
  bizdata_ops_singleline2tuple_obj = []
  bizdata_ops_tuple2singleline_obj = []
  bizdata_ops_dl2array_obj = []
  //--------------------------------------
  //--------------Orchestration---------------
  // bizdata_ops_file_obj = []
  bizdata_ops_email_obj = []
  bizdata_ops_restapi_obj = []
  bizdata_ops_json_obj = []
  //-----------------------------------------
  //--------------Cleaning-----------------
  bizdata_ops_dropeventsstartswith_obj = []
  bizdata_ops_dropalleventvalues_obj = []
  bizdata_ops_eliminate_obj = []
  bizdata_ops_rename_obj = []
  bizdata_ops_calculater_obj = []
  bizdata_ops_dateanalytics_obj = []
  bizdata_ops_substitute_obj = []
  bizdata_ops_strip_obj = []
  bizdata_ops_substring_obj = []
  bizdata_ops_round_obj = []
  //-----------------------------------------
  //--------------Pipeline Controls-----------------
  bizdata_ops_sleeptime_obj = []
  bizdata_ops_pycode_obj = []
  bizdata_ops_aiops_obj = []
  bizdata_ops_filter_obj = []
  bizdata_ops_filterends_obj = []
  //-----------------------------------------
  bizdata_ops_jdbcoutput_obj = []
  bizdata_ops_postgres_obj = []
  bizdata_ops_replacinganyvalue_obj = []
  bizdata_ops_restapitarget_obj = []
  bizdata_ops_dlakeingestion_obj = []
  bizdata_ops_dlsearch_obj = []
  bizdata_ops_analytics_obj = []
  bizdata_ops_docunderstanding_obj = []
  bizdata_ops_imgunderstanding_obj = []

  //-----------------------------------
  isDataTypeFromEnabled: boolean = false;
  isAppendFromEnabled: boolean = false;
  isTitlecaseFromEnabled: boolean = false;
  isUppercaseFromEnabled: boolean = false;
  isLowercaseFromEnabled: boolean = false;
  isData_extractorFromEnabled: boolean = false;
  isTrimFromEnabled: boolean = false;
  isBase64encodingFromEnabled: boolean = false;
  isBase64decodingFromEnabled: boolean = false;
  isJSON_to_XMLFromEnabled: boolean = false;
  isXML_to_JSONFromEnabled: boolean = false;
  isGeneratesequenceFromEnabled: boolean = false;
  isJson2stringFromEnabled: boolean = false;
  isString2jsonFromEnabled: boolean = false;
  isToplevelFromEnabled: boolean = false;
  isDatetimestampFromEnabled: boolean = false;
  isRepeatfirstrowFromEnabled: boolean = false;
  isEncodedecodeFromEnabled: boolean = false;
  isZipfileinbase64FromEnabled: boolean = false;
  isArraycountFromEnabled: boolean = false;
  isPdfextractorFromEnabled: boolean = false;
  isPdfextractorFormEnabled: boolean = false;
  isFileextractorFormEnabled: boolean = false;
  isGorkPatternFormEnabled: boolean = false;
  isRawSentenceGeneratorFormEnabled: boolean = false;
  isTimeUnitsFormEnabled: boolean = false;
  isDataChunkingFormEnabled: boolean = false;
  isJson2avroFormEnabled: boolean = false;
  isHTMLExtractorFormEnabled: boolean = false;
  isAvro2jsonFormEnabled: boolean = false;
  isExtract2ArrayFormEnabled:boolean = false;
  //-----------------------------------//

  //-----Waringlging-------------------------------//
  isDl2jsonFromEnabled: boolean = false;
  isJSON2dlFromEnabled: boolean = false;
  isDataaggregationFromEnabled: boolean = false;
  isPivotFromEnabled: boolean = false;
  isUnPivotFromEnabled: boolean = false;
  chopFormEnabled: boolean = false
  singleline2tupleFormEnabled: boolean = false
  tuple2singlelineFormEnabled: boolean = false
  isDl2arrayFormEnabled: boolean = false
  //---------------------------------------------//
  //--------------Orchestration---------------
  // isfileFromEnabled: boolean = false;
  isemailFromEnabled: boolean = false;
  isrestapiFormEnabled: boolean = false
  isjsonFormEnabled: boolean = false
  //-----------------------------------
  isDLIngestionFormEnabled: boolean = false;
  isDlsearchFormEnabled: boolean = false;
  //--------------Cleaning---------------
  isdropeventsstartswithFromEnabled: boolean = false;
  isdropalleventvaluesFromEnabled: boolean = false;
  iseliminateFromEnabled: boolean = false;
  isrenameFromEnabled: boolean = false
  iscalculaterFromEnabled: boolean = false
  isdateanalyticsFromEnabled: boolean = false
  issubstituteFromEnabled: boolean = false
  isstripFromEnabled: boolean = false
  issubstringFromEnabled: boolean = false
  isroundFromEnabled: boolean = false;
  //---------------------------------------------//
  //--------------Pipeline Controls---------------
  issleepFromEnabled: boolean = false;
  ispycodeFromEnabled: boolean = false;
  isaiopsFromEnabled: boolean = false;
  isjdbcoutputFromEnabled: boolean = false;
  isfilterFromEnabled: boolean = false;
  isfilterEndsFromEnabled: boolean = false;
  //---------------------------------------------//
  isDocunderstandingFromEnabled: boolean = false;
  isImgunderstandingFromEnabled: boolean = false;
  isPostgresFromEnabled: boolean = false;
  isReplacingvalueFromEnabled: boolean = false;
  isRestapitargetFromEnabled: boolean = false;
  isAnalyticsFromEnabled: boolean = false;
  isDataextractorEnabled: boolean = false;
  isjdbcsourceFormEnabled: boolean = false;

  user_key_2: string = '';
  user_key_3: string = '';
  user_key_4: string = '';
  user_key_5: string = '';
  user_key_6: string = '';
  user_key_7: string = '';
  user_key_url_6: string = '';
  key_name_to_update_3: string = '';
  key_name_to_update_4: string = '';
  key_name_to_update_5: string = '';
  response_parameters_2: string = '';
  response_parameters_3: string = '';
  response_parameters_4: string = '';
  response_parameters_5: string = '';
  response_parameters_6: string = '';
  response_parameters_7: string = '';
  custom_pagination_script: string = '';
  another_response_parameter_2: string = '';

  operations = {};
  operationsSearch = {};
  search: any;
  searchFilter: boolean = false;
  searchOperations = [];
  blocks: Array<any> = []
  newBlocks = [];
  finalBlocks: Array<any> = []
  finalBlocksTmp: Array<any> = []
  filteredArray: Array<any> = []
  isOpsFromEnabled = false;
  formIndex: string = '';
  timertypeval: string = 'interval';
  submitted: boolean = false;
  isNewSource: boolean = false;
  isNewTarget: boolean = false;
  splitValue: number = 3;
  username = true;
  password = true;
  targetusername = true;
  targetpassword = true;
  datatargetusername = true;
  datatargetpassword = true;
  selectedProfileFileBlob;

  name = 'ng2-ckeditor';
  ckeConfig: any;
  // mycontent: string = 'this is home';
  log: string = '';
  @ViewChild("myckeditor") ckeditor: any;
  ckEditorConfig: any = {
    toolbar: [
      ['Source', 'Templates', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
      ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
      ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
      ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'],
      ['Link', 'Unlink', 'Anchor'],
      ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
      ['Styles', 'Format', 'Font', 'FontSize'],
      ['TextColor', 'BGColor'],
      ['ShowBlocks']
    ],
    fullPage: true,
    allowedContent: true,
    versionCheck: false
  };

  environmentSourceForm: UntypedFormGroup;
  environmentTargetForm: UntypedFormGroup;
  environmentData: any[] = [];
  valueType: string = 'text';
  environmentColumns: string[] = [
    'environment_name',
  ];
  environmentType = [
    { value: 'text', viewValue: 'Default' },
    { value: 'password', viewValue: 'Secret' },
  ];
  sourceTabs: string[] = [];
  targetTabs: string[] = [];
  selected: UntypedFormGroup = new UntypedFormGroup({});
  selectAfterAdding = true;
  env_name: string;
  selectedSourceTabIndex: number = 0;
  selectedTargetTabIndex: number = 0;
  newEnvName: string;
  selectedSourceEnvironment: string;
  selectedTargetEnvironment: string;

  body_source_raw_json: string = ""
  body_source_raw_xml: string = ""

  environmentForm: UntypedFormGroup;
  environmentRAOForm: UntypedFormGroup;
  showMenu = false;
  showTargetMenu = false;
  selectedTabIndex: number = 0;
  currentDisplayedEnvIndex: number = 0;
  currentDisplayedEnvIndexRAO: number = 0;
  currentTargetDisplayedEnvIndex: number = 0;
  showEnvironmentTab: boolean = false;
  showEnvironmentTabRAO: boolean = false;
  showTargetEnvironmentTab: boolean = false;
  selectedEnvTabs: string[] = [];
  selectedEnvTabsRAO: string[] = [];
  selectedTargetEnvTabs: string[] = [];
  catalogObj: any;
  catalogId: any;
  integrationDataSource = [];
  cartData: any = {};
  sourceCartId: any = '';
  opsCartId: any = '';
  targetCartId: any = '';
  isTesting: boolean = false;

  standalone = true;

  sourceTestApi: any;
  sourceDatabaseTestApi: any;
  sourceDatalakeTestApi: any;
  searchDatalakeTestApi :any;
  targetTestApi: any;
  targetRAOTestApi: any;
  targetDatabaseTestApi: any;
  operationPycodeApTestApi: any;
  operationDatabaseTestApi: any;

  spinnerSource: boolean = false;
  spinnerSourceDatabase: boolean = false;
  spinnerSourceDatalake: boolean = false;
  spinnerSearchDatalake: boolean = false;
  spinnerTargetRAO: boolean = false;
  spinnerOperationPycodeApi: boolean = false;
  spinnerOperationDatabase: boolean = false;
  spinnerTarget: boolean = false;
  spinnerTargetDatabase: boolean = false;

  spinnerSourceShow: boolean = false;
  spinnerSourceDatabaseShow: boolean = false;
  spinnerSourceDatalakeShow: boolean = false;
  spinnerSearchDatalakeShow: boolean = false;
  spinnerTargetRAOShow: boolean = false;
  spinnerOperationPycodeApiShow: boolean = false;
  spinnerOperationDatabaseShow: boolean = false;
  spinnerTargetShow: boolean = false;
  spinnerTargetDatabaseShow: boolean = false;

  index = 0;
  consoleDataArr = []
  consoleData = {
    operationName: '',
    data: ''
  }
  items = {
    'source': [
      {
        name: 'Request Header',
        subItems: []
      }, {
        name: 'Request Params',
        subItems: []
      }, {
        name: 'Request Body',
        subItems: []
      }, {
        name: 'Pre Request Script',
        subItems: []
      },
      {
        requestMethod: '',
        requestUrl: ''
      }], 'target': [
        {
          name: 'Request Header',
          subItems: []
        }, {
          name: 'Request Params',
          subItems: []
        }, {
          name: 'Request Body',
          subItems: []
        }, {
          name: 'Pre Request Script',
          subItems: []
        },
        {
          requestMethod: '',
          requestUrl: ''
        }]
  };
  visibleIndex = -1
  copyPreviewData: any;
  copyPreviewDataSource:any;
  isPreviewRequestShow: boolean = true;
  milstoneAPIPayloadConfig = new Object()
  isConsole: boolean = false;
  //Output types for Email Source.
  email_out_types = [{ label: 'Text', value: 'text' }, { label: 'HTML', value: 'html' }, { label: 'Base64', value: 'base64' }]

  public webSocketSubscription: Subscription;
  wsresponse = [];
  hass_pass;
  wsconnect: boolean = false;
  wsconnectSpinner: boolean = false;
  pagination_retry_seconds: any;
  IndexNames:any;
  filteredTargetOptions: Observable<HeaderValue[]>;
  filteredDlSearchOptions: Observable<HeaderValue[]>;
  filteredDlIngestionOptions: Observable<HeaderValue[]>;

  contentDiv = document.getElementById('contentDiv');
  contentDivOps = document.getElementById('contentDivOps0');
  endpoint_url = "";
  params_key = [];
  contentDevSourceParamKey;
  params_value = [];
  contentDevSourceParamValue;
  headers_key = [];
  contentDevHeaderKey;
  headers_value = [];
  contentDevHeaderValue;
  source_auth = "";
  contentDevSourceAuth;
  // source_authUser = "";
  // contentDevSourceAuthUser;
  // source_authPassword = "";
  // contentDevSourceAuthPassword;
  ops_environment=[];//selectedSourceEnv
  source_environment = [];
  target_environment = [];
  contentDivTarget = document.getElementById('contentDivTarget');
  endpoint_target_url = "";
  params_target_key = [];
  contentDevTargetParam;
  params_target_value = [];
  contentDevTargetParamValue;
  headers_target_key = [];
  contentDevTargetHeaderKey;
  headers_target_value = [];
  contentDevTargetHeaderValue;
  target_auth = "";
  ops_auth=[];
  contentDevTargetAuth;
  source_authUser = "";
  // contentDevSourceAuthUser;
  hidden_user=""
  source_authPassword = "";
  // contentDevSourceAuthPassword;
  contentDevSourceAuthUser = document.getElementById('contentDevSourceAuthUser'); 
  contentDevSourceAuthPassword = document.getElementById('contentDevSourceAuthPassword'); 
  hidden_password=''
  target_authUser = "";
  contentDevTargetAuthUser = document.getElementById('contentDevTargetAuthUser'); 
  hidden_target_user=""
  target_authPassword = "";
  contentDevTargetAuthPassword=  document.getElementById('contentDevTargetAuthPassword');
  hidden_target_password="";
  endpoint_ops_url=[];
  ops_authUser = [];
  ops_authPassword = [];
  params_ops_key=[];
  params_ops_value=[];
  headers_ops_key=[];
  headers_ops_value=[];
  params_ops_raw={};
  headers_ops_raw ={};
  bridgeResponse: any;
  // target_authUser = "";
  // contentDevTargetAuthUser;
  // target_authPassword = "";
  // contentDevTargetAuthPassword;
  
  constructor(
    private backendService: BackendService, private searchService:SearchService,
    public breakpointObserver: BreakpointObserver,
    private _formBuilder: UntypedFormBuilder,
    public storage: Storage,
    private router: Router,
    public alertController: AlertController,
    private elRef: ElementRef,
    public helperService: HelperService,
    private sanitizer: DomSanitizer,
    private modalCtrl: ModalController,
    private routerOutlet: IonRouterOutlet,
    private _dialog: MatDialog,
    private clipboard: Clipboard,
    private webSocketService: WebSocketSourceService,
    private bottomSheet: MatBottomSheet,
    private _snackBar: MatSnackBar,
    private viewContainerRef: ViewContainerRef, 
    private cfr: ComponentFactoryResolver
  ) { }

  showSubItem(ind) {
    if (this.visibleIndex === ind) {
      this.visibleIndex = -1;
    } else {
      this.visibleIndex = ind;
    }
  }

  showBottomSheet(): void {
    this.bottomSheet.open(PostmanConsoleComponent, { disableClose: true, hasBackdrop: false });
  }

  ngOnInit() {
    this.searchService.loading$.subscribe(isLoading => {
      this.loader = isLoading;
    });
    this.getStorage().then((res)=>{
      if(!res.goldFinchGenerateAccessToken){
        this.helperService.generateToken().then((response_index)=>{
          this.IndexNames=response_index;
        })
      }
      else{
        this.helperService.getindexdetails().then((names)=>{
          this.IndexNames=names
        })
      }
    })
    this.helperService.getFromPageReset(true);
    this.parentNavigationHelpSubscription = this.helperService.parentNavigationHelpFunction$.subscribe((data) => {
      this.closetesturl(data);
      this.closetesturltarget(data);
    });
    this.helperService.getNavHelp().subscribe(toggle => {
      if (toggle) {
        this.closebubblecross();
      }
      this.getTimeZone();
    });

    this.sourcePostmanPreviewSubscription = this.helperService.sourcePostmanPreviewFunction$.subscribe((data) => {
      this.loadPostmanPreviewComponent(data, 'source');
    });
    this.targetPostmanPreviewSubscription = this.helperService.targetPostmanPreviewFunction$.subscribe((data) => {
      this.loadPostmanPreviewComponent(data, 'target');
    });

    // this.breakpointObserver.observe(['(min-width: 1600px)']).subscribe((state: BreakpointState) => {
    //   if (state.matches) {
    //     this.splitValue = 4;
    //     this.newBlocks = this.splitArr(this.finalBlocks, this.splitValue);
    //   } else {
    //     this.splitValue = 3;
    //     this.newBlocks = this.splitArr(this.finalBlocks, this.splitValue);
    //   }
    // });

    this.operationsArr.find(e => {
      if (e.code == 'TRSFR') {
        let __tmpArr = [];
        if (ops_restapi['bizdata_ops_datatypes']) __tmpArr.push(this.opsSegregation("bizdata_ops_datatypes"));
        if (ops_restapi['bizdata_ops_append']) __tmpArr.push(this.opsSegregation("bizdata_ops_append"));
        if (ops_restapi['bizdata_ops_titlecase']) __tmpArr.push(this.opsSegregation("bizdata_ops_titlecase"));
        if (ops_restapi['bizdata_ops_uppercase']) __tmpArr.push(this.opsSegregation("bizdata_ops_uppercase"));
        if (ops_restapi['bizdata_ops_lowercase']) __tmpArr.push(this.opsSegregation("bizdata_ops_lowercase"));
        if (ops_restapi['bizdata_ops_dataextractor']) __tmpArr.push(this.opsSegregation("bizdata_ops_dataextractor"));
        if (ops_restapi['bizdata_ops_trim']) __tmpArr.push(this.opsSegregation("bizdata_ops_trim"));
        if (ops_restapi['bizdata_ops_json2string']) __tmpArr.push(this.opsSegregation("bizdata_ops_json2string"));
        if (ops_restapi['bizdata_ops_string2json']) __tmpArr.push(this.opsSegregation("bizdata_ops_string2json"));
        if (ops_restapi['bizdata_ops_jsontoxml']) __tmpArr.push(this.opsSegregation("bizdata_ops_jsontoxml"));
        if (ops_restapi['bizdata_ops_xmltojson']) __tmpArr.push(this.opsSegregation("bizdata_ops_xmltojson"));
        if (ops_restapi['bizdata_ops_base64encoding']) __tmpArr.push(this.opsSegregation("bizdata_ops_base64encoding"));
        if (ops_restapi['bizdata_ops_base64decoding']) __tmpArr.push(this.opsSegregation("bizdata_ops_base64decoding"));
        if (ops_restapi['bizdata_ops_generatesequence']) __tmpArr.push(this.opsSegregation("bizdata_ops_generatesequence"));
        if (ops_restapi['bizdata_ops_toplevel']) __tmpArr.push(this.opsSegregation("bizdata_ops_toplevel"));
        if (ops_restapi['bizdata_ops_datetimestamp']) __tmpArr.push(this.opsSegregation("bizdata_ops_datetimestamp"));
        if (ops_restapi['bizdata_ops_repeatfirstrow']) __tmpArr.push(this.opsSegregation("bizdata_ops_repeatfirstrow"));
        if (ops_restapi['bizdata_ops_round']) __tmpArr.push(this.opsSegregation("bizdata_ops_round"));
        if (ops_restapi['bizdata_ops_calculater']) __tmpArr.push(this.opsSegregation("bizdata_ops_calculater"));
        if (ops_restapi['bizdata_ops_dateanalytics']) __tmpArr.push(this.opsSegregation("bizdata_ops_dateanalytics"));
        if (ops_restapi['bizdata_ops_pdfextractor']) __tmpArr.push(this.opsSegregation("bizdata_ops_pdfextractor"));
        if (ops_restapi['bizdata_ops_fileextractor']) __tmpArr.push(this.opsSegregation("bizdata_ops_fileextractor"));
        if (ops_restapi['bizdata_ops_arraycount']) __tmpArr.push(this.opsSegregation("bizdata_ops_arraycount"));
        if (ops_restapi['bizdata_ops_encodedecode']) __tmpArr.push(this.opsSegregation("bizdata_ops_encodedecode"));
        if (ops_restapi['bizdata_ops_zipfileinbase64']) __tmpArr.push(this.opsSegregation("bizdata_ops_zipfileinbase64"));
        if (ops_restapi['bizdata_ops_grokpattern']) __tmpArr.push(this.opsSegregation("bizdata_ops_grokpattern"));
        if (ops_restapi['bizdata_ops_rawsentencegenerator']) __tmpArr.push(this.opsSegregation("bizdata_ops_rawsentencegenerator"));
        if (ops_restapi['bizdata_ops_timeunits']) __tmpArr.push(this.opsSegregation("bizdata_ops_timeunits"));
        if (ops_restapi['bizdata_ops_datachunking']) __tmpArr.push(this.opsSegregation("bizdata_ops_datachunking"));
        if (ops_restapi['bizdata_ops_htmlextractor']) __tmpArr.push(this.opsSegregation("bizdata_ops_htmlextractor"));
        if (ops_restapi['bizdata_ops_json2avro']) __tmpArr.push(this.opsSegregation("bizdata_ops_json2avro"));
        if (ops_restapi['bizdata_ops_avro2json']) __tmpArr.push(this.opsSegregation("bizdata_ops_avro2json"));
        if (ops_restapi['bizdata_ops_extract2array']) __tmpArr.push(this.opsSegregation("bizdata_ops_extract2array"));
        e.blocks.push(...__tmpArr);
      } else
        if (e.code == 'WRGL') {
          let __tmpArr = [];
          if (ops_restapi['bizdata_ops_singletomultiline']) __tmpArr.push(this.opsSegregation("bizdata_ops_singletomultiline"));
          if (ops_restapi['bizdata_ops_dl2array']) __tmpArr.push(this.opsSegregation("bizdata_ops_dl2array"));
          if (ops_restapi['bizdata_ops_dl2json']) __tmpArr.push(this.opsSegregation("bizdata_ops_dl2json"));
          if (ops_restapi['bizdata_ops_json2dl']) __tmpArr.push(this.opsSegregation("bizdata_ops_json2dl"));
          if (ops_restapi['bizdata_ops_dataaggregation']) __tmpArr.push(this.opsSegregation("bizdata_ops_dataaggregation"));
          if (ops_restapi['bizdata_ops_pivot']) __tmpArr.push(this.opsSegregation("bizdata_ops_pivot"));
          if (ops_restapi['bizdata_ops_unpivot']) __tmpArr.push(this.opsSegregation("bizdata_ops_unpivot"));
          if (ops_restapi['bizdata_ops_singleline2tuple']) __tmpArr.push(this.opsSegregation("bizdata_ops_singleline2tuple"));
          if (ops_restapi['bizdata_ops_tuple2singleline']) __tmpArr.push(this.opsSegregation("bizdata_ops_tuple2singleline"));
          e.blocks.push(...__tmpArr);
        } else
          if (e.code == 'ORCSTR') {
            let __tmpArr = [];
            // if (ops_restapi['bizdata_ops_file']) __tmpArr.push(this.opsSegregation("bizdata_ops_file"));
            if (ops_restapi['bizdata_ops_jdbcoutput']) __tmpArr.push(this.opsSegregation("bizdata_ops_jdbcoutput"));
            if (ops_restapi['bizdata_ops_email']) __tmpArr.push(this.opsSegregation("bizdata_ops_email"));
            if (ops_restapi['bizdata_ops_restapitarget']) __tmpArr.push(this.opsSegregation("bizdata_ops_restapitarget"));
            if (ops_restapi['bizdata_ops_dlakeingestion']) __tmpArr.push(this.opsSegregation("bizdata_ops_dlakeingestion"));
            if (ops_restapi['bizdata_ops_dlsearch']) __tmpArr.push(this.opsSegregation("bizdata_ops_dlsearch"));
            e.blocks.push(...__tmpArr);
          } else
            if (e.code == 'CLENG') {
              let __tmpArr = [];
              if (ops_restapi['bizdata_ops_dropeventsstartswith']) __tmpArr.push(this.opsSegregation("bizdata_ops_dropeventsstartswith"));
              if (ops_restapi['bizdata_ops_dropalleventvalues']) __tmpArr.push(this.opsSegregation("bizdata_ops_dropalleventvalues"));
              if (ops_restapi['bizdata_ops_eliminate']) __tmpArr.push(this.opsSegregation("bizdata_ops_eliminate"));
              // if (ops_restapi['bizdata_ops_round']) __tmpArr.push(this.opsSegregation("bizdata_ops_round"));
              // if (ops_restapi['bizdata_ops_calculater']) __tmpArr.push(this.opsSegregation("bizdata_ops_calculater"));
              // if (ops_restapi['bizdata_ops_dateanalytics']) __tmpArr.push(this.opsSegregation("bizdata_ops_dateanalytics"));
              if (ops_restapi['bizdata_ops_substitute']) __tmpArr.push(this.opsSegregation("bizdata_ops_substitute"));
              if (ops_restapi['bizdata_ops_rename']) __tmpArr.push(this.opsSegregation("bizdata_ops_rename"));
              if (ops_restapi['bizdata_ops_strip']) __tmpArr.push(this.opsSegregation("bizdata_ops_strip"));
              if (ops_restapi['bizdata_ops_substring']) __tmpArr.push(this.opsSegregation("bizdata_ops_substring"));
              e.blocks.push(...__tmpArr);
            } else
              if (e.code == 'PIPECTRL') {
                let __tmpArr = [];
                if (ops_restapi['bizdata_ops_sleeptime']) __tmpArr.push(this.opsSegregation("bizdata_ops_sleeptime"));
                if (ops_restapi['bizdata_ops_pycode']) __tmpArr.push(this.opsSegregation("bizdata_ops_pycode"));
                if (ops_restapi['bizdata_ops_aiops']) __tmpArr.push(this.opsSegregation("bizdata_ops_aiops"));
                if (ops_restapi['bizdata_ops_filter']) __tmpArr.push(this.opsSegregation("bizdata_ops_filter"));
                if (ops_restapi['bizdata_ops_filterends']) __tmpArr.push(this.opsSegregation("bizdata_ops_filterends"));
                e.blocks.push(...__tmpArr);
              } else {
                if (e.code == 'DEEPLRG') {
                  let __tmpArr = [];
                  if (ops_restapi['bizdata_ops_docunderstanding']) __tmpArr.push(this.opsSegregation("bizdata_ops_docunderstanding"));
                  if (ops_restapi['bizdata_ops_imgunderstanding']) __tmpArr.push(this.opsSegregation("bizdata_ops_imgunderstanding"));
                  e.blocks.push(...__tmpArr);
                }

              }
    })

    this.incomingSearchText$.pipe(debounceTime(500)).subscribe((value) => {
      this.search = value;
      this.searchOps(this.search);
    });
    //---------------------Storing the Transformation key from response-------------------//
    // if(this.bizdata_ops_datatypes_obj.hasOwnProperty('source') || this.bizdata_ops_datatypes_obj.hasOwnProperty('target')){

    // }
    // this.bizdata_ops_datatypes_obj = this.helperService.removeSourceTargetTag([Object.keys(ops_restapi['bizdata_ops_datatypes'])])

    this.bizdata_ops_datatypes_obj = Object.keys(ops_restapi['bizdata_ops_datatypes']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_datatypes_obj)
    // for( var i = 0; i <  this.bizdata_ops_datatypes_obj.length; i++){
    //   if (  this.bizdata_ops_datatypes_obj[i] == 'source') {
    //     this.bizdata_ops_datatypes_obj.splice(i, 1);
    //   }
    //   if (  this.bizdata_ops_datatypes_obj[i] == 'target') {
    //     this.bizdata_ops_datatypes_obj.splice(i, 1);
    //   }
    // }
    this.bizdata_ops_titlecase_obj = Object.keys(ops_restapi['bizdata_ops_titlecase']);
    for (var i = 0; i < this.bizdata_ops_titlecase_obj.length; i++) {
      if (this.bizdata_ops_titlecase_obj[i] == 'source') {
        this.bizdata_ops_titlecase_obj.splice(i, 1);
      }
      if (this.bizdata_ops_titlecase_obj[i] == 'target') {
        this.bizdata_ops_titlecase_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_append_obj = Object.keys(ops_restapi['bizdata_ops_append']);
    for (var i = 0; i < this.bizdata_ops_append_obj.length; i++) {
      if (this.bizdata_ops_append_obj[i] == 'source') {
        this.bizdata_ops_append_obj.splice(i, 1);
      }
      if (this.bizdata_ops_append_obj[i] == 'target') {
        this.bizdata_ops_append_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_uppercase_obj = Object.keys(ops_restapi['bizdata_ops_uppercase']);
    for (var i = 0; i < this.bizdata_ops_uppercase_obj.length; i++) {
      if (this.bizdata_ops_uppercase_obj[i] == 'source') {
        this.bizdata_ops_uppercase_obj.splice(i, 1);
      }
      if (this.bizdata_ops_uppercase_obj[i] == 'target') {
        this.bizdata_ops_uppercase_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_lowercase_obj = Object.keys(ops_restapi['bizdata_ops_lowercase']);
    for (var i = 0; i < this.bizdata_ops_lowercase_obj.length; i++) {
      if (this.bizdata_ops_lowercase_obj[i] == 'source') {
        this.bizdata_ops_lowercase_obj.splice(i, 1);
      }
      if (this.bizdata_ops_lowercase_obj[i] == 'target') {
        this.bizdata_ops_lowercase_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_dataextractor_obj = Object.keys(ops_restapi['bizdata_ops_dataextractor']);
    for (var i = 0; i < this.bizdata_ops_dataextractor_obj.length; i++) {
      if (this.bizdata_ops_dataextractor_obj[i] == 'source') {
        this.bizdata_ops_dataextractor_obj.splice(i, 1);
      }
      if (this.bizdata_ops_dataextractor_obj[i] == 'target') {
        this.bizdata_ops_dataextractor_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_base64decoding_obj = Object.keys(ops_restapi['bizdata_ops_base64decoding']);
    for (var i = 0; i < this.bizdata_ops_base64decoding_obj.length; i++) {
      if (this.bizdata_ops_base64decoding_obj[i] == 'source') {
        this.bizdata_ops_base64decoding_obj.splice(i, 1);
      }
      if (this.bizdata_ops_base64decoding_obj[i] == 'target') {
        this.bizdata_ops_base64decoding_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_trim_obj = Object.keys(ops_restapi['bizdata_ops_trim']);
    for (var i = 0; i < this.bizdata_ops_trim_obj.length; i++) {
      if (this.bizdata_ops_trim_obj[i] == 'source') {
        this.bizdata_ops_trim_obj.splice(i, 1);
      }
      if (this.bizdata_ops_trim_obj[i] == 'target') {
        this.bizdata_ops_trim_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_base64encoding_obj = Object.keys(ops_restapi['bizdata_ops_base64encoding']);
    for (var i = 0; i < this.bizdata_ops_base64encoding_obj.length; i++) {
      if (this.bizdata_ops_base64encoding_obj[i] == 'source') {
        this.bizdata_ops_base64encoding_obj.splice(i, 1);
      }
      if (this.bizdata_ops_base64encoding_obj[i] == 'target') {
        this.bizdata_ops_base64encoding_obj.splice(i, 1);
      }
    }

    this.bizdata_ops_generatesequence_obj = Object.keys(ops_restapi['bizdata_ops_generatesequence']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_generatesequence_obj)
    this.bizdata_ops_json2string_obj = Object.keys(ops_restapi['bizdata_ops_json2string']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_json2string_obj)
    this.bizdata_ops_string2json_obj = Object.keys(ops_restapi['bizdata_ops_string2json']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_string2json_obj)
    this.bizdata_ops_toplevel_obj = Object.keys(ops_restapi['bizdata_ops_toplevel']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_toplevel_obj)
    this.bizdata_ops_datetimestamp_obj = Object.keys(ops_restapi['bizdata_ops_datetimestamp']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_datetimestamp_obj)
    this.bizdata_ops_jsontoxml_obj = Object.keys(ops_restapi['bizdata_ops_jsontoxml']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_jsontoxml_obj)
    this.bizdata_ops_xmltojson_obj = Object.keys(ops_restapi['bizdata_ops_xmltojson']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_xmltojson_obj)
    this.bizdata_ops_repeatfirstrow_obj = Object.keys(ops_restapi['bizdata_ops_repeatfirstrow']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_repeatfirstrow_obj)
    this.bizdata_ops_encodedecode_obj = Object.keys(ops_restapi['bizdata_ops_encodedecode']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_encodedecode_obj)
    this.bizdata_ops_zipfileinbase64_obj = Object.keys(ops_restapi['bizdata_ops_zipfileinbase64']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_zipfileinbase64_obj)
    this.bizdata_ops_arraycount_obj = Object.keys(ops_restapi['bizdata_ops_arraycount']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_arraycount_obj)
    this.bizdata_ops_pdfextractor_obj = Object.keys(ops_restapi['bizdata_ops_pdfextractor']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_pdfextractor_obj)
    this.bizdata_ops_fileextractor_obj = Object.keys(ops_restapi['bizdata_ops_fileextractor']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_fileextractor_obj)
    this.bizdata_ops_grokpattern_obj = Object.keys(ops_restapi['bizdata_ops_grokpattern']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_grokpattern_obj)
    this.bizdata_ops_rawsentencegenerator_obj = Object.keys(ops_restapi['bizdata_ops_rawsentencegenerator']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_rawsentencegenerator_obj)
    this.bizdata_ops_timeunits_obj = Object.keys(ops_restapi['bizdata_ops_timeunits']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_timeunits_obj)
    this.bizdata_ops_datachunking_obj = Object.keys(ops_restapi['bizdata_ops_datachunking']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_datachunking_obj)
    this.bizdata_ops_json2avro_obj = Object.keys(ops_restapi['bizdata_ops_json2avro']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_json2avro_obj)
    this.bizdata_ops_htmlextractor_obj = Object.keys(ops_restapi['bizdata_ops_htmlextractor']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_htmlextractor_obj)
    this.bizdata_ops_avro2json_obj = Object.keys(ops_restapi['bizdata_ops_avro2json']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_avro2json_obj)
    this.bizdata_ops_extract2array_obj = Object.keys(ops_restapi['bizdata_ops_extract2array']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_extract2array_obj);
    //---------------------------------------------------------------------------------------------//
    //-------------------------Wrangling----------------------------------------------------------//
    this.bizdata_ops_dl2json_obj = Object.keys(ops_restapi['bizdata_ops_dl2json']);
    for (var i = 0; i < this.bizdata_ops_dl2json_obj.length; i++) {
      if (this.bizdata_ops_dl2json_obj[i] == 'source') {
        this.bizdata_ops_dl2json_obj.splice(i, 1);
      }
      if (this.bizdata_ops_dl2json_obj[i] == 'target') {
        this.bizdata_ops_dl2json_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_json2dl_obj = Object.keys(ops_restapi['bizdata_ops_json2dl']);
    for (var i = 0; i < this.bizdata_ops_json2dl_obj.length; i++) {
      if (this.bizdata_ops_json2dl_obj[i] == 'source') {
        this.bizdata_ops_json2dl_obj.splice(i, 1);
      }
      if (this.bizdata_ops_json2dl_obj[i] == 'target') {
        this.bizdata_ops_json2dl_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_dataaggregation_obj = Object.keys(ops_restapi['bizdata_ops_dataaggregation']);
    for (var i = 0; i < this.bizdata_ops_dataaggregation_obj.length; i++) {
      if (this.bizdata_ops_dataaggregation_obj[i] == 'source') {
        this.bizdata_ops_dataaggregation_obj.splice(i, 1);
      }
      if (this.bizdata_ops_dataaggregation_obj[i] == 'target') {
        this.bizdata_ops_dataaggregation_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_pivot_obj = Object.keys(ops_restapi['bizdata_ops_pivot']);
    for (var i = 0; i < this.bizdata_ops_pivot_obj.length; i++) {
      if (this.bizdata_ops_pivot_obj[i] == 'source') {
        this.bizdata_ops_pivot_obj.splice(i, 1);
      }
      if (this.bizdata_ops_pivot_obj[i] == 'target') {
        this.bizdata_ops_pivot_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_unpivot_obj = Object.keys(ops_restapi['bizdata_ops_unpivot']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_unpivot_obj)
    this.bizdata_ops_singletomultiline_obj = Object.keys(ops_restapi['bizdata_ops_singletomultiline']);
    for (var i = 0; i < this.bizdata_ops_singletomultiline_obj.length; i++) {
      if (this.bizdata_ops_singletomultiline_obj[i] == 'source') {
        this.bizdata_ops_singletomultiline_obj.splice(i, 1);
      }
      if (this.bizdata_ops_singletomultiline_obj[i] == 'target') {
        this.bizdata_ops_singletomultiline_obj.splice(i, 1);
      }
    }
    this.bizdata_ops_singleline2tuple_obj = Object.keys(ops_restapi['bizdata_ops_singleline2tuple']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_singleline2tuple_obj)
    this.bizdata_ops_tuple2singleline_obj = Object.keys(ops_restapi['bizdata_ops_tuple2singleline']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_tuple2singleline_obj)
    this.bizdata_ops_dl2array_obj = Object.keys(ops_restapi['bizdata_ops_dl2array']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dl2array_obj)
    //---------------------------------------------------------------------------------------------//
    // this.bizdata_ops_file_obj = Object.keys(ops_restapi['bizdata_ops_file']);
    // this.helperService.removeSourceTargetTag(this.bizdata_ops_file_obj)
    this.bizdata_ops_email_obj = Object.keys(ops_restapi['bizdata_ops_email']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_email_obj)
    this.bizdata_ops_restapi_obj = Object.keys(ops_restapi['bizdata_ops_restapi']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_restapi_obj)
    this.bizdata_ops_dropeventsstartswith_obj = Object.keys(ops_restapi['bizdata_ops_dropeventsstartswith']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dropeventsstartswith_obj)
    this.bizdata_ops_dropalleventvalues_obj = Object.keys(ops_restapi['bizdata_ops_dropalleventvalues']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dropalleventvalues_obj)
    this.bizdata_ops_eliminate_obj = Object.keys(ops_restapi['bizdata_ops_eliminate']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_eliminate_obj)
    this.bizdata_ops_round_obj = Object.keys(ops_restapi['bizdata_ops_round']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_round_obj)
    this.bizdata_ops_calculater_obj = Object.keys(ops_restapi['bizdata_ops_calculater']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_calculater_obj)
    this.bizdata_ops_dateanalytics_obj = Object.keys(ops_restapi['bizdata_ops_dateanalytics']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dateanalytics_obj)
    this.bizdata_ops_substitute_obj = Object.keys(ops_restapi['bizdata_ops_substitute']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_substitute_obj)
    this.bizdata_ops_strip_obj = Object.keys(ops_restapi['bizdata_ops_strip']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_strip_obj)
    this.bizdata_ops_substring_obj = Object.keys(ops_restapi['bizdata_ops_substring']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_substring_obj)
    this.bizdata_ops_rename_obj = Object.keys(ops_restapi['bizdata_ops_rename']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_rename_obj)
    this.bizdata_ops_sleeptime_obj = Object.keys(ops_restapi['bizdata_ops_sleeptime']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_sleeptime_obj)
    this.bizdata_ops_pycode_obj = Object.keys(ops_restapi['bizdata_ops_pycode']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_pycode_obj)
    this.bizdata_ops_aiops_obj = Object.keys(ops_restapi['bizdata_ops_aiops']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_aiops_obj)
    this.bizdata_ops_filter_obj = Object.keys(ops_restapi['bizdata_ops_filter']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_filter_obj)
    this.bizdata_ops_filterends_obj = Object.keys(ops_restapi['bizdata_ops_filterends']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_filterends_obj)

    this.bizdata_ops_jdbcoutput_obj = Object.keys(ops_restapi['bizdata_ops_jdbcoutput']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_jdbcoutput_obj)
    this.bizdata_ops_postgres_obj = Object.keys(ops_restapi['bizdata_ops_postgres']);
    this.bizdata_ops_replacinganyvalue_obj = Object.keys(ops_restapi['bizdata_ops_replacinganyvalue']);
    this.bizdata_ops_restapitarget_obj = Object.keys(ops_restapi['bizdata_ops_restapitarget']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_restapitarget_obj)
    this.bizdata_ops_dlakeingestion_obj = Object.keys(ops_restapi['bizdata_ops_dlakeingestion']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dlakeingestion_obj)
    this.bizdata_ops_dlsearch_obj = Object.keys(ops_restapi['bizdata_ops_dlsearch']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_dlsearch_obj)
    this.bizdata_ops_analytics_obj = Object.keys(ops_restapi['bizdata_ops_analytics']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_analytics_obj)
    this.bizdata_ops_docunderstanding_obj = Object.keys(ops_restapi['bizdata_ops_docunderstanding']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_docunderstanding_obj)
    this.bizdata_ops_imgunderstanding_obj = Object.keys(ops_restapi['bizdata_ops_imgunderstanding']);
    this.helperService.removeSourceTargetTag(this.bizdata_ops_imgunderstanding_obj)

    let operations = [];
    this.operationsArr.map((item) => {
      operations.push(...item.blocks);
    })
    this.operations = { 'blockArr': operations };
    this.operationsArrSearch = _.cloneDeep(this.operationsArr);
    let operationsSearch = [];
    this.operationsArrSearch.map((item) => {
      operationsSearch.push(...item.blocks);
    })
    this.operationsSearch = { 'blockArr': operationsSearch };
    //console.log(this.operationsArr);
    // //console.log(ops_restapi)
    this.stepperOrientation = this.breakpointObserver.observe('(min-width: 800px)').pipe(map(({ matches }) => matches ? 'horizontal' : 'vertical'));
    this.operationParam = ["parameter-1", "parameter-2", "parameter-3", "parameter-4"]
    this.breakpointObserver.observe(['(min-width: 1024px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1024 = true;
      } else {
        this.hide1024 = false;
      }
      this.getStorage().then((res) => {
        if (res.showDialog == 1) {
          this.bubbleshow = true;
        } else {
          this.bubbleshow = false;
        }
      })
    });

    this.getUserIp();

    this.dataSource = this._formBuilder.group({
      'bridge_source_type': ['', Validators.required],
      'bridge_source': ['', Validators.required],
      'bridge_source_business_object': ["", Validators.required],
      'bridge_source_endpoint_method': [''],
      'bridge_source_endpoint_url': [''],
      'bridge_source_endpoint_params_raw': new UntypedFormArray([]),
      'bridge_source_endpoint_headers': new UntypedFormArray([]),
      'bridge_source_endpoint_authentication_type': [''],
      'bridge_source_endpoint_body_raw': [''],
      'pre_request_script': [''],
      'bridge_source_response': [{},[]],
      'bridge_source_pagination_type': [''],
      'bridge_source_body_type': ['TEXT'],
      'response_parameters_2': [''],
      'another_response_parameter_2': [''],
      'pagination_retry_seconds': [5],
      'user_key_2': [''],
      'user_key_3': [''],
      'key_name_to_update_3': [''],
      'response_parameters_3': [''],
      'user_key_4': [''],
      'key_name_to_update_4': [''],
      'response_parameters_4': [''],
      'user_key_5': [''],
      'key_name_to_update_5': [''],
      'response_parameters_5': [''],
      'user_key_6': [''],
      'user_key_url_6': [''],
      'response_parameters_6': [''],
      'user_key_7': [''],
      'response_parameters_7': [''],
      'custom_pagination_script': [''],
      'min_number': [0],
      'max_number': [1000],
      'today_str': ['%Y-%m-%dT00:00:01Z'],
      'yesterday_str': ['%Y-%m-%dT00:00:01Z'],
      'rolling_time_format': ['%Y-%m-%dT%H:%M:00.000'],
      'rolling_frequency': [900],
      'offset_value': [0],
      'bridge_source_endpoint_selected_environments_name': [''],
      'response_type': ['text']
    });
    this.dataSource.controls['bridge_source_type'].setValue(this.bridgeSourceType[0]);
    this.bridge_source_type = 1;
    this.environmentForm = this._formBuilder.group({
      selected_environment: ['No Environment'],
      bridge_endpoint_selected_environments_name: ['', Validators.required],
      bridge_endpoint_environments_raw: this._formBuilder.array([]),
    });

    this.environmentTargetForm = this._formBuilder.group({
      selected_environment: ['No Environment'],
      bridge_endpoint_selected_environments_name: ['', Validators.required],
      bridge_endpoint_environments_raw: this._formBuilder.array([]),
    });

    this.environmentRAOForm = this._formBuilder.group({
      selected_environment: ['No Environment'],
      bridge_endpoint_selected_environments_name: ['', Validators.required],
      bridge_endpoint_environments_raw: this._formBuilder.array([]),
    });
    // this.dataOperations = this._formBuilder.group({
    //   // secondCtrl: ['', Validators.required],
    // });
    this.restAPIForm();
    this.dataTarget = this._formBuilder.group({
      'bridge_target_type': ['1', Validators.required],
      'bridge_target': ['', Validators.required],
      'bridge_target_business_object': ["", Validators.required],
      'bridge_target_endpoint_method': [''],
      'bridge_target_endpoint_url': [''],
      'bridge_target_endpoint_params_raw': new UntypedFormArray([]),
      'bridge_target_endpoint_headers': new UntypedFormArray([]),
      'bridge_target_endpoint_authentication_type': [''],
      'bridge_target_body_type': ['TEXT'],
      'bridge_target_endpoint_body_raw': [''],
      'pre_request_script': [''],
      'bridge_target_response': [{},[]],
      'bridge_target_endpoint_selected_environments_name': [''],
      'response_type': ['text'],
      'datalake_id': ['']
    });
    (<UntypedFormGroup>this.dataTarget).controls['bridge_target_type'].setValue(1);
    this.dataTarget.controls['bridge_target_type'].setValue(this.bridgeTargetType[0]);
    this.bridge_target_type = 1;
    this.mapping = this._formBuilder.group({
      // secondCtrl: ['', Validators.required],
    });

    this.summary = this._formBuilder.group({
      'bridge_name': [''],
      'bridge_description': ['', Validators.required],
      'timertype': [''],
      'interval': [''],
      'schedule': [''],
      'time_zone': [''],
      'toggle': [0],
      'sbs': [1000, [Validators.min(1)]],
      'now': ['1'],
      'srwt': [4000, [Validators.min(4000), Validators.max(10000)]],
      'logsize': [20, [Validators.min(20)]]
    })

    this.editorSourceOptions = new JsonEditorOptions()
    this.editorSourceOptions.mode = 'code'; //set only one mode
    this.editorSourceOptions.mainMenuBar = false;
    this.editorSourceOptions.onEditable=(Node):boolean=>{
      return false;
    }

    this.editorTargetOptions = new JsonEditorOptions()
    this.editorTargetOptions.mode = 'code'; //set only one mode
    this.editorTargetOptions.mainMenuBar = false;
    this.editorTargetOptions.onEditable=(Node):boolean=>{
      return false;
    }

    this.appendoptions = new JsonEditorOptions()
    this.appendoptions.mode = 'code'; //set only one mode
    this.appendoptions.mainMenuBar = false;

    this.renameoptions = new JsonEditorOptions()
    this.renameoptions.mode = 'code'; //set only one mode
    this.renameoptions.mainMenuBar = false;

    this.singletomultioptions = new JsonEditorOptions()
    this.singletomultioptions.mode = 'code'; //set only one mode
    this.singletomultioptions.mainMenuBar = false;

    this.editor2Options = new JsonEditorOptions()
    this.editor2Options.mode = 'view'; //set only one mode
    this.editor2Options.mainMenuBar = false;

    this.getStorage().then((res) => {
      // GET API METHODS
      this.getMethod(res.token).then((method_list) => {
        this.methodList = method_list;
        let bridge_endpoint_metho_source = this.methodList.filter(function (entry) { return entry.id === 1 });
        this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_endpoint_metho_source[0]);

        let bridge_endpoint_method_target = this.methodList.filter(function (entry) { return entry.id === 1 });
        this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_endpoint_method_target[0]);

        // GET API AUTH TYPE
        this.getAuth(res.token).then((auth_list) => {
          this.authenticationSourceTypeOptions = auth_list;
          this.authenticationTargetTypeOptions = auth_list;
          let endpoint_authentication_type_source = this.authenticationSourceTypeOptions.filter(function (entry) { return entry.id === 1 });
          this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(endpoint_authentication_type_source[0]);

          let endpoint_authentication_type_target = this.authenticationTargetTypeOptions.filter(function (entry) { return entry.id === 1 });
          this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(endpoint_authentication_type_target[0]);
        })
      })

      this.dataSource.controls['bridge_source_pagination_type'].setValue(this.paginationTypeOptions[0]);

      // *************************
      // Load products with brand for source data
      // *************************
      this.getDataSource().then(res => {
        let data: [] = res as [];
        this.bridgeSourceList = data;
        this.bridgeSourceProduct$ = this.dataSource.get('bridge_source')!.valueChanges.pipe(
          startWith(''),
          map(value => {
            this.enableDataSourceClearIcon = value ? true : false;
            return this._filterMapSource(value || '')
          }),
        );
      });

      // *************************
      // Load products with brand for target data
      // *************************
      this.getDataTarget().then(res => {
        let data: [] = res as [];
        this.bridgeTargetList = data;
        this.bridgeTarget$ = this.dataTarget.get('bridge_target')!.valueChanges.pipe(
          startWith(''),
          map(value => {
            this.enableDataTargetClearIcon = value ? true : false;
            return this._filterMapTarget(value || '')
          }),
        );
      });

      // *************************
      // Load storage name for jdbc operation
      // *************************
      this.getStorageNameJDBCO().then(res => {
        let data: [] = res as [];
        this.storageNameJDBCOList = data;
      });

      // this.getHeader_Keys().then(res => {
      //   let data: [] = res as [];
      //   this.bridgeSourceHeaderValueList = data;
      //   // //console.log(data, this.bridgeSourceHeaderValueList)
      // });

      this.getSourceDlVersionDL().then(res => {
        let data: [] = res as [];
        this.sourceVerisonListDL = data;
      });
      this.getDlVersionDLO().then(res => {
        let data: [] = res as [];
        this.verisonListDLO = data;
        this.targetVerisonListDL = data;
      });
      this.getDlVersionDLS().then(res => {
        let data: [] = res as [];
        this.verisonListDLS = data;
      });
    })

    this.addSourceParams(0);
    this.addSourceHeaders(0);
    this.addTargetParams(0);
    this.addTargetHeaders(0);

    this.summary.patchValue({ schedule: '* * * * *' });
    this.summary.patchValue({ interval: 60 });

    this.webSocketSubscription = this.webSocketService.getMessages().subscribe({
      next: (message) => {
        this.wsconnectSpinner = false;
        this.wsconnect = true;
        this.wsresponse.push(JSON.parse(message.data));
        this.dataSource.controls['bridge_source_response'].setValue(this.wsresponse);
      }
    })
    this._appendScriptEditor?.codeMirror.setOption('mode', 'javascript');
  }

  showConsole:boolean = false;
  ionViewDidEnter() {
    setTimeout(() => {
      this.showConsole = true;
    }, 1000);
  };

  addEnter(i:number){
    this.aiopsRows().controls[i].get('question').patchValue(this.aiopsRows().controls[i].get('question').value+'\n');
  }

  ngAfterViewInit() {
    let observer = new IntersectionObserver((entries) => {
      let boxes = Array.from(
        document.getElementsByClassName('cdk-overlay-connected-position-bounding-box') as HTMLCollectionOf<HTMLElement>,
      );
      //console.log(boxes);
      if (entries[0].boundingClientRect.top < 64) {
        boxes.forEach(box => {
          box.style.marginTop = '64px';
          box.style.overflow = 'hidden';
        });
      } else {
        // //console.log(entries[0].boundingClientRect.top);
        boxes.forEach(box => {
          box.style.marginTop = '0px';
          box.style.overflow = 'auto';
        });
      }
    }, { threshold: [0] });

    // observer.observe(this.autoCompleteFormField._elementRef.nativeElement);

    let observer1 = new IntersectionObserver((entries) => {
      let boxesTarget = Array.from(
        document.getElementsByClassName('cdk-overlay-connected-position-bounding-box') as HTMLCollectionOf<HTMLElement>,
      );
      if (entries[0].boundingClientRect.top < 70) {
        boxesTarget.forEach(box => {
          box.style.marginTop = "70px";
          box.style.overflow = 'hidden';
        });
      } else {
        boxesTarget.forEach(box => {
          box.style.marginTop = '0px';
          box.style.overflow = 'auto';
        });
      }
      // this.autocomplete.closePanel();        
    }, { threshold: [1] });
    // observer1.observe(this.autoCompleteFormFieldTarget._elementRef.nativeElement);
    this.ionViewDidEnter();
  }

  
  private getMethod(token: string) {
    return new Promise((resolve) => {
      this.backendService.GetAPICall('getMethod', token).subscribe(
        method_res => {
          // let bridge_endpoint_method = method_res.filter(function (entry) { return entry.id === 1 });
          // if (this.bridge_source_type == 1) {
          //   this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_endpoint_method[0]);
          // }
          // if (this.bridge_target_type == 1) {
          //   this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_endpoint_method[0]);
          // }
          resolve(method_res)
        })
    })
  }

  private getAuth(token: string) {
    return new Promise((resolve) => {
      this.backendService.GetAPICall('getAuth', token).subscribe(
        auth_res => {
          // let endpoint_authentication_type = auth_res.filter(function (entry) { return entry.id === 1 });
          // if (this.bridge_source_type == 1) {
          //   this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(endpoint_authentication_type[0]);
          // }
          // if (this.bridge_target_type == 1) {
          //   this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(endpoint_authentication_type[0]);
          // }
          resolve(auth_res)
        })
    })
  }

  private _filterMapSource(value: string): ProductGroup[] {
    return this.bridgeSourceList
      .map(res => ({ brand_name: res.brand_name, products: filterSource(res.products, value) }))
      .filter(res => res.products.length > 0);
  }

  private _filterMapTarget(value: string): ProductGroup[] {
    return this.bridgeTargetList
      .map(res => ({ brand_name: res.brand_name, products: filterSource(res.products, value) }))
      .filter(res => res.products.length > 0);
  }

  private _filterMapSourceBusinessObject(value: string): BusinessObject[] {
    const filterValue = value.toLowerCase();
    return this.bridgeSourceBusinessObjectList.filter(option => option.business_obj.toLowerCase().includes(filterValue));
  }

  private _filterMapTargetBusinessObject(value: string): BusinessObject[] {
    const filterValue = value.toLowerCase();
    return this.bridgeTargetBusinessObjectList.filter(option => option.business_obj.toLowerCase().includes(filterValue));
  }

  private _filterMapTimeZone(value: string): TimeZone[] {
    //console.log(value)
    const filterValue = value.toLowerCase();
    return this.timezoneList.filter(option => option.timezone.toLowerCase().includes(filterValue));
  }

  private _filterMapSourceHeaderkey(value: string): HeaderKey[] {
    //console.log(value)
    const filterValue = value.toLowerCase();
    return this.sourceHeaderKeyList.filter(option => option.header_key.toLowerCase().includes(filterValue));
  }

  private _filterMapTargetHeaderkey(value: string): HeaderKey[] {
    const filterValue = value.toLowerCase();
    return this.targetHeaderKeyList.filter(option => option.header_key.toLowerCase().includes(filterValue));
  }

  private _filterMapAPIOperationHeaderkey(value: string): HeaderKey[] {
    const filterValue = value.toLowerCase();
    return this.apiOperationHeaderKeyList.filter(option => option.header_key.toLowerCase().includes(filterValue));
  }

  private _filterMapSourceHeaderValue(value: string): HeaderValue[] {
    const filterValue = value.toLowerCase();
    return this.sourceHeaderValueList.filter(option => option.header_value.toLowerCase().includes(filterValue));
  }

  private _filterMapTargetHeaderValue(value: string): HeaderValue[] {
    const filterValue = value.toLowerCase();
    return this.targetHeaderValueList.filter(option => option.header_value.toLowerCase().includes(filterValue));
  }

  private _filterMapAPIOperationHeaderValue(value: string): HeaderValue[] {
    const filterValue = value.toLowerCase();
    return this.apiOperationHeaderValueList.filter(option => option.header_value.toLowerCase().includes(filterValue));
  }

  private _IndexNamesOperationHeaderValue(value: string): HeaderValue[] {
    const filterValue = value.toLowerCase();
    return this.IndexNames?.filter(option => option.toLowerCase().includes(filterValue));
  }

  displayFnBusinessObject(value: BusinessObject): string {
    return value && value.business_obj ? value.business_obj : '';
  }

  displayFnSourceHeaderKey(value: HeaderKey): string {
    return value && value.header_key ? value.header_key : '';
  }

  displayFnTargetHeaderKey(value: HeaderKey): string {
    return value && value.header_key ? value.header_key : '';
  }

  displayFnAPIOperationtHeaderKey(value: HeaderKey): string {
    return value && value.header_key ? value.header_key : '';
  }

  displayFnSourceHeaderValue(value: HeaderValue): string {
    return value && value.header_value ? value.header_value : '';
  }

  displayFnTargetHeaderValue(value: HeaderValue): string {
    return value && value.header_value ? value.header_value : '';
  }

  displayFnAPIOperationHeaderValue(value: HeaderValue): string {
    return value && value.header_value ? value.header_value : '';
  }


  displayFnTimeZone(value: TimeZone): string {
    return value && value.timezone ? value.timezone : '';
  }

  displayIndexName(value: string): string {
    return value ? value : '';
  }
  copyResponse(responseData) {
    //++++++++Copy as a string (single line)++++++++++++
    // const elem = document.createElement('textarea');
    // if (type == 'json') {
    //   elem.value = JSON.stringify(responseData);
    // } else {
    //   elem.value = responseData;
    // }
    // document.body.appendChild(elem);
    // elem.select();
    // document.execCommand('copy');
    // document.body.removeChild(elem);
    //++++++++Copy as a json (multiline)+++++++++++
    this.clipboard.copy(JSON.stringify(responseData, null, 2));
    this.helperService.presentToast("Copied to clipboard.", 2000);
  }
  openLoader(){
    this.searchService.setLoading(true);
    this.loader=true;
  }

  checkTokenSessionBeforeCallMileStonApi() {
    this.consoleType = 'console_data';
    this.isConsole = true;
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.consoleDataTokenForMilestoneAPI = storage_data.mileStoneTokenConsole;
      if (storage_data.mileStoneTokenConsole == null) {
        this.generateToken('data_source').then((res: any) => {
          this.consoleDataTokenForMilestoneAPI = res;
          this.MilestoneCheckAPI();
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.MilestoneCheckAPI();
          } else {
            this.generateToken('data_source').then((res: any) => {
              this.consoleDataTokenForMilestoneAPI = res;
              this.MilestoneCheckAPI();
            })
          }
        })
      }
    })
  }
  cancelconsole(event:Event){
    event.stopPropagation();
    this.searchService.setLoading(false);
    this.loader=false;
  }
  cancelLoading(){
      this.searchService.setLoading(false);
      this.loader=false;
  }
  async generateConfig(id, title, i, breakPoint) {
    this.isConsole = true;
    this.selectedOperationId='';
    this.selectedOperation='';
    this.filteredArray = [];
    this.finalBlocksTmp = [];
    var data = await this.transformOpsJson()
    var index = -1;
    var dataArray = Object.entries(data).map(([key, value]) => ({ [key]: value }));

    var filteredObj = this.finalBlocks.find(function (item, i) {
      if (item.id === id) {
        index = i;
        return i;
      }
    });

    if (i % 2 == 0 && breakPoint == '') {
      index = index - 1;
    } else if (i % 2 == 0 && breakPoint == 'right') {
      index = index
    }
    let finalBlocksTmp = this.finalBlocks.slice(0, index + 1)
    this.finalBlocksTmp = this.finalBlocks.slice(0, index + 1)

    let filteredArray = dataArray.slice(0, index + 1);

    this.hideAllOpsForms()
    this.resetPipeValidation().then(async (res) => {
      if (res) {
        await this.generateDataSource(finalBlocksTmp, filteredArray)
      }
    })
  }

  resetPipeValidation() {
    return new Promise((resolve) => {
      for (let item of this.finalBlocks) {
        item.isValid = true;
      }
      resolve(true)
    })
  }

  async generateDataSource(finalBlocksTmp, filteredArray) {

    if (this.bridge_source_type == 1) {
      if (this.dataSource.invalid) {
        this.helperService.presentToast("Data Source form incomplete", 2000);
        return;
      }
    } else {
      if (this.dataSource.invalid) {
        this.helperService.presentToast("Data Source form incomplete", 2000);
        return;
      }
    }

    // this.selectedOperationId = '';
    let formId = []
    for (let item of this.finalBlocksTmp) {
      if (item.isMute == false) {
        if (item.title == 'Data types') {
          let dataTypeArr = this.datatypesRows().value
          for (let i = 0; i < dataTypeArr.length; i++) {
            if (item.id == dataTypeArr[i].id) {
              if ((dataTypeArr[i].boolean_operator == '' || dataTypeArr[i].boolean_operator == undefined) &&
                (dataTypeArr[i].float_operator == '' || dataTypeArr[i].float_operator == undefined) &&
                (dataTypeArr[i].integer_operator == '' || dataTypeArr[i].integer_operator == undefined) &&
                (dataTypeArr[i].datetime_operator == '' || dataTypeArr[i].datetime_operator == undefined)) {
                formId.push({ id: dataTypeArr[i].id })
              } else {
                const getstr = dataTypeArr[i];
                if(getstr.boolean_operator ||getstr.float_operator||getstr.integer_operator||getstr.datetime_operator){
                  let id=getstr.id;
                  let mute=getstr.isMute;
                  delete getstr.id;
                  delete getstr.isMute;
                  if(Object.keys(getstr).map(key=>{
                    if(getstr[key].length>0){
                      if(this.helperService.isValidString(getstr[key])){
                        return true;
                      }
                      return false;
                    }
                  }).includes(false)){
                    this.helperService.presentToast('Please provide valid STRING - Data types Operation', 2000);
                    getstr.id=id;
                    getstr.isMute=mute; 
                    formId.push({ id: dataTypeArr[i].id });
                    item.isValid = false;
                    return;
                  }
                  getstr.id=id;
                  getstr.isMute=mute;

                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Append') {
          let appendArr = this.appendRows().value;
          //console.log(appendArr);
          
          for (let i = 0; i < appendArr.length; i++) {
            if (item.id == appendArr[i].id) {
              if (appendArr[i].append == '' || appendArr[i].append == undefined) {
                formId.push({ id: appendArr[i].id })
              } else {
                var getstr = "{" + appendArr[i].append + "}";
                if (this.helperService.isValidJSON(getstr) == false) {
                  this.helperService.presentToast('Please provide valid JSON - Append Operation', 2000);
                  formId.push({ id: appendArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Titlecase') {
          let titleArr = this.titlecaseRows().value;
          for (let i = 0; i < titleArr.length; i++) {
            if (item.id == titleArr[i].id) {
              if (titleArr[i].titlecase == '' || titleArr[i].titlecase == undefined) {
                formId.push({ id: titleArr[i].id })
              } else {
                const getstr = titleArr[i].titlecase;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Titlecase Operation', 2000);
                  formId.push({ id: titleArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Uppercase') {
          let upperCaseArr = this.uppercaseRows().value;
          for (let i = 0; i < upperCaseArr.length; i++) {
            if (item.id == upperCaseArr[i].id) {
              if (upperCaseArr[i].uppercase == '' || upperCaseArr[i].uppercase == undefined) {
                formId.push({ id: upperCaseArr[i].id })
              } else {
                const getstr = upperCaseArr[i].uppercase;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Uppercase Operation', 2000);
                  formId.push({ id: upperCaseArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Lowercase') {
          let lowerCaseArr = this.lowercaseRows().value;
          for (let i = 0; i < lowerCaseArr.length; i++) {
            if (item.id == lowerCaseArr[i].id) {
              if (lowerCaseArr[i].lowercase == '' || lowerCaseArr[i].lowercase == undefined) {
                formId.push({ id: lowerCaseArr[i].id })
              } else {
                const getstr = lowerCaseArr[i].lowercase;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Lowercase Operation', 2000);
                  formId.push({ id: lowerCaseArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Data extractor') {
          let dataExtractorArr = this.dataextractorRows().value;
          for (let i = 0; i < dataExtractorArr.length; i++) {
            if (item.id == dataExtractorArr[i].id) {
              if (dataExtractorArr[i].data_extractor == '' || dataExtractorArr[i].data_extractor == undefined) {
                formId.push({ id: dataExtractorArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Trim') {
          let trimArr = this.trimRows().value;
          for (let i = 0; i < trimArr.length; i++) {
            if (trimArr[i].trim_keys == '' || trimArr[i].trim_keys == undefined) {
              if (item.id == trimArr[i].id) {
                formId.push({ id: trimArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON to String') {
          let json2stringArr = this.json2stringRows().value;
          for (let i = 0; i < json2stringArr.length; i++) {
            if (json2stringArr[i].json2string == '' || json2stringArr[i].json2string == undefined) {
              if (item.id == json2stringArr[i].id) {
                formId.push({ id: json2stringArr[i].id })
              } else {
                item.isValid = true;
              }
            }else{
                const getstr = json2stringArr[i].json2string;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - JSON to String Operation', 2000);
                  formId.push({ id: json2stringArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
            }
          }
        } else if (item.title == 'String to JSON') {
          let string2jsonArr = this.string2jsonRows().value;
          for (let i = 0; i < string2jsonArr.length; i++) {
            if (string2jsonArr[i].string2json == '' || string2jsonArr[i].string2json == undefined) {
              if (item.id == string2jsonArr[i].id) {
                formId.push({ id: string2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON to XML') {
          let jsontoxmlArr = this.jsontoxmlRows().value;
          for (let i = 0; i < jsontoxmlArr.length; i++) {
            if (item.id == jsontoxmlArr[i].id) {
              if (jsontoxmlArr[i].key_data == '' || jsontoxmlArr[i].key_data == undefined) {
                formId.push({ id: jsontoxmlArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsontoxmlArr[i].response_key == '' || jsontoxmlArr[i].response_key == undefined) {
                formId.push({ id: jsontoxmlArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'XML to JSON') {
          let xmlToJsonArr = this.xmltojsonRows().value;
          for (let i = 0; i < xmlToJsonArr.length; i++) {
            if (item.id == xmlToJsonArr[i].id) {
              if (xmlToJsonArr[i].get_key == '' || xmlToJsonArr[i].get_key == undefined) {
                formId.push({ id: xmlToJsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (xmlToJsonArr[i].response_key == '' || xmlToJsonArr[i].response_key == undefined) {
                formId.push({ id: xmlToJsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Base64 encoding') {
          let base64EncodingArr = this.base64encodingRows().value;
          for (let i = 0; i < base64EncodingArr.length; i++) {
            if (base64EncodingArr[i].base64_encode == '' || base64EncodingArr[i].base64_encode == undefined) {
              if (item.id == base64EncodingArr[i].id) {
                formId.push({ id: base64EncodingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Base64 decoding') {
          let base64DecodingArr = this.base64decodingRows().value;
          for (let i = 0; i < base64DecodingArr.length; i++) {
            if (base64DecodingArr[i].base64_decode == '' || base64DecodingArr[i].base64_decode == undefined) {
              if (item.id == base64DecodingArr[i].id) {
                formId.push({ id: base64DecodingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Generate Array Sequence Number') {
          let generatesequenceArr = this.generatesequenceRows().value;
          for (let i = 0; i < generatesequenceArr.length; i++) {
            if (item.id == generatesequenceArr[i].id) {
              if (generatesequenceArr[i].sequence_key == '' || generatesequenceArr[i].sequence_key == undefined) {
                formId.push({ id: generatesequenceArr[i].id })
              } else {
                item.isValid = true;
              }
              if (generatesequenceArr[i].sequence_number_key == '' || generatesequenceArr[i].sequence_number_key == undefined) {
                formId.push({ id: generatesequenceArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Send Keys Top of Root') {
          let toplevelArr = this.toplevelRows().value;
          for (let i = 0; i < toplevelArr.length; i++) {
            if (toplevelArr[i].column_to_root == '' || toplevelArr[i].column_to_root == undefined) {
              if (item.id == toplevelArr[i].id) {
                formId.push({ id: toplevelArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Today Timestamp') {
          let datetimestampArr = this.datetimestampRows().value;
          for (let i = 0; i < datetimestampArr.length; i++) {
            if (item.id == datetimestampArr[i].id) {
              if (datetimestampArr[i].date_format == '' || datetimestampArr[i].date_format == undefined) {
                formId.push({ id: datetimestampArr[i].id })
              } else {
                item.isValid = true;
              }
              if (datetimestampArr[i].datetime_key == '' || datetimestampArr[i].datetime_key == undefined) {
                formId.push({ id: datetimestampArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Repeat First Row Values') {
          let repeatfirstrowArr = this.repeatfirstrowRows().value;
          for (let i = 0; i < repeatfirstrowArr.length; i++) {
            if (item.id == repeatfirstrowArr[i].id) {
              if (repeatfirstrowArr[i].source_key == '' || repeatfirstrowArr[i].source_key == undefined) {
                formId.push({ id: repeatfirstrowArr[i].id })
              } else {
                item.isValid = true;
              }
              if (repeatfirstrowArr[i].fields_to_repeat_value == '' || repeatfirstrowArr[i].fields_to_repeat_value == undefined) {
                formId.push({ id: repeatfirstrowArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Encode Decode') {
          let encodedecodeArr = this.encodedecodeRows().value;
          for (let i = 0; i < encodedecodeArr.length; i++) {
            if (item.id == encodedecodeArr[i].id) {
              if (encodedecodeArr[i].response_key == '' || encodedecodeArr[i].response_key == undefined) {
                formId.push({ id: encodedecodeArr[i].id })
              } else {
                item.isValid = true;
              }
              if (encodedecodeArr[i].method_type == '' || encodedecodeArr[i].method_type == undefined) {
                formId.push({ id: encodedecodeArr[i].id })
              } else {
                item.isValid = true;
              }
              if (encodedecodeArr[i].process == '' || encodedecodeArr[i].process == undefined) {
                formId.push({ id: encodedecodeArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Zipfile in Base64') {
          let zipfileinbase64Arr = this.zipfileinbase64Rows().value;
          for (let i = 0; i < zipfileinbase64Arr.length; i++) {
            if (item.id == zipfileinbase64Arr[i].id) {
              if (zipfileinbase64Arr[i].source_key == '' || zipfileinbase64Arr[i].source_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
              if (zipfileinbase64Arr[i].file_name_key == '' || zipfileinbase64Arr[i].file_name_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
              if (zipfileinbase64Arr[i].file_extension_key == '' || zipfileinbase64Arr[i].file_extension_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
              if (zipfileinbase64Arr[i].file_data_key == '' || zipfileinbase64Arr[i].file_data_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
              if (zipfileinbase64Arr[i].base64_response_key == '' || zipfileinbase64Arr[i].base64_response_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'PDF Extractor') {
          let pdfextractorArr = this.pdfextractorRows().value;
          for (let i = 0; i < pdfextractorArr.length; i++) {
            if (item.id == pdfextractorArr[i].id) {
              if (pdfextractorArr[i].pdfLocationToggle == 'file_url') {
                if (pdfextractorArr[i].file_url == '' || pdfextractorArr[i].file_url == undefined) {
                  formId.push({ id: pdfextractorArr[i].id })
                } else {
                  item.isValid = true;
                }
                pdfextractorArr[i].base64_key = ''
              } else {
                if (pdfextractorArr[i].base64_key == '' || pdfextractorArr[i].base64_key == undefined) {
                  formId.push({ id: pdfextractorArr[i].id })
                } else {
                  item.isValid = true;
                }
                pdfextractorArr[i].file_url = ''
              }
            }
          }
        } else if (item.title == 'File Extractor') {
          let fileextractorArr = this.fileextractorRows().value;
          for (let i = 0; i < fileextractorArr.length; i++) {
            if (item.id == fileextractorArr[i].id) {
              if (fileextractorArr[i].file_data_key == '' || fileextractorArr[i].file_data_key == undefined) {
                formId.push({ id: fileextractorArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Grok Pattern') {
          let grokpatternArr = this.grokpatternRows().value;
          for (let i = 0; i < grokpatternArr.length; i++) {
            if (item.id == grokpatternArr[i].id) {
              if (grokpatternArr[i].input_key == '' || grokpatternArr[i].input_key == undefined) {
                formId.push({ id: grokpatternArr[i].id })
              } else {
                item.isValid = true;
              }
              if (grokpatternArr[i].grok_pattern == '' || grokpatternArr[i].grok_pattern == undefined) {
                formId.push({ id: grokpatternArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Raw Sentence Generator') {
          let rawsentencegeneratorArr = this.rawsentencegeneratorRows().value;
          for (let i = 0; i < rawsentencegeneratorArr.length; i++) {
            if (item.id == rawsentencegeneratorArr[i].id) {
              if (rawsentencegeneratorArr[i].raw_response_key == '' || rawsentencegeneratorArr[i].raw_response_key == undefined) {
                formId.push({ id: rawsentencegeneratorArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Array Count') {
          let arraycountArr = this.arraycountRows().value;
          for (let i = 0; i < arraycountArr.length; i++) {
            if (item.id == arraycountArr[i].id) {
              if (arraycountArr[i].array_key_name == '' || arraycountArr[i].array_key_name == undefined) {
                formId.push({ id: arraycountArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Single Line to Multiline') {
          let chopArr = this.chopRows().value;
          for (let i = 0; i < chopArr.length; i++) {
            if (item.id == chopArr[i].id) {
              if (chopArr[i].chopkey == '' || chopArr[i].chopkey == undefined) {
                formId.push({ id: chopArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON to delimiter') {
          let json2dlArr = this.json2dlRows().value;
          for (let i = 0; i < json2dlArr.length; i++) {
            if (item.id == json2dlArr[i].id) {
              if (json2dlArr[i].key_data == '' || json2dlArr[i].key_data == undefined) {
                formId.push({ id: json2dlArr[i].id })
              } else {
                item.isValid = true;
              }
              if (json2dlArr[i].delimiter == '' || json2dlArr[i].delimiter == undefined) {
                formId.push({ id: json2dlArr[i].id })
              } else {
                item.isValid = true;
              }
              if (json2dlArr[i].response_key == '' || json2dlArr[i].response_key == undefined) {
                formId.push({ id: json2dlArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Delimiter to JSON') {
          let dl2jsonArr = this.dl2jsonRows().value;
          for (let i = 0; i < dl2jsonArr.length; i++) {
            if (item.id == dl2jsonArr[i].id) {
              dl2jsonArr[i].autodetect_column_names = dl2jsonArr[i].autodetect_column_names.toString();
              dl2jsonArr[i].skip_header = dl2jsonArr[i].skip_header.toString();
              if (dl2jsonArr[i].key_data == '' || dl2jsonArr[i].key_data == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2jsonArr[i].delimiter == '' || dl2jsonArr[i].delimiter == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2jsonArr[i].autodetect_column_names == '' || dl2jsonArr[i].autodetect_column_names == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2jsonArr[i].skip_header == '' || dl2jsonArr[i].skip_header == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2jsonArr[i].response_key == '' || dl2jsonArr[i].response_key == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Delimiter to Array') {
          let dl2arrayArr = this.dl2arrayRows().value;
          for (let i = 0; i < dl2arrayArr.length; i++) {
            if (item.id == dl2arrayArr[i].id) {
              if (dl2arrayArr[i].dl_key == '' || dl2arrayArr[i].dl_key == undefined) {
                formId.push({ id: dl2arrayArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2arrayArr[i].delimiter == '' || dl2arrayArr[i].delimiter == undefined) {
                formId.push({ id: dl2arrayArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Data aggregation') {
          let dataAggregationArr = this.dataaggregationRows().value;
          for (let i = 0; i < dataAggregationArr.length; i++) {
            if (item.id == dataAggregationArr[i].id) {
              if (dataAggregationArr[i].groupby_key == '' || dataAggregationArr[i].groupby_key == undefined) {
                formId.push({ id: dataAggregationArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dataAggregationArr[i].array_key == '' || dataAggregationArr[i].array_key == undefined) {
                formId.push({ id: dataAggregationArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Unpivot') {
          let unPivotArr = this.unpivotRows().value;
          for (let i = 0; i < unPivotArr.length; i++) {
            if (item.id == unPivotArr[i].id) {
              if (unPivotArr[i].transpose_key_name == '' || unPivotArr[i].transpose_key_name == undefined) {
                formId.push({ id: unPivotArr[i].id })
              } else {
                item.isValid = true;
              }
              if (unPivotArr[i].transpose_value == '' || unPivotArr[i].transpose_value == undefined) {
                formId.push({ id: unPivotArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Pivot') {
          let PivotArr = this.pivotRows().value;
          for (let i = 0; i < PivotArr.length; i++) {
            if (item.id == PivotArr[i].id) {
              if (PivotArr[i].transposed_key_name == '' || PivotArr[i].transposed_key_name == undefined) {
                formId.push({ id: PivotArr[i].id })
              } else {
                item.isValid = true;
              }
              if (PivotArr[i].transposed_value == '' || PivotArr[i].transposed_value == undefined) {
                formId.push({ id: PivotArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Single Line to Tuple') {
          let singleline2tupleArr = this.singleline2tupleRows().value;
          for (let i = 0; i < singleline2tupleArr.length; i++) {
            if (item.id == singleline2tupleArr[i].id) {
              if (singleline2tupleArr[i].singleline_key == '' || singleline2tupleArr[i].singleline_key == undefined) {
                formId.push({ id: singleline2tupleArr[i].id })
              } else {
                item.isValid = true;
              }
              if (singleline2tupleArr[i].table_headers == '' || singleline2tupleArr[i].table_headers == undefined) {
                formId.push({ id: singleline2tupleArr[i].id })
              } else {
                item.isValid = true;
              }
              if (singleline2tupleArr[i].tuple_key == '' || singleline2tupleArr[i].tuple_key == undefined) {
                formId.push({ id: singleline2tupleArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Tuple to Single Line') {
          let tuple2singlelineArr = this.tuple2singlelineRows().value;
          for (let i = 0; i < tuple2singlelineArr.length; i++) {
            if (item.id == tuple2singlelineArr[i].id) {
              if (tuple2singlelineArr[i].tuple_key == '' || tuple2singlelineArr[i].tuple_key == undefined) {
                formId.push({ id: tuple2singlelineArr[i].id })
              } else {
                item.isValid = true;
              }
              if (tuple2singlelineArr[i].headers == '' || tuple2singlelineArr[i].headers == undefined) {
                formId.push({ id: tuple2singlelineArr[i].id })
              } else {
                item.isValid = true;
              }
              if (tuple2singlelineArr[i].singleline_key == '' || tuple2singlelineArr[i].singleline_key == undefined) {
                formId.push({ id: tuple2singlelineArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Drop all events to start with') {
          let dropeventsstartswithArr = this.dropeventsstartswithRows().value;
          for (let i = 0; i < dropeventsstartswithArr.length; i++) {
            if (item.id == dropeventsstartswithArr[i].id) {
              if (dropeventsstartswithArr[i].drop_all_event_to_start_with == '' || dropeventsstartswithArr[i].drop_all_event_to_start_with == undefined) {
                formId.push({ id: dropeventsstartswithArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Drop all events for value') {
          let dropalleventvaluesArr = this.dropalleventvaluesRows().value;
          for (let i = 0; i < dropalleventvaluesArr.length; i++) {
            if (item.id == dropalleventvaluesArr[i].id) {
              if (dropalleventvaluesArr[i].drop_all_event_for_value == '' || dropalleventvaluesArr[i].drop_all_event_for_value == undefined) {
                formId.push({ id: dropalleventvaluesArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Eliminate') {
          let eliminateArr = this.eliminateRows().value;
          for (let i = 0; i < eliminateArr.length; i++) {
            if (item.id == eliminateArr[i].id) {
              if (eliminateArr[i].eliminate == '' || eliminateArr[i].eliminate == undefined) {
                formId.push({ id: eliminateArr[i].id })
              } else {
                const getstr = eliminateArr[i].eliminate;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Eliminate Operation', 2000);
                  formId.push({ id: eliminateArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Round') {
          let roundArr = this.roundRows().value;
          for (let i = 0; i < roundArr.length; i++) {
            if (item.id == roundArr[i].id) {
              if (roundArr[i].round_keys == '' || roundArr[i].round_keys == undefined) {
                formId.push({ id: roundArr[i].id })
              } else {
                const getstr = roundArr[i].round_keys;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Round Operation', 2000);
                  formId.push({ id: roundArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
              if (roundArr[i].decimal_key_number == '' || roundArr[i].decimal_key_number == undefined) {
                formId.push({ id: roundArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Calculator') {
          let calculaterArr = this.calculaterRows().value;
          for (let i = 0; i < calculaterArr.length; i++) {
            if (item.id == calculaterArr[i].id) {
              if (calculaterArr[i].calculation_keys == '' || calculaterArr[i].calculation_keys == undefined) {
                formId.push({ id: calculaterArr[i].id })
              } else {
                item.isValid = true;
              }
              if (calculaterArr[i].new_calculation_keys == '' || calculaterArr[i].new_calculation_keys == undefined) {
                formId.push({ id: calculaterArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Date Analytics') {
          let dateanalyticsArr = this.dateanalyticsRows().value;
          for (let i = 0; i < dateanalyticsArr.length; i++) {
            if (item.id == dateanalyticsArr[i].id) {
              if (dateanalyticsArr[i].date_field_key == '' || dateanalyticsArr[i].date_field_key == undefined) {
                formId.push({ id: dateanalyticsArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dateanalyticsArr[i].fiscal_month_start == '' || dateanalyticsArr[i].fiscal_month_start == undefined) {
                formId.push({ id: dateanalyticsArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dateanalyticsArr[i].weekday == '' || dateanalyticsArr[i].weekday == undefined) {
                formId.push({ id: dateanalyticsArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Substitute') {
          let substituteArr = this.substituteRows().value;
          for (let i = 0; i < substituteArr.length; i++) {
            if (item.id == substituteArr[i].id) {
              if (substituteArr[i].substitute == '' || substituteArr[i].substitute == undefined) {
                formId.push({ id: substituteArr[i].id })
              } else {
                const getstr = substituteArr[i].substitute;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Substitute Operation', 2000);
                  formId.push({ id: substituteArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Rename') {
          let renameArr = this.renameRows().value;
          for (let i = 0; i < renameArr.length; i++) {
            if (item.id == renameArr[i].id) {
              if (renameArr[i].rename == '' || renameArr[i].rename == undefined) {
                formId.push({ id: renameArr[i].id })
              } else {
                var getstr = "{" + renameArr[i].rename + "}";
                if (this.helperService.isValidJSON(getstr) == false) {
                  this.helperService.presentToast('Please provide valid JSON - Rename Operation', 2000);
                  formId.push({ id: renameArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Strip') {
          let stripArr = this.stripRows().value;
          for (let i = 0; i < stripArr.length; i++) {
            if (item.id == stripArr[i].id) {
              if (stripArr[i].strip == '' || stripArr[i].strip == undefined) {
                formId.push({ id: stripArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Substring') {
          let substringArr = this.substringRows().value;
          for (let i = 0; i < substringArr.length; i++) {
            if (item.id == substringArr[i].id) {
              if (substringArr[i].substring == '' || substringArr[i].substring == undefined) {
                formId.push({ id: substringArr[i].id })
              } else {
                var getstr = "{" + substringArr[i].substring + "}";
                if (this.helperService.isValidJSON(getstr) == false) {
                  this.helperService.presentToast('Please provide valid JSON - Substring Operation', 2000);
                  formId.push({ id: substringArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'API') {
          let restapiArr = this.restapiRows().value;
            for (let i = 0; i < restapiArr.length; i++){
              if (item.id == restapiArr[i].id) {
                if(restapiArr[i].is_new_target){
                  if(restapiArr[i].new_bridge_target == '' || restapiArr[i].new_bridge_target == undefined){
                    formId.push({ id: restapiArr[i].id })
                  } else {
                    item.isValid = true;
                  }
                  if(restapiArr[i].new_bridge_target_business_object == '' || restapiArr[i].new_bridge_target_business_object == undefined){
                    formId.push({ id: restapiArr[i].id })
                  } else {
                    item.isValid = true;
                  }
                } else {
                  if(restapiArr[i].bridge_target == '' || restapiArr[i].bridge_target == undefined){
                    formId.push({ id: restapiArr[i].id })
                  } else {
                    item.isValid = true;
                  }
                  if(restapiArr[i].bridge_target_business_object == '' || restapiArr[i].bridge_target_business_object == undefined){
                    formId.push({ id: restapiArr[i].id })
                  } else {
                    item.isValid = true;
                  }
                }
              //   if(restapiArr[i].bridge_target_endpoint_url == '' || restapiArr[i].bridge_target_endpoint_url == undefined){
              //     formId.push({ id: restapiArr[i].id })
              //   } else {
              //     item.isValid = true;
              //   }
              //   if(restapiArr[i].bridge_target_endpoint_authentication_type.id == 6){
              //     if(restapiArr[i].bridge_target_oauth_refresh_token_endpoint_method == '' || restapiArr[i].bridge_target_oauth_refresh_token_endpoint_method == undefined){
              //     formId.push({ id: restapiArr[i].id })
              //   }
              //   if(restapiArr[i].bridge_target_oauth_refresh_token_endpoint_url == '' || restapiArr[i].bridge_target_oauth_refresh_token_endpoint_url == undefined){
              //     formId.push({ id: restapiArr[i].id })
              //   } else {
              //     item.isValid = true;
              //   }
              // }
              }
             
            }
        } else if (item.title == "DL Ingestion") {
          let dlIngestionArr = this.dlIngestionRows().value;
          for (let i = 0; i < dlIngestionArr.length; i++) {
            if (item.id == dlIngestionArr[i].id) {
              if (dlIngestionArr[i].index_name == '' || dlIngestionArr[i].index_name == undefined) {
                formId.push({ id: dlIngestionArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == "DataLake Search") {
          let dlsearchArr = this.dlsearchRows().value;
          for (let i = 0; i < dlsearchArr.length; i++) {
            if (item.id == dlsearchArr[i].id) {
              if (dlsearchArr[i].dlsearch_index_name == '' || dlsearchArr[i].dlsearch_index_name == undefined) {
                formId.push({ id: dlsearchArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Sleep time') {
          let sleepArr = this.sleepRows().value;
          for (let i = 0; i < sleepArr.length; i++) {
            if (item.id == sleepArr[i].id) {
              if (sleepArr[i].sleep_time == '' || sleepArr[i].sleep_time == undefined) {
                formId.push({ id: sleepArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Python') {
          let pycodeArr = this.pycodeRows().value;
          for (let i = 0; i < pycodeArr.length; i++) {
            if (item.id == pycodeArr[i].id) {
              if (pycodeArr[i].pycode == '' || pycodeArr[i].pycode == undefined) {
                formId.push({ id: pycodeArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Filter') {
          let filterArr = this.filterRows().value;
          for (let i = 0; i < filterArr.length; i++) {
            if (item.id == filterArr[i].id) {
              if (filterArr[i].conditional_statement == '' || filterArr[i].conditional_statement == undefined) {
                formId.push({ id: filterArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Email') {
          let emailArr = this.emailRows().value;
          for (let i = 0; i < emailArr.length; i++) {
            if (item.id == emailArr[i].id) {
              if (emailArr[i].From == '' || emailArr[i].From == undefined) {
                formId.push({ id: emailArr[i].id })
              } else {
                item.isValid = true;
              }
              if (emailArr[i].password == '' || emailArr[i].password == undefined) {
                formId.push({ id: emailArr[i].id })
              } else {
                item.isValid = true;
              }
              if (emailArr[i].mailserver == '' || emailArr[i].mailserver == undefined) {
                formId.push({ id: emailArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON') {
          let jsonArr = this.jsonRows().value;
          for (let i = 0; i < jsonArr.length; i++) {
            if (item.id == jsonArr[i].id) {
              if (jsonArr[i].jdbc_driver == '' || jsonArr[i].jdbc_driver == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].jdbc_string == '' || jsonArr[i].jdbc_string == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].jdbc_jar_file == '' || jsonArr[i].jdbc_jar_file == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].username == '' || jsonArr[i].username == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].password == '' || jsonArr[i].password == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].unique_key == '' || jsonArr[i].unique_key == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].query == '' || jsonArr[i].query == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].response_parameter == '' || jsonArr[i].response_parameter == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].timer_type == '' || jsonArr[i].timer_type == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].schedule == '' || jsonArr[i].schedule == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].interval_in_seconds == '' || jsonArr[i].interval_in_seconds == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].multiline == '' || jsonArr[i].multiline == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Database') {
          let jdbcArr = this.jdbcoutputRows().value;
          for (let i = 0; i < jdbcArr.length; i++) {
            if (item.id == jdbcArr[i].id) {
              if (jdbcArr[i].db_version == '' || jdbcArr[i].db_version == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].host_ip == '' || jdbcArr[i].host_ip == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].port_number == '' || jdbcArr[i].port_number == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].schema_name == '' || jdbcArr[i].schema_name == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].username == '' || jdbcArr[i].username == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].password == '' || jdbcArr[i].password == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].query == '' || jdbcArr[i].query == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        }else if (item.title == 'AI Operation') {
          let aiopsArr = this.aiopsRows().value;
          for (let i = 0; i < aiopsArr.length; i++) {
            if (item.id == aiopsArr[i].id) {
              if (aiopsArr[i].question == '' || aiopsArr[i].question == undefined) {
                formId.push({ id: aiopsArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        }else if (item.title == 'Document Understanding') {
          let docunderstandingArr = this.docunderstandingRows().value;
          for (let i = 0; i < docunderstandingArr.length; i++) {
            if (item.id == docunderstandingArr[i].id) {
              if (docunderstandingArr[i].text_key == '' || docunderstandingArr[i].text_key == undefined) {
                formId.push({ id: docunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (docunderstandingArr[i].questions[0].docunderstanding_question == '' || docunderstandingArr[i].questions[0].docunderstanding_question == undefined) {
                formId.push({ id: docunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (docunderstandingArr[i].questions[0].docunderstanding_attribute == '' || docunderstandingArr[i].questions[0].docunderstanding_attribute == undefined) {
                formId.push({ id: docunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (docunderstandingArr[i].output_key == '' || docunderstandingArr[i].output_key == undefined) {
                formId.push({ id: docunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Image Understanding') {
          let imgunderstandingArr = this.imgunderstandingRows().value;
          for (let i = 0; i < imgunderstandingArr.length; i++) {
            if (item.id == imgunderstandingArr[i].id) {
              if (imgunderstandingArr[i].img_key == '' || imgunderstandingArr[i].img_key == undefined) {
                formId.push({ id: imgunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (imgunderstandingArr[i].questions[0].imgunderstanding_question == '' || imgunderstandingArr[i].questions[0].imgunderstanding_question == undefined) {
                formId.push({ id: imgunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (imgunderstandingArr[i].questions[0].imgunderstanding_attribute == '' || imgunderstandingArr[i].questions[0].imgunderstanding_attribute == undefined) {
                formId.push({ id: imgunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (imgunderstandingArr[i].output_key == '' || imgunderstandingArr[i].output_key == undefined) {
                formId.push({ id: imgunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Data Chunking') {
          let datachunkingArr = this.datachunkingRows().value;
          for (let i = 0; i < datachunkingArr.length; i++) {
            if (item.id == datachunkingArr[i].id) {
              if (datachunkingArr[i].process_key == '' || datachunkingArr[i].process_key == undefined) {
                formId.push({ id: datachunkingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (datachunkingArr[i].chunk_key == '' || datachunkingArr[i].chunk_key == undefined) {
                formId.push({ id: datachunkingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (datachunkingArr[i].token_size == '' || datachunkingArr[i].token_size == undefined) {
                formId.push({ id: datachunkingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (datachunkingArr[i].group_by_chunk == '' || datachunkingArr[i].group_by_chunk == undefined) {
                formId.push({ id: datachunkingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'HTML Extractor') {
          let htmlextractorArr = this.htmlExtractorRows().value;
          for (let i = 0; i < htmlextractorArr.length; i++) {
            if (item.id == htmlextractorArr[i].id) {
              if (htmlextractorArr[i].input_html_key == '' || htmlextractorArr[i].input_html_key == undefined) {
                formId.push({ id: htmlextractorArr[i].id })
              } else {
                item.isValid = true;
              }
              if (htmlextractorArr[i].output_data_key == '' || htmlextractorArr[i].output_data_key == undefined) {
                formId.push({ id: htmlextractorArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON to AVRO') {
          let json2avroArr = this.jason2avroRows().value;
          for (let i = 0; i < json2avroArr.length; i++) {
            if (item.id == json2avroArr[i].id) {
              if (json2avroArr[i].jsondata_key == '' || json2avroArr[i].jsondata_key == undefined) {
                formId.push({ id: json2avroArr[i].id })
              } else {
                item.isValid = true;
              }
              if (json2avroArr[i].avro_schema == '' || json2avroArr[i].avro_schema == undefined) {
                formId.push({ id: json2avroArr[i].id })
              } else {
                var getstr = "{" + json2avroArr[i].avro_schema + "}";
                if (this.helperService.isValidJSON(getstr) == false) {
                  this.helperService.presentToast('Please provide valid JSON - JSON to AVRO Operation', 2000);
                  formId.push({ id: json2avroArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
              if (json2avroArr[i].response_key == '' || json2avroArr[i].response_key == undefined) {
                formId.push({ id: json2avroArr[i].id })
              } else {
                item.isValid = true;
              }

            }
          }
        } else if (item.title == 'AVRO to JSON') {
          let avro2jsonArr = this.avro2jsonRows().value;
          for (let i = 0; i < avro2jsonArr.length; i++) {
            if (item.id == avro2jsonArr[i].id) {
              if (avro2jsonArr[i].avro_data == '' || avro2jsonArr[i].avro_data == undefined) {
                formId.push({ id: avro2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (avro2jsonArr[i].json_data_key == '' || avro2jsonArr[i].json_data_key == undefined) {
                formId.push({ id: avro2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Extract to Array') {
          let extract2ArrayArr = this.extract2ArrayRows().value;
          for (let i = 0; i < extract2ArrayArr.length; i++) {
            if (item.id == extract2ArrayArr[i].id) {
              if (extract2ArrayArr[i].list_object_key == '' || extract2ArrayArr[i].list_object_key == undefined) {
                formId.push({ id: extract2ArrayArr[i].id })
              } else {
                item.isValid = true;
              }
              if (extract2ArrayArr[i].extraction_key == '' || extract2ArrayArr[i].extraction_key == undefined) {
                formId.push({ id: extract2ArrayArr[i].id })
              } else {
                item.isValid = true;
              }
              if (extract2ArrayArr[i].array_collection_key == '' || extract2ArrayArr[i].array_collection_key == undefined) {
                formId.push({ id: extract2ArrayArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        }
      }
    }

    const uniqueId = [...new Set(formId.map(x => x.id))]
    for (let item of this.finalBlocksTmp) {
      for (let id of uniqueId) {
        if (item.id == id) {
          item.isValid = false;
        }
      }
    }

    if (uniqueId.length > 0) {
      this.helperService.presentToast("Data operation form incomplete", 2000);
      return
    }
    let dataSourceConfig;
    let configKey = 'bizdata_ops_restapi';
    let time_zone;
    if (this.timertypeval == "interval") {
      time_zone = '';
      this.summary.value.schedule = "* * * * *"
    } else {
      time_zone = this.summary.value.time_zone;
      time_zone = time_zone.timezone;
    }
    if (this.bridge_source_type == 1) {
      configKey = 'bizdata_ops_restapi';
      let sourcePostmanFormData;
      for (const component of this.postmanuiComponents.toArray()) {
        if (component.apiCatalogFormType === 'source') {
          sourcePostmanFormData = await component.getApiCatalogPostmanData();
        }
      }

      if (this.dataSource.invalid) {
        console.log("Invalid form controls:", this.getSourceInvalidControls());
        this.helperService.presentToast("Data Source form incomplete", 2000);
        return;
      }

      if(sourcePostmanFormData.sourcePostmanFormInvalid) {
        return;
      }

      dataSourceConfig = {
        'endpoint_url'                     : sourcePostmanFormData?.sourceApiEndpointUrlTest,
        'endpoint_method'                  : sourcePostmanFormData?.sourceEndpointMethodTest,
        'endpoint_params'                  : sourcePostmanFormData?.sourceParamsDataTest,
        "authentication_type"              : sourcePostmanFormData?.sourceAuthTypeTest,
        "username"                         : sourcePostmanFormData?.sourceAuthUsernameTest,
        "password"                         : sourcePostmanFormData?.sourceAuthPasswordTest,
        "refresh_token_method"             : sourcePostmanFormData?.sourceAuthRtemethodTest,
        "refresh_token_url"                : sourcePostmanFormData?.sourceAuthRteurlTest,
        "refresh_token_headers"            : sourcePostmanFormData?.sourceAuthRteheadersTest,
        "refresh_token_params"             : sourcePostmanFormData?.sourceAuthRteparamsTest,
        "refresh_token_body"               : sourcePostmanFormData?.sourceAuthRtebodyTest,
        'endpoint_headers'                 : sourcePostmanFormData?.sourceHeadersDataTest,
        'body_type'                        : sourcePostmanFormData?.sourceEndpointBodyType,
        'endpoint_body'                    : sourcePostmanFormData?.sourceEndpointBodyDataTest,
        "pre_request_script"               : sourcePostmanFormData?.sourcePreRequestScriptTest,
        "pagination_style"                 : "no_pagination",
        "response_parameters"              : "['items']",
        "another_response_parameter"       : "",
        "key_name_to_update"               : "offset",
        "user_key"                         : "hasMore",
        "user_key_url"                     : "Link",
        "custom_pagination_script"         : sourcePostmanFormData?.sourceCustomPaginationScript,
        "min_num"                          : sourcePostmanFormData?.sourceMinNum,
        "max_num"                          : sourcePostmanFormData?.sourceMaxNum,
        "today_str"                        : `datetime.now().strftime('${sourcePostmanFormData?.sourceTodayStr}')`,
        "yesterday_str"                    : `(datetime.now() - timedelta(1)).strftime('${sourcePostmanFormData?.sourceYesterdayStr}')`,
        "rolling_time_format"              : sourcePostmanFormData?.sourceRollingTimeFormat,
        "rolling_frequency"                : sourcePostmanFormData?.sourceRollingFrequency,
        "offset_value"                     : sourcePostmanFormData?.sourceOffsetValue,
        "response_type"                    : sourcePostmanFormData?.sourceResponseType,
        "target"                           : "bizdata_dataset",
        "source_selected_environment_name" : sourcePostmanFormData?.sourceSelectedEnvironment,
        "source_environment_variables"     : sourcePostmanFormData?.sourceEnvironmentList,
      }

    } else if (this.bridge_source_type == 2) {
      configKey = 'bizdata_ops_jdbcsource'

      if (this.dataSource.value.jdbc_string.includes('host_ip')) {
        this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('host_ip', this.dataSource.value.host_ip)
      }
      if (this.dataSource.value.jdbc_string.includes('port_number')) {
        this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('port_number', this.dataSource.value.port_number)
      }
      if (this.dataSource.value.jdbc_string.includes('schema_name')) {
        this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('schema_name', this.dataSource.value.schema_name)
      }
      dataSourceConfig = {
        "key_data": "",
        "chunks_size": this.dataSource.value.chunks_size,
        "jdbc_driver": this.dataSource.value.jdbc_driver,
        "jdbc_string": this.dataSource.value.jdbc_string,
        "username": this.dataSource.value.username,
        "password": await this.helperService.encrypt(this.dataSource.value.password),
        "jdbc_jar_file": this.dataSource.value.jdbc_jar_file,
        "response_parameter": this.dataSource.value.response_parameter,
        "query": this.dataSource.value.query,
        "target": "bizdata_dataset",
        "limit_query": this.dataSource.value.limit_query
      }
    } else if (this.bridge_source_type == 3) {
      configKey = this.sourceDLListOpName.op_name //'bizdata_ops_bizintel360source'
      dataSourceConfig = {
        "version": this.dataSource.value.version,
        "dlsource_host": this.dataSource.value.dlsource_host,
        "dlsource_port": this.dataSource.value.dlsource_port,
        "dlsource_username": this.dataSource.value.dlsource_username,
        "dlsource_password": this.dataSource.value.dlsource_password?await this.helperService.encrypt(this.dataSource.value.dlsource_password):"",
        "dlsource_ca_certs_path": this.dataSource.value.dlsource_ca_certs_path,
        "dlsource_index_name": `bizintel360-${this.dataSource.value.dlsource_index_name}`,
        "scroll": this.dataSource.value.scroll,
        "dlsource_timeout": this.dataSource.value.dlsource_timeout,
        "dlsource_batch_size": this.dataSource.value.dlsource_batch_size,
        "dlsource_body": this.dataSource.value.dlsource_body,
        "timer_type": this.timertypeval,
        "interval_in_seconds": this.summary.value.interval ? this.summary.value.interval : 60,
        "schedule": this.summary.value.schedule ? this.summary.value.schedule : "* * * * *",
        "time_zone": time_zone,
        "target": "bizdata_dataset"
      }

    } else if (this.bridge_source_type == 4) {
      configKey = 'bizdata_ops_websocketsource'
      let sourceWsParams = this.dataSource.value.bridge_source_ws_endpoint_params_raw;
      let sourceWsHeaders = this.dataSource.value.bridge_source_ws_endpoint_headers;
      let sourceWsHeadersArr = [];
      let sourceWsParamsArr = [];
      if (sourceWsParams) {
        for (let index in sourceWsParams) {
          let data;
          if (sourceWsParams[index].bridge_source_ws_paramKey) {
            data = {
              'key': sourceWsParams[index].bridge_source_ws_paramKey,
              'value': sourceWsParams[index].bridge_source_ws_paramValue,
              'description': sourceWsParams[index].bridge_source_ws_paramDescription
            }
            sourceWsParamsArr.push(data);
          }

        }
      }
      if (sourceWsHeaders) {
        for (let index in sourceWsHeaders) {
          let data;
          if (sourceWsHeaders[index].bridge_source_ws_headerKey) {
            data = {
              'key': sourceWsHeaders[index].bridge_source_ws_headerKey,
              'value': sourceWsHeaders[index].bridge_source_ws_headerValue,
              'description': sourceWsHeaders[index].bridge_source_ws_headerDescription
            }
            sourceWsHeadersArr.push(data);
          }

        }
      }

      dataSourceConfig = {
        "endpoint_url": this.dataSource.value.bridge_source_ws_endpoint_url,
        "params": sourceWsParamsArr,
        "headers": sourceWsHeadersArr,
        "message": this.dataSource.value.bridge_source_ws_message.trim(),
        "timer_type": this.timertypeval,
        "interval_in_seconds": this.summary.value.interval ? this.summary.value.interval : 60,
        "schedule": this.summary.value.schedule ? this.summary.value.schedule : "* * * * *",
        "time_zone": time_zone,
        "target": "bizdata_dataset"
      }
    }
    else if (this.bridge_source_type == 5) {
      configKey = 'bizdata_ops_emailsource'
      dataSourceConfig = {
        "user_email": this.dataSource.value.user_email,
        "password": await this.helperService.encrypt(this.dataSource.value.email_password),
        "mail_server": this.dataSource.value.mail_server,
        "out_type": this.dataSource.value.out_type,
        "port_number": Number(this.dataSource.value.email_port_number),
        "timer_type": this.timertypeval,
        "interval_in_seconds": this.summary.value.interval ? this.summary.value.interval : 60,
        "schedule": this.summary.value.schedule ? this.summary.value.schedule : "* * * * *",
        "target": "bizdata_dataset"
      }
    }

    let transformation_ops_json = new Object();
    const sortArray = (arr1, arr2) => {
      arr2.sort((a, b) => {
        const aVal: any = Object.values(a)[0];
        const bVal: any = Object.values(b)[0];
        const arr1_index1 = arr1.findIndex(object => object.id === aVal.id);
        const arr1_index2 = arr1.findIndex(object => object.id === bVal.id);
        return arr1_index1 - arr1_index2;
      });
    };
    sortArray(finalBlocksTmp, filteredArray);
    //console.log(sortArray(finalBlocksTmp, filteredArray));
    
    for (let i = 0; i < filteredArray.length; i++) {
      Object.assign(transformation_ops_json, filteredArray[i]);
    }
    for (let i = 0; i < filteredArray.length; i++) {
      let key = Object.keys(filteredArray[i])
      if(key[0].includes("bizdata_ops_jdbcoutput")){
        filteredArray[i][key[0]].query = [filteredArray[i][key[0]].query];
      }
      Object.assign(transformation_ops_json, filteredArray[i]);
    }
    let transformation_ops_json_tmp = Object.assign({ [configKey]: dataSourceConfig }, transformation_ops_json);
    this.milstoneAPIPayloadConfig = _.cloneDeep(transformation_ops_json_tmp);
    this.checkTokenSessionBeforeCallMileStonApi();
    return transformation_ops_json_tmp;
  }

  ai_ops_source=new Subject<any>();
  selectedOperation:string=''
  MilestoneCheckAPI() {
    // let filterMileApiPayloadConf = this.milstoneAPIPayloadConfig;
    let filterMileApiPayloadConf = {};
    for (const [key, value] of Object.entries(this.milstoneAPIPayloadConfig)) {
      if (!value.isMute) {
        filterMileApiPayloadConf[key] = value;
        delete value.isMute;
        delete value.id;
      }
    };
    this.openLoader();

    this.getStorage().then((res) => {
      let url = environment.python_api_base_url + "/MilestoneCheck/app?top_k=5";
      let startFrom   = new Date().getTime();
      this.backendService.PostMilestoneAPICall(url, filterMileApiPayloadConf, res.mileStoneTokenConsole)
        .pipe(
          timeout(300000),
          catchError((err) => {
            this.cancelLoading();
            if (err.name === 'TimeoutError') {
              this.isConsole = false;
              this.helperService.presentToast("Request timed out. Please try again later.", 1000);
            } else if (err.status === 401) {
              this.storage.set('milestonetoken_console', null);
              this.checkTokenSessionBeforeCallMileStonApi();
            } else {
              this.isConsole = false;
              this.helperService.presentToast("An error occurred. Please try again later.", 1000);
            }
            return throwError(() => err);
          })
        )
        .subscribe(
          (data) => {
            const endTime = new Date().getTime();
            const diff = (endTime - startFrom)/1000 + ' Seconds';
            let keys = Object.keys(filterMileApiPayloadConf);
            let payloadConfig_arr = _.cloneDeep(this.finalBlocksTmp);
            let payloadConfig_arr_tmp = payloadConfig_arr.filter(obj => obj.isMute == false);
            if (this.helperService.isConsoleClear) {
              this.consoleDataArr = []
              this.helperService.isConsoleClear = false;
            }
            let dataSourceKey = ''
            if (keys[keys.length - 1] == "bizdata_ops_restapi") {
              dataSourceKey = 'API ( HTTPS, FTP, SFTP, SOAP/REST/ GraphQL)'
            } else if (keys[keys.length - 1] == "bizdata_ops_jdbcsource") {
              dataSourceKey = 'Database'
            } else if (keys[keys.length - 1] == "bizdata_ops_websocketsource") {
              dataSourceKey = 'Websocket'
            } else if (keys[keys.length - 1] == "bizdata_ops_emailsource") {
              dataSourceKey = 'Email'
            } else if (keys[keys.length - 1] == "bizdata_ops_dlakesource") {
              dataSourceKey = 'Bizintel360 Data Lake'
            }
            let consoleData = {
              operationName : keys[keys.length-1] == "bizdata_ops_restapi" ||  keys[keys.length-1] == 'bizdata_ops_jdbcsource' || keys[keys.length-1] == 'bizdata_ops_websocketsource' || keys[keys.length-1] == 'bizdata_ops_emailsource' || keys[keys.length-1] == 'bizdata_ops_dlakesource' ? dataSourceKey : `${payloadConfig_arr_tmp[payloadConfig_arr_tmp.length-1]?.title} ${payloadConfig_arr_tmp[payloadConfig_arr_tmp.length-1].count}`,
              data:data.body,
              status:data.status, 
              response_time:diff
            }
            let json_data={};
            if (data.body.includes("&quot;")) {
              data.body = data.body.replaceAll("&quot;", '"')
                               .replaceAll("&lt;", '<')
                               .replaceAll("&gt;", '>');
            }
            let parser=new DOMParser()
            const doc = parser.parseFromString(data.body, 'text/html');
            let index = 1;
            doc.querySelectorAll('pre').forEach((element: HTMLElement) => {
              let jsonData = JSON.parse(element.textContent || '{}');
              
              if (element.innerHTML.includes('<!--?xml')) {
                Object.keys(jsonData).forEach((key) => {
                  if (typeof jsonData[key] === 'string' && jsonData[key].includes('\n\n\t')) {
                    jsonData[key] = this.helperService.extractXml(element.innerHTML);
                  }
                });
              }
              json_data[index]=jsonData;
              index++;
            });
            console.log(json_data)
            this.cancelLoading();
            if(this.selectedOperation!=='ai'){
            this.consoleDataArr.unshift(consoleData);
            this.helperService.shareConsoleData(this.consoleDataArr)
            }else{
            this.ai_ops_source.next(json_data);
            }
          }
        )
      }
    )
  }

  //============================== Source Environment Settings ==============================//

  bridgeEnvironments(): UntypedFormArray {
    return this.environmentForm.get('bridge_endpoint_environments_raw') as UntypedFormArray;
  }

  envData(index: number): UntypedFormArray {
    return this.bridgeEnvironments().at(index).get('env_vars') as UntypedFormArray;
  }

  openEnvironment(showEnvironmentTab: boolean) {
    this.addTab();
    this.selectedTabIndex = this.bridgeEnvironments().value.length - 1;
    this.currentDisplayedEnvIndex = this.selectedTabIndex; // Update the displayed index
    this.showEnvironmentTab = showEnvironmentTab;
    this.environmentForm.patchValue({
      selected_environment: 'No Environment',
      bridge_endpoint_selected_environments_name: 'No Environment'
    })
  }

  onEnvironmentChange(event: any) {
    const selectedEnvironment = event.value;
    if (this.showEnvironmentTab == false) {
      this.showEnvironmentTab = false;
    }
    let env_name_arr = []
    for (let control of this.bridgeEnvironments().controls) {
      env_name_arr.push(control.value.env_name);
    }
    this.currentDisplayedEnvIndex = env_name_arr.indexOf(selectedEnvironment);
    this.environmentForm.patchValue({
      selected_environment: selectedEnvironment
    })
    setTimeout(() => {
      this.onChangeSelectedEnvironment();
    }, 200);

  }

  onTargetEnvironmentChange(event: any) {
    const selectedEnvironment = event.value;
    if (this.showEnvironmentTab == false) {
      this.showEnvironmentTab = false;
    }
    let env_name_arr = []
    for (let control of this.bridgeTargetEnvironments().controls) {
      env_name_arr.push(control.value.env_name);
    }
    this.currentTargetDisplayedEnvIndex = env_name_arr.indexOf(selectedEnvironment);
    this.environmentTargetForm.patchValue({
      selected_environment: selectedEnvironment
    })
    setTimeout(() => {
      this.onChangeTargetSelectedEnvironment();
    }, 200);
  }

  addTab() {
    const envTabArray = this._formBuilder.array([this.newEnvironmentsTab()]);
    const bridgeEnvironmentsArray = this.bridgeEnvironments();
    const noCurlyBracesPattern = /^(?!.*[{}]).+$/;
  
    const newGroup = this._formBuilder.group({
      env_name: ['', [
        Validators.required,
        Validators.pattern(noCurlyBracesPattern)
      ]],
      env_vars: envTabArray,
    });
  
    const envNameControl = newGroup.get('env_name');
  
    envNameControl.statusChanges.subscribe(status => {
      if (status === 'INVALID' && envNameControl.dirty) {
        envNameControl.markAsTouched();
      }
    });
  
    bridgeEnvironmentsArray.push(newGroup);
  }
  
  

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  toggleTargetMenu() {
    this.showTargetMenu = !this.showTargetMenu;
  }

  exitEnvironment() {
    if (this.environmentForm.value.selected_environment == 'No Environment') {
      this.currentDisplayedEnvIndex = -1;
    }
    this.showEnvironmentTab = !this.showEnvironmentTab;
    this.onChangeSelectedEnvironment();
  }


  confirmSaveEnv(tabName, index) {
    if (tabName == '' || tabName == undefined) {
      return this.helperService.presentToast("Environment form incomplete", 3000);;
    }
    const header = 'Confirm!';
    const msg = 'Are you sure you want to save this environment?';
    this.confirmSaveEnvAlert(header, msg, tabName, index);
  }

  async confirmSaveEnvAlert(header, msg, tabName, index) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.saveEnv(tabName, index);
          },
        },
      ],
    });
    await alert.present();
  }

  async confirmClearOperation() {
    const alert = await this.alertController.create({
      header: 'Confirm!',
      message: 'Are you sure? You want to clear all operations.',
      buttons: [
        {
          text: 'No',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'Yes',
          cssClass: 'primary-text',
          handler: () => {
            this.clearOps();
          },
        },
      ],
    });
    await alert.present();
  }

  saveEnv(tabName, index) {
    if (this.selectedEnvTabs.length == 0) {
      this.selectedEnvTabs.push(tabName);
      return
    }
    let selectedEnvIndex = this.selectedEnvTabs.indexOf(this.environmentForm.value.selected_environment)
    if (this.environmentForm.value.selected_environment == 'No Environment') {
      selectedEnvIndex = this.selectedEnvTabs.length - 1;
    }
    for (let tab of this.selectedEnvTabs) {
      if ((tab == tabName || tab.toUpperCase() == tabName.toUpperCase()) && selectedEnvIndex != index) {
        return this.helperService.presentToast("Environment name already exits!", 3000);;
      }
    }
    if (selectedEnvIndex >= 0 && selectedEnvIndex == index) {
      this.selectedEnvTabs[index] = tabName;
      this.environmentForm.patchValue({
        selected_environment: tabName,
        bridge_endpoint_selected_environments_name: tabName
      })
    } else {
      this.selectedEnvTabs.push(tabName);
    }
  }

  confirmDeleteEnv(tabName, index) {
    const header = 'Confirm!';
    const msg = 'Are you sure you want to delete environment?';
    this.confirmDeleteEnvAlert(header, msg, tabName, index);
  }

  async confirmDeleteEnvAlert(header, msg, tabName, index) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteEnv(tabName, index);
          },
        },
      ],
    });
    await alert.present();
  }

  deleteEnv(tabName, index) {
    this.selectedEnvTabs.splice(index, 1);
    this.bridgeEnvironments().removeAt(index);
    this.currentDisplayedEnvIndex = -1;
    this.environmentForm.patchValue({
      selected_environment: 'No Environment',
      bridge_endpoint_selected_environments_name: 'No Environment'
    })
  }

  newEnvironmentsTab(): UntypedFormGroup {
    return this._formBuilder.group({
      variable: '',
      type: 'text',
      value: '',
      valueType: ['text']
    });
  }


  addValueEnvironments(data: any): UntypedFormGroup {
    data = { environmentVariable: '', environmentType: '', environmentValue: '', ...data }
    return this._formBuilder.group({
      variable: data.variable,
      type: data.type,
      value: data.value,
      valueType: ['text']
    });
  }

  togglePassword(index: number, envIndex: number) {
    let valueTypeControl = this.envData(index).at(envIndex).get('valueType');
    if (valueTypeControl.value === 'password') {
      valueTypeControl.setValue('text');
    } else {
      valueTypeControl.setValue('password');
    }
  }

  envChangeType(e, i, index) {
    let valueTypeControl = this.envData(index).at(i).get('valueType');
    if (e.value == 'password') {
      valueTypeControl.setValue('password');
    } else {
      valueTypeControl.setValue('text')
    }
  }

  addEnvironmentsTab(index: number) {
    this.envData(index).push(this.newEnvironmentsTab());
  }

  removeEnvironmentsTab(index: number, envIndex: number): void {
    const envTabArray = this.bridgeEnvironments().at(index).get('env_vars') as UntypedFormArray;
    if (envTabArray.length > 1) {
      envTabArray.removeAt(envIndex);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in environment variables ", 2000);
    }
  }

  //========================================== Rest API Operation ===============================//

  bridgeRAOEnvironments(empIndex): UntypedFormArray {
    return this.restapiRows().at(empIndex).get('bridge_endpoint_environments_raw') as UntypedFormArray;
  }

  envRAOData(index: number, empIndex): UntypedFormArray {
    return this.bridgeRAOEnvironments(index).at(empIndex).get('env_vars') as UntypedFormArray;
  }

  openEnvironmentRAO(showEnvironmentTab: boolean, index) {
    this.addTabRAO('', index);
    this.selectedTabIndex = this.bridgeRAOEnvironments(index).controls.length - 1;
    this.currentDisplayedEnvIndexRAO = this.selectedTabIndex; // Update the displayed index
    this.showEnvironmentTabRAO = showEnvironmentTab;
    this.restapiRows().at(index).patchValue({
      selected_environment: 'No Environment',
      bridge_endpoint_selected_environments_name: 'No Environment'
    })
  }

  addTabRAO(env_name?, index?) {
    const envTabArray = this._formBuilder.array([this.newEnvironmentsTabRAO()]);
    const bridgeEnvironmentsArray = this.restapiRows().at(index).get('bridge_endpoint_environments_raw') as UntypedFormArray;
    const noCurlyBracesPattern = /^(?!.*[{}]).+$/;
  
    const newGroup = this._formBuilder.group({
      env_name: ['', [
        Validators.required,
        Validators.pattern(noCurlyBracesPattern)
      ]],
      env_vars: envTabArray,
    });
  
    const envNameControl = newGroup.get('env_name');
  
    envNameControl.statusChanges.subscribe(status => {
      if (status === 'INVALID' && envNameControl.dirty) {
        envNameControl.markAsTouched();
      }
    });
  
    bridgeEnvironmentsArray.push(newGroup);
  }


  confirmSaveEnvRAO(tabName, index, selectedEnvironment,ops_index) {
    if (tabName == '' || tabName == undefined) {
      return this.helperService.presentToast("Environment form incomplete", 3000);;
    }
    const header = 'Confirm!';
    const msg = 'Are you sure you want to save this environment?';
    this.confirmSaveEnvAlertRAO(header, msg, tabName, index, selectedEnvironment,ops_index);
  }

  async confirmSaveEnvAlertRAO(header, msg, tabName, index, selectedEnvironment,ops_index) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.saveEnvRA0(tabName, index, selectedEnvironment,ops_index);
          },
        },
      ],
    });
    await alert.present();
  }

  saveEnvRA0(tabName, index, selectedEnvironment,ops_index) {
    if (this.selectedEnvTabsRAO.length == 0) {
      this.selectedEnvTabsRAO.push(tabName);
      return
    }
    let selectedEnvIndex = this.selectedEnvTabsRAO.indexOf(selectedEnvironment)
    if (selectedEnvironment == 'No Environment') {
      selectedEnvIndex = this.selectedEnvTabsRAO.length - 1;
    }
    for (let tab of this.selectedEnvTabsRAO) {
      if ((tab == tabName || tab.toUpperCase() == tabName.toUpperCase()) && selectedEnvIndex != index) {
        return this.helperService.presentToast("Environment name already exits!", 3000);;
      }
    }
    if (selectedEnvIndex >= 0 && selectedEnvIndex == index) {
      this.selectedEnvTabs[index] = tabName;
      this.restapiRows().at(ops_index).patchValue({
        selected_environment: tabName,
        bridge_endpoint_selected_environments_name: tabName
      })
    } else {
      this.selectedEnvTabsRAO.push(tabName);
    }
  }

  onEnvironmentChangeRAO(event: any, index) {
    const selectedEnvironment = event.value;
    if (this.showEnvironmentTabRAO == false) {
      this.showEnvironmentTabRAO = false;
    }
    let env_name_arr = []
    for (let control of this.bridgeRAOEnvironments(index).controls) {      
      env_name_arr.push(control.value.env_name);
    }
    this.currentDisplayedEnvIndexRAO = env_name_arr.indexOf(selectedEnvironment);
    this.restapiRows().at(index).patchValue({
      selected_environment: selectedEnvironment,
    })
    setTimeout(() => {
      this.ops_environment = [];
      this.onChangeSelectedOpsEnvironment(index, selectedEnvironment);
    }, 200);
  }

  exitEnvironmentRAO(selectedEnvironment,i) {
    if (selectedEnvironment == 'No Environment') {
      this.currentDisplayedEnvIndexRAO = -1;
    }
    this.showEnvironmentTabRAO = !this.showEnvironmentTabRAO;
    this.onChangeSelectedOpsEnvironment(i, selectedEnvironment);
  }

  newEnvironmentsTabRAO(): UntypedFormGroup {
    return this._formBuilder.group({
      variable: '',
      type: 'text',
      value: '',
      valueType: ['text']
    });
  }

  addValueEnvironmentsRAO(data: any): UntypedFormGroup {
    data = { environmentVariable: '', environmentType: '', environmentValue: '', ...data }
    return this._formBuilder.group({
      variable: data.variable,
      type: data.type,
      value: data.value,
      valueType: ['']
    });
  }

  addRAOEnvironmentsTab(index: number, envIndex) {
    this.envRAOData(index, envIndex).push(this.newEnvironmentsTabRAO());
  }

  removeRAOEnvironmentsTab(index: number, envIndex: number, envVarIndex: number): void {
    const envTabArray = this.bridgeRAOEnvironments(index).at(envIndex).get('env_vars') as UntypedFormArray;
    if (envTabArray.length > 1) {
      envTabArray.removeAt(envVarIndex);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in environment variables ", 2000);
    }
  }
  segmentChanged(event: any) {
    const value = event.detail.value;
    if (value === 'first') this.slides.slideTo(0);
    else if (value === 'second') this.slides.slideTo(1);
    else if (value === 'third') this.slides.slideTo(2);
  }

  async slideChanged() {
    const index = await this.slides.getActiveIndex();
    if (index === 0) this.selectedSegment = 'first';
    else if (index === 1) this.selectedSegment = 'second';
    else if (index === 2) this.selectedSegment = 'third';
  }

  envRAOChangeType(e, index, envIndex) {
    let valueTypeControl = this.envRAOData(index, envIndex).at(envIndex).get('valueType');
    if (e.value == 'password') {
      valueTypeControl.setValue('password');
    } else {
      valueTypeControl.setValue('text')
    }
  }

  toggleRAOPassword(index: number, j, envIndex: number) {
    let valueTypeControl = this.envRAOData(index, j).at(envIndex).get('valueType');
    if (valueTypeControl.value === 'password') {
      valueTypeControl.setValue('text');
    } else {
      valueTypeControl.setValue('password');
    }
  }

  //=============================================================================================//

  //=========================== Target Environment Settings ======================//
  exitTargetEnvironment() {
    if (this.environmentTargetForm.value.selected_environment == 'No Environment') {
      this.currentTargetDisplayedEnvIndex = -1;
    }
    this.showTargetEnvironmentTab = !this.showTargetEnvironmentTab;
    this.onChangeTargetSelectedEnvironment();
  }

  newEnvironmentsTargetTab(): UntypedFormGroup {
    return this._formBuilder.group({
      variable: '',
      type: 'text',
      value: '',
      valueType: ['text']
    });
  }

  addTargetValueEnvironments(data: any): UntypedFormGroup {
    data = { environmentVariable: '', environmentType: '', environmentValue: '', ...data }
    return this._formBuilder.group({
      variable: data.variable,
      type: data.type,
      value: data.value,
      valueType: ['']
    });
  }


  confirmTargetSaveEnv(tabName, index) {
    if (tabName == '' || tabName == undefined) {
      return this.helperService.presentToast("Environment form incomplete", 3000);;
    }
    const header = 'Confirm!';
    const msg = 'Are you sure you want to save this environment?';
    this.confirmTargetSaveEnvAlert(header, msg, tabName, index);
  }

  async confirmTargetSaveEnvAlert(header, msg, tabName, index) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.saveTargetEnv(tabName, index);
          },
        },
      ],
    });
    await alert.present();
  }

  saveTargetEnv(tabName, index) {
    if (this.selectedTargetEnvTabs.length == 0) {
      this.selectedTargetEnvTabs.push(tabName);
      return
    }
    let selectedEnvIndex = this.selectedTargetEnvTabs.indexOf(this.environmentTargetForm.value.selected_environment)
    if (this.environmentTargetForm.value.selected_environment == 'No Environment') {
      selectedEnvIndex = this.selectedTargetEnvTabs.length - 1;
    }
    for (let tab of this.selectedTargetEnvTabs) {
      if ((tab == tabName || tab.toUpperCase() == tabName.toUpperCase()) && selectedEnvIndex != index) {
        return this.helperService.presentToast("Environment name already exits!", 3000);;
      }
    }
    if (selectedEnvIndex >= 0 && selectedEnvIndex == index) {
      this.selectedTargetEnvTabs[index] = tabName;
      this.environmentTargetForm.patchValue({
        selected_environment: tabName,
        bridge_endpoint_selected_environments_name: tabName
      })
    } else {
      this.selectedTargetEnvTabs.push(tabName);
    }
  }

  // destinationDropped(event: CdkDragDrop<any>) {
  //   setTimeout(()=>{
  //     let eq = _.isEqual( event.previousContainer.data.blocks, event.container.data.blocks);
  //     if (eq) {
  //       let e = this.blocks.findIndex(e=> //console.log(e) );
  //       // this.blocks[event.previousContainer.data.index] = event.container.data.block;
  //       // this.blocks[event.container.data.index] = event.previousContainer.data.block;
  //       // this.blocks = this.blocks.map( (value)  => ({ "title": value.title, "id": this.helperService.generateRandomId(6) }));
  //       // this.newBlocks = this.splitArr(this.blocks, 4);
  //       // //console.log(this.newBlocks);
  //     } else {
  //       copyArrayItem(event.previousContainer.data, event.container.data.blockArr, event.previousIndex, event.container.data.index);
  //       this.blocks = this.blocks.map( (value)  => ({ "title": value.title, "id": this.helperService.generateRandomId(6) }));
  //       this.newBlocks = this.splitArr(this.blocks, 4);
  //     }
  //     if (event.previousContainer.data) {
  //       remove(this.operations, { temp: true });
  //     }
  //   }, 100)
  // }

  bridgenameCheck(event) {
    return ((event.keyCode >= '65' && event.keyCode <= '90') || (event.key >= '0' && event.key <= '9') || ['ArrowLeft', 'ArrowRight', 'Backspace', ' ', '_', 'Tab'].includes(event.key));
  }
  dlakeIndexSource(event){
    this.bridge_summary_source_name = this.dataSource.value.dlsource_index_name;
  }
  dlakeIndexTarget(event){
    this.bridge_summary_target_name = this.dataTarget.value.index_name;
  }
  advanceSettingSBS(event) {
    if (event.target.value >= 1) {
      this.summary.controls["sbs"].setValue(event.target.value);
    } else {
      // alert();
      this.summary.controls["sbs"].setValue(1000);
    }
  }

  advanceSettingSRWT(event) {
    if (event.target.value >= 4000 && event.target.value <= 10000) {
      this.summary.controls["srwt"].setValue(event.target.value);
    } else {
      this.summary.controls["srwt"].setErrors({ 'outOfRange': true });
    }
  }

  advanceSettingLogSize(event) {
    if (event.target.value >= 20) {
      this.summary.controls["logsize"].setValue(event.target.value);
    }
  }

  removeItem(id, title) {
    let removedItem = this.finalBlocks.find(e => e.id === id);
    let indexOfBlock = this.finalBlocks.findIndex(index => index.id === removedItem.id);
    let currentCount = this.finalBlocks[indexOfBlock].count;
    this.finalBlocks.splice(indexOfBlock, 1);
    this.blocks.splice(indexOfBlock, 1);
    if (title == "Email") {
      this.removeEmailOpsTos(indexOfBlock);
    }
    // this.newBlocks = this.splitArr(this.finalBlocks, 4);
    this.newBlocks = this.splitArr(this.finalBlocks, 3);
    if (this.finalBlocks.length == 0) this.blocks = [];
    this.removeAndRestOpsForm(id, title, currentCount);
  }

  removeAndRestOpsForm(id, title, currentCount) {
    let totalCount;
    if (title == 'Data types') {
      this.isDataTypeFromEnabled = false;
      let index = this.datatypesRows().value.findIndex(x => x.id == id);
      this.datatypesRows().removeAt(index);
      totalCount = this.datatypesRows().controls.length;
    } else if (title == 'Append') {
      this.isAppendFromEnabled = false;
      let index = this.appendRows().value.findIndex(x => x.id == id);
      this.appendRows().removeAt(index);
      totalCount = this.appendRows().controls.length;
    } else if (title == 'Titlecase') {
      this.isTitlecaseFromEnabled = false;
      let index = this.titlecaseRows().value.findIndex(x => x.id == id);
      this.titlecaseRows().removeAt(index);
      totalCount = this.titlecaseRows().controls.length;
    } else if (title == 'Uppercase') {
      this.isUppercaseFromEnabled = false;
      let index = this.uppercaseRows().value.findIndex(x => x.id == id);
      this.uppercaseRows().removeAt(index);
      totalCount = this.uppercaseRows().controls.length;
    } else if (title == 'Lowercase') {
      this.isLowercaseFromEnabled = false;
      let index = this.lowercaseRows().value.findIndex(x => x.id == id);
      this.lowercaseRows().removeAt(index);
      totalCount = this.lowercaseRows().controls.length;
    } else if (title == 'Data extractor') {
      this.isData_extractorFromEnabled = false;
      let index = this.dataextractorRows().value.findIndex(x => x.id == id);
      this.dataextractorRows().removeAt(index);
      totalCount = this.dataextractorRows().controls.length;
    } else if (title == 'Trim') {
      this.isTrimFromEnabled = false;
      let index = this.trimRows().value.findIndex(x => x.id == id);
      this.trimRows().removeAt(index);
      totalCount = this.trimRows().controls.length;
    } else if (title == 'Base64 encoding') {
      this.isBase64encodingFromEnabled = false;
      let index = this.base64encodingRows().value.findIndex(x => x.id == id);
      this.base64encodingRows().removeAt(index);
      totalCount = this.base64encodingRows().controls.length;
    } else if (title == 'Base64 decoding') {
      this.isBase64decodingFromEnabled = false;
      let index = this.base64decodingRows().value.findIndex(x => x.id == id);
      this.base64decodingRows().removeAt(index);
      totalCount = this.base64decodingRows().controls.length;
    } else if (title == 'XML to JSON') {
      this.isXML_to_JSONFromEnabled = false;
      let index = this.xmltojsonRows().value.findIndex(x => x.id == id);
      this.xmltojsonRows().removeAt(index);
      totalCount = this.xmltojsonRows().controls.length;
    } else if (title == 'JSON to delimiter') {
      this.isJSON2dlFromEnabled = false
      let index = this.json2dlRows().value.findIndex(x => x.id == id);
      this.json2dlRows().removeAt(index);
      totalCount = this.json2dlRows().controls.length;
    } else if (title == 'Delimiter to JSON') {
      this.isDl2jsonFromEnabled = false
      let index = this.dl2jsonRows().value.findIndex(x => x.id == id);
      this.dl2jsonRows().removeAt(index);
      totalCount = this.dl2jsonRows().controls.length;
    } else if (title == 'JSON to String') {
      this.isJson2stringFromEnabled = false
      let index = this.json2stringRows().value.findIndex(x => x.id == id);
      this.json2stringRows().removeAt(index);
      totalCount = this.json2stringRows().controls.length;
    } else if (title == 'String to JSON') {
      this.isString2jsonFromEnabled = false
      let index = this.string2jsonRows().value.findIndex(x => x.id == id);
      this.string2jsonRows().removeAt(index);
    } else if (title == 'JSON to XML') {
      this.isJSON_to_XMLFromEnabled = false
      let index = this.jsontoxmlRows().value.findIndex(x => x.id == id);
      this.jsontoxmlRows().removeAt(index);
      totalCount = this.jsontoxmlRows().controls.length;
    } else if (title == 'Repeat First Row Values') {
      this.isRepeatfirstrowFromEnabled = false
      let index = this.repeatfirstrowRows().value.findIndex(x => x.id == id);
      this.repeatfirstrowRows().removeAt(index);
      totalCount = this.repeatfirstrowRows().controls.length;
    } else if (title == 'Generate Array Sequence Number') {
      this.isGeneratesequenceFromEnabled = false
      let index = this.generatesequenceRows().value.findIndex(x => x.id == id);
      this.generatesequenceRows().removeAt(index);
      totalCount = this.generatesequenceRows().controls.length;
    } else if (title == 'Send Keys Top of Root') {
      this.isToplevelFromEnabled = false
      let index = this.toplevelRows().value.findIndex(x => x.id == id);
      this.toplevelRows().removeAt(index);
      totalCount = this.toplevelRows().controls.length;
    } else if (title == 'Today Timestamp') {
      this.isDatetimestampFromEnabled = false
      let index = this.datetimestampRows().value.findIndex(x => x.id == id);
      this.datetimestampRows().removeAt(index);
      totalCount = this.datetimestampRows().controls.length;
    } else if (title == 'Data aggregation') {
      this.isDataaggregationFromEnabled = false
      let index = this.dataaggregationRows().value.findIndex(x => x.id == id);
      this.dataaggregationRows().removeAt(index);
      totalCount = this.dataaggregationRows().controls.length;
    } else if (title == 'Pivot') {
      this.isPivotFromEnabled = false
      let index = this.pivotRows().value.findIndex(x => x.id == id);
      this.pivotRows().removeAt(index);
      totalCount = this.pivotRows().controls.length;
    } else if (title == 'Unpivot') {
      this.isUnPivotFromEnabled = false
      let index = this.unpivotRows().value.findIndex(x => x.id == id);
      this.unpivotRows().removeAt(index);
      totalCount = this.unpivotRows().controls.length;
    } else if (title == 'Single Line to Multiline') {
      this.chopFormEnabled = false
      let index = this.chopRows().value.findIndex(x => x.id == id);
      this.chopRows().removeAt(index);
      totalCount = this.chopRows().controls.length;
    } else if (title == 'Single Line to Tuple') {
      this.singleline2tupleFormEnabled = false
      let index = this.singleline2tupleRows().value.findIndex(x => x.id == id);
      this.singleline2tupleRows().removeAt(index);
      totalCount = this.singleline2tupleRows().controls.length;
    } else if (title == 'Tuple to Single Line') {
      this.tuple2singlelineFormEnabled = false
      let index = this.singleline2tupleRows().value.findIndex(x => x.id == id);
      this.tuple2singlelineRows().removeAt(index);
      totalCount = this.tuple2singlelineRows().controls.length;
    } else if (title == 'Rename') {
      this.isrenameFromEnabled = false
      let index = this.renameRows().value.findIndex(x => x.id == id);
      this.renameRows().removeAt(index);
      totalCount = this.renameRows().controls.length;
    } else if (title == 'Drop all events to start with') {
      this.isdropeventsstartswithFromEnabled = false
      let index = this.dropeventsstartswithRows().value.findIndex(x => x.id == id);
      this.dropeventsstartswithRows().removeAt(index);
      totalCount = this.dropeventsstartswithRows().controls.length;
    } else if (title == 'Eliminate') {
      this.iseliminateFromEnabled = false
      let index = this.eliminateRows().value.findIndex(x => x.id == id);
      this.eliminateRows().removeAt(index);
      totalCount = this.eliminateRows().controls.length;
    } else if (title == 'Round') {
      this.isroundFromEnabled = false
      let index = this.roundRows().value.findIndex(x => x.id == id);
      this.roundRows().removeAt(index);
      totalCount = this.roundRows().controls.length;
    } else if (title == 'Calculator') {
      this.iscalculaterFromEnabled = false
      let index = this.calculaterRows().value.findIndex(x => x.id == id);
      this.calculaterRows().removeAt(index);
      totalCount = this.calculaterRows().controls.length;
    } else if (title == 'Date Analytics') {
      this.isdateanalyticsFromEnabled = false
      let index = this.dateanalyticsRows().value.findIndex(x => x.id == id);
      this.dateanalyticsRows().removeAt(index);
      totalCount = this.dateanalyticsRows().controls.length;
    } else if (title == 'Substitute') {
      this.issubstituteFromEnabled = false;
      let index = this.substituteRows().value.findIndex(x => x.id == id);
      this.substituteRows().removeAt(index);
      totalCount = this.substituteRows().controls.length;
    } else if (title == 'Strip') {
      this.isstripFromEnabled = false;
      let index = this.stripRows().value.findIndex(x => x.id == id);
      this.stripRows().removeAt(index);
      totalCount = this.stripRows().controls.length;
    } else if (title == 'Substring') {
      this.issubstringFromEnabled = false;
      let index = this.substringRows().value.findIndex(x => x.id == id);
      this.substringRows().removeAt(index);
      totalCount = this.substringRows().controls.length;
    } else if (title == 'Drop all events for value') {
      this.isdropalleventvaluesFromEnabled = false
      let index = this.dropalleventvaluesRows().value.findIndex(x => x.id == id);
      this.dropalleventvaluesRows().removeAt(index);
      totalCount = this.dropalleventvaluesRows().controls.length;
    } else if (title == 'API') {
      this.isrestapiFormEnabled = false
      let index = this.restapiRows().value.findIndex(x => x.id == id);
      this.restapiRows().removeAt(index);
      this.opsData.splice(index, 1);
      totalCount = this.restapiRows().controls.length;
    } else if (title == 'Sleep time') {
      this.issleepFromEnabled = false
      let index = this.sleepRows().value.findIndex(x => x.id == id);
      this.sleepRows().removeAt(index);
      totalCount = this.sleepRows().controls.length;
    } else if (title == 'Python') {
      this.ispycodeFromEnabled = false
      let index = this.pycodeRows().value.findIndex(x => x.id == id);
      this.pycodeRows().removeAt(index);
      totalCount = this.pycodeRows().controls.length;
    }  else if (title == 'AI Operation') {
      this.isaiopsFromEnabled = false
      let index = this.aiopsRows().value.findIndex(x => x.id == id);
      this.aiopsRows().removeAt(index);
      totalCount = this.aiopsRows().controls.length;
      this.operationResponses[index]="";
      this.operationStatus[index] = "";
      this.operationResponseTime[index] = "";
      this.operationResponse_err[index] = "";

    } 
    else if (title == 'Email') {
      this.isemailFromEnabled = false
      let index = this.emailRows().value.findIndex(x => x.id == id);
      this.emailRows().removeAt(index);
      totalCount = this.emailRows().controls.length;
    } else if (title == 'JSON') {
      this.isjsonFormEnabled = false
      let index = this.jsonRows().value.findIndex(x => x.id == id);
      this.jsonRows().removeAt(index);
      totalCount = this.jsonRows().controls.length;
    } else if (title == 'DL Ingestion') {
      this.isDLIngestionFormEnabled = false
      let index = this.dlIngestionRows().value.findIndex(x => x.id == id);
      this.dlIngestionRows().removeAt(index);
      totalCount = this.dlIngestionRows().controls.length;
      // } else if (title == 'File') {
      //   this.isfileFromEnabled = false
      //   let index = this.fileRows().value.findIndex(x => x.id == id);
      //   this.fileRows().removeAt(index);
    } else if (title == 'DataLake Search') {
      this.isDlsearchFormEnabled = false
      let index = this.dlsearchRows().value.findIndex(x => x.id == id);
      this.dlsearchRows().removeAt(index);
      totalCount = this.dlsearchRows().controls.length;
    } else if (title == 'Database') {
      this.isjdbcoutputFromEnabled = false
      let index = this.jdbcoutputRows().value.findIndex(x => x.id == id);
      this.jdbcoutputRows().removeAt(index);
      totalCount = this.jdbcoutputRows().controls.length;
    } else if (title == 'Filter') {
      this.isfilterFromEnabled = false
      let index = this.filterRows().value.findIndex(x => x.id == id);
      this.filterRows().removeAt(index);
      totalCount = this.filterRows().controls.length;
    } else if (title == 'Encode Decode') {
      this.isEncodedecodeFromEnabled = false
      let index = this.encodedecodeRows().value.findIndex(x => x.id == id);
      this.encodedecodeRows().removeAt(index);
      totalCount = this.encodedecodeRows().controls.length;
    } else if (title == 'Zipfile in Base64') {
      this.isZipfileinbase64FromEnabled = false
      let index = this.zipfileinbase64Rows().value.findIndex(x => x.id == id);
      this.zipfileinbase64Rows().removeAt(index);
      totalCount = this.zipfileinbase64Rows().controls.length;
    } else if (title == 'Array Count') {
      this.isArraycountFromEnabled = false
      let index = this.arraycountRows().value.findIndex(x => x.id == id);
      this.arraycountRows().removeAt(index);
      totalCount = this.arraycountRows().controls.length;
    } else if (title == 'Delimiter to Array') {
      this.isDl2arrayFormEnabled = false
      let index = this.dl2arrayRows().value.findIndex(x => x.id == id);
      this.dl2arrayRows().removeAt(index);
      totalCount = this.dl2arrayRows().controls.length;
    } else if (title == 'PDF Extractor') {
      this.isPdfextractorFormEnabled = false
      let index = this.pdfextractorRows().value.findIndex(x => x.id == id);
      this.pdfextractorRows().removeAt(index);
      totalCount = this.pdfextractorRows().controls.length;
    } else if (title == 'File Extractor') {
      this.isFileextractorFormEnabled = false
      let index = this.fileextractorRows().value.findIndex(x => x.id == id);
      this.fileextractorRows().removeAt(index);
      totalCount = this.fileextractorRows().controls.length;
    } else if (title == 'Document Understanding') {
      this.isDocunderstandingFromEnabled = false
      let index = this.docunderstandingRows().value.findIndex(x => x.id == id);
      this.docunderstandingRows().removeAt(index);
      totalCount = this.docunderstandingRows().controls.length;
    } else if (title == 'Grok Pattern') {
      this.isGorkPatternFormEnabled = false
      let index = this.grokpatternRows().value.findIndex(x => x.id == id);
      this.grokpatternRows().removeAt(index);
      totalCount = this.grokpatternRows().controls.length;
    } else if (title == 'Image Understanding') {
      this.isImgunderstandingFromEnabled = false
      let index = this.imgunderstandingRows().value.findIndex(x => x.id == id);
      this.imgunderstandingRows().removeAt(index);
      totalCount = this.imgunderstandingRows().controls.length;
    } else if (title == 'Filter Ends') {
      this.isfilterEndsFromEnabled = false
      let index = this.filterEndsRows().value.findIndex(x => x.id == id);
      this.filterEndsRows().removeAt(index);
      totalCount = this.filterEndsRows().controls.length;
    } else if (title == 'Raw Sentence Generator') {
      this.isRawSentenceGeneratorFormEnabled = false
      let index = this.rawsentencegeneratorRows().value.findIndex(x => x.id == id);
      this.rawsentencegeneratorRows().removeAt(index);
      totalCount = this.rawsentencegeneratorRows().controls.length;
    } else if (title == 'Time Units') {
      this.isTimeUnitsFormEnabled = false
      let index = this.timeunitsRows().value.findIndex(x => x.id == id);
      this.timeunitsRows().removeAt(index);
      totalCount = this.timeunitsRows().controls.length;
    } else if (title == 'Data Chunking') {
      this.isDataChunkingFormEnabled = false
      let index = this.datachunkingRows().value.findIndex(x => x.id == id);
      this.datachunkingRows().removeAt(index);
      totalCount = this.datachunkingRows().controls.length;
    } else if (title == 'HTML Extractor') {
      this.isHTMLExtractorFormEnabled = false
      let index = this.htmlExtractorRows().value.findIndex(x => x.id == id);
      this.htmlExtractorRows().removeAt(index);
      totalCount = this.htmlExtractorRows().controls.length;
    }
    else if (title == 'JSON to AVRO') {
      this.isJson2avroFormEnabled = false
      let index = this.jason2avroRows().value.findIndex(x => x.id == id);
      this.jason2avroRows().removeAt(index);
      totalCount = this.jason2avroRows().controls.length;
    } else if (title == 'AVRO to JSON') {
      this.isAvro2jsonFormEnabled = false
      let index = this.avro2jsonRows().value.findIndex(x => x.id == id);
      this.avro2jsonRows().removeAt(index);
      totalCount = this.avro2jsonRows().controls.length;
    } else if (title == 'Extract to Array') {
      this.isExtract2ArrayFormEnabled = false
      let index = this.extract2ArrayRows().value.findIndex(x => x.id == id);
      this.extract2ArrayRows().removeAt(index);
      totalCount = this.extract2ArrayRows().controls.length;
    }


    //Middle or last possition - We have to decrease the count - 1; 
    let filterdOperation = this.finalBlocks.filter(function (entry) { return entry.title == title });
    if (totalCount >= currentCount) {
      for (let i = currentCount - 1; i < filterdOperation.length; i++) {
        filterdOperation[i].count = filterdOperation[i].count - 1;
      }
    }
    //if one operation exists in drop section
    if (this.finalBlocks.length == 0) {
      this.selectedOperationId = '';
    }
  }


  // drop(event: CdkDragDrop<any>) {
  //   //console.log(event);
  //   let eq = _.isEqual( event.previousContainer.data.blockArr, event.container.data.blockArr);
  //   if (eq) {
  //     //console.log("1");
  //     this.blocks[event.previousContainer.data.index] = event.container.data.block;
  //     this.blocks[event.container.data.index] = event.previousContainer.data.block;
  //     // moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  //     // this.blocks = this.blocks.map( (value)  => ({ "title": value.title, "id": this.helperService.generateRandomId(6) }));
  //     // this.newBlocks = this.splitArr(this.blocks, 4);
  //   } else {
  //     //console.log("2");
  //     copyArrayItem(event.previousContainer.data.blockArr, event.container.data.blockArr, event.previousIndex, event.currentIndex);
  //     this.blocks = this.blocks.map( (value)  => ({ title: value.title, keys: value.keys, id: this.helperService.generateRandomId(6) }));
  //     // let newArr = _.chunk(this.blocks, 4);
  //     // //console.log(newArr);
  //     // this.newBlocks = this.splitArr(this.blocks, 4);
  //     //console.log(this.blocks);
  //     this.newBlocks = this.reverseAfterArrays(this.blocks, 3);
  //     //console.log("newBlocks", this.newBlocks);
  //     this.dataArray = []
  //     for(let item of this.newBlocks){
  //       this.dataArray.push({
  //         IsEnabletd : false,
  //         Title : item.title,
  //         Id: item.id
  //       })
  //     }
  //     //console.log(this.dataArray)
  //   }
  //   if (event.previousContainer.data) {
  //     remove(this.operations, { temp: true });
  //   }
  // }

  // onSourceListExited(event) {
  //   this.operations.splice(event.container.getItemIndex(event.item) + 1, 0, { ... event.item.data, temp: true });
  // }


  noReturnPredicate() {
    return false;
  }

  onSourceListEntered(event: CdkDragEnter<any>) {
    remove(this.operations, { temp: true });
  }
  onSourceListEnteredSearch(event: CdkDragEnter<any>) {
    remove(this.operationsSearch, { temp: true });
  }

  loadPostmanPreviewComponent(previewData?, type?) {
    this.items[type][0].subItems = [];
    this.items[type][1].subItems = [];
    this.items[type][2].subItems = [];
    this.items[type][3].subItems = [];
    if(type == 'source'){
      this.copyPreviewDataSource = previewData;
    }else{
      this.copyPreviewData = previewData;
    }
    this.index == 1
    this.visibleIndex=-1;
    for (const [key, value] of Object.entries(previewData?.endpoint_headers)) {
      let haederObj = { headerKey: key, headerValue: value }
      this.items[type][0].subItems.push(haederObj)
    }
    for (const [key, value] of Object.entries(previewData?.endpoint_params)) {
      let paramObj = { paramKey: key, paramValue: value }
      this.items[type][1].subItems.push(paramObj)
    }
    let preRequestScriptTmp = {
      preRequestScript: previewData?.pre_request_script
    }
    let requestBodyTmp = { requestBody: null };
    if (typeof previewData?.endpoint_body === 'string') {
      requestBodyTmp.requestBody = previewData.endpoint_body;
    } else if (previewData?.endpoint_body) {
      requestBodyTmp.requestBody = JSON.stringify(previewData.endpoint_body);
    } else {
      requestBodyTmp.requestBody = null;
    }
    // this._previewPostmanEditor.codeMirror.refresh();
    this.items[type][2].subItems.push(requestBodyTmp)
    this.items[type][3].subItems.push(preRequestScriptTmp)
    this.items[type][4].requestMethod = previewData?.endpoint_method ? previewData?.endpoint_method : "";
    this.items[type][4].requestUrl = previewData?.endpoint_url ? previewData?.endpoint_url : "";
  }

  loadAPIPostmanPreviewComponent(previewData?, formId?) {
    var idIndex = -1;
    var filteredObj = this.restapiRows().controls.find(function (item, i) {
      if (item.value.id === formId) {
        idIndex = i;
        return i;
      }
    });
    let items = (<UntypedFormGroup>this.restapiRows().at(idIndex)).get('preview_postman_data')
    this.index == 1
    for (const [key, valuetmp] of Object.entries(previewData?.requestHeaders)) {
      let headerObj = { headerKey: key, headerValue: valuetmp }
      items.value[0].subItems.push(headerObj)
    }
    for (const [key, value] of Object.entries(previewData?.requestParams)) {
      let paramObj = { paramKey: key, paramValue: value }
      items.value[1].subItems.push(paramObj)
    }
    let preRequestScriptTmp = {
      preRequestScript: previewData?.preRequestScript
    }
    let requestBodyTmp = { requestBody: null };
    if (typeof previewData?.requestBody === 'string') {
      requestBodyTmp.requestBody = previewData.requestBody;
    } else if (previewData?.requestBody) {
      requestBodyTmp.requestBody = JSON.stringify(previewData.requestBody);
    } else {
      requestBodyTmp.requestBody = null;
    }
    // this._previewPostmanEditor.codeMirror.refresh();
    items.value[2].subItems.push(requestBodyTmp)
    items.value[3].subItems.push(preRequestScriptTmp)
    items.value[4].requestMethod = previewData?.requestMethod
    items.value[4].requestUrl = previewData?.requestUrl
    //console.log(this.restapiRows().at(idIndex).get('preview_postman_data'))
  }

  drop(event: CdkDragDrop<any>) {
    //console.log(event);
    let eq = _.isEqual(event.previousContainer.data.blockArr, event.container.data.blockArr);
    if (eq) {
      if (event.previousContainer.data.block == undefined) {
        //console.log(event.item.data);
        copyArrayItem(event.previousContainer.data.blockArr, event.container.data.blockArr, event.previousIndex, 0);
        var id = this.helperService.generateRandomId(6)
        var item = event.container.data.blockArr[0].title
        var isMute = false;
        this.finalBlocks.push({
          id: id,
          keys: event.container.data.blockArr[0].keys,
          title: item,
          isValid: true,
          isMute: isMute,
        })
        // this.blocks = this.blocks.map( (value)  => ({ title: value.title, keys: value.keys, id: this.helperService.generateRandomId(6) }));
        this.newBlocks = this.splitArr(this.finalBlocks, 3);
        // this.newBlocks = this.splitArr(this.finalBlocks, this.splitValue);
        // console.log(this.finalBlocks);
        // console.log(this.newBlocks);
        this.openForm(item, id)
      } else {
        let current_ops_index = this.finalBlocks.findIndex((element) => element.id == event.container.data.block.id);
        let previous_ops_index = this.finalBlocks.findIndex((element) => element.id == event.previousContainer.data.block.id);
        if (previous_ops_index > current_ops_index) {
          this.finalBlocks.splice(current_ops_index, 0, event.previousContainer.data.block);
          this.finalBlocks.splice(previous_ops_index + 1, 1)
        }
        if (current_ops_index > previous_ops_index) {
          this.finalBlocks.splice(previous_ops_index, 1)
          this.finalBlocks.splice(current_ops_index, 0, event.previousContainer.data.block);
        }

        let filterdOperationCurrent = this.finalBlocks.filter(function (entry) { return entry.title == event.container.data.block.title });
        let filterdOperationPrevious = this.finalBlocks.filter(function (entry) { return entry.title == event.previousContainer.data.block.title });
        let countCurrent = 1, countPrevious = 1;;
        for (let i = 0; i < filterdOperationCurrent.length; i++) {
          filterdOperationCurrent[i].count = countCurrent;
          countCurrent++;
        }
        for (let i = 0; i < filterdOperationPrevious.length; i++) {
          filterdOperationPrevious[i].count = countPrevious;
          countPrevious++;
        }
        this.newBlocks = this.splitArr(this.finalBlocks, 3);
        // console.log(this.finalBlocks);
        // console.log(this.newBlocks);
        // this.newBlocks = this.splitArr(this.finalBlocks, this.splitValue);
      }
    } else {
      //console.log(event.item.data);
      copyArrayItem(event.previousContainer.data.blockArr, event.container.data.blockArr, event.previousIndex, 0);
      var id = this.helperService.generateRandomId(6)
      var item = event.container.data.blockArr[0].title
      var isMute = false;
      this.finalBlocks.push({
        id: id,
        keys: event.container.data.blockArr[0].keys,
        title: item,
        isValid: true,
        isMute: isMute
      })
      // this.blocks = this.blocks.map( (value)  => ({ title: value.title, keys: value.keys, id: this.helperService.generateRandomId(6) }));
      this.newBlocks = this.splitArr(this.finalBlocks, 3);
      // this.newBlocks = this.splitArr(this.finalBlocks, this.splitValue);
      // console.log(this.finalBlocks);
      // console.log(this.newBlocks);
      this.openForm(item, id)
    }
    if (event.previousContainer.data) {
      remove(this.operations, { temp: true });
      remove(this.operationsSearch, { temp: true });
    }

    if (item == 'Data types') {
      this.addNewDataTypesForm(id, isMute);
    } else if (item == 'Append') {
      this.addNewAppendForm(id, isMute);
    } else if (item == 'Titlecase') {
      this.addNewTitlecaseForm(id, isMute);
    } else if (item == 'Uppercase') {
      this.addNewUppercaseForm(id, isMute);
    } else if (item == 'Lowercase') {
      this.addNewLowercaseForm(id, isMute);
    } else if (item == 'Data extractor') {
      this.addNewDataExtractorForm(id, isMute)
    } else if (item == 'Trim') {
      this.addNewTrimForm(id, isMute);
    } else if (item == 'Base64 encoding') {
      this.addNewBase64encodingForm(id, isMute)
    } else if (item == 'Base64 decoding') {
      this.addNewBase64decodingForm(id, isMute)
    } else if (item == 'JSON to XML') {
      this.addNewJSONtoXMLForm(id, isMute)
    } else if (item == 'XML to JSON') {
      this.addNewXmltojsonForm(id, isMute)
    } else if (item == 'Repeat First Row Values') {
      this.addNewRepeatfirstrowForm(id, isMute)
    } else if (item == 'JSON to delimiter') {
      this.addNewJson2dlForm(id, isMute)
    } else if (item == 'Delimiter to JSON') {
      this.addNewDl2jsonForm(id, isMute)
    } else if (item == 'JSON to String') {
      this.addNewJson2stringForm(id, isMute)
    } else if (item == 'String to JSON') {
      this.addNewString2jsonForm(id, isMute)
    } else if (item == 'Generate Array Sequence Number') {
      this.addNewGeneratesequenceForm(id, isMute)
    } else if (item == 'Send Keys Top of Root') {
      this.addNewToplevelForm(id, isMute)
    } else if (item == 'Today Timestamp') {
      this.addNewDatetimestampForm(id, isMute)
    } else if (item == 'Data aggregation') {
      this.addNewDataaggregationForm(id, isMute)
    } else if (item == 'Pivot') {
      this.addNewPivotForm(id, isMute)
    } else if (item == 'Unpivot') {
      this.addNewUnPivotForm(id, isMute)
    } else if (item == 'Single Line to Multiline') {
      this.addNewChopForm(id, isMute)
    } else if (item == 'Single Line to Tuple') {
      this.addNewSingleline2tupleForm(id, isMute)
    } else if (item == 'Tuple to Single Line') {
      this.addNewTuple2singlelineForm(id, isMute)
    } else if (item == 'Rename') {
      this.addNewRnameForm(id, isMute)
    } else if (item == 'Drop all events to start with') {
      this.addNewDropeventsstartswithForm(id, isMute)
    } else if (item == 'Eliminate') {
      this.addNewEliminateForm(id, isMute)
    } else if (item == 'Drop all events for value') {
      this.addNewDropalleventvaluesForm(id, isMute)
    } else if (item == 'Round') {
      this.addNewRoundForm(id, isMute)
    } else if (item == 'Calculator') {
      this.addNewCalculaterForm(id, isMute)
    } else if (item == 'Date Analytics') {
      this.addNewDateanalyticsForm(id, isMute)
    } else if (item == 'Substitute') {
      this.addNewSubstituteForm(id, isMute)
    } else if (item == 'Strip') {
      this.addNewStripForm(id, isMute)
    } else if (item == 'Substring') {
      this.addNewSubstringForm(id, isMute)
    } else if (item == 'API') {
      this.addNewRestapiForm(id, isMute)
    } else if (item == 'Sleep time') {
      this.addNewSleepForm(id, isMute)
    } else if (item == 'Python') {
      this.addNewPycodeForm(id, isMute)
    } else if (item == 'AI Operation') {
      this.addNewAiOpsForm(id, isMute)
    } else if (item == 'Email') {
      this.addNewEmailForm(id, isMute)
    } else if (item == 'JSON') {
      this.addNewJsonForm(id, isMute)
      // } else if (item == 'File') {
      //   this.addNewFileForm(id)
    } else if (item == 'DL Ingestion') {
      this.addNewDLIngestionForm(id, isMute)
    } else if (item == 'DataLake Search') {
      this.addNewDlsearchForm(id, isMute)
    } else if (item == 'Database') {
      this.addNewJdbcoutputForm(id, isMute)
    } else if (item == 'Filter') {
      this.addNewFilterForm(id, isMute)
    } else if (item == 'Encode Decode') {
      this.addNewEncodedecodeForm(id, isMute)
    } else if (item == 'Zipfile in Base64') {
      this.addNewZipfileinbase64Form(id, isMute)
    } else if (item == 'Array Count') {
      this.addNewArraycountForm(id, isMute)
    } else if (item == 'Delimiter to Array') {
      this.addNewDl2arrayForm(id, isMute)
    } else if (item == 'PDF Extractor') {
      this.addNewPdfextractorForm(id, isMute)
    } else if (item == 'File Extractor') {
      this.addNewFileextractorForm(id, isMute)
    } else if (item == 'Document Understanding') {
      this.addNewDocunderstandingForm(id, isMute)
    } else if (item == 'Grok Pattern') {
      this.addNewGrokPatternForm(id, isMute)
    } else if (item == 'Image Understanding') {
      this.addNewImgunderstandingForm(id, isMute)
    } else if (item == 'Filter Ends') {
      this.addNewFilterEndsForm(id, isMute)
    } else if (item == 'Raw Sentence Generator') {
      this.addNewRawSentenceGeneratorForm(id, isMute)
    } else if (item == 'Time Units') {
      this.addNewTimeUnitsForm(id, isMute)
    } else if (item == 'Data Chunking') {
      this.addNewDataChunkingForm(id, isMute)
    } else if (item == 'JSON to AVRO') {
      this.addNewjson2avroForm(id, isMute)
    } else if (item == 'HTML Extractor') {
      this.addNewHtmlExtractorForm(id, isMute)
    } else if (item == 'AVRO to JSON') {
      this.addNewavro2jsonForm(id, isMute)
    } else if(item == 'Extract to Array'){
      this.addNewExtract2ArrayForm(id, isMute);
    }
    var index = -1;
    var filteredObj = this.finalBlocks.find(function (item, i) {
      if (item.id === id) {
        index = i;
        return i;
      }
    });
    if (eq) {
      if (event.previousContainer.data.block == undefined) {
        this.finalBlocks[index].element_id = this.getUniqueID(item, index);
      }
    } else {
      this.finalBlocks[index].element_id = this.getUniqueID(item, index);
    }
  }

  getUniqueID(item, index) {
    let count, unique_id = '';
    if (item == 'Data types') {
      count = this.datatypesRows().controls.length
      unique_id = `bizdata_ops_datatypes_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Append') {
      count = this.appendRows().controls.length
      unique_id = `bizdata_ops_append_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Titlecase') {
      count = this.titlecaseRows().controls.length
      unique_id = `bizdata_ops_titlecase_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Uppercase') {
      count = this.uppercaseRows().controls.length
      unique_id = `bizdata_ops_uppercase_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Lowercase') {
      count = this.lowercaseRows().controls.length
      unique_id = `bizdata_ops_lowercase_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Data extractor') {
      count = this.dataextractorRows().controls.length
      unique_id = `bizdata_ops_dataextractor_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Trim') {
      count = this.trimRows().controls.length
      unique_id = `bizdata_ops_trim_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Base64 encoding') {
      count = this.base64encodingRows().controls.length
      unique_id = `bizdata_ops_base64decoding_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Base64 decoding') {
      count = this.base64decodingRows().controls.length
      unique_id = `Base64_decoding_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'JSON to XML') {
      count = this.jsontoxmlRows().controls.length
      unique_id = `bizdata_ops_jsontoxml_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'XML to JSON') {
      count = this.xmltojsonRows().controls.length
      unique_id = `bizdata_ops_xmltojson_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Repeat First Row Values') {
      count = this.repeatfirstrowRows().controls.length
      unique_id = `bizdata_ops_repeatfirstrow_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'JSON to delimiter') {
      count = this.json2dlRows().controls.length
      unique_id = `bizdata_ops_json2dl_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Delimiter to JSON') {
      count = this.dl2jsonRows().controls.length
      unique_id = `bizdata_ops_dl2json_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'JSON to String') {
      count = this.json2stringRows().controls.length
      unique_id = `bizdata_ops_json2string_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'String to JSON') {
      count = this.string2jsonRows().controls.length
      unique_id = `bizdata_ops_string2json_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Generate Array Sequence Number') {
      count = this.generatesequenceRows().controls.length
      unique_id = `bizdata_ops_generatesequence_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Send Keys Top of Root') {
      count = this.toplevelRows().controls.length
      unique_id = `bizdata_ops_toplevel_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Today Timestamp') {
      count = this.datetimestampRows().controls.length
      unique_id = `bizdata_ops_datetimestamp_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Data aggregation') {
      count = this.dataaggregationRows().controls.length
      unique_id = `bizdata_ops_dataaggregation_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Pivot') {
      count = this.pivotRows().controls.length
      unique_id = `bizdata_ops_pivot_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Unpivot') {
      count = this.unpivotRows().controls.length
      unique_id = `bizdata_ops_unpivot_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Single Line to Multiline') {
      count = this.chopRows().controls.length
      unique_id = `bizdata_ops_singletomultiline_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Single Line to Tuple') {
      count = this.singleline2tupleRows().controls.length
      unique_id = `bizdata_ops_singleline2tuple_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Tuple to Single Line') {
      count = this.tuple2singlelineRows().controls.length
      unique_id = `bizdata_ops_tuple2singleline_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Rename') {
      count = this.renameRows().controls.length
      unique_id = `bizdata_ops_rename_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Drop all events to start with') {
      count = this.dropeventsstartswithRows().controls.length
      unique_id = `bizdata_ops_dropeventsstartswith_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Eliminate') {
      count = this.eliminateRows().controls.length
      unique_id = `bizdata_ops_eliminate_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Drop all events for value') {
      count = this.dropalleventvaluesRows().controls.length
      unique_id = `bizdata_ops_dropalleventvalues_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Round') {
      count = this.roundRows().controls.length
      unique_id = `bizdata_ops_round_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Calculator') {
      count = this.calculaterRows().controls.length
      unique_id = `bizdata_ops_calculator_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Date Analytics') {
      count = this.dateanalyticsRows().controls.length
      unique_id = `bizdata_ops_dateanalytics_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Substitute') {
      count = this.substituteRows().controls.length
      unique_id = `bizdata_ops_substitute_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Strip') {
      count = this.stripRows().controls.length
      unique_id = `bizdata_ops_strip_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Substring') {
      count = this.substringRows().controls.length
      unique_id = `bizdata_ops_substring_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'API') {
      count = this.restapiRows().controls.length
      unique_id = `bizdata_ops_restapitarget_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Sleep time') {
      count = this.sleepRows().controls.length
      unique_id = `bizdata_ops_sleeptime_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Python') {
      count = this.pycodeRows().controls.length
      unique_id = `bizdata_ops_pycode_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'AI Operation') {
      count = this.aiopsRows().controls.length
      unique_id = `bizdata_ops_aiops_${count}`
      this.finalBlocks[index].count = count;
    } 
    else if (item == 'Email') {
      count = this.emailRows().controls.length
      unique_id = `bizdata_ops_email_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'JSON') {
      count = this.jsonRows().controls.length
      unique_id = `JSON_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'DL Ingestion') {
      count = this.dlIngestionRows().controls.length
      unique_id = `bizdata_ops_dlakeingestion_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'DataLake Search') {
      count = this.dlsearchRows().controls.length
      unique_id = `bizdata_ops_dlsearch_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Database') {
      count = this.jdbcoutputRows().controls.length
      unique_id = `bizdata_ops_jdbcoutput_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Filter') {
      count = this.filterRows().controls.length
      unique_id = `bizdata_ops_filter_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Encode Decode') {
      count = this.encodedecodeRows().controls.length
      unique_id = `bizdata_ops_encodedecode_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Zipfile in Base64') {
      count = this.zipfileinbase64Rows().controls.length
      unique_id = `bizdata_ops_zipfileinbase64_${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Array Count') {
      count = this.arraycountRows().controls.length
      unique_id = `bizdata_ops_arraycount${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Delimiter to Array') {
      count = this.dl2arrayRows().controls.length
      unique_id = `bizdata_ops_dl2array${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'PDF Extractor') {
      count = this.pdfextractorRows().controls.length
      unique_id = `bizdata_ops_pdfextractor${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'File Extractor') {
      count = this.fileextractorRows().controls.length
      unique_id = `bizdata_ops_fileextractor${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Document Understanding') {
      count = this.docunderstandingRows().controls.length
      unique_id = `bizdata_ops_docunderstanding${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Grok Pattern') {
      count = this.grokpatternRows().controls.length
      unique_id = `bizdata_ops_grokpattern${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Image Understanding') {
      count = this.imgunderstandingRows().controls.length
      unique_id = `bizdata_ops_imgunderstanding${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Filter Ends') {
      count = this.filterEndsRows().controls.length
      unique_id = `bizdata_ops_filterends${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Raw Sentence Generator') {
      count = this.rawsentencegeneratorRows().controls.length
      unique_id = `bizdata_ops_rawsentencegenerator${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Time Units') {
      count = this.timeunitsRows().controls.length
      unique_id = `bizdata_ops_timeunits${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Data Chunking') {
      count = this.datachunkingRows().controls.length
      unique_id = `bizdata_ops_datachunking${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'HTML Extractor') {
      count = this.htmlExtractorRows().controls.length
      unique_id = `bizdata_ops_htmlextractor${count}`
      this.finalBlocks[index].count = count;
    }
    else if (item == 'JSON to AVRO') {
      count = this.jason2avroRows().controls.length
      unique_id = `bizdata_ops_jason2avro${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'AVRO to JSON') {
      count = this.avro2jsonRows().controls.length
      unique_id = `bizdata_ops_avro2json${count}`
      this.finalBlocks[index].count = count;
    } else if (item == 'Extract to Array'){
      count = this.extract2ArrayRows().controls.length;
      unique_id = `bizdata_ops_extract2array${count}`
      this.finalBlocks[index].count = count;
    }
    return unique_id;
  }

 async transformOpsJson() {
    let transformation_ops_json = new Object();
    let transformation_ops_arr = [];
    let _var = 'bizdata_ops';

    // == TRANSFORMATION == //
    let datatypesRows = this.bizdata_ops_datatypes_fb.value.datatypesRows;
    let appendRows = this.bizdata_ops_append_fb.value.appendRows;
    //console.log(appendRows);
    
    let titlecaseRows = this.bizdata_ops_titlecase_fb.value.titlecaseRows;
    let uppercaseRows = this.bizdata_ops_uppercase_fb.value.uppercaseRows;
    let lowercaseRows = this.bizdata_ops_lowercase_fb.value.lowercaseRows;
    let dataextractorRows = this.bizdata_ops_dataextractor_fb.value.dataextractorRows;
    let trimRows = this.bizdata_ops_trim_fb.value.trimRows;
    let base64decodingRows = this.bizdata_ops_base64decoding_fb.value.base64decodingRows;
    let base64encodingRows = this.bizdata_ops_base64encoding_fb.value.base64encodingRows;
    let jsontoxmlRows = this.bizdata_ops_jsontoxml_fb.value.jsontoxmlRows;
    let xmltojsonRows = this.bizdata_ops_xmltojson_fb.value.xmltojsonRows;
    let generatesequenceRows = this.bizdata_ops_generatesequence_fb.value.generatesequenceRows;
    let json2stringRows = this.bizdata_ops_json2string_fb.value.json2stringRows;
    let string2jsonRows = this.bizdata_ops_string2json_fb.value.string2jsonRows;
    let toplevelRows = this.bizdata_ops_toplevel_fb.value.toplevelRows;
    let datetimestampRows = this.bizdata_ops_datetimestamp_fb.value.datetimestampRows;
    let repeatfirstrowRows = this.bizdata_ops_repeatfirstrow_fb.value.repeatfirstrowRows;
    let encodedecodeRows = this.bizdata_ops_encodedecode_fb.value.encodedecodeRows;
    let zipfileinbase64Rows = this.bizdata_ops_zipfileinbase64_fb.value.zipfileinbase64Rows;
    let arraycountRows = this.bizdata_ops_arraycount_fb.value.arraycountRows;
    let pdfextractorRows = this.bizdata_ops_pdfextractor_fb.value.pdfextractorRows;
    let fileextractorRows = this.bizdata_ops_fileextractor_fb.value.fileextractorRows;
    let grokpatternRows = this.bizdata_ops_grokpattern_fb.value.grokpatternRows;
    let rawsentencegeneratorRows = this.bizdata_ops_rawsentencegenerator_fb.value.rawsentencegeneratorRows;
    let timeunitsRows = this.bizdata_ops_timeunits_fb.value.timeunitsRows;
    let datachunkingRows = this.bizdata_ops_datachunking_fb.value.datachunkingRows;
    let jason2avroRows = this.bizdata_ops_jason2avro_fb.value.jason2avroRows;
    let htmlExtractorRows = this.bizdata_ops_htmlextractor_fb.value.htmlExtractorRows;
    let avro2jsonRows = this.bizdata_ops_avro2json_fb.value.avro2jsonRows;
    let extract2ArrayRows = this.bizdata_ops_extract2array_fb.value.extract2ArrayRows;

    // == WRANGLING == //
    let dl2jsonRows = this.bizdata_ops_dl2json_fb.value.dl2jsonRows;
    let json2dlRows = this.bizdata_ops_json2dl_fb.value.json2dlRows;
    let dataaggregationRows = this.bizdata_ops_dataaggregation_fb.value.dataaggregationRows;
    let pivotRows = this.bizdata_ops_pivot_fb.value.pivotRows;
    let singleline2tupleRows = this.bizdata_ops_singleline2tuple_fb.value.singleline2tupleRows;
    let tuple2singlelineRows = this.bizdata_ops_tuple2singleline_fb.value.tuple2singlelineRows;
    let unPivotRows = this.bizdata_ops_unpivot_fb.value.unpivotRows;
    let chopRows = this.bizdata_ops_singletomultiline_fb.value.chopRows;
    let dl2arrayRows = this.bizdata_ops_dl2array_fb.value.dl2arrayRows;

    // == ORCHESTRATION == //
    // let fileRows = this.bizdata_ops_file_fb.value.fileRows;
    let jdbcoutputRows = this.bizdata_ops_jdbcoutput_fb.value.jdbcoutputRows;
    let emailRows = this.bizdata_ops_email_fb.value.emailRows;
    let restapiRows = this.bizdata_ops_restapi_fb.value.restapiRows;
    // let restapiRows = this.opsData;
    let dlIngestionRows = this.bizdata_ops_dlakeingestion_fb.value.dlIngestionRows;
    let dlsearchRows = this.bizdata_ops_dlsearch_fb.value.dlsearchRows;

    // == CLEANING == //
    let dropeventsstartswithRows = this.bizdata_ops_dropeventsstartswith_fb.value.dropeventsstartswithRows;
    let dropalleventvaluesRows = this.bizdata_ops_dropalleventvalues_fb.value.dropalleventvaluesRows;
    let eliminateRows = this.bizdata_ops_eliminate_fb.value.eliminateRows;
    let calculatorRows = this.bizdata_ops_calculater_fb.value.calculaterRows;
    let roundRows = this.bizdata_ops_round_fb.value.roundRows;
    let dateanalyticsRows = this.bizdata_ops_dateanalytics_fb.value.dateanalyticsRows;
    let substituteRows = this.bizdata_ops_substitute_fb.value.substituteRows;
    let renameRows = this.bizdata_ops_rename_fb.value.renameRows;
    let stripRows = this.bizdata_ops_strip_fb.value.stripRows;
    let substringRows = this.bizdata_ops_substring_fb.value.substringRows;

    // == PIPELINE CONTROL == //
    let sleepRows = this.bizdata_ops_sleeptime_fb.value.sleepRows;
    let pycodeRows = this.bizdata_ops_pycode_fb.value.pycodeRows;
    let aiopsRows = this.bizdata_ops_aiops_fb.value.aiopsRows;
    let filterRows = this.bizdata_ops_filter_fb.value.filterRows;
    let filterEndsRows = this.bizdata_ops_filterends_fb.value.filterEndsRows;

    let docunderstandingRows = this.bizdata_ops_docunderstanding_fb.value.docunderstandingRows;
    let imgunderstandingRows = this.bizdata_ops_imgunderstanding_fb.value.imgunderstandingRows;


    // ************** TRANSFORMATION *************** //
    if (datatypesRows) {
      let i = 0;
      let arr = _.cloneDeep(datatypesRows);
      for (let object of arr) {
        // delete object.id;
        if (object.boolean_operator != '' && object.boolean_operator != undefined) {
          object.boolean_operator = this.helperService.stringToObjectConverter("Array", object.boolean_operator);
        } else {
          object.boolean_operator = [];
        }
        if (object.datetime_operator != '' && object.datetime_operator != undefined) {
          object.datetime_operator = this.helperService.stringToObjectConverter("Array", object.datetime_operator);
        } else {
          object.datetime_operator = [];
        }
        if (object.float_operator != '' && object.float_operator != undefined) {
          object.float_operator = this.helperService.stringToObjectConverter("Array", object.float_operator);
        } else {
          object.float_operator = [];
        }
        if (object.integer_operator != '' && object.integer_operator != undefined) {
          object.integer_operator = this.helperService.stringToObjectConverter("Array", object.integer_operator);
        } else {
          object.integer_operator = [];
        }
        let json_obj = new Object();
        let bizdata_ops_datatypes: any = ops_restapi.bizdata_ops_datatypes as any;
        object = Object.assign({ source: bizdata_ops_datatypes?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_datatypes?.target });
        // if (_.has(bizdata_ops_datatypes, 'source')) object['source'] = bizdata_ops_datatypes?.source;
        // if (_.has(bizdata_ops_datatypes, 'target')) object['target'] = bizdata_ops_datatypes?.target;
        if (i == 0) json_obj[`${_var}_datatypes_1`] = object;
        else json_obj[`${_var}_datatypes_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (appendRows) {
      let i = 0;
      let arr = _.cloneDeep(appendRows);
      for (let object of arr) {
        // delete object.id;
        object.append = this.helperService.stringToObjectConverter("Json", object.append,'append');
        let json_obj = new Object();
        let bizdata_ops_append: any = ops_restapi.bizdata_ops_append as any;
        object = Object.assign({ source: bizdata_ops_append?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_append?.target });
        if (i == 0) json_obj[`${_var}_append_1`] = object;
        else json_obj[`${_var}_append_${i + 1}`] = object;
        //console.log(json_obj);
        
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (titlecaseRows) {
      let i = 0;
      let arr = _.cloneDeep(titlecaseRows);
      for (let object of arr) {
        // delete object.id;
        object.titlecase = this.helperService.stringToObjectConverter("Array", object.titlecase);
        let json_obj = new Object();
        let bizdata_ops_titlecase: any = ops_restapi.bizdata_ops_titlecase as any;
        object = Object.assign({ source: bizdata_ops_titlecase?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_titlecase?.target });
        if (i == 0) json_obj[`${_var}_titlecase_1`] = object;
        else json_obj[`${_var}_titlecase_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (uppercaseRows) {
      let i = 0;
      let arr = _.cloneDeep(uppercaseRows);
      for (let object of arr) {
        // delete object.id;
        object.uppercase = this.helperService.stringToObjectConverter("Array", object.uppercase);
        let json_obj = new Object();
        let bizdata_ops_uppercase: any = ops_restapi.bizdata_ops_uppercase as any;
        object = Object.assign({ source: bizdata_ops_uppercase?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_uppercase?.target });
        if (i == 0) json_obj[`${_var}_uppercase_1`] = object;
        else json_obj[`${_var}_uppercase_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (lowercaseRows) {
      let i = 0;
      let arr = _.cloneDeep(lowercaseRows);
      for (let object of arr) {
        // delete object.id;
        object.lowercase = this.helperService.stringToObjectConverter("Array", object.lowercase);
        let json_obj = new Object();
        let bizdata_ops_lowercase: any = ops_restapi.bizdata_ops_lowercase as any;
        object = Object.assign({ source: bizdata_ops_lowercase?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_lowercase?.target });
        if (i == 0) json_obj[`${_var}_lowercase_1`] = object;
        else json_obj[`${_var}_lowercase_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (dataextractorRows) {
      let i = 0;
      let arr = _.cloneDeep(dataextractorRows);
      for (let object of arr) {
        // delete object.id;
        if (object.data_extractor != '' && object.data_extractor != undefined) {
          object.data_extractor = this.helperService.stringToObjectConverter("Array", object.data_extractor);
        } else {
          object.data_extractor = []
        }
        if (object.data_extractor_keys != '' && object.data_extractor_keys != undefined) {
          object.data_extractor_keys = this.helperService.stringToObjectConverter("Array", object.data_extractor_keys);
        } else {
          object.data_extractor_keys = []
        }
        let json_obj = new Object();
        let bizdata_ops_dataextractor: any = ops_restapi.bizdata_ops_dataextractor as any;
        object = Object.assign({ source: bizdata_ops_dataextractor?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_dataextractor?.target });
        if (i == 0) json_obj[`${_var}_dataextractor_1`] = object;
        else json_obj[`${_var}_dataextractor_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (trimRows) {
      let i = 0;
      let arr = _.cloneDeep(trimRows);
      for (let object of arr) {
        // delete object.id;
        object.trim_keys = this.helperService.stringToObjectConverter("Array", object.trim_keys);
        let json_obj = new Object();
        let bizdata_ops_trim: any = ops_restapi.bizdata_ops_trim as any;
        object = Object.assign({ source: bizdata_ops_trim?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_trim?.target });
        if (i == 0) json_obj[`${_var}_trim_1`] = object;
        else json_obj[`${_var}_trim_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (json2stringRows) {
      let i = 0;
      let arr = _.cloneDeep(json2stringRows);
      for (let object of arr) {
        // delete object.id;
        object.json2string = this.helperService.stringToObjectConverter("Array", object.json2string);
        let json_obj = new Object();
        let bizdata_ops_json2string: any = ops_restapi.bizdata_ops_json2string as any;
        object = Object.assign({ source: bizdata_ops_json2string?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_json2string?.target });
        if (i == 0) json_obj[`${_var}_json2string_1`] = object;
        else json_obj[`${_var}_json2string_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (string2jsonRows) {
      let i = 0;
      let arr = _.cloneDeep(string2jsonRows);
      for (let object of arr) {
        // delete object.id;
        object.string2json = this.helperService.stringToObjectConverter("Array", object.string2json);
        let json_obj = new Object();
        let bizdata_ops_string2json: any = ops_restapi.bizdata_ops_string2json as any;
        object = Object.assign({ source: bizdata_ops_string2json?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_string2json?.target });
        if (i == 0) json_obj[`${_var}_string2json_1`] = object;
        else json_obj[`${_var}_string2json_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (jsontoxmlRows) {
      let i = 0;
      let arr = _.cloneDeep(jsontoxmlRows);
      for (let object of arr) {
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_jsontoxml: any = ops_restapi.bizdata_ops_jsontoxml as any;
        object = Object.assign({ source: bizdata_ops_jsontoxml?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_jsontoxml?.target });
        if (i == 0) json_obj[`${_var}_jsontoxml_1`] = object;
        else json_obj[`${_var}_jsontoxml_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (base64encodingRows) {
      let i = 0;
      let arr = _.cloneDeep(base64encodingRows);
      for (let object of arr) {
        // delete object.id;
        object.base64_encode = this.helperService.stringToObjectConverter("Array", object.base64_encode);
        let json_obj = new Object();
        let bizdata_ops_base64encoding: any = ops_restapi.bizdata_ops_base64encoding as any;
        object = Object.assign({ source: bizdata_ops_base64encoding?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_base64encoding?.target });
        if (i == 0) json_obj[`${_var}_base64encoding_1`] = object;
        else json_obj[`${_var}_base64encoding_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (base64decodingRows) {
      let i = 0;
      let arr = _.cloneDeep(base64decodingRows);
      for (let object of arr) {
        // delete object.id;
        object.base64_decode = this.helperService.stringToObjectConverter("Array", object.base64_decode);
        let json_obj = new Object();
        let bizdata_ops_base64decoding: any = ops_restapi.bizdata_ops_base64decoding as any;
        object = Object.assign({ source: bizdata_ops_base64decoding?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_base64decoding?.target });
        if (i == 0) json_obj[`${_var}_base64decoding_1`] = object;
        else json_obj[`${_var}_base64decoding_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (generatesequenceRows) {
      let i = 0;
      let arr = _.cloneDeep(generatesequenceRows);
      for (let object of arr) {
        // delete object.id;
        object.sequence_key = this.helperService.stringToObjectConverter("String", object.sequence_key);
        object.sequence_number_key = this.helperService.stringToObjectConverter("String", object.sequence_number_key);
        let json_obj = new Object();
        let bizdata_ops_generatesequence: any = ops_restapi.bizdata_ops_generatesequence as any;
        object = Object.assign({ source: bizdata_ops_generatesequence?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_generatesequence?.target });
        if (i == 0) json_obj[`${_var}_generatesequence_1`] = object;
        else json_obj[`${_var}_generatesequence_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (repeatfirstrowRows) {
      let i = 0;
      let arr = _.cloneDeep(repeatfirstrowRows);
      for (let object of arr) {
        // delete object.id;
        if (object.fields_to_repeat_value != '' && object.fields_to_repeat_value != undefined) {
          object.fields_to_repeat_value = this.helperService.stringToObjectConverter("Array", object.fields_to_repeat_value);
        } else {
          object.fields_to_repeat_value = []
        }
        let json_obj = new Object();
        let bizdata_ops_repeatfirstrow: any = ops_restapi.bizdata_ops_repeatfirstrow as any;
        object = Object.assign({ source: bizdata_ops_repeatfirstrow?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_repeatfirstrow?.target });
        if (i == 0) json_obj[`${_var}_repeatfirstrow_1`] = object;
        else json_obj[`${_var}_repeatfirstrow_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (toplevelRows) {
      let i = 0;
      let arr = _.cloneDeep(toplevelRows);
      for (let object of arr) {
        // delete object.id;
        object.column_to_root = this.helperService.stringToObjectConverter("Array", object.column_to_root);
        let json_obj = new Object();
        let bizdata_ops_toplevel: any = ops_restapi.bizdata_ops_toplevel as any;
        object = Object.assign({ source: bizdata_ops_toplevel?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_toplevel?.target });
        if (i == 0) json_obj[`${_var}_toplevel_1`] = object;
        else json_obj[`${_var}_toplevel_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (datetimestampRows) {
      let i = 0;
      let arr = _.cloneDeep(datetimestampRows);
      for (let object of arr) {
        // delete object.id;
        // object.date_format = this.helperService.stringToObjectConverter("String", object.date_format);
        // object.datetime_key = this.helperService.stringToObjectConverter("String", object.datetime_key);
        let json_obj = new Object();
        let bizdata_ops_datetimestamp: any = ops_restapi.bizdata_ops_datetimestamp as any;
        object = Object.assign({ source: bizdata_ops_datetimestamp?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_datetimestamp?.target });
        if (i == 0) json_obj[`${_var}_datetimestamp_1`] = object;
        else json_obj[`${_var}_datetimestamp_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (xmltojsonRows) {
      let i = 0;
      let arr = _.cloneDeep(xmltojsonRows);
      for (let object of arr) {
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_xmltojson: any = ops_restapi.bizdata_ops_xmltojson as any;
        object = Object.assign({ source: bizdata_ops_xmltojson?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_xmltojson?.target });
        if (i == 0) json_obj[`${_var}_xmltojson_1`] = object;
        else json_obj[`${_var}_xmltojson_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (encodedecodeRows) {
      let i = 0;
      let arr = _.cloneDeep(encodedecodeRows);
      for (let object of arr) {
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_encodedecode: any = ops_restapi.bizdata_ops_encodedecode as any;
        object = Object.assign({ source: bizdata_ops_encodedecode?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_encodedecode?.target });
        if (i == 0) json_obj[`${_var}_encodedecode_1`] = object;
        else json_obj[`${_var}_encodedecode_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (zipfileinbase64Rows) {
      let i = 0;
      let arr = _.cloneDeep(zipfileinbase64Rows);
      for (let object of arr) {
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_zipfileinbase64: any = ops_restapi.bizdata_ops_zipfileinbase64 as any;
        object = Object.assign({ source: bizdata_ops_zipfileinbase64?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_zipfileinbase64?.target });
        if (i == 0) json_obj[`${_var}_zipfileinbase64_1`] = object;
        else json_obj[`${_var}_zipfileinbase64_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    } if (arraycountRows) {
      let i = 0;
      let arr = _.cloneDeep(arraycountRows);
      for (let object of arr) {
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_arraycount: any = ops_restapi.bizdata_ops_arraycount as any;
        object = Object.assign({ source: bizdata_ops_arraycount?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_arraycount?.target });
        if (i == 0) json_obj[`${_var}_arraycount_1`] = object;
        else json_obj[`${_var}_arraycount_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    } if (pdfextractorRows) {
      let i = 0;
      let arr = _.cloneDeep(pdfextractorRows);
      for (let object of arr) {
        let json_obj = new Object();
        let bizdata_ops_pdfextractor: any = ops_restapi.bizdata_ops_pdfextractor as any;
        object = Object.assign({ source: bizdata_ops_pdfextractor?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_pdfextractor?.target });
        if (i == 0) json_obj[`${_var}_pdfextractor_1`] = object;
        else json_obj[`${_var}_pdfextractor_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    } if (fileextractorRows) {
      let i = 0;
      let arr = _.cloneDeep(fileextractorRows);
      for (let object of arr) {
        let json_obj = new Object();
        let bizdata_ops_fileextractor: any = ops_restapi.bizdata_ops_fileextractor as any;
        object = Object.assign({ source: bizdata_ops_fileextractor?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_fileextractor?.target });
        if (i == 0) json_obj[`${_var}_fileextractor_1`] = object;
        else json_obj[`${_var}_fileextractor_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    } if (grokpatternRows) {
      let i = 0;
      let arr = _.cloneDeep(grokpatternRows);
      for (let object of arr) {
        let json_obj = new Object();
        let bizdata_ops_grokpattern: any = ops_restapi.bizdata_ops_grokpattern as any;
        object = Object.assign({ source: bizdata_ops_grokpattern?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_grokpattern?.target });
        if (i == 0) json_obj[`${_var}_grokpattern_1`] = object;
        else json_obj[`${_var}_grokpattern_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    } if (rawsentencegeneratorRows) {
      let i = 0;
      let arr = _.cloneDeep(rawsentencegeneratorRows);
      for (let object of arr) {
        if (object.include_keys != '' && object.include_keys != undefined) {
          object.include_keys = this.helperService.stringToObjectConverter("Array", object.include_keys);
        } else {
          object.include_keys = []
        }
        let json_obj = new Object();
        let bizdata_ops_rawsentencegenerator: any = ops_restapi.bizdata_ops_rawsentencegenerator as any;
        object = Object.assign({ source: bizdata_ops_rawsentencegenerator?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_rawsentencegenerator?.target });
        if (i == 0) json_obj[`${_var}_rawsentencegenerator_1`] = object;
        else json_obj[`${_var}_rawsentencegenerator_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    } if (timeunitsRows) {
      let i = 0;
      let arr = _.cloneDeep(timeunitsRows);
      for (let object of arr) {
        if (object.timestamp_column != '' && object.timestamp_column != undefined) {
          object.timestamp_column = this.helperService.stringToObjectConverter("Array", object.timestamp_column);
        } else {
          object.timestamp_column = []
        }
        let json_obj = new Object();
        let bizdata_ops_timeunits: any = ops_restapi.bizdata_ops_timeunits as any;
        object = Object.assign({ source: bizdata_ops_timeunits?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_timeunits?.target });
        if (i == 0) json_obj[`${_var}_timeunits_1`] = object;
        else json_obj[`${_var}_timeunits_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    } if (datachunkingRows) {
      let i = 0;
      let arr = _.cloneDeep(datachunkingRows);
      for (let object of arr) {
        let json_obj = new Object();
        object.token_size = JSON.parse(object.token_size);
        let bizdata_ops_datachunking: any = ops_restapi.bizdata_ops_datachunking as any;
        object = Object.assign({ source: bizdata_ops_datachunking?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_datachunking?.target });
        if (i == 0) json_obj[`${_var}_datachunking_1`] = object;
        else json_obj[`${_var}_datachunking_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    } if (htmlExtractorRows) {
      let i = 0;
      let arr = _.cloneDeep(htmlExtractorRows);
      for (let object of arr) {
        let json_obj = new Object();
        let bizdata_ops_htmlextractor: any = ops_restapi.bizdata_ops_htmlextractor as any;
        object = Object.assign({ source: bizdata_ops_htmlextractor?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_htmlextractor?.target });
        if (i == 0) json_obj[`${_var}_htmlextractor_1`] = object;
        else json_obj[`${_var}_htmlextractor_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }

    if (jason2avroRows) {
      let i = 0;
      let arr = _.cloneDeep(jason2avroRows);
      for (let object of arr) {
        let json_obj = new Object();
        let bizdata_ops_json2avro: any = ops_restapi.bizdata_ops_json2avro as any;
        object = Object.assign({ source: bizdata_ops_json2avro?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_json2avro?.target });
        if (typeof object.avro_schema === 'string') {
          object.avro_schema = this.helperService.stringToObjectConverter("Json", object.avro_schema);
        }

        if (i == 0) json_obj[`${_var}_json2avro_1`] = object;
        else json_obj[`${_var}_json2avro_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (avro2jsonRows) {
      let i = 0;
      let arr = _.cloneDeep(avro2jsonRows);
      for (let object of arr) {
        let json_obj = new Object();
        let bizdata_ops_avro2json: any = ops_restapi.bizdata_ops_avro2json as any;
        object = Object.assign({ source: bizdata_ops_avro2json?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_avro2json?.target });
        if (i == 0) json_obj[`${_var}_avro2json_1`] = object;
        else json_obj[`${_var}_avro2json_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    // bizdata_ops_extract2array
    if(extract2ArrayRows) {
      let i = 0;
      let arr = _.cloneDeep(extract2ArrayRows);
      for (let object of arr) {
        let json_obj = new Object();
        if (object.extraction_key != '' && object.extraction_key != undefined) {
          object.extraction_key = this.helperService.stringToObjectConverter("Array", object.extraction_key);
        } else {
          object.extraction_key = []
        }
        if (object.array_collection_key != '' && object.array_collection_key != undefined) {
          object.array_collection_key = this.helperService.stringToObjectConverter("Array", object.array_collection_key);
        } else {
          object.array_collection_key = []
        }
        let bizdata_ops_extract2array: any = ops_restapi.bizdata_ops_extract2array as any;
        object = Object.assign({ source: bizdata_ops_extract2array?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_extract2array?.target });
        if (i == 0) json_obj[`${_var}_extract2array_1`] = object;
        else json_obj[`${_var}_extract2array_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    // **************** ^^^^^^^ **************** //


    // ************** WRANGLING *************** //
    if (dl2jsonRows) {
      let i = 0;
      let arr = _.cloneDeep(dl2jsonRows);
      for (let object of arr) {
        if (object.fields != '' && object.fields != undefined) {
          object.fields = this.helperService.stringToObjectConverter("Array", object.fields);
        } else {
          object.fields = []
        }
        if (object.delimiter.includes("\\")) {
          object.delimiter = JSON.stringify(object.delimiter).replace(new RegExp('\\\\\\\\', "g"), '\\');
          object.delimiter = JSON.parse(object.delimiter);
        }
        // object.autodetect_column_names = object.autodetect_column_names ? 'true' : 'false';
        // object.skip_header = object.skip_header ? 'true' : 'false';
        delete object.isCheckedAuto;
        delete object.isCheckedSkip;
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_dl2json: any = ops_restapi.bizdata_ops_dl2json as any;
        object = Object.assign({ source: bizdata_ops_dl2json?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_dl2json?.target });
        if (i == 0) json_obj[`${_var}_dl2json_1`] = object;
        else json_obj[`${_var}_dl2json_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (json2dlRows) {
      let i = 0;
      let arr = _.cloneDeep(json2dlRows);
      for (let object of arr) {
        if (object.fields != '' && object.fields != undefined) {
          object.fields = this.helperService.stringToObjectConverter("Array", object.fields);
        } else {
          object.fields = []
        }
        if (object.delimiter.includes("\\")) {
          object.delimiter = JSON.stringify(object.delimiter).replace(new RegExp('\\\\\\\\', "g"), '\\');
          object.delimiter = JSON.parse(object.delimiter);
        }
        delete object.isCheckedAuto;
        delete object.isCheckedSkip;
        let json_obj = new Object();
        let bizdata_ops_json2dl: any = ops_restapi.bizdata_ops_json2dl as any;
        object = Object.assign({ source: bizdata_ops_json2dl?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_json2dl?.target });
        if (i == 0) json_obj[`${_var}_json2dl_1`] = object;
        else json_obj[`${_var}_json2dl_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (dataaggregationRows) {
      let i = 0;
      let arr = _.cloneDeep(dataaggregationRows);
      for (let object of arr) {
        if (object.array_key_nested_columns == "" || object.array_key_nested_columns == null) {
          object.array_key_nested_columns = []
        } else {
          object.array_key_nested_columns = this.helperService.stringToObjectConverter("Array", object.array_key_nested_columns);
        }
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_dataaggregation: any = ops_restapi.bizdata_ops_dataaggregation as any;
        object = Object.assign({ source: bizdata_ops_dataaggregation?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_dataaggregation?.target });
        if (i == 0) json_obj[`${_var}_dataaggregation_1`] = object;
        else json_obj[`${_var}_dataaggregation_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (dl2arrayRows) {
      let i = 0;
      let arr = _.cloneDeep(dl2arrayRows);
      for (let object of arr) {
        if (object.delimiter.includes("\\")) {
          object.delimiter = JSON.stringify(object.delimiter).replace(new RegExp('\\\\\\\\', "g"), '\\');
          object.delimiter = JSON.parse(object.delimiter);
        }
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_dl2array: any = ops_restapi.bizdata_ops_dl2array as any;
        object = Object.assign({ source: bizdata_ops_dl2array?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_dl2array?.target });
        if (i == 0) json_obj[`${_var}_dl2array_1`] = object;
        else json_obj[`${_var}_dl2array_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (pivotRows) {
      let i = 0;
      let arr = _.cloneDeep(pivotRows);
      for (let object of arr) {
        object.transposed_key_name = this.helperService.stringToObjectConverter("Array", object.transposed_key_name);
        object.transposed_value = this.helperService.stringToObjectConverter("Array", object.transposed_value);
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_pivot: any = ops_restapi.bizdata_ops_pivot as any;
        object = Object.assign({ source: bizdata_ops_pivot?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_pivot?.target });
        if (i == 0) json_obj[`${_var}_pivot_1`] = object;
        else json_obj[`${_var}_pivot_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (unPivotRows) {
      let i = 0;
      let arr = _.cloneDeep(unPivotRows);
      for (let object of arr) {
        object.transpose_key_name = this.helperService.stringToObjectConverter("Array", object.transpose_key_name).map((str)=>str.replace(/\s+/g, ""));
        // console.log(object.transpose_key_name)
        object.transpose_value = this.helperService.stringToObjectConverter("Array", object.transpose_value).map((str)=>str.replace(/\s+/g, ""));
        // console.log(object.transpose_value)
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_unpivot: any = ops_restapi.bizdata_ops_unpivot as any;
        object = Object.assign({ source: bizdata_ops_unpivot?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_unpivot?.target });
        if (i == 0) json_obj[`${_var}_unpivot_1`] = object;
        else json_obj[`${_var}_unpivot_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (chopRows) {
      let i = 0;
      let arr = _.cloneDeep(chopRows);
      for (let object of arr) {
        // object.chopkey = object.chopkey.replaceAll('"',"'")
        // delete object.id;
        // object.chopkey = this.helperService.stringToObjectConverter("String", object.chopkey);
        let json_obj = new Object();
        let bizdata_ops_singletomultiline: any = ops_restapi.bizdata_ops_singletomultiline as any;
        object = Object.assign({ source: bizdata_ops_singletomultiline?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_singletomultiline?.target });
        if (i == 0) json_obj[`${_var}_singletomultiline_1`] = object;
        else json_obj[`${_var}_singletomultiline_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (singleline2tupleRows) {
      let i = 0;
      let arr = _.cloneDeep(singleline2tupleRows);
      for (let object of arr) {
        if (object.table_headers != '' && object.table_headers != undefined) {
          object.table_headers = this.helperService.stringToObjectConverter("Array", object.table_headers);
        } else {
          object.table_headers = []
        }
        // object.transposed_key_name = object.transposed_key_name.replaceAll('"',"'")
        // object.transposed_value = object.transposed_value.replaceAll('"',"'")
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_singleline2tuple: any = ops_restapi.bizdata_ops_singleline2tuple as any;
        object = Object.assign({ source: bizdata_ops_singleline2tuple?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_singleline2tuple?.target });
        if (i == 0) json_obj[`${_var}_singleline2tuple_1`] = object;
        else json_obj[`${_var}_singleline2tuple_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }

    if (tuple2singlelineRows) {
      let i = 0;
      let arr = _.cloneDeep(tuple2singlelineRows);
      for (let object of arr) {
        if (object.headers != '' && object.headers != undefined) {
          object.headers = this.helperService.stringToObjectConverter("Array", object.headers);
        } else {
          object.headers = []
        }
        // object.transposed_key_name = object.transposed_key_name.replaceAll('"',"'")
        // object.transposed_value = object.transposed_value.replaceAll('"',"'")
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_tuple2singleline: any = ops_restapi.bizdata_ops_tuple2singleline as any;
        object = Object.assign({ source: bizdata_ops_tuple2singleline?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_tuple2singleline?.target });
        if (i == 0) json_obj[`${_var}_tuple2singleline_1`] = object;
        else json_obj[`${_var}_tuple2singleline_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    // **************** ^^^^^^^ **************** //


    // ************** ORCHESTRATION *************** //
    // if (fileRows) {
    //   let i = 0;
    //   let arr = _.cloneDeep(fileRows);
    //   for (let object of arr) {
    //     object.target_location = object.target_location.replaceAll('"', "'")
    //     object.extension = object.extension.replaceAll('"', "'")
    //     object.write_mode = object.write_mode.replaceAll('"', "'")
    //     // delete object.id;
    //     let json_obj = new Object();
    //     let bizdata_ops_file: any = ops_restapi.bizdata_ops_file as any;
    //     if (_.has(bizdata_ops_file, 'source')) object['source'] = bizdata_ops_file?.source;
    //     if (_.has(bizdata_ops_file, 'target')) object['target'] = bizdata_ops_file?.target;
    //     if (i == 0) json_obj[`${_var}_file`] = object;
    //     else json_obj[`${_var}_file_${i}`] = object;
    //     transformation_ops_arr.push(json_obj);
    //     i++;
    //   }
    // }
    if (jdbcoutputRows) {
      let i = 0;
      let arr = _.cloneDeep(jdbcoutputRows);
      for (let object of arr) {
        if (object.jdbc_string.includes('host_ip')) {
          object.jdbc_string = object.jdbc_string.replace('host_ip', object.host_ip)
        }
        if (object.jdbc_string.includes('port_number')) {
          object.jdbc_string = object.jdbc_string.replace('port_number', object.port_number)
        }
        if (object.jdbc_string.includes('schema_name')) {
          object.jdbc_string = object.jdbc_string.replace('schema_name', object.schema_name)
        }
        if (object.tuple_key == '' || object.tuple_key == undefined) {
          object.tuple_key = ""
        } else {
          object.tuple_key = object.tuple_key//this.helperService.stringToObjectConverter("Array", object.tuple_key);
        }
        if (object.query == '' || object.query == undefined) {
          object.query = ""
        } else {
          // if(object.query[0]=='"'){
          //   object.query = object.query.substring(1, object.query.length - 1);
          // }else{
            object.query = object.query//query = object.query// this.helperService.stringToObjectConverter('Array', object.query)
          // }
        }
        let bizdata_ops_jdbcoutput = {
          "source": "bizdata_dataset",
          "storage_name": object.storage_name,
          "db_version": object.db_version,
          "host_ip": object.host_ip,
          "port_number": object.port_number,
          "schema_name": object.schema_name,
          "tuple_key": object.tuple_key,
          "batch_size": +(object.batch_size),
          "jdbc_driver": object.jdbc_driver,
          "jdbc_string": object.jdbc_string,
          "jar_file": object.jar_file,
          "username": object.username,
          "password": await this.helperService.encrypt(object.password),
          "query": object.query,
          "isMute": object.isMute,
          "id": object.id,
          "target": "bizdata_dataset",
        }
        // delete object.id;
        let json_obj = new Object();
        if (i == 0) json_obj[`${_var}_jdbcoutput_1`] = bizdata_ops_jdbcoutput;
        else json_obj[`${_var}_jdbcoutput_${i + 1}`] = bizdata_ops_jdbcoutput;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (emailRows) {
      let i = 0;
      let arr = _.cloneDeep(emailRows);
      for (let object of arr) {
        object.to = this.emailsOpsTo[i];
        object.cc = this.emailsOpsCc[i];
        object.bcc = this.emailsOpsBcc[i];
        if (object.password != '' && object.password != undefined) {
          object.password=await this.helperService.encrypt(object.password);
        }
        if (object.to != '' && object.to != undefined) {
          object.to = object.to;
          // object.to = this.helperService.stringToObjectConverter("Array", object.to);
        } else {
          object.to = []
        }
        if (object.cc != '' && object.cc != undefined) {
          object.cc = object.cc;
          // object.cc = this.helperService.stringToObjectConverter("Array", object.cc);
        } else {
          object.cc = []
        }
        if (object.bcc != '' && object.bcc != undefined) {
          object.bcc = object.bcc;
          // object.bcc = this.helperService.stringToObjectConverter("Array", object.bcc);
        } else {
          object.bcc = []
        }
        if (object.port_number == '' && object.port_number != undefined) {
          object.port_number = 465
        } else {
          object.port_number = +(object.port_number)
        }
        if (object.attachment == "" || object.attachment == undefined || object.attachment == 'no') {
          object.attachment = "no"
          object.file_name = ""
        }
        if(object.body && object.body.includes("<p>")){
          object.body = object.body.replaceAll(/&lt;/g, '<').replaceAll(/&gt;/g, '>').replaceAll(/&nbsp;/g, '').replaceAll(/&quot;/g, '"').replaceAll(/&#39;/g, "'").replaceAll(/<br \/>/g, "").replaceAll(/<\/p>\n\n<p>/g, "").replaceAll(/<\/p>\n<p>/g, "");
          let body = object.body.split("<p>")[1] || "";
          body = body.split("</p>")[0] || "";
          object.body = body.trim() ? "<html>" + body + "</html>" : "";
        }else {
          object.body = ""; 
        }
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_email: any = ops_restapi.bizdata_ops_email as any;
        object = Object.assign({ source: bizdata_ops_email?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_email?.target });
        if (i == 0) json_obj[`${_var}_email_1`] = object;
        else json_obj[`${_var}_email_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    
    if (restapiRows) {
      let i = 0;
      let arr = _.cloneDeep(restapiRows);
      for (let object of arr) {
        let object1 = this.opsData[i].input_structure_json.input.bizdata_rest;
        let opsParams=[];
        if(object1.endpoint_params != undefined){
          if(object1.endpoint_params.length > 0){
            for(let ops of object1.endpoint_params){
              if((ops.paramKey != "" && ops.paramValue != "") && (ops.paramKey != undefined && ops.paramValue != undefined)){
                let obj = {
                  key: ops.paramKey,
                  value: ops.paramValue,
                  description: ops.paramDescription
                }
                opsParams.push(obj);
              }else if((ops.key != "" && ops.key != undefined) && (ops.value != "" && ops.value != undefined)){
                opsParams.push(ops);
              }
            }
          }
        }
        let opsHeaders=[];
        if(object1.endpoint_headers != undefined){
          if(object1.endpoint_headers.length > 0){
            for(let ops of object1.endpoint_headers){
              if((ops.headerKey != "" && ops.headerValue != "") && (ops.headerKey != undefined && ops.headerValue != undefined)){
                let obj = {
                  key: ops.headerKey,
                  value: ops.headerValue,
                  description: ops.headerDescription
                }
                opsHeaders.push(obj);
              }else if((ops.key != "" && ops.key != undefined) && (ops.value != "" && ops.value != undefined)){
                opsHeaders.push(ops);
              }        
            }
          }
        }
        
        // if (object1.refresh_token_endpoint_header  != '' && object1.refresh_token_endpoint_header  != undefined) {
        //   if (this.helperService.isValidJSON(object1.refresh_token_endpoint_header  == true)) {
        //     object1.refresh_token_endpoint_header  = object1.refresh_token_endpoint_header  ? this.helperService.isJsonString(object1.refresh_token_endpoint_header ) : {};
        //   } else {
        //     object1.refresh_token_endpoint_header  = object1.refresh_token_endpoint_header  ? this.helperService.stringToObjectConverter("String", object1.refresh_token_endpoint_headers ) : "";
        //   }
        // }

        if (object1.body_type == 'JSON') {
          object1.endpoint_body = (object1.endpoint_body) ? this.helperService.isJsonString(object1.endpoint_body) : {}
        } else {
          object1.endpoint_body = (object1.endpoint_body) ? (object1.endpoint_body) : ""
        }

        let selectedEnv = this.opsData[i].environment_name;
        let env_setting = this.opsData[i].environment_variables;
        // let environment_variables = object1.input_structure_json.input.bizdata_rest.environment_variables;
        let env_variable = [];
        for(let env of env_setting){
          if(env.env_name != ""){
            env_variable.push(env);
          }
        }
        let regexNewLineOpsRestapiTarget = /\\n/g;
        let pre_request_script_ops_restapitarget = object1.pre_request_script?.replace(regexNewLineOpsRestapiTarget, "\\\n");
        
        let bizdata_ops_restapitarget = {
          'endpoint_url': object1.endpoint_url,
          'endpoint_method': this.isConsole ? object1.endpoint_method.method.toLowerCase() : object1.endpoint_method,//this.isConsole ? object1.bridge_target_endpoint_method.method.toLowerCase() : object1.bridge_target_endpoint_method,
          'endpoint_headers': this.isConsole ? this.arrayToObject(opsHeaders) : opsHeaders,//this.isConsole ? this.arrayToObject1(targetHeadersArr) : targetHeadersArr,
          'endpoint_params': this.isConsole ? this.arrayToObject(opsParams) : opsParams,
          'authentication_type': this.isConsole ? object1.authentication_type.type.toLowerCase() : object1.authentication_type,
          // 'authentication_token': (object1.bridge_target_authentication_token) ? object1.bridge_target_authentication_token : '',
          'username': (object1.username) ? object1.username : '',
          'password': (object1.password) ? await this.helperService.encrypt(object1.password) : '',
          'refresh_token_url': object1.refresh_token_endpoint_url ? await this.helperService.encrypt(object1.refresh_token_endpoint_url) : "",
          'refresh_token_headers': object1.refresh_token_endpoint_header ? object1.refresh_token_endpoint_header : {},
          'refresh_token_params': object1.refresh_token_endpoint_params ? object1.refresh_token_endpoint_params : {},
          'refresh_token_method': object1.refresh_token_endpoint_method,
          'refresh_token_body': object1.refresh_token_endpoint_body ? await this.helperService.encrypt(JSON.stringify(object1.refresh_token_endpoint_body)) : "",
          'body_type': object1.body_type,
          'endpoint_body': object1.endpoint_body,
          "pre_request_script": (pre_request_script_ops_restapitarget) ? await this.helperService.encrypt(this.helperService.isString(pre_request_script_ops_restapitarget)) : '',
          "response_type": object1.response_type ? object1.response_type : "",
          "selected_environment": selectedEnv ? selectedEnv : "",
          "environment_variables": env_variable ? env_variable : "",
          "isMute": object.isMute,
          "id": object.id,
        }

        bizdata_ops_restapitarget["target_id"] = object.is_new_target ? 0 : object.bridge_target_business_object.id;
        bizdata_ops_restapitarget["target_name"] = object.is_new_target ? object.new_bridge_target : object.bridge_target;
        bizdata_ops_restapitarget["target_business_obj_id"] = object.is_new_target ? 0 : object.bridge_target_business_object.id;
        bizdata_ops_restapitarget["target_business_obj"] = object.is_new_target ? object.new_bridge_target_business_object : object.bridge_target_business_object.business_obj;
        // delete object.id;
        let json_obj = new Object();
        bizdata_ops_restapitarget = Object.assign({ source: "bizdata_dataset" }, bizdata_ops_restapitarget);
        bizdata_ops_restapitarget = Object.assign({}, bizdata_ops_restapitarget, { target: "bizdata_dataset" });
        if (i == 0) json_obj[`${_var}_restapitarget_1`] = bizdata_ops_restapitarget;
        else json_obj[`${_var}_restapitarget_${i + 1}`] = bizdata_ops_restapitarget;
        // console.log(json_obj);
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }

    if (dlIngestionRows) {
      let i = 0;
      let arr = _.cloneDeep(dlIngestionRows);
      for (let object of arr) {
        let dlakeingestion_obj = {
          "source": "bizdata_dataset",
          "version": object.version,
          "dlake_host": object.dlake_host ? object.dlake_host : "",
          "dlake_port": object.dlake_port ? object.dlake_port : +(""),
          "dlusername": object.dlusername ? object.dlusername : "",
          "dlpassword": object.dlpassword ? await this.helperService.encrypt(object.dlpassword) : "",
          "ca_certs_path": object.dl_ca_certs_path ? object.dl_ca_certs_path : "",
          "index_name": `bizintel360-${object.index_name}`,
          "action_type": object.action_type,
          "primary_key": object.primary_key,
          "refresh_type": "True",
          "request_timeout_sec": 1000,
          "indexing_type": object.indexing_type,
          "max_retries": 10,
          "chunk_size": 500,
          "thread_count": 4,
          "queue_size": 4,
          "isMute": object.isMute,
          "id": object.id,
          "target": "bizdata_dataset",
        }
        let json_obj = new Object();
        dlakeingestion_obj = Object.assign({ source: "bizdata_dataset" }, dlakeingestion_obj);
        dlakeingestion_obj = Object.assign({}, dlakeingestion_obj, { target: "bizdata_dataset" });
        if (i == 0) json_obj[`${object.version.op_name}_1`] = dlakeingestion_obj;
        else json_obj[`${object.version.op_name}_${i + 1}`] = dlakeingestion_obj;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }

    if (dlsearchRows) {
      let i = 0;
      let arr = _.cloneDeep(dlsearchRows);
      for (let object of arr) {
        let dlsearch_obj = {
          "source": "bizdata_dataset",
          "version": object.version,
          "dlsearch_host": object.dlsearch_host ? object.dlsearch_host : "",
          "dlsearch_port": object.dlsearch_port ? object.dlsearch_port : +(""),
          "dlsearch_username": object.dlsearch_username ? object.dlsearch_username : "",
          "dlsearch_password":  object.dlsearch_password ? await this.helperService.encrypt(object.dlsearch_password) : "",
          "dlsearch_ca_certs_path": object.dlsearch_ca_certs_path ? object.dlsearch_ca_certs_path : "",
          "dlsearch_index_name": `bizintel360-${object.dlsearch_index_name}`,
          "dlsearch_scroll": object.dlsearch_scroll,
          "dlsearch_timeout": object.dlsearch_timeout,
          "dlsearch_batch_size": 1000,
          "dlsearch_body": object.dlsearch_body,//this.helperService.stringToObjectConverter("String", object.dlsearch_body),
          "isMute": object.isMute,
          "id": object.id,
          "target": "bizdata_dataset",
        }
        let json_obj = new Object();
        dlsearch_obj = Object.assign({ source: "bizdata_dataset" }, dlsearch_obj);
        dlsearch_obj = Object.assign({}, dlsearch_obj, { target: "bizdata_dataset" });
        if (i == 0) json_obj[`${object.version.op_name}_1`] = dlsearch_obj;
        else json_obj[`${object.version.op_name}_${i + 1}`] = dlsearch_obj;
        //console.log(json_obj);
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    // **************** ^^^^^^^ **************** //


    // ************** CLEANING *************** //
    if (dropeventsstartswithRows) {
      let i = 0;
      let arr = _.cloneDeep(dropeventsstartswithRows);
      for (let object of arr) {
        object.drop_all_event_to_start_with = this.helperService.stringToObjectConverter("Array", object.drop_all_event_to_start_with);
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_dropeventsstartswith: any = ops_restapi.bizdata_ops_dropeventsstartswith as any;
        object = Object.assign({ source: bizdata_ops_dropeventsstartswith?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_dropeventsstartswith?.target });
        if (i == 0) json_obj[`${_var}_dropeventsstartswith_1`] = object;
        else json_obj[`${_var}_dropeventsstartswith_${i + 1} `] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (dropalleventvaluesRows) {
      let i = 0;
      let arr = _.cloneDeep(dropalleventvaluesRows);
      for (let object of arr) {
        object.drop_all_event_for_value = this.helperService.stringToObjectConverter("Array", object.drop_all_event_for_value);
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_dropalleventvalues: any = ops_restapi.bizdata_ops_dropalleventvalues as any;
        object = Object.assign({ source: bizdata_ops_dropalleventvalues?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_dropalleventvalues?.target });
        if (i == 0) json_obj[`${_var}_dropalleventvalues_1`] = object;
        else json_obj[`${_var}_dropalleventvalues_${i + 1} `] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (eliminateRows) {
      let i = 0;
      let arr = _.cloneDeep(eliminateRows);
      for (let object of arr) {
        object.eliminate = this.helperService.stringToObjectConverter("Array", object.eliminate);
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_eliminate: any = ops_restapi.bizdata_ops_eliminate as any;
        object = Object.assign({ source: bizdata_ops_eliminate?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_eliminate?.target });
        if (i == 0) json_obj[`${_var}_eliminate_1`] = object;
        else json_obj[`${_var}_eliminate_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (calculatorRows) {
      let i = 0;
      let arr = _.cloneDeep(calculatorRows);
      for (let object of arr) {
        object.calculation_keys = this.helperService.stringToObjectConverter("Array", object.calculation_keys);
        object.new_calculation_keys = this.helperService.stringToObjectConverter("Array", object.new_calculation_keys);
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_calculater: any = ops_restapi.bizdata_ops_calculater as any;
        object = Object.assign({ source: bizdata_ops_calculater?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_calculater?.target });
        if (i == 0) json_obj[`${_var}_calculator_1`] = object;
        else json_obj[`${_var}_calculator_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (roundRows) {
      let i = 0;
      let arr = _.cloneDeep(roundRows);
      for (let object of arr) {
        object.round_keys = this.helperService.stringToObjectConverter("Array", object.round_keys);
        object.decimal_key_number = +(object.decimal_key_number);
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_round: any = ops_restapi.bizdata_ops_round as any;
        object = Object.assign({ source: bizdata_ops_round?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_round?.target });
        if (i == 0) json_obj[`${_var}_round_1`] = object;
        else json_obj[`${_var}_round_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (dateanalyticsRows) {
      let i = 0;
      let arr = _.cloneDeep(dateanalyticsRows);
      for (let object of arr) {
        // object.date_field_key = this.helperService.stringToObjectConverter("Array", object.date_field_key);
        object.fiscal_month_start = +(object.fiscal_month_start);
        if (object.date_column != '' && object.date_column != undefined) {
          object.date_column = this.helperService.stringToObjectConverter("Array", object.date_column);
        } else {
          object.date_column = []
        }
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_dateanalytics: any = ops_restapi.bizdata_ops_dateanalytics as any;
        object = Object.assign({ source: bizdata_ops_dateanalytics?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_dateanalytics?.target });
        if (i == 0) json_obj[`${_var}_dateanalytics_1`] = object;
        else json_obj[`${_var}_dateanalytics_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (substituteRows) {
      let i = 0;
      let arr = _.cloneDeep(substituteRows);
      for (let object of arr) {
        object.substitute = this.helperService.stringToObjectConverter("Array", object.substitute,'strip_Substitute');
        let tmpSub=''
        for(let sub of object.substitute){
          sub=sub.replace(/\\"/g,'"');
          tmpSub+=sub+','
        }
        object.substitute=tmpSub.split(',')
        object.substitute.pop()
        let json_obj = new Object();
        let bizdata_ops_substitute: any = ops_restapi.bizdata_ops_substitute as any;
        object = Object.assign({ source: bizdata_ops_substitute?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_substitute?.target });
        if (i == 0) json_obj[`${_var}_substitute_1`] = object;
        else json_obj[`${_var}_substitute_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (stripRows) {
      let i = 0;
      let arr = _.cloneDeep(stripRows);
      for (let object of arr) {
        // delete object.id;
        object.strip = this.helperService.stringToObjectConverter("Array", object.strip, "strip");
        let json_obj = new Object();
        let bizdata_ops_strip: any = ops_restapi.bizdata_ops_strip as any;
        object = Object.assign({ source: bizdata_ops_strip?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_strip?.target });
        if (i == 0) json_obj[`${_var}_strip_1`] = object;
        else json_obj[`${_var}_strip_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (substringRows) {
      let i = 0;
      let arr = _.cloneDeep(substringRows);
      for (let object of arr) {
        object.substring = this.helperService.stringToObjectConverter("Json", object.substring);
        let json_obj = new Object();
        let bizdata_ops_substring: any = ops_restapi.bizdata_ops_substring as any;
        object = Object.assign({ source: bizdata_ops_substring?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_substring?.target });
        if (i == 0) json_obj[`${_var}_substring_1`] = object;
        else json_obj[`${_var}_substring_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (renameRows) {
      let i = 0;
      let arr = _.cloneDeep(renameRows);
      for (let object of arr) {
        object.rename = this.helperService.stringToObjectConverter("Json", object.rename);
        let json_obj = new Object();
        let bizdata_ops_rename: any = ops_restapi.bizdata_ops_rename as any;
        object = Object.assign({ source: bizdata_ops_rename?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_rename?.target });
        if (i == 0) json_obj[`${_var}_rename_1`] = object;
        else json_obj[`${_var}_rename_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    // ****************Exit ^^^^^^^ **************** //


    // ************** PIPELINE CONTROL *************** //
    if (sleepRows) {
      let i = 0;
      let arr = _.cloneDeep(sleepRows);
      for (let object of arr) {
        object.sleep_time = +(object.sleep_time)
        // delete object.id;
        let json_obj = new Object();
        let bizdata_ops_sleeptime: any = ops_restapi.bizdata_ops_sleeptime as any;
        object = Object.assign({ source: bizdata_ops_sleeptime?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_sleeptime?.target });
        if (i == 0) json_obj[`${_var}_sleeptime_1`] = object;
        else json_obj[`${_var}_sleeptime_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (pycodeRows) {
      let i = 0;
      let arr = _.cloneDeep(pycodeRows);
      for (let object of arr) {
        // delete object.id;
        if (object.pycode.includes("\\")) {
          object.pycode = JSON.stringify(object.pycode).replace(new RegExp('\\\\\\\\', "g"), '\\');
          object.pycode = JSON.parse(object.pycode);
        }
        let json_obj = new Object();
        let bizdata_ops_pycode: any = ops_restapi.bizdata_ops_pycode as any;
        object = Object.assign({ source: bizdata_ops_pycode?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_pycode?.target });
        if (i == 0) json_obj[`${_var}_pycode_1`] = object;
        else json_obj[`${_var}_pycode_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    if (aiopsRows) {
      let i = 0;
      let arr = _.cloneDeep(aiopsRows);
      for (let object of arr) {
        let aiops_obj={
          "source": "bizdata_dataset",
          "question":object.question,
          "target": "bizdata_dataset",
          "id": object.id,
          "isMute": object.isMute
        }
        let json_obj = new Object();
        if (i == 0) json_obj[`${_var}_aiops_1`] = aiops_obj;
        else json_obj[`${_var}_aiops_${i + 1}`] = aiops_obj;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }

    if (filterRows) {
      let i = 0;
      let arr = _.cloneDeep(filterRows);
      for (let object of arr) {
        let json_obj = new Object();
        let bizdata_ops_filter: any = ops_restapi.bizdata_ops_filter as any;
        object = Object.assign({ source: bizdata_ops_filter?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_filter?.target });
        if (i == 0) json_obj[`${_var}_filter_1`] = object;
        else json_obj[`${_var}_filter_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }

    if (filterEndsRows) {
      let i = 0;
      let arr = _.cloneDeep(filterEndsRows);
      for (let object of arr) {
        let json_obj = new Object();
        let bizdata_ops_filterends: any = ops_restapi.bizdata_ops_filterends as any;
        object = Object.assign({ source: bizdata_ops_filterends?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_filterends?.target });
        if (i == 0) json_obj[`${_var}_filterends_1`] = object;
        else json_obj[`${_var}_filterends_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }

    if (docunderstandingRows) {
      let i = 0;
      let arr = _.cloneDeep(docunderstandingRows);
      for (let object of arr) {
        let questionParams = object.questions;
        let questionParamsArr = [];

        if (questionParams) {
          for (let param of questionParams) {
            let value = Object.values(param)
            questionParamsArr.push(value)

          }
        }
        object.questions = questionParamsArr;
        let json_obj = new Object();
        let bizdata_ops_docunderstanding: any = ops_restapi.bizdata_ops_docunderstanding as any;
        object = Object.assign({ source: bizdata_ops_docunderstanding?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_docunderstanding?.target });
        if (i == 0) json_obj[`${_var}_docunderstanding_1`] = object;
        else json_obj[`${_var}_docunderstanding_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }

    if (imgunderstandingRows) {
      let i = 0;
      let arr = _.cloneDeep(imgunderstandingRows);
      for (let object of arr) {
        let questionParams = object.questions;
        let questionParamsArr = [];

        if (questionParams) {
          for (let param of questionParams) {
            let value = Object.values(param)
            questionParamsArr.push(value)

          }
        }
        object.questions = questionParamsArr;
        let json_obj = new Object();
        let bizdata_ops_imgunderstanding: any = ops_restapi.bizdata_ops_imgunderstanding as any;
        object = Object.assign({ source: bizdata_ops_imgunderstanding?.source }, object);
        object = Object.assign({}, object, { target: bizdata_ops_imgunderstanding?.target });
        if (i == 0) json_obj[`${_var}_imgunderstanding_1`] = object;
        else json_obj[`${_var}_imgunderstanding_${i + 1}`] = object;
        transformation_ops_arr.push(json_obj);
        i++;
      }
    }
    console.log(transformation_ops_arr);
    // **************** ^^^^^^^ **************** //
    const sortArray = (arr1, arr2) => {
      console.log(arr1,arr2)
      arr2.sort((a, b) => {
        const aVal: any = Object.values(a)[0];
        const bVal: any = Object.values(b)[0];
        const arr1_index1 = arr1.findIndex(object => object.id === aVal.id);
        const arr1_index2 = arr1.findIndex(object => object.id === bVal.id);
        return arr1_index1 - arr1_index2;
      });
    };

    sortArray(this.finalBlocks, transformation_ops_arr);

    if (this.isConsole) {
      for (let i = 0; i < transformation_ops_arr.length; i++) {
        if (Object.keys(transformation_ops_arr[i])[0].includes("bizdata_ops_json2dl") || Object.keys(transformation_ops_arr[i])[0].includes("bizdata_ops_dl2json")) {
          transformation_ops_arr[i][Object.keys(transformation_ops_arr[i])[0]].autodetect_column_names = transformation_ops_arr[i][Object.keys(transformation_ops_arr[i])[0]].autodetect_column_names.toString();
          transformation_ops_arr[i][Object.keys(transformation_ops_arr[i])[0]].skip_header = transformation_ops_arr[i][Object.keys(transformation_ops_arr[i])[0]].skip_header.toString();
        }
      }
      
    //   transformation_ops_arr = transformation_ops_arr.filter(obj => !Object.values(obj)[0]["isMute"]);
     
    //   transformation_ops_arr = transformation_ops_arr.map(obj => {
    //   //console.log(obj);
    
    //     let newObj = {};
    //     for (let key in obj) {
    //         newObj[key] = { ...obj[key] };
    //         delete newObj[key].isMute;
    //         delete newObj[key].id;
    //     }
    //     //console.log(newObj);
    //     return newObj;
    //   });
    }

    for (let i = 0; i < transformation_ops_arr.length; i++) {
      let key = Object.keys(transformation_ops_arr[i])
      if(key[0].includes("bizdata_ops_jdbcoutput")){
        transformation_ops_arr[i][key[0]].query = transformation_ops_arr[i][key[0]].query;
      }
      Object.assign(transformation_ops_json, transformation_ops_arr[i]);
    }
    //console.log(transformation_ops_json);
    // //console.log(JSON.stringify(transformation_ops_json));   
    return transformation_ops_json;
  }

  onChangeGetDlversion(event, index) {
    let value = event.value.op_name
    this.getStorage().then((res) => {
      let payload = {
        "dlversion": event.value.dlversion,
        "op_name": value,
        "op_type": "ingestion"
      }
      this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
        (response) => {
          this.helperService.decryptpayload(response.data).then((records)=>{
          let data=JSON.parse(records);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlake_host'].setValue(data.dlhost_name);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlpassword'].setValue(data.dlpsw);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlake_port'].setValue(+(data.dlport));
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlusername'].setValue(data.dlusername);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dl_ca_certs_path'].setValue(data.dl_ca_certs_path);
          });
        },
        (error) => {
          //console.log(error);
        }
      );
    })
  }

  onChangeGetDlversionDLS(event, index) {
    let value = event.value.op_name
    this.getStorage().then((res) => {
      let payload = {
        "dlversion": event.value.dlversion,
        "op_name": value,
        "op_type": "search"
      }
      this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
        (response) => {
          this.helperService.decryptpayload(response.data).then((records)=>{
            let data=JSON.parse(records);
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_host'].setValue(data.dlhost_name);
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_password'].setValue(data.dlpsw);
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_port'].setValue(+(data.dlport));
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_username'].setValue(data.dlusername);
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_ca_certs_path'].setValue(data.dl_ca_certs_path);
          });
        },
        (error) => {
          //console.log(error);
        }
      );
    })
  }

  onChangeProcessEDO(event, index) {

  }

  // findKey(json, key){
  //   const getValue = (keyPath: string) => _.get(json, keyPath, undefined) as number;
  //   const key_item = getValue(key);
  //   return key_item == undefined? true: false;
  // }

  restAPIForm() {
    //----------------Transformation Form Init---------------//
    // this.bizdata_ops_datatypes_fb = new FormGroup({})
    // for(const key of Object.keys(ops_restapi['bizdata_ops_datatypes'])) {
    //   //console.log(key,ops_restapi['bizdata_ops_datatypes'][key])
    //   this.bizdata_ops_datatypes_fb.addControl(key,this._formBuilder.control(['']));
    // }
    this.bizdata_ops_datatypes_fb = this._formBuilder.group({
      datatypesRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_datatypes_fb = this._formBuilder.group({
    //   "boolean_operator": [[]],
    //   "float_operator": [[]],
    //   "integer_operator": [[]],
    //   "datetime_operator": [[]],
    // });
    this.bizdata_ops_append_fb = this._formBuilder.group({
      appendRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_append_fb = this._formBuilder.group({
    //   'append': [[]]
    // });
    this.bizdata_ops_titlecase_fb = this._formBuilder.group({
      titlecaseRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_titlecase_fb = this._formBuilder.group({
    //   'Titlecase': [[]],
    // });
    this.bizdata_ops_uppercase_fb = this._formBuilder.group({
      uppercaseRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_uppercase_fb = this._formBuilder.group({
    //   'uppercase': [[]],
    // });
    this.bizdata_ops_lowercase_fb = this._formBuilder.group({
      lowercaseRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_lowercase_fb = this._formBuilder.group({
    //   'lowercase': [[]],
    // });
    this.bizdata_ops_dataextractor_fb = this._formBuilder.group({
      dataextractorRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dataextractor_fb = this._formBuilder.group({
    //   "data_extractor": [[]],
    //   "data_extractor_keys": [[]],
    // });
    this.bizdata_ops_trim_fb = this._formBuilder.group({
      trimRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_trim_fb = this._formBuilder.group({
    //   "trim_keys": [[]],
    // });
    this.bizdata_ops_base64decoding_fb = this._formBuilder.group({
      base64decodingRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_base64decoding_fb = this._formBuilder.group({
    //   "base64_decode": [[]],
    // });
    this.bizdata_ops_base64encoding_fb = this._formBuilder.group({
      base64encodingRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_base64encoding_fb = this._formBuilder.group({
    //   "base64_encode": [[]],
    // })
    this.bizdata_ops_jsontoxml_fb = this._formBuilder.group({
      jsontoxmlRows: new UntypedFormArray([])
    });
    this.bizdata_ops_xmltojson_fb = this._formBuilder.group({
      xmltojsonRows: new UntypedFormArray([])
    });
    this.bizdata_ops_repeatfirstrow_fb = this._formBuilder.group({
      repeatfirstrowRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_xmltojson_fb = this._formBuilder.group({
    //   'get_key': [''],
    // });
    //----------------Waringling Form Init------------------//
    // this.bizdata_ops_json2dl_fb = new FormGroup({})
    // for(const key of Object.keys(ops_restapi['bizdata_ops_json2dl'])) {
    //   this.bizdata_ops_json2dl_fb.addControl(key,this._formBuilder.control(['']));
    // };
    this.bizdata_ops_json2dl_fb = this._formBuilder.group({
      json2dlRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_json2dl_fb = this._formBuilder.group({
    //   "key_data": [''],
    //   "delimiter": [''],
    //   "fields": [[]],
    //   "autodetect_column_names": [''],
    //   "skip_header": [''],
    //   "response_key": [''],
    // });
    this.bizdata_ops_dl2json_fb = this._formBuilder.group({
      dl2jsonRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dl2json_fb = this._formBuilder.group({
    //   "key_data": [''],
    //   "delimiter": [''],
    //   "fields": [[]],
    //   "autodetect_column_names": [''],
    //   "skip_header": [''],
    //   "response_key": [''],
    // });
    this.bizdata_ops_generatesequence_fb = this._formBuilder.group({
      generatesequenceRows: new UntypedFormArray([])
    });
    this.bizdata_ops_json2string_fb = this._formBuilder.group({
      json2stringRows: new UntypedFormArray([])
    });
    this.bizdata_ops_string2json_fb = this._formBuilder.group({
      string2jsonRows: new UntypedFormArray([])
    });
    this.bizdata_ops_toplevel_fb = this._formBuilder.group({
      toplevelRows: new UntypedFormArray([])
    });
    this.bizdata_ops_datetimestamp_fb = this._formBuilder.group({
      datetimestampRows: new UntypedFormArray([])
    });
    this.bizdata_ops_dataaggregation_fb = this._formBuilder.group({
      dataaggregationRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dataaggregation_fb = this._formBuilder.group({
    //   "groupby_key": [''],
    //   "array_key": [''],
    //   "array_key_nested_columns": [[]],
    // });
    // });
    this.bizdata_ops_pivot_fb = this._formBuilder.group({
      pivotRows: new UntypedFormArray([])
    });
    this.bizdata_ops_unpivot_fb = this._formBuilder.group({
      unpivotRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_pivot_fb = this._formBuilder.group({
    //   "transposed_key_name": [[]],
    //   "transposed_value": [[]],
    // });
    this.bizdata_ops_singletomultiline_fb = this._formBuilder.group({
      chopRows: new UntypedFormArray([])
    });
    this.bizdata_ops_singleline2tuple_fb = this._formBuilder.group({
      singleline2tupleRows: new UntypedFormArray([])
    });
    this.bizdata_ops_tuple2singleline_fb = this._formBuilder.group({
      tuple2singlelineRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_chopkey_fb = this._formBuilder.group({
    //   "chopkey": [''],
    // });
    // this.bizdata_ops_file_fb = this._formBuilder.group({
    //   fileRows: new FormArray([])
    // });
    // this.bizdata_ops_file_fb = this._formBuilder.group({
    //   "target_location": [''],
    //   "extension": [''],
    //   "write_mode": ['']
    // });
    this.bizdata_ops_email_fb = this._formBuilder.group({
      emailRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_email_fb = this._formBuilder.group({
    //   'drop_all_event_to_start_with': [''],
    //   "response_parameter": [''],
    //   "mailserver": [''],
    //   "port_number": [''],
    //   "From": [''],
    //   "to": [''],
    //   "password": [''],
    //   "cc": [[]],
    //   "response_key": [''],
    //   "seperator": [''],
    //   "attachment": [''],
    //   "attachment_extension": [''],
    //   "in_data": [''],
    //   "body_arr": [[]],
    //   "subject": [''],
    //   "body": [''],
    // });
    this.bizdata_ops_restapi_fb = this._formBuilder.group({
      restapiRows: new UntypedFormArray([])
    });

    this.bizdata_ops_dlakeingestion_fb = this._formBuilder.group({
      dlIngestionRows: new UntypedFormArray([])
    });

    this.bizdata_ops_dlsearch_fb = this._formBuilder.group({
      dlsearchRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_restapi_fb = this._formBuilder.group({
    //   'drop_all_event_to_start_with': [''],
    //   "min_num": [''],
    //   "max_num": [''],
    //   "endpoint_url": [''],
    //   "endpoint_headers": [[]],
    //   "endpoint_method": [''],
    //   "endpoint_body": [[]],
    //   "endpoint_params": [[]],
    //   "authentication_type": [''],
    //   "username": [''],
    //   "password": [''],
    //   "refresh_token_url": [''],
    //   "refresh_token_headers": [''],
    //   "refresh_token_method": [''],
    //   "refresh_token_body": [''],
    //   "refresh_token_params": [[]],
    //   "pre_request_script": [''],
    //   "response_parameters": [''],
    //   "another_response_parameter": [''],
    //   "key_name_to_update": [''],
    //   "user_key": [''],
    //   "pagination_style": [''],
    //   "timer_type": [''],
    //   "interval_in_seconds": [''],
    //   "schedule": [''],
    //   "user_key_url": ['']
    // });
    this.bizdata_ops_json_fb = this._formBuilder.group({
      jsonRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_json_fb = this._formBuilder.group({
    //   'drop_all_event_to_start_with': [''],
    //   "jdbc_driver": [''],
    //   "jdbc_string": [''],
    //   "jdbc_jar_file": [''],
    //   "username": [''],
    //   "password": [''],
    //   "unique_key": [''],
    //   "query": [''],
    //   "response_parameter": [''],
    //   "timer_type": [''],
    //   "schedule": [''],
    //   "interval_in_seconds": [''],
    //   "multiline": [''],
    // });
    this.bizdata_ops_dropeventsstartswith_fb = this._formBuilder.group({
      dropeventsstartswithRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dropeventsstartswith_fb = this._formBuilder.group({
    //   'drop_all_event_to_start_with': [[]],
    // });
    this.bizdata_ops_dropalleventvalues_fb = this._formBuilder.group({
      dropalleventvaluesRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_dropalleventvalues_fb = this._formBuilder.group({
    //   'drop_all_event_for_value': [[]],
    // });
    this.bizdata_ops_eliminate_fb = this._formBuilder.group({
      eliminateRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_eliminate_fb = this._formBuilder.group({
    //   "eliminate": [[]],
    // });
    this.bizdata_ops_calculater_fb = this._formBuilder.group({
      calculaterRows: new UntypedFormArray([])
    });
    this.bizdata_ops_dateanalytics_fb = this._formBuilder.group({
      dateanalyticsRows: new UntypedFormArray([])
    });
    this.bizdata_ops_substitute_fb = this._formBuilder.group({
      substituteRows: new UntypedFormArray([])
    });
    this.bizdata_ops_strip_fb = this._formBuilder.group({
      stripRows: new UntypedFormArray([])
    });
    this.bizdata_ops_substring_fb = this._formBuilder.group({
      substringRows: new UntypedFormArray([])
    });
    this.bizdata_ops_rename_fb = this._formBuilder.group({
      renameRows: new UntypedFormArray([])
    });
    this.bizdata_ops_round_fb = this._formBuilder.group({
      roundRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_rename_fb = this._formBuilder.group({
    //   "rename": [[]],
    // });
    this.bizdata_ops_sleeptime_fb = this._formBuilder.group({
      sleepRows: new UntypedFormArray([])
    });
    // this.bizdata_ops_sleeptime_fb = this._formBuilder.group({
    //   "sleep_time": [''],
    // });
    this.bizdata_ops_pycode_fb = this._formBuilder.group({
      pycodeRows: new UntypedFormArray([])
    });

    this.bizdata_ops_aiops_fb = this._formBuilder.group({
      aiopsRows: new UntypedFormArray([])
    });

    this.bizdata_ops_jdbcoutput_fb = this._formBuilder.group({
      jdbcoutputRows: new UntypedFormArray([])
    });

    this.bizdata_ops_filter_fb = this._formBuilder.group({
      filterRows: new UntypedFormArray([])
    });

    this.bizdata_ops_encodedecode_fb = this._formBuilder.group({
      encodedecodeRows: new UntypedFormArray([])
    });

    this.bizdata_ops_zipfileinbase64_fb = this._formBuilder.group({
      zipfileinbase64Rows: new UntypedFormArray([])
    });

    this.bizdata_ops_arraycount_fb = this._formBuilder.group({
      arraycountRows: new UntypedFormArray([])
    });

    this.bizdata_ops_dl2array_fb = this._formBuilder.group({
      dl2arrayRows: new UntypedFormArray([])
    });

    this.bizdata_ops_pdfextractor_fb = this._formBuilder.group({
      pdfextractorRows: new UntypedFormArray([])
    });

    this.bizdata_ops_fileextractor_fb = this._formBuilder.group({
      fileextractorRows: new UntypedFormArray([])
    });

    this.bizdata_ops_docunderstanding_fb = this._formBuilder.group({
      docunderstandingRows: new UntypedFormArray([])
    });

    this.bizdata_ops_grokpattern_fb = this._formBuilder.group({
      grokpatternRows: new UntypedFormArray([])
    });

    this.bizdata_ops_imgunderstanding_fb = this._formBuilder.group({
      imgunderstandingRows: new UntypedFormArray([])
    });

    this.bizdata_ops_filterends_fb = this._formBuilder.group({
      filterEndsRows: new UntypedFormArray([])
    });

    this.bizdata_ops_rawsentencegenerator_fb = this._formBuilder.group({
      rawsentencegeneratorRows: new UntypedFormArray([])
    });

    this.bizdata_ops_timeunits_fb = this._formBuilder.group({
      timeunitsRows: new UntypedFormArray([])
    });
    this.bizdata_ops_datachunking_fb = this._formBuilder.group({
      datachunkingRows: new UntypedFormArray([])
    });
    this.bizdata_ops_jason2avro_fb = this._formBuilder.group({
      jason2avroRows: new UntypedFormArray([])
    });
    this.bizdata_ops_htmlextractor_fb = this._formBuilder.group({
      htmlExtractorRows: new UntypedFormArray([])
    });
    this.bizdata_ops_avro2json_fb = this._formBuilder.group({
      avro2jsonRows: new UntypedFormArray([])
    });    
    this.bizdata_ops_extract2array_fb = this._formBuilder.group({
      extract2ArrayRows: new UntypedFormArray([])
    });
  }

  // get f() { return this.bizdata_ops_append_fb.controls; }
  // get t() { return this.f.appendRows as FormArray; }

  datatypesRows(): UntypedFormArray {
    return this.bizdata_ops_datatypes_fb.get("datatypesRows") as UntypedFormArray
  }

  appendRows(): UntypedFormArray {
    return this.bizdata_ops_append_fb.get("appendRows") as UntypedFormArray
  }

  titlecaseRows(): UntypedFormArray {
    return this.bizdata_ops_titlecase_fb.get("titlecaseRows") as UntypedFormArray
  }

  uppercaseRows(): UntypedFormArray {
    return this.bizdata_ops_uppercase_fb.get("uppercaseRows") as UntypedFormArray
  }

  lowercaseRows(): UntypedFormArray {
    return this.bizdata_ops_lowercase_fb.get("lowercaseRows") as UntypedFormArray
  }

  dataextractorRows(): UntypedFormArray {
    return this.bizdata_ops_dataextractor_fb.get("dataextractorRows") as UntypedFormArray
  }

  trimRows(): UntypedFormArray {
    return this.bizdata_ops_trim_fb.get("trimRows") as UntypedFormArray
  }

  base64decodingRows(): UntypedFormArray {
    return this.bizdata_ops_base64decoding_fb.get("base64decodingRows") as UntypedFormArray
  }

  base64encodingRows(): UntypedFormArray {
    return this.bizdata_ops_base64encoding_fb.get("base64encodingRows") as UntypedFormArray
  }

  jsontoxmlRows(): UntypedFormArray {
    return this.bizdata_ops_jsontoxml_fb.get("jsontoxmlRows") as UntypedFormArray
  }

  xmltojsonRows(): UntypedFormArray {
    return this.bizdata_ops_xmltojson_fb.get("xmltojsonRows") as UntypedFormArray
  }

  repeatfirstrowRows(): UntypedFormArray {
    return this.bizdata_ops_repeatfirstrow_fb.get("repeatfirstrowRows") as UntypedFormArray
  }

  encodedecodeRows(): UntypedFormArray {
    return this.bizdata_ops_encodedecode_fb.get("encodedecodeRows") as UntypedFormArray
  }

  generatesequenceRows(): UntypedFormArray {
    return this.bizdata_ops_generatesequence_fb.get("generatesequenceRows") as UntypedFormArray
  }

  json2stringRows(): UntypedFormArray {
    return this.bizdata_ops_json2string_fb.get("json2stringRows") as UntypedFormArray
  }

  string2jsonRows(): UntypedFormArray {
    return this.bizdata_ops_string2json_fb.get("string2jsonRows") as UntypedFormArray
  }

  toplevelRows(): UntypedFormArray {
    return this.bizdata_ops_toplevel_fb.get("toplevelRows") as UntypedFormArray
  }

  datetimestampRows(): UntypedFormArray {
    return this.bizdata_ops_datetimestamp_fb.get("datetimestampRows") as UntypedFormArray
  }

  arraycountRows(): UntypedFormArray {
    return this.bizdata_ops_arraycount_fb.get("arraycountRows") as UntypedFormArray
  }

  pdfextractorRows(): UntypedFormArray {
    return this.bizdata_ops_pdfextractor_fb.get("pdfextractorRows") as UntypedFormArray
  }

  fileextractorRows(): UntypedFormArray {
    return this.bizdata_ops_fileextractor_fb.get("fileextractorRows") as UntypedFormArray
  }

  grokpatternRows(): UntypedFormArray {
    return this.bizdata_ops_grokpattern_fb.get("grokpatternRows") as UntypedFormArray
  }

  rawsentencegeneratorRows(): UntypedFormArray {
    return this.bizdata_ops_rawsentencegenerator_fb.get("rawsentencegeneratorRows") as UntypedFormArray
  }

  timeunitsRows(): UntypedFormArray {
    return this.bizdata_ops_timeunits_fb.get("timeunitsRows") as UntypedFormArray
  }
  datachunkingRows(): UntypedFormArray {
    return this.bizdata_ops_datachunking_fb.get("datachunkingRows") as UntypedFormArray
  }
  jason2avroRows(): UntypedFormArray {
    return this.bizdata_ops_jason2avro_fb.get("jason2avroRows") as UntypedFormArray
  }

  htmlExtractorRows(): UntypedFormArray {
    return this.bizdata_ops_htmlextractor_fb.get("htmlExtractorRows") as UntypedFormArray
  }
  avro2jsonRows(): UntypedFormArray {
    return this.bizdata_ops_avro2json_fb.get("avro2jsonRows") as UntypedFormArray
  }
  extract2ArrayRows(): UntypedFormArray {
    return this.bizdata_ops_extract2array_fb.get("extract2ArrayRows") as UntypedFormArray
  }
  //--------------------------
  json2dlRows(): UntypedFormArray {
    return this.bizdata_ops_json2dl_fb.get("json2dlRows") as UntypedFormArray
  }

  dl2jsonRows(): UntypedFormArray {
    return this.bizdata_ops_dl2json_fb.get("dl2jsonRows") as UntypedFormArray
  }

  dataaggregationRows(): UntypedFormArray {
    return this.bizdata_ops_dataaggregation_fb.get("dataaggregationRows") as UntypedFormArray
  }

  pivotRows(): UntypedFormArray {
    return this.bizdata_ops_pivot_fb.get("pivotRows") as UntypedFormArray
  }

  unpivotRows(): UntypedFormArray {
    return this.bizdata_ops_unpivot_fb.get("unpivotRows") as UntypedFormArray
  }

  chopRows(): UntypedFormArray {
    return this.bizdata_ops_singletomultiline_fb.get("chopRows") as UntypedFormArray
  }

  singleline2tupleRows(): UntypedFormArray {
    return this.bizdata_ops_singleline2tuple_fb.get("singleline2tupleRows") as UntypedFormArray
  }

  tuple2singlelineRows(): UntypedFormArray {
    return this.bizdata_ops_tuple2singleline_fb.get("tuple2singlelineRows") as UntypedFormArray
  }

  // fileRows(): FormArray {
  //   return this.bizdata_ops_file_fb.get("fileRows") as FormArray
  // }

  emailRows(): UntypedFormArray {
    return this.bizdata_ops_email_fb.get("emailRows") as UntypedFormArray
  }

  restapiRows(): UntypedFormArray {
    return this.bizdata_ops_restapi_fb.get("restapiRows") as UntypedFormArray
  }

  dlIngestionRows(): UntypedFormArray {
    return this.bizdata_ops_dlakeingestion_fb.get("dlIngestionRows") as UntypedFormArray
  }

  dlsearchRows(): UntypedFormArray {
    return this.bizdata_ops_dlsearch_fb.get("dlsearchRows") as UntypedFormArray
  }

  jsonRows(): UntypedFormArray {
    return this.bizdata_ops_json_fb.get("jsonRows") as UntypedFormArray
  }

  dropeventsstartswithRows(): UntypedFormArray {
    return this.bizdata_ops_dropeventsstartswith_fb.get("dropeventsstartswithRows") as UntypedFormArray
  }

  dropalleventvaluesRows(): UntypedFormArray {
    return this.bizdata_ops_dropalleventvalues_fb.get("dropalleventvaluesRows") as UntypedFormArray
  }

  eliminateRows(): UntypedFormArray {
    return this.bizdata_ops_eliminate_fb.get("eliminateRows") as UntypedFormArray
  }

  roundRows(): UntypedFormArray {
    return this.bizdata_ops_round_fb.get("roundRows") as UntypedFormArray
  }

  calculaterRows(): UntypedFormArray {
    return this.bizdata_ops_calculater_fb.get("calculaterRows") as UntypedFormArray
  }


  dateanalyticsRows(): UntypedFormArray {
    return this.bizdata_ops_dateanalytics_fb.get("dateanalyticsRows") as UntypedFormArray
  }

  substituteRows(): UntypedFormArray {
    return this.bizdata_ops_substitute_fb.get("substituteRows") as UntypedFormArray
  }

  stripRows(): UntypedFormArray {
    return this.bizdata_ops_strip_fb.get("stripRows") as UntypedFormArray
  }

  substringRows(): UntypedFormArray {
    return this.bizdata_ops_substring_fb.get("substringRows") as UntypedFormArray
  }

  renameRows(): UntypedFormArray {
    return this.bizdata_ops_rename_fb.get("renameRows") as UntypedFormArray
  }

  sleepRows(): UntypedFormArray {
    return this.bizdata_ops_sleeptime_fb.get("sleepRows") as UntypedFormArray
  }

  pycodeRows(): UntypedFormArray {
    return this.bizdata_ops_pycode_fb.get("pycodeRows") as UntypedFormArray
  }

  filterRows(): UntypedFormArray {
    return this.bizdata_ops_filter_fb.get("filterRows") as UntypedFormArray
  }

  filterEndsRows(): UntypedFormArray {
    return this.bizdata_ops_filterends_fb.get("filterEndsRows") as UntypedFormArray
  }

  jdbcoutputRows(): UntypedFormArray {
    return this.bizdata_ops_jdbcoutput_fb.get("jdbcoutputRows") as UntypedFormArray
  }

  aiopsRows(): UntypedFormArray {
    return this.bizdata_ops_aiops_fb.get("aiopsRows") as UntypedFormArray
  }

  zipfileinbase64Rows(): UntypedFormArray {
    return this.bizdata_ops_zipfileinbase64_fb.get("zipfileinbase64Rows") as UntypedFormArray
  }

  dl2arrayRows(): UntypedFormArray {
    return this.bizdata_ops_dl2array_fb.get("dl2arrayRows") as UntypedFormArray
  }

  docunderstandingRows(): UntypedFormArray {
    return this.bizdata_ops_docunderstanding_fb.get("docunderstandingRows") as UntypedFormArray
  }

  imgunderstandingRows(): UntypedFormArray {
    return this.bizdata_ops_imgunderstanding_fb.get("imgunderstandingRows") as UntypedFormArray
  }

  dataTypesForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      boolean_operator: '',
      float_operator: '',
      integer_operator: '',
      datetime_operator: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewDataTypesForm(id, isMute) {
    this.datatypesRows().push(this.dataTypesForm(id, isMute));
  }

  appendForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      append: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewAppendForm(id, isMute) {
    this.appendRows().push(this.appendForm(id, isMute));
  }


  titlecaseForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      titlecase: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewTitlecaseForm(id, isMute) {
    this.titlecaseRows().push(this.titlecaseForm(id, isMute));
  }

  uppercaseForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      uppercase: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewUppercaseForm(id, isMute) {
    this.uppercaseRows().push(this.uppercaseForm(id, isMute));
  }

  lowercaseForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      lowercase: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewLowercaseForm(id, isMute) {
    this.lowercaseRows().push(this.lowercaseForm(id, isMute));
  }

  dataExtractorForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      data_extractor: '',
      data_extractor_keys: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewDataExtractorForm(id, isMute) {
    this.dataextractorRows().push(this.dataExtractorForm(id, isMute));
  }

  trimForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      trim_keys: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewTrimForm(id, isMute) {
    this.trimRows().push(this.trimForm(id, isMute));
  }

  base64decodingForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      base64_decode: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewBase64decodingForm(id, isMute) {
    this.base64decodingRows().push(this.base64decodingForm(id, isMute));
  }

  base64encodingForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      input_type: 'string',
      base64_encode: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewBase64encodingForm(id, isMute) {
    this.base64encodingRows().push(this.base64encodingForm(id, isMute));
  }

  isbase64encodeToggle(event, index) {
    let value = event.value;
    (<UntypedFormGroup>this.base64encodingRows().at(index)).controls['input_type'].setValue(value);
    // (<UntypedFormGroup>this.base64encodingRows().at(index)).controls['isCheckedAuto'].setValue(value);
  }
  jsontoxmlForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: '',
      response_key: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewJSONtoXMLForm(id, isMute) {
    this.jsontoxmlRows().push(this.jsontoxmlForm(id, isMute));
  }

  xmltojsonForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      get_key: '',
      response_key: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewXmltojsonForm(id, isMute) {
    this.xmltojsonRows().push(this.xmltojsonForm(id, isMute));
  }

  repeatfirstrowForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      source_key: '',
      fields_to_repeat_value: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewRepeatfirstrowForm(id, isMute) {
    this.repeatfirstrowRows().push(this.repeatfirstrowForm(id, isMute));
  }

  encodedecodeForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      response_key: '',
      method_type: '',
      process: 'encode',
      isMute: isMute,
      id: id,
    })
  }

  addNewEncodedecodeForm(id, isMute) {
    this.encodedecodeRows().push(this.encodedecodeForm(id, isMute));
  }

  generatesequenceForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      sequence_key: "",
      sequence_number_key: "",
      isMute: isMute,
      id: id,
    })
  }

  addNewGeneratesequenceForm(id, isMute) {
    this.generatesequenceRows().push(this.generatesequenceForm(id, isMute));
  }

  json2stringForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      json2string: "",
      isMute: isMute,
      id: id,
    })
  }

  addNewJson2stringForm(id, isMute) {
    this.json2stringRows().push(this.json2stringForm(id, isMute));
  }

  string2jsonForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      string2json: "",
      isMute: isMute,
      id: id,
    })
  }

  addNewString2jsonForm(id, isMute) {
    this.string2jsonRows().push(this.string2jsonForm(id, isMute));
  }

  toplevelForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      column_to_root: "",
      isMute: isMute,
      id: id,
    })
  }

  addNewToplevelForm(id, isMute) {
    this.toplevelRows().push(this.toplevelForm(id, isMute));
  }

  datetimestampForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      date_format: "",
      datetime_key: "",
      isMute: isMute,
      id: id,
    })
  }

  addNewDatetimestampForm(id, isMute) {
    this.datetimestampRows().push(this.datetimestampForm(id, isMute));
  }
  //--------------------------------------------
  json2dlForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: '',
      delimiter: '',
      fields: '',
      autodetect_column_names: true,
      skip_header: false,
      response_key: '',
      isCheckedAuto: true,
      isCheckedSkip: false,
      isMute: isMute,
      id: id,
    })
  }

  addNewJson2dlForm(id, isMute) {
    this.json2dlRows().push(this.json2dlForm(id, isMute));
  }

  isJson2DlAutoDetectColumnNameToggle(event: any, index) {
    let isAutoDetect = false;
    if (event.checked == true) {
      isAutoDetect = true;
    }
    this.json2dlRows().controls[index].patchValue({ autodetect_column_names: isAutoDetect });
  }

  isJson2DlSkipHeaderToggle(event: any, index) {
    let isSkipHeader = false;
    if (event.checked == true) {
      isSkipHeader = true;
    }
    this.json2dlRows().controls[index].patchValue({ skip_header: isSkipHeader });
  }

  dl2jsonForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      key_data: '',
      delimiter: '',
      fields: '',
      autodetect_column_names: true,
      skip_header: false,
      response_key: '',
      isCheckedAuto: true,
      isCheckedSkip: false,
      isMute: isMute,
      id: id,
    })
  }

  addNewDl2jsonForm(id, isMute) {
    this.dl2jsonRows().push(this.dl2jsonForm(id, isMute));
  }

  isDl2JsonAutoDetectColumnNameToggle(event: any, index) {
    let isAutoDetect = false;
    if (event.checked == true) {
      isAutoDetect = true;
    }
    this.dl2jsonRows().controls[index].patchValue({ autodetect_column_names: isAutoDetect });
  }

  isDl2JsonSkipHeaderToggle(event: any, index) {
    let isSkipHeader = false;
    if (event.checked == true) {
      isSkipHeader = true;
    }
    this.dl2jsonRows().controls[index].patchValue({ skip_header: isSkipHeader });
  }

  dataaggregationForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      agg_data_key: '',
      groupby_key: '',
      array_key: '',
      array_key_nested_columns: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewDataaggregationForm(id, isMute) {
    this.dataaggregationRows().push(this.dataaggregationForm(id, isMute));
  }

  pivotForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({

      get_key: '',
      transposed_key_name: '',
      transposed_value: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewPivotForm(id, isMute) {
    this.pivotRows().push(this.pivotForm(id, isMute));
  }

  unpivotForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      transpose_key_name: '',
      transpose_value: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewUnPivotForm(id, isMute) {
    this.unpivotRows().push(this.unpivotForm(id, isMute));
  }

  chopForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      chopkey: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewChopForm(id, isMute) {
    this.chopRows().push(this.chopForm(id, isMute));
  }

  singleline2tupleForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      singleline_key: '',
      table_headers: '',
      tuple_key: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewSingleline2tupleForm(id, isMute) {
    this.singleline2tupleRows().push(this.singleline2tupleForm(id, isMute));
  }

  tuple2singlelineForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      tuple_key: '',
      headers: '',
      singleline_key: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewTuple2singlelineForm(id, isMute) {
    this.tuple2singlelineRows().push(this.tuple2singlelineForm(id, isMute));
  }

  // fileForm(id): FormGroup {
  //   return this._formBuilder.group({
  //     target_location: '',
  //     extension: '',
  //     write_mode: '',
  //     id: id,
  //   })
  // }

  // addNewFileForm(id) {
  //   this.fileRows().push(this.fileForm(id));
  // }

  emailForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      From: "",
      password: "",
      mailserver: ["",[Validators.required, Validators.pattern(/^(?!\d+$).+/)]],
      port_number: '465',
      to: "",
      cc: "",
      bcc: "",
      subject: "",
      source_key: "",
      body: "",
      attachment: "",
      file_name: "",
      isMute: isMute,
      id: id,
    })
  }

  addNewEmailForm(id, isMute) {

    this.emailsOpsTo.push([]);
    this.emailsOpsCc.push([]);
    this.emailsOpsBcc.push([]);
    this.emailRows().push(this.emailForm(id, isMute));
  }

  isAttachmentToggle(event: any, index) {
    let isAttachment = 'no';
    if (event.checked == true) {
      isAttachment = 'yes'
    }
    this.emailRows().controls[index].patchValue({ attachment: isAttachment });
  }

  restapiForm(id, isMute): FormGroup {
    return this._formBuilder.group({
      'bridge_target': ['', Validators.required],
      'bridge_target_business_object': ['', Validators.required],
      'bridge_target_endpoint_method': ['', Validators.required],
      'bridge_target_endpoint_url': [''],
      'bridge_target_endpoint_params_raw': new UntypedFormArray([]),
      'bridge_target_endpoint_headers': new UntypedFormArray([]),
      'preview_postman_data': new UntypedFormArray([]),
      'bridge_target_endpoint_authentication_type': [''],
      'bridge_target_body_type': ['TEXT'],
      'bridge_target_endpoint_body_raw': [''],
      'bridge_target_response': [{},[]],
      'pre_request_script': [''],
      'is_new_target': [false],
      'bridgeTargetBusinessObjectRAO': [],
      'bridgeTargetCartIdRAO': [''],
      'drop_all_event_to_start_with': [''],
      "min_num": [''],
      "max_num": [''],
      "endpoint_url": [''],
      "endpoint_headers": [''],
      "endpoint_method": [''],
      "endpoint_body": [''],
      "endpoint_params": [''],
      "authentication_type": [''],
      "username": ['',Validators.required],
      "password": ['',Validators.required],
      "refresh_token_url": [''],
      "refresh_token_headers": [''],
      "refresh_token_method": [''],
      "refresh_token_body": [''],
      "refresh_token_params": [''],
      "response_parameters": [''],
      "another_response_parameter": [''],
      "key_name_to_update": [''],
      "user_key": [''],
      "pagination_style": [''],
      "timer_type": [''],
      "interval_in_seconds": [''],
      "schedule": [''],
      "time_zone": [''],
      "user_key_url": [''],
      "bizdata_dataset_status": [''],
      "selected_environment": ['No Environment'],
      "bridge_endpoint_selected_environments_name": ['', Validators.required],
      "bridge_endpoint_environments_raw": this._formBuilder.array([]),
      'response_type': ['text'],
      'isMute': isMute,
      "id": id,
    })
  }

  addNewRestapiForm(id, isMute) {
    this.addChild();
    this.restapiRows().push(this.restapiForm(id, isMute));
    //------- Retriving the index of a particular RAO Form -------//
    var index = -1;
    var filteredObj = this.restapiRows().controls.find(function (item, i) {
      if (item.value.id === id) {
        index = i;
        return i;
      }
    });
    //------- Load products with brand for target data REST API Opetation -------//
    this.getDataTarget().then(res => {
      let data: [] = res as [];
      this.bridgeTargetListRAO = data;
      this.bridgeTargetRAO$ = (<UntypedFormGroup>this.restapiRows().at(index)).get('bridge_target')!.valueChanges.pipe(
        startWith(''),
        map(value => {
          this.enableDataTargetRAOClearIcon = value ? true : false;
          return this._filterMapTarget(value || '')
        }),
      );
    }); // Load products with brand for target data REST API Opetation
    let bridge_endpoint_method = this.methodList.filter(function (entry) { return entry.id === 1 });
    this.restapiRows().at(index).patchValue({
      bridge_target_endpoint_method: bridge_endpoint_method[0]
    });
    this.addTargetParamsRAO(index);
    let bridge_endpoint_authentication_type = this.authenticationTargetTypeOptions.filter(function (entry) { return entry.id === 1 });
    this.restapiRows().at(index).patchValue({
      bridge_target_endpoint_authentication_type: bridge_endpoint_authentication_type[0]
    });

    const previewData = this.restapiRows().at(index).get('preview_postman_data') as FormArray;
    const items = [
      { name: 'Request Header', subItems: [] },
      { name: 'Request Params', subItems: [] },
      { name: 'Request Body', subItems: [] },
      { name: 'Pre Request Script', subItems: [] },
      { requestMethod: '', requestUrl: '' }
    ];
    // Loop through the data and push it into the FormArray
    items.forEach(item => {
      previewData.push(this._formBuilder.group(item));
    });
    this.addTargetHeadersRAO(index);
    this.endpoint_ops_url[index]='';
    this.params_ops_key[index]=[];
    this.params_ops_value[index]=[];
    this.headers_ops_key[index]=[];
    this.headers_ops_value[index]=[];
    this.ops_auth[index]=[];
    this.ops_authUser[index]=[];
    this.ops_authPassword[index]=[];
    this.onChangeSelectedOpsEnvironment(index,"");
  }

  makeOptions = () => {
    // this._bodyRestAPIEditor.codeMirror.refresh();
    let codeMirrorEditorOptions = {
      lineNumbers: true,
      lineWrapping: true,
      theme: "default",
      mode: { name: "text" }
    };
    // let options = new JsonEditorOptions();
    // options.mode = 'code'; //set only one mode
    // options.mainMenuBar = false;
    return codeMirrorEditorOptions;
  }


  makeResponseOptions = (responseType) => {
    // this._sourceResponseEditor.codeMirror.refresh();
    let codeMirrorEditorOptions: any;
    if (responseType == 'text') {
      codeMirrorEditorOptions = {
        lineNumbers: true,
        lineWrapping: true,
        theme: "default",
        mode: { name: "text" }
      };
    } else if (responseType == 'content') {
      codeMirrorEditorOptions = {
        lineNumbers: true,
        lineWrapping: true,
        theme: "default",
        mode: { name: "text" }
      };
    } else if (responseType == 'json') {
      codeMirrorEditorOptions = {
        lineNumbers: true,
        lineWrapping: true,
        theme: "default",
        mode: { name: "text" }
      };
    }
    return codeMirrorEditorOptions;
  }

  jsonForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      'drop_all_event_to_start_with': [''],
      "jdbc_driver": [''],
      "jdbc_string": [''],
      "jdbc_jar_file": [''],
      "username": [''],
      "password": [''],
      "unique_key": [''],
      "query": [''],
      "response_parameter": [''],
      "timer_type": [''],
      "schedule": [''],
      "time_zone": [''],
      "interval_in_seconds": [''],
      "multiline": [''],
      'isMute': isMute,
      id: id,
    })
  }

  addNewJsonForm(id, isMute) {
    this.jsonRows().push(this.jsonForm(id, isMute));
  }

  dropeventsstartswithForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      drop_all_event_to_start_with: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewDropeventsstartswithForm(id, isMute) {
    this.dropeventsstartswithRows().push(this.dropeventsstartswithForm(id, isMute));
  }


  dropalleventvaluesForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      drop_all_event_for_value: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewDropalleventvaluesForm(id, isMute) {
    this.dropalleventvaluesRows().push(this.dropalleventvaluesForm(id, isMute));
  }

  eliminateForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      eliminate: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewEliminateForm(id, isMute) {
    this.eliminateRows().push(this.eliminateForm(id, isMute));
  }

  roundForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      round_keys: '',
      decimal_key_number: '2',
      isMute: isMute,
      id: id,
    })
  }

  addNewRoundForm(id, isMute) {
    this.roundRows().push(this.roundForm(id, isMute));
  }

  calculaterForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      calculation_keys: '',
      new_calculation_keys: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewCalculaterForm(id, isMute) {
    this.calculaterRows().push(this.calculaterForm(id, isMute));
  }

  dateanalyticsForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      date_field_key: '',
      fiscal_month_start: '',
      date_column: '',
      weekday: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewDateanalyticsForm(id, isMute) {
    this.dateanalyticsRows().push(this.dateanalyticsForm(id, isMute));
  }

  substituteForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      substitute: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewSubstituteForm(id, isMute) {
    this.substituteRows().push(this.substituteForm(id, isMute));
  }

  stripForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      strip: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewStripForm(id, isMute) {
    this.stripRows().push(this.stripForm(id, isMute));
  }

  substringForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      substring: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewSubstringForm(id, isMute) {
    this.substringRows().push(this.substringForm(id, isMute));
  }

  renameForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      rename: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewRnameForm(id, isMute) {
    this.renameRows().push(this.renameForm(id, isMute));
  }

  dlIngestionForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "version": '',
      "dlake_host": "",
      "dlake_port": "",
      "dlusername": "",
      "dlpassword": "",
      "dl_ca_certs_path": "",
      "index_name": "",
      "action_type": "upsert",
      "primary_key": "",
      "refresh_type": "True",
      "request_timeout_sec": 200,
      "indexing_type": "parallel_bulk",
      "max_retries": 10,
      "chunk_size": 500,
      "thread_count": 4,
      "queue_size": 4,
      "isMute": isMute,
      id: id,
    })
  }

  addNewDLIngestionForm(id, isMute) {
    this.dlIngestionRows().push(this.dlIngestionForm(id, isMute));
    this.filteredDlIngestionOptions = this.dlIngestionRows().controls[this.dlIngestionRows().controls.length-1].get('index_name').valueChanges.pipe(
      startWith(''),
      map(value => this._IndexNamesOperationHeaderValue(value || '')),
    );
    var index = -1;
    var filteredObj = this.dlIngestionRows().controls.find(function (item, i) {
      if (item.value.id === id) {
        index = i;
        return i;
      }
    });
    if (this.verisonListDLO.length > 0) {
      this.dlIngestionRows().at(index).patchValue({
        version: this.verisonListDLO[0]
      });
    }
    let value = (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['version'].value.dlversion;
    this.getStorage().then((res) => {
      let payload = {
        "dlversion": this.verisonListDLO[0].dlversion,
        "op_name": this.verisonListDLO[0].op_name,
        "op_type": "ingestion"
      }
      this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
        (response) => {
          this.helperService.decryptpayload(response.data).then((records)=>{
          let data=JSON.parse(records);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlake_host'].setValue(data.dlhost_name);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlpassword'].setValue(data.dlpsw);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlake_port'].setValue(+(data.dlport));
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dlusername'].setValue(data.dlusername);
          (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['dl_ca_certs_path'].setValue(data.dl_ca_certs_path);
          });
        },
        (error) => {
          //console.log(error);
        }
      );
    })

  }

  dlsearchForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "version": '',
      "dlsearch_host": "",
      "dlsearch_port": "",
      "dlsearch_username": "",
      "dlsearch_password": "",
      "dlsearch_ca_certs_path": "",
      "dlsearch_index_name": "",
      "dlsearch_scroll": "2m",
      "dlsearch_timeout": 120,
      "dlsearch_batch_size": 1000,
      "dlsearch_body": '{"query": { "match_all": {} } }',
      "dlsearch_body_response" : "",
      "isMute": isMute,
      "id": id,
    })
  }

  addNewDlsearchForm(id, isMute) {
    this.dlsearchRows().push(this.dlsearchForm(id, isMute));
    this.filteredDlSearchOptions = this.dlsearchRows().controls[this.dlsearchRows().controls.length-1].get('dlsearch_index_name').valueChanges.pipe(
      startWith(''),
      map(value => this._IndexNamesOperationHeaderValue(value || '')),
    );
    var index = -1;
    var filteredObj = this.dlsearchRows().controls.find(function (item, i) {
      if (item.value.id === id) {
        index = i;
        return i;
      }
    });
    if (this.verisonListDLS.length > 0) {
      this.dlsearchRows().at(index).patchValue({
        version: this.verisonListDLS[0]
      });
    }
    let value = (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['version'].value.dlversion;
    this.getStorage().then((res) => {
      let payload = {
        "dlversion": this.verisonListDLS[0].dlversion,
        "op_name": this.verisonListDLS[0].op_name,
        "op_type": "search"
      }
      this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
        (response) => {
          this.helperService.decryptpayload(response.data).then((records)=>{
            let data=JSON.parse(records);
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_host'].setValue(data.dlhost_name);
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_password'].setValue(data.dlpsw);
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_port'].setValue(+(data.dlport));
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_username'].setValue(data.dlusername);
          (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['dlsearch_ca_certs_path'].setValue(data.dl_ca_certs_path);
          });
        },
        (error) => {
          //console.log(error);
        }
      );
    })
  }

  sleepForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      sleep_time: '',
      isMute: isMute,
      id: id,
    })
  }

  addNewSleepForm(id, isMute) {
    this.sleepRows().push(this.sleepForm(id, isMute));
  }

  pycodeForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      pycode: "",
      status: "",
      response: "",
      isMute: isMute,
      id: id,
    })
  }

  addNewAiOpsForm(id, isMute) {
    this.selectedOperation='ai'
    this.aiopsRows().push(this.aiopsForm(id, isMute));
    setTimeout(()=>{
    let textarea=document.getElementById('ai_ops_input') as HTMLTextAreaElement;
    textarea.placeholder="Convert country field into lowercase\nChange the date format of 'InvoiceDate' to dd-MM-yyyy format\nmake email field to base64 encode\n";
    }, 0)
    this.startTypewriterEffect()
  }

  aiopsForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      question: "",
      status: "",
      response: "",
      target_input_payload:"",
      target_data:"",
      dos:"",
      donts:"",
      isMute: isMute,
      id: id,
      isgenerated:false,
      isgenerating:false,
      selectedTemplate:"",
      selectedTemplateKey:"",
      messages:this._formBuilder.array([]),
      source:''
    })
  }

  addNewPycodeForm(id, isMute) {
    this.pycodeRows().push(this.pycodeForm(id, isMute));
  }

  filterForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      conditional_statement: [""],
      isMute: isMute,
      id: id,
    })
  }

  addNewFilterForm(id, isMute) {
    this.filterRows().push(this.filterForm(id, isMute));
  }

  filterEndsForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      isMute: isMute,
      id: id,
    })
  }

  addNewFilterEndsForm(id, isMute) {
    this.filterEndsRows().push(this.filterEndsForm(id, isMute));
  }

  jdbcoutputForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "storage_name": "",
      "db_version_list": [],
      "db_version": "",
      "tuple_key": "",
      "host_ip": "",
      "port_number": ["3306", [Validators.required,Validators.pattern('^[0-9]*$')]],
      "schema_name": "",
      "batch_size": '1000',
      "jdbc_driver": "",
      "jdbc_string": "",
      "jar_file": "",
      "username": "",
      "password": "",
      "query": "",
      "status": "",
      "response": {},
      "isMute": isMute,
      "id": id
    })
  }

  addNewJdbcoutputForm(id, isMute) {
    this.jdbcoutputRows().push(this.jdbcoutputForm(id, isMute));
    var index = -1;
    var filteredObj = this.jdbcoutputRows().controls.find(function (item, i) {
      if (item.value.id === id) {
        index = i;
        return i;
      }
    });
    (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['storage_name'].setValue(this.storageNameJDBCOList[0]);
    if (this.jdbcoutputRows().at(index).value.storage_name != undefined && this.jdbcoutputRows().at(index).value.storage_name != "") {
      this.getDlVersionJDBCO(this.jdbcoutputRows().at(index).value.storage_name, index)
    }
  }

  zipfileinbase64Form(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "source_key": "",
      "file_name_key": "",
      "file_extension_key": "",
      "file_data_key": "",
      "base64_response_key": "",
      "isMute": isMute,
      "id": id
    })
  }

  addNewZipfileinbase64Form(id, isMute) {
    this.zipfileinbase64Rows().push(this.zipfileinbase64Form(id, isMute));
  }

  arraycountForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "array_key_name": "",
      "isMute": isMute,
      "id": id
    })
  }

  addNewArraycountForm(id, isMute) {
    this.arraycountRows().push(this.arraycountForm(id, isMute));
  }

  pdfextractorForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "pdfLocationToggle": "file_url",
      "file_url": "",
      "base64_key": "",
      "isMute": isMute,
      "id": id
    })
  }
  fileextractorForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "file_data_key": "",
      "isMute": isMute,
      "id": id
    })
  }
  addNewPdfextractorForm(id, isMute) {
    this.pdfextractorRows().push(this.pdfextractorForm(id, isMute));
  }
  addNewFileextractorForm(id, isMute) {
    this.fileextractorRows().push(this.fileextractorForm(id, isMute));
  }
  addNewGrokPatternForm(id, isMute) {
    this.grokpatternRows().push(this.gorkpatterForm(id, isMute));
  }

  gorkpatterForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "input_key": "",
      "grok_pattern": "",
      "isMute": isMute,
      "id": id
    })
  }

  addNewRawSentenceGeneratorForm(id, isMute) {
    this.rawsentencegeneratorRows().push(this.rawsentencegeneratorForm(id, isMute));
  }

  rawsentencegeneratorForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "singleline_key": "",
      "include_keys": "",
      "raw_response_key": "",
      "isMute": isMute,
      "id": id
    })
  }

  addNewTimeUnitsForm(id, isMute) {
    this.timeunitsRows().push(this.timeunitsForm(id, isMute));
  }

  timeunitsForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "timestamp_key": "",
      "timestamp_column": "",
      "isMute": isMute,
      "id": id
    })
  }
  addNewDataChunkingForm(id, isMute) {
    this.datachunkingRows().push(this.datachunkingForm(id, isMute));
  }
  datachunkingForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "process_key": [''],
      "chunk_key": "",
      "token_size": 1000,
      "group_by_chunk": "",
      "isMute": isMute,
      "id": id
    })
  }
  addNewjson2avroForm(id, isMute) {
    this.jason2avroRows().push(this.jason2avroForm(id, isMute));
  }
  jason2avroForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "jsondata_key": '',
      "avro_schema": '',
      "response_key": '',
      "isMute": isMute,
      "id": id
    })
  }
  addNewavro2jsonForm(id, isMute) {
    this.avro2jsonRows().push(this.avro2jsonForm(id, isMute));
  }
  avro2jsonForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "avro_data": '',
      "json_data_key": '',
      "isMute": isMute,
      "id": id
    })
  }
  addNewExtract2ArrayForm(id, isMute) {
    this.extract2ArrayRows().push(this.extract2ArrayForm(id, isMute));
  }
  extract2ArrayForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "list_object_key": '',
      "extraction_key": [],
      "array_collection_key":[],
      "isMute": isMute,
      "id": id
    })
  }



  dl2arrayForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "dl_key": "",
      "delimiter": "",
      "isMute": isMute,
      "id": id
    })
  }

  addNewDl2arrayForm(id, isMute) {
    this.dl2arrayRows().push(this.dl2arrayForm(id, isMute));
  }


  docunderstandingForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "text_key": [''],
      "questions": new UntypedFormArray([]),
      "output_key": [''],
      "isMute": isMute,
      "id": id
    })
  }

  imgunderstandingForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "img_key": [''],
      "questions": new UntypedFormArray([]),
      "output_key": [''],
      "isMute": isMute,
      "id": id
    })
  }

  addNewImgunderstandingForm(id, isMute) {
    this.imgunderstandingRows().push(this.imgunderstandingForm(id, isMute));
    var index = -1;
    var filteredObj = this.imgunderstandingRows().controls.find(function (item, i) {
      if (item.value.id === id) {
        index = i;
        return i;
      }
    });
    this.addImgunderstandingQuestion(index);
  }

  addNewDocunderstandingForm(id, isMute) {
    this.docunderstandingRows().push(this.docunderstandingForm(id, isMute));
    var index = -1;
    var filteredObj = this.docunderstandingRows().controls.find(function (item, i) {
      if (item.value.id === id) {
        index = i;
        return i;
      }
    });
    this.addDocunderstandingQuestion(index);
  }

  htmlExtractorForm(id, isMute): UntypedFormGroup {
    return this._formBuilder.group({
      "input_html_key": "",
      "output_data_key": "",
      "isMute": isMute,
      "id": id
    })
  }

  addNewHtmlExtractorForm(id, isMute) {
    this.htmlExtractorRows().push(this.htmlExtractorForm(id, isMute));
  }

  validateMinNum(event) {
    let value = event.target.value;
    return ((event.key >= '0' && event.key <= '9') && (value <= 100) || ['ArrowLeft', 'ArrowRight', 'Backspace', ' '].includes(event.key));
  }

  validateMaxNum(event) {
    let value = event.target.value;
    return ((event.key >= '0' && event.key <= '9') || ['ArrowLeft', 'ArrowRight', 'Backspace', ' '].includes(event.key));
  }

  validateSleetTime(event) {
    let value = event.target.value;
    return ((event.key >= '0' && event.key <= '9') || ['ArrowLeft', 'ArrowRight', 'Backspace', ' '].includes(event.key));
  }

  validateDateAnalytics(event) {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const proposedValue = currentValue + event.key;

    // Allow control keys such as backspace, delete, arrows, etc.
    const controlKeys = ['ArrowLeft', 'ArrowRight', 'Backspace', 'Delete'];
    if (controlKeys.includes(event.key)) {
      return true;
    }

    // Allow only numbers and prevent invalid values
    if (/^\d+$/.test(event.key)) {
      const numberValue = Number(proposedValue);
      if (numberValue >= 1 && numberValue <= 12) {
        return true;
      }
    }

    // Prevent default action for any other keys
    event.preventDefault();
    return false;
  }

  opsSegregation(_opsname) {
    let dl = { title: "", icon: "", element_id: "" };
    switch (_opsname) {
      case 'bizdata_ops_jdbcoutput':
        dl['title'] = ops_name.bizdata_ops_jdbcoutput;
        dl['keys'] = ops_restapi.bizdata_ops_jdbcoutput;
        dl['icon'] = 'orchestration/database';
        dl['element_id'] = 'jdbcoutput';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_singletomultiline':
        dl['title'] = ops_name.bizdata_ops_singletomultiline;
        dl['keys'] = ops_restapi.bizdata_ops_singletomultiline;
        dl['icon'] = 'wrangling/Singleline to Multiline';
        dl['element_id'] = 'singletomultiline';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_eliminate':
        dl['title'] = ops_name.bizdata_ops_eliminate;
        dl['keys'] = ops_restapi.bizdata_ops_eliminate;
        dl['icon'] = 'cleaning/eliminate';
        dl['element_id'] = 'eliminate';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_rename':
        dl['title'] = ops_name.bizdata_ops_rename;
        dl['keys'] = ops_restapi.bizdata_ops_rename;
        dl['icon'] = 'cleaning/rename';
        dl['element_id'] = 'rename';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_append':
        dl['title'] = ops_name.bizdata_ops_append;
        dl['keys'] = ops_restapi.bizdata_ops_append;
        dl['icon'] = 'transformation/append';
        dl['element_id'] = 'append';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_uppercase':
        dl['title'] = ops_name.bizdata_ops_uppercase;
        dl['keys'] = ops_restapi.bizdata_ops_uppercase;
        dl['icon'] = 'transformation/upper_case';
        dl['element_id'] = 'uppercase';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_titlecase':
        dl['title'] = ops_name.bizdata_ops_titlecase;
        dl['keys'] = ops_restapi.bizdata_ops_titlecase;
        dl['icon'] = 'transformation/title_case';
        dl['element_id'] = 'titlecase';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_lowercase':
        dl['title'] = ops_name.bizdata_ops_lowercase;
        dl['keys'] = ops_restapi.bizdata_ops_lowercase;
        dl['icon'] = 'transformation/lower_case';
        dl['element_id'] = 'lowercase';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_dropeventsstartswith':
        dl['title'] = ops_name.bizdata_ops_dropeventsstartswith;
        dl['keys'] = ops_restapi.bizdata_ops_dropeventsstartswith;
        dl['icon'] = 'cleaning/drop_all_events_to_start_with';
        dl['element_id'] = 'dropeventsstartswith';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_dropalleventvalues':
        dl['title'] = ops_name.bizdata_ops_dropalleventvalues;
        dl['keys'] = ops_restapi.bizdata_ops_dropalleventvalues;
        dl['icon'] = 'cleaning/drop_all_events_for_value';
        dl['element_id'] = 'dropalleventvalues';
        return dl;
      // dl['id'] = this.helperService.generateRandomId(6);
      case 'bizdata_ops_round':
        dl['title'] = ops_name.bizdata_ops_round;
        dl['keys'] = ops_restapi.bizdata_ops_round;
        dl['icon'] = 'transformation/Round__1';
        dl['element_id'] = 'round';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_calculater':
        dl['title'] = ops_name.bizdata_ops_calculater;
        dl['keys'] = ops_restapi.bizdata_ops_calculater;
        dl['icon'] = 'transformation/Calculater__1';
        dl['element_id'] = 'calculater';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_dateanalytics':
        dl['title'] = ops_name.bizdata_ops_dateanalytics;
        dl['keys'] = ops_restapi.bizdata_ops_dateanalytics;
        dl['icon'] = 'transformation/Date_Analytics__1';
        dl['element_id'] = 'dateanalytics';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_substitute':
        dl['title'] = ops_name.bizdata_ops_substitute;
        dl['keys'] = ops_restapi.bizdata_ops_substitute;
        dl['icon'] = 'cleaning/substitute';
        dl['element_id'] = 'substitute';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_strip':
        dl['title'] = ops_name.bizdata_ops_strip;
        dl['keys'] = ops_restapi.bizdata_ops_strip;
        dl['icon'] = 'cleaning/strip__1';
        dl['element_id'] = 'strip';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_substring':
        dl['title'] = ops_name.bizdata_ops_substring;
        dl['keys'] = ops_restapi.bizdata_ops_substring;
        dl['icon'] = 'cleaning/substring__1';
        dl['element_id'] = 'substring';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_generatesequence':
        dl['title'] = ops_name.bizdata_ops_generatesequence;
        dl['keys'] = ops_restapi.bizdata_ops_generatesequence;
        dl['icon'] = 'transformation/Generate Array Sequence Number';
        dl['element_id'] = 'generatesequence';
        return dl;
      case 'bizdata_ops_repeatfirstrow':
        dl['title'] = ops_name.bizdata_ops_repeatfirstrow
        dl['keys'] = ops_restapi.bizdata_ops_repeatfirstrow;
        dl['icon'] = 'transformation/Repeat First Row Values';
        dl['element_id'] = 'repeatfirstrow';
        return dl;
      case 'bizdata_ops_json2string':
        dl['title'] = ops_name.bizdata_ops_json2string;
        dl['keys'] = ops_restapi.bizdata_ops_json2string;
        dl['icon'] = 'transformation/json_to_string';
        dl['element_id'] = 'json2string';
        return dl;
      case 'bizdata_ops_string2json':
        dl['title'] = ops_name.bizdata_ops_string2json;
        dl['keys'] = ops_restapi.bizdata_ops_string2json;
        dl['icon'] = 'transformation/String to JSON';
        dl['element_id'] = 'string2json';
        return dl;
      case 'bizdata_ops_toplevel':
        dl['title'] = ops_name.bizdata_ops_toplevel;
        dl['keys'] = ops_restapi.bizdata_ops_toplevel;
        dl['icon'] = 'transformation/send_keys_top_of_root';
        dl['element_id'] = 'toplevel';
        return dl;
      case 'bizdata_ops_datetimestamp':
        dl['title'] = ops_name.bizdata_ops_datetimestamp;
        dl['keys'] = ops_restapi.bizdata_ops_datetimestamp;
        dl['icon'] = 'transformation/Today timestamp';
        dl['element_id'] = 'datetimestamp';
        return dl;
      case 'bizdata_ops_dataaggregation':
        dl['title'] = ops_name.bizdata_ops_dataaggregation;
        dl['keys'] = ops_restapi.bizdata_ops_dataaggregation;
        dl['icon'] = 'wrangling/data_aggregation';
        dl['element_id'] = 'dataaggregation';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_datetimestamp':
        return [];
      case 'bizdata_ops_datatypes':
        dl['title'] = ops_name.bizdata_ops_datatypes;
        dl['keys'] = ops_restapi.bizdata_ops_datatypes;
        dl['icon'] = 'transformation/data_type';
        dl['element_id'] = 'datatypes';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_pivot':
        dl['title'] = ops_name.bizdata_ops_pivot;
        dl['keys'] = ops_restapi.bizdata_ops_pivot;
        dl['icon'] = 'wrangling/Pivot';
        dl['element_id'] = 'pivot';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_unpivot':
        dl['title'] = ops_name.bizdata_ops_unpivot;
        dl['keys'] = ops_restapi.bizdata_ops_unpivot;
        dl['icon'] = 'wrangling/unPivot';
        dl['element_id'] = 'unpivot';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_singleline2tuple':
        dl['title'] = ops_name.bizdata_ops_singleline2tuple;
        dl['keys'] = ops_restapi.bizdata_ops_singleline2tuple;
        dl['icon'] = 'wrangling/Single line to Tuple';
        dl['element_id'] = 'singleline2tuple';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_tuple2singleline':
        dl['title'] = ops_name.bizdata_ops_tuple2singleline;
        dl['keys'] = ops_restapi.bizdata_ops_tuple2singleline;
        dl['icon'] = 'wrangling/Tuple to Single line';
        dl['element_id'] = 'tuple2singleline';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_postgres':
        return [];
      case 'bizdata_ops_replacinganyvalue':
        return [];
      case 'bizdata_ops_trim':
        dl['title'] = ops_name.bizdata_ops_trim;
        dl['keys'] = ops_restapi.bizdata_ops_trim;
        dl['icon'] = 'transformation/trim';
        dl['element_id'] = 'trim';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_base64decoding':
        dl['title'] = ops_name.bizdata_ops_base64decoding;
        dl['keys'] = ops_restapi.bizdata_ops_base64decoding;
        dl['icon'] = 'transformation/base64_decoding';
        dl['element_id'] = 'base64decoding';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_base64encoding':
        dl['title'] = ops_name.bizdata_ops_base64encoding;
        dl['keys'] = ops_restapi.bizdata_ops_base64encoding;
        dl['icon'] = 'transformation/base64_encoding';
        dl['element_id'] = 'base64encoding';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_bodmascal':
        return [];
      case 'bizdata_ops_json2dl':
        dl['title'] = ops_name.bizdata_ops_json2dl;
        dl['keys'] = ops_restapi.bizdata_ops_json2dl;
        dl['icon'] = 'wrangling/json_to_delimiter';
        dl['element_id'] = 'json2dl';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_dl2json':
        dl['title'] = ops_name.bizdata_ops_dl2json;
        dl['keys'] = ops_restapi.bizdata_ops_dl2json;
        dl['icon'] = 'wrangling/delimite_to_json';
        dl['element_id'] = 'dl2json';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_jsontoxml':
        dl['title'] = ops_name.bizdata_ops_jsontoxml;
        dl['keys'] = ops_restapi.bizdata_ops_jsontoxml;
        dl['icon'] = 'transformation/JSON to XML';
        dl['element_id'] = 'jsontoxml';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_xmltojson':
        dl['title'] = ops_name.bizdata_ops_xmltojson;
        dl['keys'] = ops_restapi.bizdata_ops_xmltojson;
        dl['icon'] = 'transformation/xml_to_json';
        dl['element_id'] = 'xmltojson';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_restapitarget':
        dl['title'] = ops_name.bizdata_ops_restapitarget;
        dl['keys'] = ops_restapi.bizdata_ops_restapitarget;
        dl['icon'] = 'orchestration/rest_api';
        dl['element_id'] = 'restapitarget';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_dlakeingestion':
        dl['title'] = ops_name.bizdata_ops_dlakeingestion;
        dl['keys'] = ops_restapi.bizdata_ops_dlakeingestion;
        dl['icon'] = 'orchestration/Bizintel360_DL_Ingestion_06';
        dl['element_id'] = 'dlakeingestion';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_dlsearch':
        dl['title'] = ops_name.bizdata_ops_dlsearch;
        dl['keys'] = ops_restapi.bizdata_ops_dlsearch;
        dl['icon'] = 'orchestration/Bizintel360_DL_Search_Lookups';
        dl['element_id'] = 'dlsearch';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_email':
        dl['title'] = ops_name.bizdata_ops_email;
        dl['keys'] = ops_restapi.bizdata_ops_email;
        dl['icon'] = 'orchestration/email';
        dl['element_id'] = 'email';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_analytics':
        return [];
      case 'bizdata_ops_dataextractor':
        dl['title'] = ops_name.bizdata_ops_dataextractor;
        dl['keys'] = ops_restapi.bizdata_ops_dataextractor;
        dl['icon'] = 'transformation/data_extractor';
        dl['element_id'] = 'dataextractor';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      // case 'bizdata_ops_file':
      //   dl['title'] = ops_name.bizdata_ops_file;
      //   dl['keys'] = ops_restapi.bizdata_ops_file;
      //   dl['icon'] = 'orchestration/file';
      //   // dl['id'] = this.helperService.generateRandomId(6);
      //   return dl;
      case 'bizdata_ops_sleeptime':
        dl['title'] = ops_name.bizdata_ops_sleeptime;
        dl['keys'] = ops_restapi.bizdata_ops_sleeptime;
        dl['icon'] = 'pipeline_control/sleep_time';
        dl['element_id'] = 'sleep';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_pycode':
        dl['title'] = ops_name.bizdata_ops_pycode;
        dl['keys'] = ops_restapi.bizdata_ops_pycode;
        dl['icon'] = 'pipeline_control/python_operation';
        dl['element_id'] = 'pycode';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_filter':
        dl['title'] = ops_name.bizdata_ops_filter;
        dl['keys'] = ops_restapi.bizdata_ops_filter;
        dl['icon'] = 'pipeline_control/filter_operation';
        dl['element_id'] = 'filter';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_encodedecode':
        dl['title'] = ops_name.bizdata_ops_encodedecode;
        dl['keys'] = ops_restapi.bizdata_ops_encodedecode;
        dl['icon'] = 'transformation/Encode_Decode';
        dl['element_id'] = 'encodedecode';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_zipfileinbase64':
        dl['title'] = ops_name.bizdata_ops_zipfileinbase64;
        dl['keys'] = ops_restapi.bizdata_ops_zipfileinbase64;
        dl['icon'] = 'transformation/Zip';
        dl['element_id'] = 'zipfileinbase64';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_arraycount':
        dl['title'] = ops_name.bizdata_ops_arraycount;
        dl['keys'] = ops_restapi.bizdata_ops_arraycount;
        dl['icon'] = 'transformation/Array_Count';
        dl['element_id'] = 'arraycount';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_dl2array':
        dl['title'] = ops_name.bizdata_ops_dl2array;
        dl['keys'] = ops_restapi.bizdata_ops_dl2array;
        dl['icon'] = 'wrangling/Delimiter_to_Array';
        dl['element_id'] = 'dl2array';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_pdfextractor':
        dl['title'] = ops_name.bizdata_ops_pdfextractor;
        dl['keys'] = ops_restapi.bizdata_ops_pdfextractor;
        dl['icon'] = 'transformation/PDF_Extractor_02';
        dl['element_id'] = 'pdfextractor';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_fileextractor':
        dl['title'] = ops_name.bizdata_ops_fileextractor;
        dl['keys'] = ops_restapi.bizdata_ops_fileextractor;
        dl['icon'] = 'transformation/html_extractor11-01';
        dl['element_id'] = 'fileextractor';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_docunderstanding':
        dl['title'] = ops_name.bizdata_ops_docunderstanding;
        dl['keys'] = ops_restapi.bizdata_ops_docunderstanding;
        dl['icon'] = 'deep_learning/document_understanding';
        dl['element_id'] = 'docunderstanding';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_grokpattern':
        dl['title'] = ops_name.bizdata_ops_grokpattern;
        dl['keys'] = ops_restapi.bizdata_ops_grokpattern;
        dl['icon'] = 'transformation/Grok_Pattern';
        dl['element_id'] = 'grokpattern';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_imgunderstanding':
        dl['title'] = ops_name.bizdata_ops_imgunderstanding;
        dl['keys'] = ops_restapi.bizdata_ops_imgunderstanding;
        dl['icon'] = 'deep_learning/Image_understanding';
        dl['element_id'] = 'imgunderstanding';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_filterends':
        dl['title'] = ops_name.bizdata_ops_filterends;
        dl['keys'] = ops_restapi.bizdata_ops_filterends;
        dl['icon'] = 'pipeline_control/Filter_Ends';
        dl['element_id'] = 'filterends';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_rawsentencegenerator':
        dl['title'] = ops_name.bizdata_ops_rawsentencegenerator;
        dl['keys'] = ops_restapi.bizdata_ops_rawsentencegenerator;
        dl['icon'] = 'transformation/Raw_Sentence_Generator_02';
        dl['element_id'] = 'rawsentencegenerator';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_timeunits':
        dl['title'] = ops_name.bizdata_ops_timeunits;
        dl['keys'] = ops_restapi.bizdata_ops_timeunits;
        dl['icon'] = 'transformation/Time_Units';
        dl['element_id'] = 'timeunits';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_datachunking':
        dl['title'] = ops_name.bizdata_ops_datachunking;
        dl['keys'] = ops_restapi.bizdata_ops_datachunking;
        dl['icon'] = 'transformation/data_chunking';
        dl['element_id'] = 'datachunking';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_json2avro':
        dl['title'] = ops_name.bizdata_ops_json2avro;
        dl['keys'] = ops_restapi.bizdata_ops_json2avro;
        dl['icon'] = 'transformation/JSON to Avro';
        dl['element_id'] = 'json2avro';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      case 'bizdata_ops_htmlextractor':
        dl['title'] = ops_name.bizdata_ops_htmlextractor;
        dl['keys'] = ops_restapi.bizdata_ops_htmlextractor;
        dl['icon'] = 'transformation/html_extractor';
        dl['element_id'] = 'htmlextractor';
        return dl;
      case 'bizdata_ops_avro2json':
        dl['title'] = ops_name.bizdata_ops_avrojson;
        dl['keys'] = ops_restapi.bizdata_ops_avro2json;
        dl['icon'] = 'transformation/AVRO to JSON';
        dl['element_id'] = 'avro2json';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
        case 'bizdata_ops_extract2array':
      dl['title'] = ops_name.bizdata_ops_extract2array;
      dl['keys'] = ops_restapi.bizdata_ops_extract2array;
      dl['icon'] = 'transformation/Extract to Array';
      dl['element_id'] = 'extract2Array';
      // dl['id'] = this.helperService.generateRandomId(6);
      return dl;
      case 'bizdata_ops_aiops':
        dl['title'] = ops_name.bizdata_ops_aiops;
        dl['keys'] = ops_restapi.bizdata_ops_aiops;
        dl['icon'] = 'cleaning/aioperation';
        dl['element_id'] = 'aiops';
        // dl['id'] = this.helperService.generateRandomId(6);
        return dl;
      default:
        return [];
    }
  }

  // opsSegregation(_opsname) {
  //   let dl = { title: "", icon: "" };
  //   switch (_opsname) {
  //     case 'bizdata_ops_jdbcoutput':
  //       dl['title'] = ops_name.bizdata_ops_jdbcoutput;
  //       dl['keys'] = ops_restapi.bizdata_ops_jdbcoutput;
  //       dl['icon'] = 'orchestration/database';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_singletomultiline':
  //       dl['title'] = ops_name.bizdata_ops_singletomultiline;
  //       dl['keys'] = ops_restapi.bizdata_ops_singletomultiline;
  //       dl['icon'] = 'wrangling/Singleline to Multiline';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_eliminate':
  //       dl['title'] = ops_name.bizdata_ops_eliminate;
  //       dl['keys'] = ops_restapi.bizdata_ops_eliminate;
  //       dl['icon'] = 'cleaning/eliminate';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_rename':
  //       dl['title'] = ops_name.bizdata_ops_rename;
  //       dl['keys'] = ops_restapi.bizdata_ops_rename;
  //       dl['icon'] = 'cleaning/rename';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_append':
  //       dl['title'] = ops_name.bizdata_ops_append;
  //       dl['keys'] = ops_restapi.bizdata_ops_append;
  //       dl['icon'] = 'transformation/append';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_uppercase':
  //       dl['title'] = ops_name.bizdata_ops_uppercase;
  //       dl['keys'] = ops_restapi.bizdata_ops_uppercase;
  //       dl['icon'] = 'transformation/upper_case';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_titlecase':
  //       dl['title'] = ops_name.bizdata_ops_titlecase;
  //       dl['keys'] = ops_restapi.bizdata_ops_titlecase;
  //       dl['icon'] = 'transformation/title_case';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_lowercase':
  //       dl['title'] = ops_name.bizdata_ops_lowercase;
  //       dl['keys'] = ops_restapi.bizdata_ops_lowercase;
  //       dl['icon'] = 'transformation/lower_case';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_dropeventsstartswith':
  //       dl['title'] = ops_name.bizdata_ops_dropeventsstartswith;
  //       dl['keys'] = ops_restapi.bizdata_ops_dropeventsstartswith;
  //       dl['icon'] = 'cleaning/drop_all_events_to_start_with';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_dropalleventvalues':
  //       dl['title'] = ops_name.bizdata_ops_dropalleventvalues;
  //       dl['keys'] = ops_restapi.bizdata_ops_dropalleventvalues;
  //       dl['icon'] = 'cleaning/drop_all_events_for_value';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_round':
  //       dl['title'] = ops_name.bizdata_ops_round;
  //       dl['keys'] = ops_restapi.bizdata_ops_round;
  //       dl['icon'] = 'transformation/Round__1';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_calculater':
  //       dl['title'] = ops_name.bizdata_ops_calculater;
  //       dl['keys'] = ops_restapi.bizdata_ops_calculater;
  //       dl['icon'] = 'transformation/Calculater__1';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_dateanalytics':
  //       dl['title'] = ops_name.bizdata_ops_dateanalytics;
  //       dl['keys'] = ops_restapi.bizdata_ops_dateanalytics;
  //       dl['icon'] = 'transformation/Date_Analytics__1';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_substitute':
  //       dl['title'] = ops_name.bizdata_ops_substitute;
  //       dl['keys'] = ops_restapi.bizdata_ops_substitute;
  //       dl['icon'] = 'cleaning/substitute';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_strip':
  //       dl['title'] = ops_name.bizdata_ops_strip;
  //       dl['keys'] = ops_restapi.bizdata_ops_strip;
  //       dl['icon'] = 'cleaning/strip__1';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_substring':
  //       dl['title'] = ops_name.bizdata_ops_substring;
  //       dl['keys'] = ops_restapi.bizdata_ops_substring;
  //       dl['icon'] = 'cleaning/substring__1';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_generatesequence':
  //       dl['title'] = ops_name.bizdata_ops_generatesequence;
  //       dl['keys'] = ops_restapi.bizdata_ops_generatesequence;
  //       dl['icon'] = 'transformation/Generate Array Sequence Number';
  //       return dl;
  //     case 'bizdata_ops_repeatfirstrow':
  //       dl['title'] = ops_name.bizdata_ops_repeatfirstrow
  //       dl['keys'] = ops_restapi.bizdata_ops_repeatfirstrow;
  //       dl['icon'] = 'transformation/Repeat First Row Values';
  //       return dl;
  //     case 'bizdata_ops_json2string':
  //       dl['title'] = ops_name.bizdata_ops_json2string;
  //       dl['keys'] = ops_restapi.bizdata_ops_json2string;
  //       dl['icon'] = 'transformation/json_to_string';
  //       return dl;
  //     case 'bizdata_ops_string2json':
  //       dl['title'] = ops_name.bizdata_ops_string2json;
  //       dl['keys'] = ops_restapi.bizdata_ops_string2json;
  //       dl['icon'] = 'transformation/String to JSON';
  //       return dl;
  //     case 'bizdata_ops_toplevel':
  //       dl['title'] = ops_name.bizdata_ops_toplevel;
  //       dl['keys'] = ops_restapi.bizdata_ops_toplevel;
  //       dl['icon'] = 'transformation/send_keys_top_of_root';
  //       return dl;
  //     case 'bizdata_ops_datetimestamp':
  //       dl['title'] = ops_name.bizdata_ops_datetimestamp;
  //       dl['keys'] = ops_restapi.bizdata_ops_datetimestamp;
  //       dl['icon'] = 'transformation/Today timestamp';
  //       return dl;
  //     case 'bizdata_ops_dataaggregation':
  //       dl['title'] = ops_name.bizdata_ops_dataaggregation;
  //       dl['keys'] = ops_restapi.bizdata_ops_dataaggregation;
  //       dl['icon'] = 'wrangling/data_aggregation';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_datatypes':
  //       dl['title'] = ops_name.bizdata_ops_datatypes;
  //       dl['keys'] = ops_restapi.bizdata_ops_datatypes;
  //       dl['icon'] = 'transformation/data_type';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_pivot':
  //       dl['title'] = ops_name.bizdata_ops_pivot;
  //       dl['keys'] = ops_restapi.bizdata_ops_pivot;
  //       dl['icon'] = 'wrangling/Pivot';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_unpivot':
  //       dl['title'] = ops_name.bizdata_ops_unpivot;
  //       dl['keys'] = ops_restapi.bizdata_ops_unpivot;
  //       dl['icon'] = 'wrangling/unPivot';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_singleline2tuple':
  //       dl['title'] = ops_name.bizdata_ops_singleline2tuple;
  //       dl['keys'] = ops_restapi.bizdata_ops_singleline2tuple;
  //       dl['icon'] = 'wrangling/Single line to Tuple';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_tuple2singleline':
  //       dl['title'] = ops_name.bizdata_ops_tuple2singleline;
  //       dl['keys'] = ops_restapi.bizdata_ops_tuple2singleline;
  //       dl['icon'] = 'wrangling/Tuple to Single line';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_postgres':
  //       return [];
  //     case 'bizdata_ops_replacinganyvalue':
  //       return [];
  //     case 'bizdata_ops_trim':
  //       dl['title'] = ops_name.bizdata_ops_trim;
  //       dl['keys'] = ops_restapi.bizdata_ops_trim;
  //       dl['icon'] = 'transformation/trim';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_base64decoding':
  //       dl['title'] = ops_name.bizdata_ops_base64decoding;
  //       dl['keys'] = ops_restapi.bizdata_ops_base64decoding;
  //       dl['icon'] = 'transformation/base64_decoding';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_base64encoding':
  //       dl['title'] = ops_name.bizdata_ops_base64encoding;
  //       dl['keys'] = ops_restapi.bizdata_ops_base64encoding;
  //       dl['icon'] = 'transformation/base64_encoding';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_bodmascal':
  //       return [];
  //     case 'bizdata_ops_json2dl':
  //       dl['title'] = ops_name.bizdata_ops_json2dl;
  //       dl['keys'] = ops_restapi.bizdata_ops_json2dl;
  //       dl['icon'] = 'wrangling/json_to_delimiter';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_dl2json':
  //       dl['title'] = ops_name.bizdata_ops_dl2json;
  //       dl['keys'] = ops_restapi.bizdata_ops_dl2json;
  //       dl['icon'] = 'wrangling/delimite_to_json';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_jsontoxml':
  //       dl['title'] = ops_name.bizdata_ops_jsontoxml;
  //       dl['keys'] = ops_restapi.bizdata_ops_jsontoxml;
  //       dl['icon'] = 'transformation/JSON to XML';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_xmltojson':
  //       dl['title'] = ops_name.bizdata_ops_xmltojson;
  //       dl['keys'] = ops_restapi.bizdata_ops_xmltojson;
  //       dl['icon'] = 'transformation/xml_to_json';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_restapitarget':
  //       dl['title'] = ops_name.bizdata_ops_restapitarget;
  //       dl['keys'] = ops_restapi.bizdata_ops_restapitarget;
  //       dl['icon'] = 'orchestration/rest_api';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_dlakeingestion':
  //       dl['title'] = ops_name.bizdata_ops_dlakeingestion;
  //       dl['keys'] = ops_restapi.bizdata_ops_dlakeingestion;
  //       dl['icon'] = 'orchestration/Bizintel360_DL_Ingestion_06';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_dlsearch':
  //       dl['title'] = ops_name.bizdata_ops_dlsearch;
  //       dl['keys'] = ops_restapi.bizdata_ops_dlsearch;
  //       dl['icon'] = 'orchestration/Bizintel360_DL_Search_Lookups';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_email':
  //       dl['title'] = ops_name.bizdata_ops_email;
  //       dl['keys'] = ops_restapi.bizdata_ops_email;
  //       dl['icon'] = 'orchestration/email';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_analytics':
  //       return [];
  //     case 'bizdata_ops_dataextractor':
  //       dl['title'] = ops_name.bizdata_ops_dataextractor;
  //       dl['keys'] = ops_restapi.bizdata_ops_dataextractor;
  //       dl['icon'] = 'transformation/data_extractor';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     // case 'bizdata_ops_file':
  //     //   dl['title'] = ops_name.bizdata_ops_file;
  //     //   dl['keys'] = ops_restapi.bizdata_ops_file;
  //     //   dl['icon'] = 'orchestration/file';
  //     //   // dl['id'] = this.helperService.generateRandomId(6);
  //     //   return dl;
  //     case 'bizdata_ops_sleeptime':
  //       dl['title'] = ops_name.bizdata_ops_sleeptime;
  //       dl['keys'] = ops_restapi.bizdata_ops_sleeptime;
  //       dl['icon'] = 'pipeline_control/sleep_time';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_pycode':
  //       dl['title'] = ops_name.bizdata_ops_pycode;
  //       dl['keys'] = ops_restapi.bizdata_ops_pycode;
  //       dl['icon'] = 'pipeline_control/python_operation';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_filter':
  //       dl['title'] = ops_name.bizdata_ops_filter;
  //       dl['keys'] = ops_restapi.bizdata_ops_filter;
  //       dl['icon'] = 'pipeline_control/filter_operation';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     case 'bizdata_ops_encodedecode':
  //       dl['title'] = ops_name.bizdata_ops_encodedecode;
  //       dl['keys'] = ops_restapi.bizdata_ops_encodedecode;
  //       dl['icon'] = 'transformation/Encode_Decode';
  //       // dl['id'] = this.helperService.generateRandomId(6);
  //       return dl;
  //     default:
  //       return [];
  //   }
  // }

  async openForm(item, id, ops?) {

    this.indexSelectionEmail = 0;
    for (let item of this.finalBlocks) {
      if (id == item.id) {
        item.isValid = true;
        break;
      }
    }
    // //console.log(item, id);
    this.selectedOperationId = id;
    // this.hideAllOpsForms();
    this.isDataTypeFromEnabled = false;
    this.isBase64decodingFromEnabled = false;
    this.isBase64encodingFromEnabled = false;
    this.isData_extractorFromEnabled = false;
    this.isTitlecaseFromEnabled = false;
    this.isUppercaseFromEnabled = false;
    this.isLowercaseFromEnabled = false;
    this.isTrimFromEnabled = false;
    this.isAppendFromEnabled = false;
    this.isJSON_to_XMLFromEnabled = false;
    this.isXML_to_JSONFromEnabled = false;
    this.isGeneratesequenceFromEnabled = false;
    this.isJson2stringFromEnabled = false;
    this.isString2jsonFromEnabled = false;
    this.isToplevelFromEnabled = false;
    this.isDatetimestampFromEnabled = false;
    this.isRepeatfirstrowFromEnabled = false;
    this.isArraycountFromEnabled = false;
    this.isPdfextractorFormEnabled = false;
    this.isGorkPatternFormEnabled = false;
    this.isRawSentenceGeneratorFormEnabled = false;
    this.isTimeUnitsFormEnabled = false;
    this.isDataChunkingFormEnabled = false;
    this.isJson2avroFormEnabled = false;
    this.isHTMLExtractorFormEnabled = false;
    this.isAvro2jsonFormEnabled = false;
    this.isExtract2ArrayFormEnabled = false;

    this.isJSON2dlFromEnabled = false;
    this.isDl2jsonFromEnabled = false;
    this.isPivotFromEnabled = false;
    this.isUnPivotFromEnabled = false;
    this.isDataaggregationFromEnabled = false;
    this.chopFormEnabled = false;
    this.singleline2tupleFormEnabled = false;
    this.tuple2singlelineFormEnabled = false;
    this.isDl2arrayFormEnabled = false;

    this.isemailFromEnabled = false
    // this.isfileFromEnabled = false
    this.isdropeventsstartswithFromEnabled = false;
    this.isdropalleventvaluesFromEnabled = false;
    this.iseliminateFromEnabled = false;
    this.isroundFromEnabled = false;
    this.iscalculaterFromEnabled = false;
    this.isdateanalyticsFromEnabled = false;
    this.issubstituteFromEnabled = false;
    this.isstripFromEnabled = false;
    this.issubstringFromEnabled = false;
    this.isrenameFromEnabled = false;
    this.ispycodeFromEnabled = false;
    this.isaiopsFromEnabled = false;

    this.isjsonFormEnabled = false;
    this.isDLIngestionFormEnabled = false
    this.isDLIngestionFormEnabled = false;
    this.isrestapiFormEnabled = false;
    this.issleepFromEnabled = false;

    this.isGeneratesequenceFromEnabled = false;
    this.isDatetimestampFromEnabled = false
    this.isPostgresFromEnabled = false
    this.isReplacingvalueFromEnabled = false
    this.isAnalyticsFromEnabled = false
    this.isDataextractorEnabled = false
    this.isjdbcoutputFromEnabled = false;
    this.isfilterFromEnabled = false;
    this.isEncodedecodeFromEnabled = false;
    this.isZipfileinbase64FromEnabled = false;
    this.isDocunderstandingFromEnabled = false;
    this.isImgunderstandingFromEnabled = false;
    this.isfilterEndsFromEnabled = false;

    if (item == 'Data types') {
      this.isDataTypeFromEnabled = true;
    } else if (item == 'Append') {
      this.isAppendFromEnabled = true;
    } else if (item == 'Titlecase') {
      this.isTitlecaseFromEnabled = true;
    } else if (item == 'Uppercase') {
      this.isUppercaseFromEnabled = true;
    } else if (item == 'Lowercase') {
      this.isLowercaseFromEnabled = true;
    } else if (item == 'Data extractor') {
      this.isData_extractorFromEnabled = true;
    } else if (item == 'Trim') {
      this.isTrimFromEnabled = true;
    } else if (item == 'Base64 encoding') {
      this.isBase64encodingFromEnabled = true;
    } else if (item == 'Base64 decoding') {
      this.isBase64decodingFromEnabled = true;
    } else if (item == 'JSON to XML') {
      this.isJSON_to_XMLFromEnabled = true;
    } else if (item == 'XML to JSON') {
      this.isXML_to_JSONFromEnabled = true;
    } else if (item == 'Repeat First Row Values') {
      this.isRepeatfirstrowFromEnabled = true;
    } else if (item == 'JSON to delimiter') {
      this.isJSON2dlFromEnabled = true
    } else if (item == 'Delimiter to JSON') {
      this.isDl2jsonFromEnabled = true
    } else if (item == 'JSON to String') {
      this.isJson2stringFromEnabled = true;
    } else if (item == 'String to JSON') {
      this.isString2jsonFromEnabled = true;
    } else if (item == 'Generate Array Sequence Number') {
      this.isGeneratesequenceFromEnabled = true;
    } else if (item == 'Send Keys Top of Root') {
      this.isToplevelFromEnabled = true;
    } else if (item == 'Today Timestamp') {
      this.isDatetimestampFromEnabled = true;
    } else if (item == 'Data aggregation') {
      this.isDataaggregationFromEnabled = true
    } else if (item == 'Pivot') {
      this.isPivotFromEnabled = true
    } else if (item == 'Unpivot') {
      this.isUnPivotFromEnabled = true
    } else if (item == 'Single Line to Multiline') {
      this.chopFormEnabled = true
    } else if (item == 'Single Line to Tuple') {
      this.singleline2tupleFormEnabled = true
    } else if (item == 'Tuple to Single Line') {
      this.tuple2singlelineFormEnabled = true
    } else if (item == 'Rename') {
      this.isrenameFromEnabled = true
    } else if (item == 'Drop all events to start with') {
      this.isdropeventsstartswithFromEnabled = true
    } else if (item == 'Eliminate') {
      this.iseliminateFromEnabled = true
    } else if (item == 'Drop all events for value') {
      this.isdropalleventvaluesFromEnabled = true
    } else if (item == 'Calculator') {
      this.iscalculaterFromEnabled = true
    } else if (item == 'Date Analytics') {
      this.isdateanalyticsFromEnabled = true
    } else if (item == 'Substitute') {
      this.issubstituteFromEnabled = true
    } else if (item == 'Strip') {
      this.isstripFromEnabled = true
    } else if (item == 'Substring') {
      this.issubstringFromEnabled = true
    } else if (item == 'Round') {
      this.isroundFromEnabled = true
    } else if (item == 'API') {
      this.isrestapiFormEnabled = true;
      if(ops?.count != undefined && ops?.count != ""){
        this.onChangeSelectedOpsEnvironment(ops?.count, "");
      }      
      this.targetusername= true;
      this.targetpassword= true;
    } else if (item == 'Sleep time') {
      this.issleepFromEnabled = true
    } else if (item == 'Python') {
      this.ispycodeFromEnabled = true
    } else if (item == 'AI Operation') {
      setTimeout(()=>{
        let textarea=document.getElementById('ai_ops_input') as HTMLTextAreaElement;
        textarea.placeholder="Convert country field into lowercase\nChange the date format of 'InvoiceDate' to dd-MM-yyyy format\nmake email field to base64 encode\n";
        }, 0)
      this.isaiopsFromEnabled = true
    } 
    else if (item == 'Email') {
      this.isemailFromEnabled = true;
    } else if (item == 'JSON') {
      this.isjsonFormEnabled = true
    } else if (item == 'DL Ingestion') {
      this.isDLIngestionFormEnabled = true;
      // } else if (item == 'File') {
      //   this.isfileFromEnabled = true
    } else if (item == 'DataLake Search') {
      this.isDlsearchFormEnabled = true;
    } else if (item == 'Database') {
      this.isjdbcoutputFromEnabled = true;
    } else if (item == 'Filter') {
      this.isfilterFromEnabled = true;
    } else if (item == 'Encode Decode') {
      this.isEncodedecodeFromEnabled = true;
    } else if (item == 'Zipfile in Base64') {
      this.isZipfileinbase64FromEnabled = true;
    } else if (item == 'Array Count') {
      this.isArraycountFromEnabled = true;
    } else if (item == 'Delimiter to Array') {
      this.isDl2arrayFormEnabled = true;
    } else if (item == 'PDF Extractor') {
      this.isPdfextractorFormEnabled = true;
    } else if (item == 'File Extractor') {
      this.isFileextractorFormEnabled = true;
    } else if (item == 'Document Understanding') {
      this.isDocunderstandingFromEnabled = true;
    } else if (item == 'Grok Pattern') {
      this.isGorkPatternFormEnabled = true;
    } else if (item == 'Image Understanding') {
      this.isImgunderstandingFromEnabled = true;
    } else if (item == 'Filter Ends') {
      this.isfilterEndsFromEnabled = true;
    } else if (item == 'Raw Sentence Generator') {
      this.isRawSentenceGeneratorFormEnabled = true;
    } else if (item == 'Time Units') {
      this.isTimeUnitsFormEnabled = true;
    } else if (item == 'Data Chunking') {
      this.isDataChunkingFormEnabled = true;
    } else if (item == 'HTML Extractor') {
      this.isHTMLExtractorFormEnabled = true;
    }
    else if (item == 'JSON to AVRO') {
      this.isJson2avroFormEnabled = true;
    } else if (item == 'AVRO to JSON') {
      this.isAvro2jsonFormEnabled = true;
    } else if(item == 'Extract to Array'){
      this.isExtract2ArrayFormEnabled = true;
    }

  }

  //=================Alert Confirmation for mute operation========================//
  async confirmMuteOperation() {
    let mute = false, isCall = false;

    if (this.selectedOperationId == '' || this.selectedOperationId == undefined) {
      isCall = true;
    } else if (this.selectedOperationId != undefined && this.selectedOperationId != '') {
      for (let item of this.finalBlocks) {
        if (this.selectedOperationId == item.id && item.isMute == true) {
          mute = false;
          isCall = false;
          break;
        } else if (this.selectedOperationId == item.id && item.isMute == false) {
          mute = true;
          isCall = false;
          break;
        } else if (this.selectedOperationId != item.id && (item.isMute == false || item.isMute == true)) {
          isCall = true;
        }
      }//---------//
    }

    if (isCall == true) {
      const alert = await this.alertController.create({
        header: 'Alert!',
        message: 'Please select the operations!',
        buttons: [
          {
            text: 'Ok',
            cssClass: 'primary-text',
            handler: () => {
              alert.dismiss();
            },
          },
        ],
      });
      await alert.present();
    } else {
      let tmp_type = mute ? 'mute' : 'unmute';
      const alert = await this.alertController.create({
        header: 'Confirm!',
        message: `Are you sure? You want to ${tmp_type} this operations`,
        buttons: [
          {
            text: 'No',
            cssClass: 'primary-text',
            handler: () => {
              alert.dismiss();
            },
          },
          {
            text: 'Yes',
            cssClass: 'primary-text',
            handler: () => {
              this.muteOperation(this.selectedOperationId, tmp_type);
            },
          },
        ],
      });
      await alert.present();
    }
  }

  muteOperation(id, type) {
    var index = -1;
    //---------Finding the index and the operaiton name-------------//
    var item = '';
    var mute: boolean;
    var filteredObj = this.finalBlocks.find(function (pipe, i) {
      if (pipe.id === id) {
        index = i;
        item = pipe.title;
        return i;
      }
    });//---------------//
    if (type == 'mute') {
      this.finalBlocks[index].isMute = true;
      mute = true;
    } else {
      this.finalBlocks[index].isMute = false;
      mute = false;
    }

    if (item == 'Data types') {
      const index = this.datatypesRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.datatypesRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Append') {
      const index = this.appendRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.appendRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Titlecase') {
      const index = this.titlecaseRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.titlecaseRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Uppercase') {
      const index = this.uppercaseRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.uppercaseRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Lowercase') {
      const index = this.lowercaseRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.lowercaseRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Data extractor') {
      const index = this.dataextractorRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dataextractorRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Trim') {
      const index = this.trimRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.trimRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Base64 encoding') {
      const index = this.base64encodingRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.base64encodingRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Base64 decoding') {
      const index = this.base64decodingRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.base64decodingRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'JSON to XML') {
      const index = this.jsontoxmlRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.jsontoxmlRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'XML to JSON') {
      const index = this.xmltojsonRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.xmltojsonRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Repeat First Row Values') {
      const index = this.repeatfirstrowRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.repeatfirstrowRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'JSON to delimiter') {
      const index = this.json2dlRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.json2dlRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Delimiter to JSON') {
      const index = this.dl2jsonRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dl2jsonRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'JSON to String') {
      const index = this.json2stringRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.json2stringRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'String to JSON') {
      const index = this.string2jsonRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.string2jsonRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Generate Array Sequence Number') {
      const index = this.generatesequenceRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.generatesequenceRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Send Keys Top of Root') {
      const index = this.toplevelRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.toplevelRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Today Timestamp') {
      const index = this.datetimestampRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.datetimestampRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Data aggregation') {
      const index = this.dataaggregationRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dataaggregationRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Pivot') {
      const index = this.pivotRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.pivotRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Unpivot') {
      const index = this.unpivotRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.unpivotRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Single Line to Multiline') {
      const index = this.chopRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.chopRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Single Line to Tuple') {
      const index = this.singleline2tupleRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.singleline2tupleRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Tuple to Single Line') {
      const index = this.tuple2singlelineRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.tuple2singlelineRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Rename') {
      const index = this.renameRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.renameRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Drop all events to start with') {
      const index = this.dropeventsstartswithRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dropeventsstartswithRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Eliminate') {
      const index = this.eliminateRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.eliminateRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Drop all events for value') {
      const index = this.dropalleventvaluesRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dropalleventvaluesRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Calculator') {
      const index = this.calculaterRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.calculaterRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Date Analytics') {
      const index = this.dateanalyticsRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dateanalyticsRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Substitute') {
      const index = this.substituteRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.substituteRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Strip') {
      const index = this.stripRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.stripRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Substring') {
      const index = this.substringRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.substringRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Round') {
      const index = this.roundRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.roundRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'API') {
      const index = this.restapiRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.restapiRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Sleep time') {
      const index = this.sleepRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.sleepRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Python') {
      const index = this.pycodeRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.pycodeRows().at(index)).controls['isMute'].setValue(mute);
    }else if (item == 'AI Operation') {
      const index = this.aiopsRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.aiopsRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Email') {
      const index = this.emailRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.emailRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'JSON') {
      const index = this.jsonRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.jsonRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'DL Ingestion') {
      const index = this.dlIngestionRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dlIngestionRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'DataLake Search') {
      const index = this.dlsearchRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dlsearchRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Database') {
      const index = this.jdbcoutputRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Filter') {
      const index = this.filterRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.filterRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Encode Decode') {
      const index = this.encodedecodeRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.encodedecodeRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Zipfile in Base64') {
      const index = this.zipfileinbase64Rows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.zipfileinbase64Rows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Array Count') {
      const index = this.arraycountRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.arraycountRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Delimiter to Array') {
      const index = this.dl2arrayRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.dl2arrayRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'PDF Extractor') {
      const index = this.pdfextractorRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.pdfextractorRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'File Extractor') {
      const index = this.fileextractorRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.fileextractorRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Document Understanding') {
      const index = this.docunderstandingRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.docunderstandingRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Grok Pattern') {
      const index = this.grokpatternRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.grokpatternRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Image Understanding') {
      const index = this.imgunderstandingRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.imgunderstandingRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Filter Ends') {
      const index = this.filterEndsRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.filterEndsRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Raw Sentence Generator') {
      const index = this.rawsentencegeneratorRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.rawsentencegeneratorRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Time Units') {
      const index = this.timeunitsRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.timeunitsRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Data Chunking') {
      const index = this.datachunkingRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.datachunkingRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'JSON to AVRO') {
      const index = this.jason2avroRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.jason2avroRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'HTML Extractor') {
      const index = this.htmlExtractorRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.htmlExtractorRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'AVRO to JSON') {
      const index = this.avro2jsonRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.avro2jsonRows().at(index)).controls['isMute'].setValue(mute);
    } else if (item == 'Extract to Array') {
      const index = this.extract2ArrayRows().controls.findIndex((item) => item.value.id === id);
      (<UntypedFormGroup>this.extract2ArrayRows().at(index)).controls['isMute'].setValue(mute);
    }

  }

  hideAllOpsForms() {
    this.isDataTypeFromEnabled = false;
    this.isBase64decodingFromEnabled = false;
    this.isBase64encodingFromEnabled = false;
    this.isData_extractorFromEnabled = false;
    this.isTitlecaseFromEnabled = false;
    this.isUppercaseFromEnabled = false;
    this.isLowercaseFromEnabled = false;
    this.isTrimFromEnabled = false;
    this.isAppendFromEnabled = false;
    this.isJSON_to_XMLFromEnabled = false;
    this.isXML_to_JSONFromEnabled = false;
    this.isGeneratesequenceFromEnabled = false;
    this.isJson2stringFromEnabled = false;
    this.isString2jsonFromEnabled = false;
    this.isToplevelFromEnabled = false;
    this.isDatetimestampFromEnabled = false;
    this.isRepeatfirstrowFromEnabled = false;
    this.isPdfextractorFormEnabled = false;
    this.isGorkPatternFormEnabled = false;
    this.isRawSentenceGeneratorFormEnabled = false;
    this.isTimeUnitsFormEnabled = false;
    this.isDataChunkingFormEnabled = false;
    this.isJson2avroFormEnabled = false;
    this.isHTMLExtractorFormEnabled = false;
    this.isAvro2jsonFormEnabled = false;
    this.isExtract2ArrayFormEnabled = false;
    this.isZipfileinbase64FromEnabled = false;
    this.isArraycountFromEnabled = false;

    this.isJSON2dlFromEnabled = false;
    this.isDl2jsonFromEnabled = false;
    this.isPivotFromEnabled = false;
    this.isUnPivotFromEnabled = false;
    this.isDataaggregationFromEnabled = false;
    this.chopFormEnabled = false;
    this.singleline2tupleFormEnabled = false;
    this.tuple2singlelineFormEnabled = false;

    this.isemailFromEnabled = false
    // this.isfileFromEnabled = false
    this.isdropeventsstartswithFromEnabled = false;
    this.isdropalleventvaluesFromEnabled = false;
    this.iseliminateFromEnabled = false;
    this.isroundFromEnabled = false;
    this.iscalculaterFromEnabled = false;
    this.isdateanalyticsFromEnabled = false;
    this.issubstituteFromEnabled = false;
    this.isstripFromEnabled = false;
    this.issubstringFromEnabled = false;
    this.isrenameFromEnabled = false;
    this.ispycodeFromEnabled = false;
    this.isaiopsFromEnabled = false;

    this.isjsonFormEnabled = false;
    this.isDLIngestionFormEnabled = false;
    this.isDLIngestionFormEnabled = false;
    this.isrestapiFormEnabled = false;
    this.issleepFromEnabled = false;

    this.isGeneratesequenceFromEnabled = false;
    this.isDatetimestampFromEnabled = false
    this.isPostgresFromEnabled = false
    this.isReplacingvalueFromEnabled = false
    this.isAnalyticsFromEnabled = false
    this.isDataextractorEnabled = false
    this.isjdbcoutputFromEnabled = false;
    this.isfilterFromEnabled = false;
    this.isEncodedecodeFromEnabled = false;
    this.isDocunderstandingFromEnabled = false;
    this.isfilterEndsFromEnabled = false;
  }

  splitArr(arr, size) {
    let newArr = [];
    for (let i = 0; i < arr.length; i += size) {
      let arr2 = arr.slice(i, i + size);
      // if(i%2 !== 0){
      //   arr2.reverse();
      // }
      newArr.push(arr2);
    }
    return newArr;
  }

  clearOps() {
    this.blocks = [];
    this.finalBlocks = [];
    this.newBlocks = [];
    this.selectedOperationId = '';
    // this.operations = [];
    this.hideAllOpsForms();
    this.restAPIForm();
  }

  getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        // //console.log(e);
        this.userIp = e.ip;
      })
  }

  getSourcePostmanDetails(id) {
    this.getStorage().then((_storage) => {
      let payload = {
        id: id
      }

      this.backendService.PostAPICall('getPostmanData', payload, _storage.token).subscribe(
        (res) => {
          // //console.log(res);
          let data = res.input_structure_json.input.bizdata_rest;
          let selectedSourceEnv;
          if (res.environment_variables != '' && res.environment_variables != null) {
            selectedSourceEnv = JSON.parse(res.environment_variables);
          }
          // ***************************
          // Data Process for Source
          // ***************************
          let bridge_source_endpoint_method = this.methodList.filter(function (entry) { return entry.id == data.endpoint_method.id });
          this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_source_endpoint_method[0]);
          let bridge_source_endpoint_authentication_type = this.authenticationSourceTypeOptions.filter(function (entry) { return entry.id === data.authentication_type.id });
          this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(bridge_source_endpoint_authentication_type[0]);
          if (data.hasOwnProperty('body_type')) {
            if (data.body_type != "" && data.body_type != undefined) {
              this.dataSource.controls['bridge_source_body_type'].setValue(data.body_type);
              if (data.body_type == 'JSON') {
                if (data.endpoint_body_raw != '' && data.endpoint_body_raw != undefined) {
                  this.dataSource.controls['bridge_source_endpoint_body_raw'].setValue(JSON.stringify(data.endpoint_body_raw));
                } else {
                  this.dataSource.controls['bridge_source_endpoint_body_raw'].setValue(data.endpoint_body_raw);
                }
              } else {
                this.dataSource.controls['bridge_source_endpoint_body_raw'].setValue(data.endpoint_body_raw);
              }
            }
          }

          // this.getSourceHeaderValue();
          this.dataSource.controls['pre_request_script'].setValue(data.pre_request_script);
          // this.dataSource.controls['pre_request_script'].setValue(decodeURIComponent(data.pre_request_script));
          this.dataSource.controls['bridge_source_endpoint_url'].setValue(data.endpoint_url);
          this.endpoint_url = data.endpoint_url;
          this.contentDiv = document.getElementById('contentDiv');
          //this.contentDiv.innerHTML = this.endpoint_url;
          if( this.contentDiv!= null){
            this.contentDiv.innerHTML = this.endpoint_url;
          }
          if (res.environment_name != '' && res.environment_name != undefined && res.environment_name != null) {
            this.environmentForm.patchValue({
              selected_environment: res.environment_name,
              bridge_endpoint_selected_environments_name: res.environment_name
            })
          } else {
            this.currentDisplayedEnvIndex = -1;
            this.environmentForm.patchValue({
              selected_environment: 'No Environment',
              bridge_endpoint_selected_environments_name: 'No Environment'
            })
          }

          this.selectedEnvTabs = [];
          this.params_key = [];
          this.params_value = [];
          this.headers_key = [];
          this.headers_value = [];
          if (res.hasOwnProperty('environment_variables')) {
            if (selectedSourceEnv != null) {
              if (selectedSourceEnv.length > 0) {
                let bridge_endpoint_environments = this.environmentForm.get('bridge_endpoint_environments_raw') as UntypedFormArray;
                bridge_endpoint_environments.clear();
                let env_name_arr = []
                for (const environment of selectedSourceEnv) {
                  env_name_arr.push(environment.env_name);
                  this.selectedEnvTabs.push(environment.env_name);
                  const envVarsArray = new UntypedFormArray([]);
                  for (const envVar of environment.env_vars) {
                    const envVarFormGroup = this.addValueEnvironments(envVar);
                    envVarsArray.push(envVarFormGroup);
                  }
                  const nestedFormGroup = new UntypedFormGroup({
                    env_name: new UntypedFormControl(environment.env_name),
                    env_vars: envVarsArray
                  });
                  bridge_endpoint_environments.push(nestedFormGroup);
                }
                this.currentDisplayedEnvIndex = env_name_arr.indexOf(this.environmentForm.value.selected_environment);
              }
            }
          }

          let bridge_source_endpoint_params_raw_array = this.dataSource.get('bridge_source_endpoint_params_raw') as UntypedFormArray;
          if (data.endpoint_param_raw.length > 0) {
            bridge_source_endpoint_params_raw_array.clear();
            for (var row of data.endpoint_param_raw) {
              // //console.log(row);
              bridge_source_endpoint_params_raw_array.push(this.addSourceValueParams(row));
              this.params_key.push(row.key);
              this.params_value.push(row.value);
            }
          } else {
            bridge_source_endpoint_params_raw_array.clear();
            this.addSourceParams(0);
          }
          let bridge_source_endpoint_headers_raw_array = this.dataSource.get('bridge_source_endpoint_headers') as UntypedFormArray;
          if (data.endpoint_headers.length > 0) {
            bridge_source_endpoint_headers_raw_array.clear();
            for (var row of data.endpoint_headers) {
              bridge_source_endpoint_headers_raw_array.push(this.addSourceValueHeaders(row));
              const controls = this.sourceHeaderKeysController().controls;
              this.getSourceHeaderKeys(controls.length - 1);
              this.getSourceHeaderValue(controls.length - 1);
              this.headers_key.push(row.key);
              this.headers_value.push(row.value);
            }
          } else {
            bridge_source_endpoint_headers_raw_array.clear();
            this.addSourceHeaders(0);
          }
          this.selectSourceType = 1; // Reset the value here
          if (bridge_source_endpoint_authentication_type[0].id == 3) {
            // Bearer Token
            this.dataSource.addControl('bridge_source_authentication_token', new UntypedFormControl(""));
            this.dataSource.controls['bridge_source_authentication_token'].setValue(data.authentication_token);
            this.selectSourceType = 3;
          } else if (bridge_source_endpoint_authentication_type[0].id == 4) {
            // Basic Auth
            this.selectSourceType = 4;
            this.dataSource.addControl('bridge_source_authentication_username', new UntypedFormControl(""));
            this.dataSource.addControl('bridge_source_authentication_password', new UntypedFormControl(""));
            this.dataSource.controls['bridge_source_authentication_username'].setValue(data.username);
            this.dataSource.controls['bridge_source_authentication_password'].setValue(data.password);
            this.source_authUser = data.username;
            this.source_authPassword = data.password;
          } else if (bridge_source_endpoint_authentication_type[0].id == 6) {
            // OAuth 2.0
            let typeof_bridge_source_oauth_refresh_token_endpoint_header = typeof data.refresh_token_endpoint_header;
            let typeof_bridge_source_oauth_refresh_token_endpoint_params = typeof data.refresh_token_endpoint_params;
            let typeof_bridge_source_oauth_refresh_token_endpoint_body = typeof data.refresh_token_endpoint_body;
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
            this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
            this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_url'].setValue(data.refresh_token_endpoint_url);
            this.source_auth = data.refresh_token_endpoint_url;
            if (typeof_bridge_source_oauth_refresh_token_endpoint_header == 'object') {
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_header'].setValue(JSON.stringify(data.refresh_token_endpoint_header));
            } else {
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_header'].setValue(data.refresh_token_endpoint_header);
            }

            if (typeof_bridge_source_oauth_refresh_token_endpoint_params == 'object') {
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_params'].setValue(JSON.stringify(data.refresh_token_endpoint_params));
            } else {
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_params'].setValue(data.refresh_token_endpoint_params);
            }

            if (typeof_bridge_source_oauth_refresh_token_endpoint_body == 'object') {
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_body'].setValue(JSON.stringify(data.refresh_token_endpoint_body));
            } else {
              this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_body'].setValue(data.refresh_token_endpoint_body);
            }


            let bridge_source_refresh_token_endpoint_method = this.methodList.filter(function (entry) { return entry.id === data.refresh_token_endpoint_method.id });
            this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_method'].setValue(bridge_source_refresh_token_endpoint_method[0]);
            this.selectSourceType = 6;
          }

          // if (res.type.id == 1) {
          let pagination = data.pagination
          // //console.log(pagination)
          var id: any;

          this.dataSource.addControl('min_number', new UntypedFormControl(""));
          this.dataSource.addControl('min_number', new UntypedFormControl(""));
          this.dataSource.controls['min_number'].setValue(pagination.min_num);
          this.dataSource.controls['max_number'].setValue(pagination.max_num)
          // this.dataSource.controls['pagination_retry_seconds'].setValue('5')

          for (let item of this.paginationTypeOptions) {
            if (pagination.pagination_style == item.type_value) {
              id = item.id
              this.selectPaginationType = id;
              this.dataSource.controls['bridge_source_pagination_type'].setValue(item);
            }
          }
          if (id == 2) {
            this.user_key_2 = pagination.user_key
            this.response_parameters_2 = pagination.response_parameters
            this.another_response_parameter_2 = pagination.another_response_parameter
            this.pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds
            this.dataSource.patchValue({
              user_key_2: pagination.user_key,
              response_parameters_2: pagination.response_parameters,
              another_response_parameter_2: pagination.another_response_parameter,
              pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
            })
          } else if (id == 3) {
            this.user_key_3 = pagination.user_key
            this.key_name_to_update_3 = pagination.key_name_to_update
            this.response_parameters_3 = pagination.response_parameters
            this.pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds
            this.dataSource.patchValue({
              user_key_3: pagination.user_key,
              key_name_to_update_3: pagination.key_name_to_update,
              response_parameters_3: pagination.response_parameters,
              pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
            })
          } else if (id == 4) {
            this.user_key_4 = pagination.user_key
            this.key_name_to_update_4 = pagination.key_name_to_update
            this.response_parameters_4 = pagination.response_parameters
            this.pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds
            this.dataSource.patchValue({
              user_key_4: pagination.user_key,
              key_name_to_update_4: pagination.key_name_to_update,
              response_parameters_4: pagination.response_parameters,
              pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
            })
          } else if (id == 5) {
            this.user_key_5 = pagination.user_key
            this.key_name_to_update_5 = pagination.key_name_to_update
            this.response_parameters_5 = pagination.response_parameters
            this.pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds
            this.dataSource.patchValue({
              user_key_5: pagination.user_key,
              key_name_to_update_5: pagination.key_name_to_update,
              response_parameters_5: pagination.response_parameters,
              pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
            })
          } else if (id == 6) {
            this.user_key_6 = pagination.user_key,
              this.user_key_url_6 = pagination.user_key_url,
              this.response_parameters_6 = pagination.response_parameters,
              this.pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds
            this.dataSource.patchValue({
              user_key_6: pagination.user_key,
              user_key_url_6: pagination.user_key_url,
              response_parameters_6: pagination.response_parameters,
              pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
            })
          } else if (id == 7) {
            this.user_key_7 = pagination.user_key;
            this.response_parameters_7 = pagination.response_parameters,
              this.pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds
            this.dataSource.patchValue({
              user_key_7: pagination.user_key,
              response_parameters_7: pagination.response_parameters,
              pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
            })
          } else if (id == 8) {
            this.custom_pagination_script = pagination.custom_pagination_script;
            this.pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds
            this.dataSource.patchValue({
              custom_pagination_script: pagination.custom_pagination_script,
              pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
            })
          }
          // ***************************
          // ***************************
        })
    })
  }


  getTargetPostmanDetailsRAO(id, index) {
    this.getStorage().then((_storage) => {
      let payload = {
        id: id
      }
      if(id == 'Create New'){
        this.opsData[index] = {
          "input_structure_json": {
            "input": {
              "bizdata_rest": {
                "endpoint_url": "",
                "endpoint_method": {
                  "id": 1,
                  "method": "GET"
                },
                "endpoint_headers": [],
                "endpoint_params": [],
                "authentication_type": {
                  "id": 1,
                  "type": "No Auth"
                },
                "username": "",
                "password": "",
                "refresh_token_url": "",
                "refresh_token_headers": {},
                "refresh_token_params": {},
                "refresh_token_method": "",
                "refresh_token_body": "",
                "body_type": "TEXT",
                "endpoint_body": " ",
                "pre_request_script": "",
                "response_type": "",
                "selected_environment": "",
                "environment_variables": []
              }
            }
          }
        };
      }else{
        this.backendService.PostAPICall('getPostmanData', payload, _storage.token).subscribe(
          (res) => {
            // if(this.opsData[index] != undefined){
              this.opsData[index] = res;
            // }
          })
      }
    })
  }

  getTargetPostmanDetails(id) {
    this.getStorage().then((_storage) => {
      let payload = {
        id: id
      }

      this.backendService.PostAPICall('getPostmanData', payload, _storage.token).subscribe(
        (res) => {
          // //console.log(res);
          let data = res.input_structure_json.input.bizdata_rest;
          let selectedTargetEnv;
          if (res.environment_variables != '' && res.environment_variables != null) {
            selectedTargetEnv = JSON.parse(res.environment_variables);
          }

          // ***************************
          // Data Process for Target
          // ***************************
          let bridge_target_endpoint_method = this.methodList.filter(function (entry) { return entry.id == data.endpoint_method.id });
          let bridge_target_endpoint_authentication_type = this.authenticationTargetTypeOptions.filter(function (entry) { return entry.id === data.authentication_type.id });
          this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_target_endpoint_method[0]);
          this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(bridge_target_endpoint_authentication_type[0]);
          if (data.hasOwnProperty('body_type')) {
            if (data.body_type != "" && data.body_type != undefined) {
              this.dataTarget.controls['bridge_target_body_type'].setValue(data.body_type);
              if (data.body_type == 'JSON') {
                if (data.endpoint_body_raw != '' && data.endpoint_body_raw != undefined) {
                  this.dataTarget.controls['bridge_target_endpoint_body_raw'].setValue(JSON.stringify(data.endpoint_body_raw));
                } else {
                  this.dataTarget.controls['bridge_target_endpoint_body_raw'].setValue(data.endpoint_body_raw);
                }
              } else {
                this.dataTarget.controls['bridge_target_endpoint_body_raw'].setValue(data.endpoint_body_raw);
              }
            }
          }

          // this.dataTarget.controls['bridge_target_endpoint_body_raw'].setValue(JSON.stringify(data.endpoint_body_raw));
          this.dataTarget.controls['pre_request_script'].setValue(data.pre_request_script);
          // this.dataTarget.controls['pre_request_script'].setValue(decodeURIComponent(data.pre_request_script));

          this.dataTarget.controls['bridge_target_endpoint_url'].setValue(data.endpoint_url);
          this.endpoint_target_url = data.endpoint_url;
          this.contentDivTarget = document.getElementById('contentDivTarget');
          
          if( this.contentDivTarget!= null){
            this.contentDivTarget.innerHTML = this.endpoint_target_url;
          }
          if (res.environment_name != '' && res.environment_name != undefined && res.environment_name != null) {
            this.environmentTargetForm.patchValue({
              selected_environment: res.environment_name,
              bridge_endpoint_selected_environments_name: res.environment_name
            })
          } else {
            this.currentTargetDisplayedEnvIndex = -1;
            this.environmentTargetForm.patchValue({
              selected_environment: 'No Environment',
              bridge_endpoint_selected_environments_name: 'No Environment'
            })
          }

          this.selectedTargetEnvTabs = [];
          this.params_target_key = [];
          this.params_target_value = [];
          this.headers_target_key = [];
          this.headers_target_value = [];
          if (res.hasOwnProperty('environment_variables')) {
            if (selectedTargetEnv != null) {
              if (selectedTargetEnv.length > 0) {
                let bridge_endpoint_environments = this.environmentTargetForm.get('bridge_endpoint_environments_raw') as UntypedFormArray;
                bridge_endpoint_environments.clear();
                let env_name_arr = []
                for (const environment of selectedTargetEnv) {
                  env_name_arr.push(environment.env_name);
                  this.selectedTargetEnvTabs.push(environment.env_name);
                  const envVarsArray = new UntypedFormArray([]);
                  for (const envVar of environment.env_vars) {
                    const envVarFormGroup = this.addTargetValueEnvironments(envVar);
                    envVarsArray.push(envVarFormGroup);
                  }
                  const nestedFormGroup = new UntypedFormGroup({
                    env_name: new UntypedFormControl(environment.env_name),
                    env_vars: envVarsArray
                  });
                  bridge_endpoint_environments.push(nestedFormGroup);
                }
                this.currentTargetDisplayedEnvIndex = env_name_arr.indexOf(this.environmentTargetForm.value.selected_environment);
              }
            }

          }

          let bridge_target_endpoint_params_raw_array = this.dataTarget.get('bridge_target_endpoint_params_raw') as UntypedFormArray;
          if (data.endpoint_param_raw.length > 0) {
            bridge_target_endpoint_params_raw_array.clear();
            for (var row of data.endpoint_param_raw) {
              // //console.log(row);
              bridge_target_endpoint_params_raw_array.push(this.addTargetValueParams(row));
              this.params_target_key.push(row.key);
              this.params_target_value.push(row.value);
            }
          } else {
            bridge_target_endpoint_params_raw_array.clear();
            this.addTargetParams(0);
          }

          let bridge_target_endpoint_headers_raw_array = this.dataTarget.get('bridge_target_endpoint_headers') as UntypedFormArray;
          if (data.endpoint_headers.length > 0) {
            bridge_target_endpoint_headers_raw_array.clear();
            for (var row of data.endpoint_headers) {
              // //console.log(row);
              bridge_target_endpoint_headers_raw_array.push(this.addTargetValueHeaders(row));
              const controls = this.targetHeaderKeysController().controls;
              this.getTargetHeaderKeys(controls.length - 1);
              this.getTargetHeaderValue(controls.length - 1);
              this.headers_target_key.push(row.key);
              this.headers_target_value.push(row.value);
            }
          } else {
            bridge_target_endpoint_headers_raw_array.clear();
            this.addTargetHeaders(0);
          }
          this.selectTargetType = 1; // Reset the value here
          if (bridge_target_endpoint_authentication_type[0].id == 3) {
            // Bearer Token
            this.dataTarget.addControl('bridge_target_authentication_token', new UntypedFormControl(""));
            this.dataTarget.controls['bridge_target_authentication_token'].setValue(data.authentication_token);
            this.selectTargetType = 3;
          } else if (bridge_target_endpoint_authentication_type[0].id == 4) {
            // Basic Auth
            this.dataTarget.addControl('bridge_target_authentication_username', new UntypedFormControl(""));
            this.dataTarget.addControl('bridge_target_authentication_password', new UntypedFormControl(""));
            this.dataTarget.controls['bridge_target_authentication_username'].setValue(data.username);
            this.dataTarget.controls['bridge_target_authentication_password'].setValue(data.password);
            this.target_authUser = data.username;
            this.target_authPassword = data.password;
            this.selectTargetType = 4;
          } else if (bridge_target_endpoint_authentication_type[0].id == 6) {
            // OAuth 2.0
            let typeof_bridge_target_oauth_refresh_token_endpoint_header = typeof data.refresh_token_endpoint_header;
            let typeof_bridge_target_oauth_refresh_token_endpoint_params = typeof data.refresh_token_endpoint_params;
            let typeof_bridge_target_oauth_refresh_token_endpoint_body = typeof data.refresh_token_endpoint_body;
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
            this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
            this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(data.refresh_token_endpoint_url);
            this.target_auth = data.refresh_token_endpoint_url;
            if (typeof_bridge_target_oauth_refresh_token_endpoint_header == 'object') {
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_header'].setValue(JSON.stringify(data.refresh_token_endpoint_header));
            } else {
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_header'].setValue(data.refresh_token_endpoint_header);
            }

            if (typeof_bridge_target_oauth_refresh_token_endpoint_params == 'object') {
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_params'].setValue(JSON.stringify(data.refresh_token_endpoint_params));
            } else {
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_params'].setValue(data.refresh_token_endpoint_params);
            }

            if (typeof_bridge_target_oauth_refresh_token_endpoint_body == 'object') {
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_body'].setValue(JSON.stringify(data.refresh_token_endpoint_body));
            } else {
              this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_body'].setValue(data.refresh_token_endpoint_body);
            }

            let bridge_target_refresh_token_endpoint_method = this.methodList.filter(function (entry) { return entry.id === data.refresh_token_endpoint_method.id });
            this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_method'].setValue(bridge_target_refresh_token_endpoint_method[0]);
            this.selectTargetType = 6;
          }
          // ***************************
          // ***************************
        
        })
    })
  }

  OnChangeBridgeSource(e) {
    this.closebubblecross();
    if (e.option.value == "Create New") {
      this.isNewSource = true;

      this.resetSourcePostman();
      this.dataSource.addControl('new_bridge_source', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('new_bridge_source_business_object', new UntypedFormControl("", [Validators.required]));
      // const is_bridge_source = this.dataSource.contains('bridge_source');
      this.dataSource.get('bridge_source').clearValidators();
      this.dataSource.get('bridge_source').updateValueAndValidity();
      const is_bridge_source_business_object = this.dataSource.contains('bridge_source_business_object');
      // if(is_bridge_source) this.dataSource.removeControl('bridge_source');
      if (is_bridge_source_business_object) this.dataSource.removeControl('bridge_source_business_object');
    } else {
      this.isNewSource = false;
      this.resetSourcePostman();
      // this.dataSource.controls['bridge_source_business_object'].enable();
      // this.dataSource.addControl('bridge_source', new FormControl("", [Validators.required]));
      this.dataSource.addControl('bridge_source_business_object', new UntypedFormControl("", [Validators.required]));
      const is_new_bridge_source = this.dataSource.contains('new_bridge_source');
      const is_new_bridge_source_business_object = this.dataSource.contains('new_bridge_source_business_object');
      if (is_new_bridge_source) this.dataSource.removeControl('new_bridge_source');
      if (is_new_bridge_source_business_object) this.dataSource.removeControl('new_bridge_source_business_object');
      this.getSourceTargetBusinessObject(e.option.value, "source");
    }
    this.closebubble();
  }


  resetSourcePostman() {
    if(this.dataSource.controls["bridge_source_authentication_username"]){
      this.dataSource.removeControl["bridge_source_authentication_username"];
    }
 
    if(this.dataSource.controls["bridge_source_authentication_password"]){
      this.dataSource.removeControl["bridge_source_authentication_password"];
    }
 
    if(this.dataSource.controls["bridge_source_oauth_refresh_token_endpoint_url"]){
      this.dataSource.removeControl["bridge_source_oauth_refresh_token_endpoint_url"];
    }
 
    if(this.dataSource.controls["bridge_source_oauth_refresh_token_endpoint_method"]){
      this.dataSource.removeControl["bridge_source_oauth_refresh_token_endpoint_method"];
    }
    this.dataSource.patchValue({
      bridge_source_endpoint_url: "",
      bridge_source_endpoint_body_raw: "",
      bridge_source_endpoint_method: "",
      bridge_source_endpoint_authentication_type: "",
      // bridge_source_authentication_username: '',
      // bridge_source_authentication_password: '',
      // bridge_source_oauth_refresh_token_endpoint_url: '',
      // bridge_source_oauth_refresh_token_endpoint_method: '',
      bridge_source_oauth_refresh_token_endpoint_header: '',
      bridge_source_oauth_refresh_token_endpoint_params: '',
      bridge_source_oauth_refresh_token_endpoint_body: '',
      pre_request_script: "",
      bridge_source_response: {},
      bridge_source_pagination_type: "",
      user_key_url: "",
      response_parameters: '',
      key_name_to_update: '',
      another_response_parameter: '',
      user_key: '',
      // pagination_retry_seconds: '',
      min_number: 0,
      max_number: 1000,
      today_str: '%Y-%m-%dT00:00:01Z',
      yesterday_str: '%Y-%m-%dT00:00:01Z',
      rolling_time_format: '%Y-%m-%dT%H:%M:00.000',
      rolling_frequency: 900,
      offset_value: 0
    })
    // this.endpoint_url = "";
    // this.contentDiv = document.getElementById('contentDiv');
    // this.contentDiv.innerHTML = "";
    // this.dataSource.controls['bridge_source_endpoint_url'].setValue("");
    // this.source_auth = "";
    // this.source_authUser = "";
    // this.source_authPassword = "";
    // this.params_key = [];
    // this.params_value = [];
    // this.headers_key = [];
    // this.headers_value = [];
    // this.username = true;
    // this.password = true;
    // let bridge_source_endpoint_params_raw_array = this.dataSource.get('bridge_source_endpoint_params_raw') as UntypedFormArray;
    // bridge_source_endpoint_params_raw_array.clear();
    // this.addSourceParams(0);

    // let bridge_source_endpoint_headers_raw_array = this.dataSource.get('bridge_source_endpoint_headers') as UntypedFormArray;
    // bridge_source_endpoint_headers_raw_array.clear();
    // this.addSourceHeaders(0);

    // let bridge_endpoint_method = this.methodList.filter(function (entry) { return entry.id === 1 });
    // this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_endpoint_method[0]);
    // // this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_method'].setValue(bridge_endpoint_method[0]);

    // let bridge_endpoint_authentication_type = this.authenticationSourceTypeOptions.filter(function (entry) { return entry.id === 1 });
    // this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(bridge_endpoint_authentication_type[0]);
    // this.selectSourceType = 1;

    // this.dataSource.controls['bridge_source_pagination_type'].setValue(this.paginationTypeOptions[0]);
    // this.selectPaginationType = 1;
  }

  OnChangeBridgeTarget(e) {
    this.closebubblecross();
    if (e.option.value == "Create New") {
      this.isNewTarget = true;
      this.resetTargetPostman();
      this.dataTarget.addControl('new_bridge_target', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('new_bridge_target_business_object', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.get('bridge_target').clearValidators();
      this.dataTarget.get('bridge_target').updateValueAndValidity();
      const is_bridge_source_business_object = this.dataTarget.contains('bridge_target_business_object');
      if (is_bridge_source_business_object) this.dataTarget.removeControl('bridge_target_business_object');
    } else {
      this.isNewTarget = false;
      this.resetTargetPostman();
      // this.dataTarget.controls['bridge_target_business_object'].enable();
      this.dataTarget.addControl('bridge_target_business_object', new UntypedFormControl("", [Validators.required]));
      const is_new_bridge_target = this.dataTarget.contains('new_bridge_target');
      const is_new_bridge_target_business_object = this.dataTarget.contains('new_bridge_target_business_object');
      if (is_new_bridge_target) this.dataTarget.removeControl('new_bridge_target');
      if (is_new_bridge_target_business_object) this.dataTarget.removeControl('new_bridge_target_business_object');
      this.getSourceTargetBusinessObject(e.option.value, "target");
    }
    this.closebubbletarget();
  }

  OnChangeBridgeTargetRAO(e, index) {
    (<UntypedFormGroup>this.restapiRows().at(index)).controls['is_new_target'].setValue(false);
    this.opsData[index] = [];
    if (e.option.value == "Create New") {
      (<UntypedFormGroup>this.restapiRows().at(index)).controls['is_new_target'].setValue(true);
      this.resetTargetPostmanRAO(index);
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('new_bridge_target', this._formBuilder.control("", [Validators.required]));
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('new_bridge_target_business_object', this._formBuilder.control("", [Validators.required]));
      (<UntypedFormGroup>this.restapiRows().at(index)).get('bridge_target').clearValidators();
      (<UntypedFormGroup>this.restapiRows().at(index)).get('bridge_target').updateValueAndValidity();
      
      const is_bridge_source_business_object = (<UntypedFormGroup>this.restapiRows().at(index)).contains('bridge_target_business_object');
      if (is_bridge_source_business_object) (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_business_object');      

      // this.getSourceTargetBusinessObjectRAO("Create New", 'target', index);
      this.getTargetPostmanDetailsRAO("Create New", index);
    } else {
      this.resetTargetPostmanRAO(index);
      (<UntypedFormGroup>this.restapiRows().at(index)).controls['is_new_target'].setValue(false);
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_business_object', this._formBuilder.control("", [Validators.required]));
      const is_new_bridge_target = (<UntypedFormGroup>this.restapiRows().at(index)).contains('new_bridge_target');
      const is_new_bridge_target_business_object = (<UntypedFormGroup>this.restapiRows().at(index)).contains('new_bridge_target_business_object');
      if (is_new_bridge_target) (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('new_bridge_target');
      if (is_new_bridge_target_business_object) (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('new_bridge_target_business_object');
      this.getSourceTargetBusinessObjectRAO(e.option.value, 'target', index)
    }
  }

  resetTargetPostmanRAO(index) {
    this.restapiRows().at(index).patchValue({
      bridge_target_endpoint_url: '',
      bridge_target_endpoint_body_raw: '',
      bridge_target_endpoint_method: '',
      bridge_target_endpoint_authentication_type: '',
      bridge_target_authentication_username: '',
      bridge_target_authentication_password: '',
      bridge_target_oauth_refresh_token_endpoint_url: '',
      bridge_target_oauth_refresh_token_endpoint_method: '',
      bridge_target_oauth_refresh_token_endpoint_header: '',
      bridge_target_oauth_refresh_token_endpoint_params: '',
      bridge_target_oauth_refresh_token_endpoint_body: '',
      pre_request_script: '',
      bridge_target_response: {},
    })
    this.params_ops_key[index]=[];
    this.params_ops_value[index]=[];
    this.headers_ops_key[index]=[];
    this.headers_ops_value[index]=[];
    this.headers_ops_raw[index]=[];
    this.params_ops_raw[index]=[];
    this.ops_auth[index]=[];
    this.ops_authUser[index]=[];
    this.ops_authPassword[index]=[];
    this.endpoint_ops_url[index]=[];
    let bridge_target_endpoint_params_raw_array = (<UntypedFormGroup>this.restapiRows().at(index)).get('bridge_target_endpoint_params_raw') as UntypedFormArray;
    bridge_target_endpoint_params_raw_array.clear();
    this.addTargetParamsRAO(index);

    let bridge_target_endpoint_headers_raw_array = (<UntypedFormGroup>this.restapiRows().at(index)).get('bridge_target_endpoint_headers') as UntypedFormArray;
    bridge_target_endpoint_headers_raw_array.clear();
    this.addTargetHeadersRAO(index);

    let bridge_endpoint_method = this.methodList.filter(function (entry) { return entry.id === 1 });
    (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridge_target_endpoint_method'].setValue(bridge_endpoint_method[0]);

    let bridge_endpoint_authentication_type = this.authenticationTargetTypeOptions.filter(function (entry) { return entry.id === 1 });
    (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridge_target_endpoint_authentication_type'].setValue(bridge_endpoint_authentication_type[0]);
    this.selectTargetType = 1;
    this.selectTargetRestApiType = 1;
  }

  resetTargetPostman() {
    this.dataTarget.patchValue({
      bridge_target_endpoint_url: '',
      bridge_target_endpoint_body_raw: '',
      bridge_target_endpoint_method: '',
      bridge_target_endpoint_authentication_type: '',
      bridge_target_authentication_username: '',
      bridge_target_authentication_password: '',
      bridge_target_oauth_refresh_token_endpoint_url: '',
      bridge_target_oauth_refresh_token_endpoint_method: '',
      bridge_target_oauth_refresh_token_endpoint_header: '',
      bridge_target_oauth_refresh_token_endpoint_params: '',
      bridge_target_oauth_refresh_token_endpoint_body: '',
      pre_request_script: '',
      bridge_target_response: {}
    })
    // this.endpoint_target_url = "";
    // this.contentDivTarget = document.getElementById('contentDivTarget');
    // this.contentDivTarget.innerHTML = "";
    // this.dataTarget.controls['bridge_target_endpoint_url'].setValue("");
    // this.target_auth = "";
    // this.target_authUser = "";
    // this.target_authPassword = "";
    // this.params_target_key = [];
    // this.params_target_value = [];
    // this.headers_target_key = [];
    // this.headers_target_value = [];
    // this.targetusername = true;
    // this.targetpassword = true;
    // let bridge_target_endpoint_params_raw_array = this.dataTarget.get('bridge_target_endpoint_params_raw') as UntypedFormArray;
    // bridge_target_endpoint_params_raw_array.clear();
    // this.addTargetParams(0);

    // let bridge_target_endpoint_headers_raw_array = this.dataTarget.get('bridge_target_endpoint_headers') as UntypedFormArray;
    // bridge_target_endpoint_headers_raw_array.clear();
    // this.addTargetHeaders(0);

    // let bridge_endpoint_method = this.methodList.filter(function (entry) { return entry.id === 1 });
    // this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_endpoint_method[0]);
    // // this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_method'].setValue(bridge_endpoint_method[0]);

    // let bridge_endpoint_authentication_type = this.authenticationTargetTypeOptions.filter(function (entry) { return entry.id === 1 });
    // this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(bridge_endpoint_authentication_type[0]);
    // this.selectTargetType = 1;
    // this.selectTargetRestApiType = 1;
  }

  addEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our Email
    if(value!=null && value !=''){    

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
      this.emails.push(value);
    } else {
      this.helperService.presentToast("Enter valid email address", 2000);
    }
  }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeEmail(email): void {
    const index = this.emails.indexOf(email);
    if (index >= 0) {
      this.emails.splice(index, 1);
      this.announcer.announce(`Removed ${email}`);
    }
  }

  editEmail(email, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove email if it no longer has a name
    if (!value) {
      this.removeEmail(email);
      return;
    }
    // Edit existing email
    const index = this.emails.indexOf(email);
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
        this.emails[index] = value;
      } else {
        this.helperService.presentToast("Enter valid email address", 2000);
      }
  }

  addEmailTarTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our Email
    if(value!= null && value != ''){
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
      this.emailsTarTo.push(value);
    } else {
      this.helperService.presentToast("Enter valid email address", 2000);
    }
  }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeEmailTarTo(email): void {
    const index = this.emailsTarTo.indexOf(email);
    if (index >= 0) {
      this.emailsTarTo.splice(index, 1);
      this.announcer.announce(`Removed ${email}`);
    }
  }

  editEmailTarTo(email, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove email if it no longer has a name
    if (!value) {
      this.removeEmailTarTo(email);
      return;
    }
    // Edit existing email
    const index = this.emailsTarTo.indexOf(email);
    if (index >= 0) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)|| /%[a-zA-Z0-9]/.test(value)) {
        this.emailsTarTo[index] = value;
      } else {
        this.helperService.presentToast("Enter valid email address", 2000);
      }

    }
  }
  addEmailTarCc(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our Email
    if(value!= null && value != ''){
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
      this.emailsTarCc.push(value);
    } else {
      this.helperService.presentToast("Enter valid email address", 2000);
    }
  }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeEmailTarCc(email): void {
    const index = this.emailsTarCc.indexOf(email);
    if (index >= 0) {
      this.emailsTarCc.splice(index, 1);
      this.announcer.announce(`Removed ${email}`);
    }
  }

  editEmailTarCc(email, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove email if it no longer has a name
    if (!value) {
      this.removeEmailTarCc(email);
      return;
    }
    // Edit existing email
    const index = this.emailsTarCc.indexOf(email);
    if (index >= 0) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
        this.emailsTarCc[index] = value;
      }  else {
        this.helperService.presentToast("Enter valid email address", 2000);
      }

    }
  }
  addEmailTarBcc(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our Email
    if(value!= null && value != ''){
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
      this.emailsTarBcc.push(value);
    } else {
      this.helperService.presentToast("Enter valid email address", 2000);
    }
  }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeEmailTarBcc(email): void {
    const index = this.emailsTarBcc.indexOf(email);
    if (index >= 0) {
      this.emailsTarBcc.splice(index, 1);
      this.announcer.announce(`Removed ${email}`);
    }
  }

  editEmailTarBcc(email, event: MatChipEditedEvent) {
    const value = event.value.trim();
    // Remove email if it no longer has a name
    if (!value) {
      this.removeEmailTarBcc(email);
      return;
    }
    // Edit existing email
    const index = this.emailsTarBcc.indexOf(email);
    if (index >= 0) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
        this.emailsTarBcc[index] = value;
      } else {
        this.helperService.presentToast("Enter valid email address", 2000);
      }

    }
  }


  addEmailOpsTo(event: MatChipInputEvent, i): void {
    const value = (event.value || '').trim();
    // Add our Email
    if(value!=null && value !=''){
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
        this.emailsOpsTo[i].push(value);
      } else {
        this.helperService.presentToast("Enter valid email address", 2000);
      }
    }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeEmailOpsTo(email, i): void {
    const index = this.emailsOpsTo[i].indexOf(email);
    if (index >= 0) {
      this.emailsOpsTo[i].splice(index, 1);
      this.announcer.announce(`Removed ${email}`);
    }
  }

  editEmailOpsTo(email, event: MatChipEditedEvent, i) {
    const value = event.value.trim();
    // Remove email if it no longer has a name
    if (!value) {
      this.removeEmailOpsTo(email, i);
      return;
    }
    // Edit existing email
    const index = this.emailsOpsTo[i].indexOf(email);
    if (index >= 0) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
        this.emailsOpsTo[i][index] = value;
      } else {
        this.helperService.presentToast("Enter valid email address", 2000);
      }

    }
  }

  addEmailOpsCc(event: MatChipInputEvent, i): void {
    const value = (event.value || '').trim();
    // Add our Email
    if(value!= null && value != ''){
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
      this.emailsOpsCc[i].push(value);
    } else {
      this.helperService.presentToast("Enter valid email address", 2000);
    }
  }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeEmailOpsCc(email, i): void {
    const index = this.emailsOpsCc[i].indexOf(email);
    if (index >= 0) {
      this.emailsOpsCc[i].splice(index, 1);
      this.announcer.announce(`Removed ${email}`);
    }
  }

  editEmailOpsCc(email, event: MatChipEditedEvent, i) {
    const value = event.value.trim();
    // Remove email if it no longer has a name
    if (!value) {
      this.removeEmailOpsCc(email, i);
      return;
    }
    // Edit existing email
    const index = this.emailsOpsCc[i].indexOf(email);
    if (index >= 0) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
        this.emailsOpsCc[i][index] = value;
      }else {
        this.helperService.presentToast("Enter valid email address", 2000);
      }

    }
  }
  addEmailOpsBcc(event: MatChipInputEvent, i): void {
    const value = (event.value || '').trim();
    // Add our Email
   if(value!=null && value !=''){
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
      this.emailsOpsBcc[i].push(value);
    } else {
      this.helperService.presentToast("Enter valid email address", 2000);
    }
  }
    // Clear the input value
    event.chipInput!.clear();
  }

  removeEmailOpsBcc(email, i): void {
    const index = this.emailsOpsBcc[i].indexOf(email);
    if (index >= 0) {
      this.emailsOpsBcc[i].splice(index, 1);
      this.announcer.announce(`Removed ${email}`);
    }
  }

  editEmailOpsBcc(email, event: MatChipEditedEvent, i) {
    const value = event.value.trim();
    // Remove email if it no longer has a name
    if (!value) {
      this.removeEmailOpsBcc(email, i);
      return;
    }
    // Edit existing email
    const index = this.emailsOpsBcc[i].indexOf(email);
    if (index >= 0) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || /%[a-zA-Z0-9]/.test(value)) {
        this.emailsOpsBcc[i][index] = value;
      } else {
        this.helperService.presentToast("Enter valid email address", 2000);
      }

    }
  }

  removeEmailOpsTos(i): void {
    this.emailsOpsTo.splice(i, 1);
    this.emailsOpsCc.splice(i, 1);
    this.emailsOpsBcc.splice(i, 1);
  }

  intervalChange(e) {
    if(e.key == 'e'){
      this.summary.controls["interval"].setValue('');
    }
    else if (e.target.value >= 1) {
      this.summary.controls["interval"].setValue(e.target.value);
    } else if(this.summary.controls["interval"].value!=null) {
      this.summary.controls["interval"].setValue(1);
    }
  }
  portEmailChange(evt): boolean {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    //console.log(charCode);
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  chunkSizeChange(e) {
    if (e.target.value >= 1) {
      this.dataSource.controls['chunks_size'].setValue(Number(e.target.value));
    } else {
      this.dataSource.controls['chunks_size'].setValue(1);
    }
  }
  dataChunkChange(i, e) {
    if (e.target.value >= 1) {
      (<UntypedFormGroup>this.datachunkingRows().at(i)).controls['token_size'].setValue(e.target.value);
    } else {
      (<UntypedFormGroup>this.datachunkingRows().at(i)).controls['token_size'].setValue(1000);
    }
  }
  onchangetimertype() {
    var val = this.summary.controls['timertype'].value;
    if (val) {
      this.timertypeval = "schedule";
      this.summary.controls['interval'].clearValidators();
      this.summary.controls['interval'].updateValueAndValidity();

    } else {
      this.timertypeval = "interval";
      this.summary.controls['schedule'].clearValidators();
      this.summary.controls['schedule'].updateValueAndValidity();
    }
  }

  toggleAdvancedSettings() {
    //console.log(this.showAdvancedSettings);
    this.showAdvancedSettings = !this.showAdvancedSettings;
  }

  async getDataSource() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.backendService.GetAPICall('getSource', res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  //Fetching Storage Name for JDBC Data operation
  async getStorageNameJDBCO() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.backendService.PostAPICall('getJDBCStorageNames', {}, res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  async getHeader_Keys() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.backendService.GetAPICall('getHeaderKeys', res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  //Fetching dlversion for JDBC Data operation
  async getDlVersionJDBCOApi(storage_name) {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        let payload = {
          "storage_name": storage_name
        }
        this.backendService.PostAPICall('getJDBCVersions', payload, res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  async getDataTarget() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.backendService.GetAPICall('getTarget', res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  async getSourceDlVersionDL() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.backendService.PostAPICall('getDLVersions', { op_type: 'source' }, res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  async getDlVersionDLO() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.backendService.PostAPICall('getDLVersions', { op_type: 'ingestion' }, res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  async getDlVersionDLS() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.backendService.PostAPICall('getDLVersions', { op_type: 'search' }, res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }

  async getSourceBusinessObject() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.backendService.GetAPICall('getTarget', res.token).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }


  onChangeBusinessObjectSource(e) {
    this.sourceCatalogueId = e.value.id;
    this.closebubblecross();
    this.closebusinessobjselect();
    // this.contentDiv = document.getElementById('contentDiv');
    // this.contentDiv.innerHTML = "";
    // this.closebubblecross();
    // this.endpoint_url = "";
    // this.dataSource.controls['bridge_source_endpoint_url'].setValue("");
    // this.source_auth = "";
    // this.source_authUser = "";
    // this.source_authPassword = "";
    // this.params_key = [];
    // this.params_value = [];
    // this.headers_key = [];
    // this.headers_value = [];
    // this.getSourcePostmanDetails(e.value.id);
    // this.closebusinessobjselect();
    // setTimeout(() => {
    //   this.onChangeSelectedEnvironment();
    // }, 500);
  }

  onChangeBusinessObjectTarget(e) {
    this.targetCatalogueId = e.value.id;
    this.closebubblecross();
    this.closebusinessobjtargetSelect();
    // //console.log(e);
    // this.contentDivTarget = document.getElementById('contentDivTarget');
    // this.closebubblecross();
    // this.contentDivTarget.innerHTML = "";
    // this.endpoint_target_url = "";
    // this.dataTarget.controls['bridge_target_endpoint_url'].setValue("");
    // this.target_auth = "";
    // this.target_authUser = "";
    // this.target_authPassword = "";
    // this.params_target_key = [];
    // this.params_target_value = [];
    // this.headers_target_key = [];
    // this.headers_target_value = [];
    // this.getTargetPostmanDetails(e.value.id);
    // this.closebusinessobjtargetSelect();
    // setTimeout(() => {
    //   this.onChangeTargetSelectedEnvironment()
    // }, 500);
  }

  onChangeBusinessObjectTargetRAO(e, index) {
    this.getTargetPostmanDetailsRAO(e.value.id, index);
    this.operationIndex = index;
    this.operationCatalogId = e.value.id;
  }

  onChangeStorageNameJDBCO(e, index) {
    this.getDlVersionJDBCO(e.value, index);
  }

  getDlVersionJDBCO(obj, index) {
    this.getDlVersionJDBCOApi(obj.storage_name).then(res => {
      let data: [] = res as [];
      //console.log(data);
      (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['db_version_list'].setValue(data);
      // if (loadFrom == 'fillNewRAO') {
      //   let bridge_target_business_object = data.filter(function (entry) { return entry.id == id; });
      //   (<FormGroup>this.restapiRows().at(index)).controls['bridge_target_business_object'].setValue(bridge_target_business_object[0]);
      // }
      // this.helperService.closeLoader();
    });
  }

  cancelPycodeApiSpinner() {
    this.operationPycodeApTestApi.unsubscribe();
    this.resetPycodeApiUIState();
  }

  resetPycodeApiUIState() {
    this.spinnerOperationPycodeApi = false;
    this.spinnerOperationPycodeApiShow = false;
  }

  checkTokenSessionBeforeTestPycodeApi(data, index) {
    this.spinnerOperationPycodeApi = true;
    this.spinnerOperationPycodeApiShow = true;
    this.type = 'pycode_operation';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForPycodeOperation = storage_data.pytokenPycodeOperation;
      if (storage_data.pytokenPycodeOperation == null) {
        this.generateToken('pycode_operation').then((res: string) => {
          this.pythonTokenForPycodeOperation = res;
          this.testPycodeApi(data, index);
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testPycodeApi(data, index);
          } else {
            this.generateToken('pycode_operation').then((res: string) => {
              this.pythonTokenForPycodeOperation = res;
              this.testPycodeApi(data, index);
            })
          }
        })
      }
    })
  }


  testPycodeApi(data, index) {
    this.spinnerOperationPycodeApi = true;
    // this.helperService.loader();
    // console.log(data)
    this.getStorage().then((res) => {
      data.pycode = this.helperService.isString(data.pycode)
      if (data.pycode.includes('\\t')) {
        data.pycode = data.pycode.replaceAll(/\\t/g, '\t').replaceAll(/\\\t/g, '\\t');
      }
      if (data.pycode.includes('\\r')) {
        data.pycode = data.pycode.replaceAll(/\\r/g, '\r').replaceAll(/\\\r/g, '\\r');
      }
      let payload = {
        "pycode": data.pycode
      }
      const api_endpoint = environment.python_api_base_url + '/pycode';
      this.operationPycodeApTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForPycodeOperation)
        .subscribe(
          data => {
            const pyResponseStatus  = data.bizdata_dataset.bizdata_dataset_status;
            const pyResponseOutput  = data.bizdata_dataset.bizdata_dataset_response;
            const pyFormGroup       = (<UntypedFormGroup>this.pycodeRows().at(index));
            pyFormGroup.controls['status'].patchValue(JSON.stringify(pyResponseStatus));
            if(pyResponseOutput?.['items']){
              pyFormGroup.controls['response'].patchValue(pyResponseOutput?.items? JSON.stringify(pyResponseOutput.items):'')
            }else{
              pyFormGroup.controls['response'].patchValue(JSON.stringify(pyResponseOutput['error_message']))
            }
            this.spinnerOperationPycodeApi = false;
            this.spinnerOperationPycodeApiShow == false;
            this.resetPycodeApiUIState();
          },
          error => {
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }

  checkTokenSessionBeforeTestAiOpsApi(data,index) {
    // if (this.ionContent) {
    //   this.ionContent.getScrollElement().then((scrollElement) => {
    //     const currentScroll = scrollElement.scrollTop;
    //     this.ionContent.scrollToPoint(0, currentScroll + 200, 30); // Scrolls down 100px smoothly
    //   });
    // }
    this.spinnerOperationPycodeApi = true;
    this.spinnerOperationPycodeApiShow = true;
    this.type = 'data_operation';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForDataOperation = storage_data.pytokenDataOperation;
      if (storage_data.pytokenDataOperation == null) {
        this.generateToken('data_operation','ai_ops').then((res: string) => {
          this.pythonTokenForDataOperation = res;
          this.testAiOpsApi(data,index);
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testAiOpsApi(data,index);
          } else {
            this.generateToken('data_operation','ai_ops').then((res: string) => {
              this.pythonTokenForDataOperation = res;
              this.testAiOpsApi(data,index);
            })
          }
        })
      }
    })
  }

  cancelaiopsApiSpinner(){
    this.isLoadings=false;
  }
  async generateContent(index:number) {
    // this.isGenerated=true;
    // this.isGenerating = true; 
    console.log(this.aiopsRows().controls[index].value);
    let templete_data=this.aiopsRows().controls[index].get('selectedTemplate').value;
    if(!templete_data){
      this.helperService.presentToast("Please select an Templete",2000);
      return
    }
    this.aiopsRows().controls[index].get('isgenerating').patchValue(true);
    let payload={
      "question":templete_data
    }
    console.log(this.pythonTokenForDataOperation);
    this.backendService.TestAiopsAPICall("https://bizdatapi-sb2.bizdata360.com/ai/generatejson", payload, this.pythonTokenForDataOperation).subscribe((response)=>{
      if(response != null){
        console.log(response.body);
      // console.log(response)
      this.aiopsRows().controls[index].patchValue({
        target_input_payload: typeof response.body.target_input_payload === "object"?JSON.stringify(response.body.target_input_payload,null,2):response.body.target_input_payload,
        target_data:typeof response.body.expected_target_data === "object"?JSON.stringify(response.body.expected_target_data,null,2):response.body.expected_target_data,
        question: response.body.question,
        dos: response.body.dos,
        donts: response.body.donts,
        isgenerating: false,
        isgenerated: true
      });
      }else{
        this.aiopsRows().controls[index].get("isgenerated").patchValue(true);
        this.aiopsRows().controls[index].get("isgenerating").patchValue(false);    
      }
      
    },
  error=>{
    console.log(error);
    // this.helperService.handleError(error);
    this.aiopsRows().controls[index].get("isgenerated").patchValue(true);
    this.aiopsRows().controls[index].get("isgenerating").patchValue(false);
  })
  }

  isSending_aiops: boolean = false;

  sendMessage(event: Event) {
    event.preventDefault(); // Prevent default form submission
    this.isSending_aiops = true;

    // Simulate API call delay
    setTimeout(() => {
      this.isSending_aiops = false;
    }, 2000);
  }
  // onInputChange(value: string){
  //   this.isTextEntered=value.trim().length > 0;
  //   console.log(this.isTextEntered);
  // }
  handleKeyDown(event: any) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // Prevent default form submission
      this.tstAiOps(event); // Call the function to send the message
    }
  }
  filterJsonData(jsonData: any): any {
    let filteredData: any = { ...jsonData };
    const keysToRemove = [
      "bizdata_dataset_status",
      "bizdata_dataset_response_time",
      "today",
      "yesterday",
      "bizdata_dataset_request_data",
      "bizdata_dataset_headers"
    ];

    keysToRemove.forEach(key => delete filteredData[key]);

    return filteredData;
  }

  isTextEntered: boolean = false;
  adjustTextareaHeight(event:any) {
    let text=event.target.value.trim();
    this.isTextEntered = text.length > 0;

    const textarea = this.chatInput.nativeElement;
    const container = this.chatInputContainer.nativeElement;
    if (textarea.value.trim() === '' && !(event.key === 'Enter' && event.shiftKey)) {
      console.log((event.key === 'Enter' && event.shiftKey));
      container.style.minHeight = '90px'; // Reset to minimum height
      textarea.style.height = '50px'; // Reset input height
      return;
    }else{
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`; 
      let newHeight = Math.max(90, Math.min(textarea.scrollHeight + 40, 220)); // Ensure min 90px, max 220px
      container.style.minHeight = `${newHeight}px`; 
    }

  }

  switchTab(index: number) {
    this.selectedIndex = index;
  }
  // onTemplateSelect(event,i): void {
  //   const selectedValue = event.value;
  //   let isgenerated_active=(this.aiopsRows().controls[i].get('isgenerated').value);
  //   this.selectedTemplates[i] = selectedValue;
  //     this.getStorage().then((res) => {
  //       let payload = {
  //         "type":"data_operation"
  //       }
  //       this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
  //         (data) => {
  //           console.log(data['data'][0].username);
  //           const payloads = new FormData();
  //           payloads.append('username', data['data'][0].username);
  //           payloads.append('password', data['data'][0].hashed_password);
  //           console.log(payload);
  //           this.backendService.PostExternalTokenAPICall("https://bizdatapi-sb2.bizdata360.com/ai/generate-api-key",payloads).subscribe(
  //             (data)=>{
  //               console.log(selectedValue);
  //             this.backendService.GetTempletes(`https://bizdatapi-sb2.bizdata360.com/ai/example_target_templates?name=${selectedValue}`,data.api_key).subscribe((response)=>{
  //               console.log(response);
  //               if(!isgenerated_active){
  //                 const input_data_tmp=response.template.question+" "+response.template.dos+" "+response.template.donts;
  //                 this.aiopsRows().controls[i].get('selectedTemplate').patchValue(input_data_tmp);
  //               }else{
  //                 this.aiopsRows().controls[i].patchValue({
  //                   target_input_payload: typeof response.template.target_input_payload === "object"?JSON.stringify(response.template.target_input_payload,null,2):response.template.target_input_payload,
  //                   target_data:typeof response.template.expected_target_data === "object"?JSON.stringify(response.template.expected_target_data,null,2):response.template.expected_target_data,
  //                   question: response.template.question,
  //                   dos: response.template.dos,
  //                   donts: response.template.donts,
  //                 });
  //               }
  //             },
  //             error=>{
  //              console.log(error)
  //           })
  //           },
  //           error=>{this.helperService.presentToast("AI Operation Authentication Failed",3000)}
  //           )
  //         },
  //         (error) => {
  //           this.helperService.presentToast("AI Operation Authentication Failed",3000)
  //         }
  //       );
  //     });

  // }

  // fetchTemplates(): void {
  //   this.getStorage().then((res) => {
  //     let payload = {
  //       "type":"data_operation"
  //     }
  //     this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
  //       (data) => {
  //         const payloads = new FormData();
  //         payloads.append('username', data['data'][0].username);
  //         payloads.append('password', data['data'][0].hashed_password);
  //         this.backendService.PostExternalTokenAPICall("https://bizdatapi-sb2.bizdata360.com/ai/generate-api-key",payloads).subscribe(
  //           (data)=>{
  //           this.backendService.GetTempletes("https://bizdatapi-sb2.bizdata360.com/ai/templatelist",data.api_key).subscribe((response)=>{
  //             this.templates=response.templates;
  //           },
  //           error=>{
  //            console.log(error)
  //         })
  //         },
  //         error=>{this.helperService.presentToast("AI Operation Authentication Failed",3000)}
  //         )
  //       },
  //       (error) => {
  //         this.helperService.presentToast("AI Operation Authentication Failed",3000)
  //       }
  //     );
  //   });

  // }

  isLoadings=false;

  removeTimestamp(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.removeTimestamp(item)); // Process arrays recursively
    } else if (typeof obj === 'object' && obj !== null) {
      let filteredObj: any = {};
      for (let key in obj) {
        if (key !== '@timestamp') {  // Remove the "@timestamp" key
          filteredObj[key] = this.removeTimestamp(obj[key]); 
        }
      }
      return filteredObj;
    }
    return obj;
  }



  formatJson(obj: any): SafeHtml {
    let filteredObj = this.removeTimestamp(obj); // Remove "@timestamp" keys

    let jsonString = JSON.stringify(filteredObj, null, 2);
    jsonString = jsonString
      .replace(/"([^"]+)":/g, '<span class="json-key">"$1"</span>:') // Green keys
      .replace(/: "(.*?)"/g, ': <span class="json-value-string">"$1"</span>') // Yellow strings
      .replace(/: (\d+)/g, ': <span class="json-value-number" >$1</span>'); // Blue numbers

    return this.sanitizer.bypassSecurityTrustHtml(`<pre style="text-align:start">${jsonString}</pre>`);
  }

  formatTimestamp(timestamp: string) {
    const date = new Date(timestamp);
    return date.toLocaleString();
  }

  copyItemToClipboard(item: any) {
    navigator.clipboard.writeText(JSON.stringify(item, null, 2));
  }
  copiedIndex: number | null = null;
  copyAiopsResponse(item:any,index){
    // navigator.clipboard.writeText(JSON.stringify(item, null, 2));
    const responseText = JSON.stringify(item, null, 2);
    this.clipboard.copy(responseText);

    // Set copiedIndex to show effect
    this.copiedIndex = index;

    // Reset copied effect after 1.5 seconds
    setTimeout(() => {
      this.copiedIndex = null;
    }, 1500);
  }

loading_aiops: boolean = false;
messages:any[] = [];
typedText: string = "";
///

async generateAIOpsConfig(id,ops?) {
  let i=0;
  let breakpoint=''
  this.newBlocks.map((row,index)=>{
    row.map((form,index2)=>{
      if(form.id==id){
        if(index%2 != 0 && index2 == 2){
          breakpoint='left';
        }
        if(index%2 == 0 && index2 == 2){
          breakpoint='right';
        }
        if(index%2 == 0 && (index2 == 0 || index2 == 1)){
          breakpoint='right';
        }
        if(index == 0 || (index%2 !=0 && index2!=2)){
          breakpoint=''
        }
        i=index;
      }
    })
    }
  )
  this.isConsole = true;
  this.filteredArray = [];
  this.finalBlocksTmp = [];
  var data = await this.transformOpsJson();
  var index = -1;
  var dataArray = Object.entries(data).map(([key, value]) => ({ [key]: value }));
  if (i % 2 == 0 && breakpoint == '') {
    index = index - 1;
  } else if (i % 2 == 0 && breakpoint == 'right') {
    index = index
  }
  var filteredObj = this.finalBlocks.find(function (item, i) {
    if (item.id === id) {
      index = i-1;
      return i;
    }
  });
  let finalBlocksTmp = this.finalBlocks.slice(0, index + 1)
  this.finalBlocksTmp = this.finalBlocks.slice(0, index + 1)

  let filteredArray = dataArray.slice(0, index + 1);
  this.resetPipeValidation().then(async (res) => {
    if (res) {
      await this.generateDataSource(finalBlocksTmp, filteredArray)
    }
  })
}

getMessageControls(index){
  let messageForm=this.aiopsRows().controls[index].get('messages') as UntypedFormArray
  return messageForm.controls
}

getai_ops_messages(index){
  let messageForm=this.aiopsRows().controls[index].get('messages') as UntypedFormArray
  return messageForm.controls;
}

  async get_ai_ops_source(index): Promise<any> {
    return new Promise((res) => {
      this.generateAIOpsConfig(this.selectedOperationId, 'ai-ops');
      this.ai_ops_source.subscribe((data: any) => {
        res(data);
      })
    })
  }

  testAiOpsApi(message, index) {
    if(this.aiopsRows().controls[index].value.isgenerating){
      return
    }
    this.operationResponse_err = {};
    let payload_ops = {
    }
    this.aiopsRows().controls[index].get('question').setValue(message.question);
    if (!message.question) {
      this.helperService.presentToast('Please provide a Transformation Data', 2000);
      this.isLoadings = false;
      return;
    }
    // message.question.value = "";
    this.isTextEntered = false;
    this.loading_aiops = true;
    let promt = message.question;
    this.getStorage().then((res) => {
      // const api_endpoint = environment.python_api_base_url + "/search?";
      let payload = {
        "type": "data_operation"
      }
      this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
        (data) => {
          const payloads = new FormData();
          payloads.append('username', data['data'][0].username);
          payloads.append('password', data['data'][0].hashed_password);
          this.backendService.PostExternalTokenAPICall(environment.python_api_base_url+"/ai/generate-api-key", payloads).subscribe(
            (data) => {
              this.get_ai_ops_source(index).then((res:any) => {
                this.getMessageControls(index).unshift(this._formBuilder.group({user:message.question.trim(), ai:'', loading_aiops:true}))
                this.aiopsRows().controls[index].get('isgenerating').setValue(true)
                try{
                  res=res.replace(/'/g, '"');
                  res=JSON.parse(res)
                  // this.aiopsRows().controls[index].get('source').setValue(res);
                }
                catch{}
                payload_ops['input_data'] = res;
                payload_ops['question'] = this.aiopsRows().controls[index].get('question').value;
                let messageIndex=this.getMessageControls(index).length-1;
                this.searchDatalakeTestApi = this.backendService.TestAiopsAPICall(environment.python_api_base_url+"/ai/transformops", payload_ops, data.api_key)
                  .subscribe(
                    data => {
                      this.bridgeResponse = data;
                      if (data != null) {
                          let response = this.bridgeResponse.body;
                          this.operationStatus[index] = data.statusCode;
                          this.operationResponseTime[index] = data.responseTime;
                          if(data.body.json_data) {
                            // this.aiopsRows().controls[index].get('messages').value[this.aiopsRows().controls[index].get('messages').value.length-1]['ai']=JSON.stringify(response.json_data, null, '\t');
                            // this.aiopsRows().controls[index].get('messages').value['loading_aiops']=false;
                            // this.restapiRows().controls[index].get('messages').value.append()
                            // this.aiopsRows().controls[index].get('source').setValue(data.body.json_data);
                            try{
                              response.json_data=response.json_data.replace(/'/g, '"');
                              response.json_data=JSON.parse(response.json_data);
                            }
                            catch{}
                            let res=''
                            for(let key of Object.keys(response.json_data)){
                              res+=JSON.stringify(response.json_data[key],null,2)
                              res+='\n'
                            }
                            res=res.replace(/\\"/g, '');
                            this.getMessageControls(index)[0].get('ai').patchValue(res)
                            this.getMessageControls(index)[0].get('loading_aiops').patchValue(false);
                            this.aiopsRows().controls[index].get('isgenerating').setValue(false);
                          }

                          if(data.body.message){
                            this.getMessageControls(index)[0].get('ai').patchValue(data.body.message)
                            this.getMessageControls(index)[0].get('loading_aiops').patchValue(false);
                            this.aiopsRows().controls[index].get('isgenerating').setValue(false);
                          }
                          // this.aiopsRows().controls[i].get('response').setValue(data.bizdata_dataset.bizdata_dataset_response);
                        else {
                          // this.aiopsRows().controls[i].get('response').setValue(data.bizdata_dataset_response);
                        }
                      } else {
                        // this.aiopsRows().controls[i].get('response').setValue(data);
                      }
                    },
                    error => {
                      console.log(error);
                      this.isLoadings = false;
                      this.helperService.closeLoader();
                      // this.helperService.presentToast(error.detail, 2000);
                      this.getMessageControls(index)[0].get('ai').patchValue(error.error.detail)
                      this.getMessageControls(index)[0].get('loading_aiops').patchValue(false)
                      this.aiopsRows().controls[index].get('isgenerating').setValue(false);
                    }
                  );
              })
            },
            error => {
              console.log(error)
            })
        }, error => {
          console.log(error);
        })

    });


  }


// messages:any[] = [];
// typedText: string = "";

isProcessing=false;
tstAiOps(event: Event) {
  event.preventDefault();
  const textarea = document.querySelector('.textarea-cls') as HTMLTextAreaElement;
  const message = textarea.value.trim();
  if (!message) return;
  this.isProcessing = true;

  this.messages.push({ user: message, ai: "", loading_aiops: true });
  textarea.value = "";
  this.isTextEntered=false;
  this.loading_aiops = true;
  setTimeout(() => {
    const index = this.messages.length - 1;
    this.messages[index].loading_aiops = false;

    // Get JSON response and start typewriter effect
    const jsonResponse = this.getSampleJsonResponse();
    // this.typewriterEffect(index, JSON.stringify(jsonResponse, null, 2));
    // this.isProcessing = false;
  }, 2000);
}

getSampleJsonResponse() {
  return {
      "id": 101,
      "username": "manoj_avula",
      "role": "frontend_developer",
      "lastLogin": "2025-03-08T09:45:00Z"
    }
}

typewriterEffect(index: number, text: string,j:number) {
  let i = 0;
  const interval = setInterval(() => {
    if (i < text.length) {
      this.messages[index][j].ai += this.formatJsonAiops(text[i]);
      i++;
    } else {
      clearInterval(interval);
      this.isProcessing=false;
    }
  }, 20); // Adjust speed here (20ms per character)
}

formatJsonAiops(char: string): string {
  if (char === '"') return '<span class="json-key" style:"color:red">"</span>';
  if (char.match(/[:]/)) return '<span class="json-symbol">:</span>';
  if (char.match(/[0-9]/)) return `<span class="json-number">${char}</span>`;
  if (char.match(/true|false|null/)) return `<span class="json-boolean">${char}</span>`;
  if (char.match(/[\{\}\[\]]/)) return `<span class="json-bracket">${char}</span>`;
  return char;
}
copiedIndexAiops: number | null = null;
copyToClipboardAiops(message,index) {
  this.copiedIndexAiops=index;
  setTimeout(()=>{
    this.copiedIndexAiops=null
  },1500);
  this.clipboard.copy(message);
}


fullLabel = "Operations Property - AI Operation";
typedLabel: string[] = [];
startTypewriterEffect() {
  let index = 0;
  const interval = setInterval(() => {
    if (index < this.fullLabel.length) {
      this.typedLabel.push(this.fullLabel[index]);
      index++;
    } else {
      clearInterval(interval);
    }
  }, 10); // Adjust speed here (100ms per character)
}

  





  onChangeDlVersionJDBCO(e, index) {
    this.getStorage().then((res) => {
      let payload = {
        "storage_name": this.jdbcoutputRows().at(index).value.storage_name.storage_name,
        "dbversion": e.value.dbversion
      }
      this.backendService.PostAPICall('getJDBCData', payload, res.token).subscribe(
        data => {
          (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['jdbc_string'].setValue(data.data.jdbc_string);
          (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['jar_file'].setValue(data.data.jar_file_name);
          (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['jdbc_driver'].setValue(data.data.jdbc_driver);
        })
    })
  }
  compareBusinessObjects(sbo1: any, sbo2: any): boolean {
    return sbo1 && sbo2 ? sbo1.business_obj === sbo2.business_obj : sbo1 === sbo2;
  }
  getSourceTargetBusinessObject(product_name, type):Promise<any> {
    return new Promise((resolve)=>{
    this.helperService.loader();
    let payload = { product_name };
    if (type == "source") payload['api_type'] = 1;
    if (type == "operations") payload['api_type'] = 2;
    if (type == "target") payload['api_type'] = 3;
    this.getStorage().then((res) => {
      this.backendService.PostAPICall('getBusinessObject', payload, res.token).subscribe(
        data => {
          if (type == "source") {
            resolve(data);
            this.bridgeSourceBusinessObjectList = data;
            this.helperService.closeLoader();
            this.bridgeSourceBusinessObject$ = this.dataSource.get('bridge_source_business_object')!.valueChanges.pipe(
              startWith(''),
              map(value => {
                const business_obj = typeof value === 'string' ? value : value?.business_obj;
                this.enableSourceBusinessObjectClearIcon = value ? true : false;
                return business_obj ? this._filterMapSourceBusinessObject(business_obj as string) : this.bridgeSourceBusinessObjectList.slice();
              })
            );
          } else if (type == "target") {
            resolve(data);
            this.bridgeTargetBusinessObjectList = data;
            this.helperService.closeLoader();
            this.bridgeTargetBusinessObject$ = this.dataTarget.get('bridge_target_business_object')!.valueChanges.pipe(
              startWith(''),
              map(value => {
                const business_obj = typeof value === 'string' ? value : value?.business_obj;
                this.enableTargetBusinessObjectClearIcon = value ? true : false;
                return business_obj ? this._filterMapTargetBusinessObject(business_obj as string) : this.bridgeTargetBusinessObjectList.slice();
              })
            )
          }
        }, error => {
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        })
    })
    })
  }

  getSourceTargetBusinessObjectRAO(product_name, type, index) {
    let payload = { product_name };
    if (type == "source") payload['api_type'] = 1;
    if (type == "target") payload['api_type'] = 3;
    this.getStorage().then(async (res) => {
      await this.helperService.loader();
      this.backendService.PostAPICall('getBusinessObject', payload, res.token).subscribe(
        data => {
          //console.log(data);
          (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridgeTargetBusinessObjectRAO'].setValue(data);
          this.helperService.closeLoader();
        })
    })
  }

  addOpParam() {
    this.operationParam.push(this.operationParam.length);
  }

  deleteParam(param: number) {
    this.operationParam.splice(param, 1);
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog"),
      pytokenDataSource: await this.storage.get("pytoken_data_source"),
      pytokenDataOperation: await this.storage.get("pytoken_data_operation"),
      pytokenEmailOperation: await this.storage.get("pytoken_email_operation"),
      pytokenPycodeOperation: await this.storage.get("pytoken_pycode_operation"),
      pytokenJdbcOperation: await this.storage.get("pytoken_jdbc_operation"),
      mileStoneTokenConsole: await this.storage.get("milestonetoken_console"),
      goldFinchGenerateAccessToken:await this.storage.get('goldFinchGenerateAccessToken'),
    }
    return data;
  }

  editorInit(editor) {
    // Here you can access editor instance
    this.editor = editor;
  }

  pycodeResponseeditorInit(editor) {
    // Here you can access editor instance
    this.editor = editor;
  }

  jdbcResponseeditorInit(editor) {
    // Here you can access editor instance
    this.editor = editor;
  }

  get bridgeSourceCatalogControls() { return this.dataSource.controls; }
  get bridgeSourceParams() { return this.bridgeSourceCatalogControls.bridge_source_endpoint_params_raw as UntypedFormArray; }
  get bridgeSourceHeaders() { return this.bridgeSourceCatalogControls.bridge_source_endpoint_headers as UntypedFormArray; }
  get sourceBusinessObjectControls() { return this.bridgeSourceCatalogControls.bridge_source_business_object as UntypedFormArray; }

  get bridgeTargetCatalogControls() { return this.dataTarget.controls; }
  get bridgeTargetParams() { return this.bridgeTargetCatalogControls.bridge_target_endpoint_params_raw as UntypedFormArray; }
  get bridgeTargetHeaders() { return this.bridgeTargetCatalogControls.bridge_target_endpoint_headers as UntypedFormArray; }
  get targetBusinessObjectControls() { return this.bridgeTargetCatalogControls.bridge_target_business_object as UntypedFormArray; }

  get bridgeSourceWsParams() { return this.bridgeSourceCatalogControls.bridge_source_ws_endpoint_params_raw as UntypedFormArray; }
  get bridgeSourceWsHeaders() { return this.bridgeSourceCatalogControls.bridge_source_ws_endpoint_headers as UntypedFormArray; }

  bridgeTargetParamsRAO(empIndex: number): UntypedFormArray {
    return this.restapiRows().at(empIndex).get('bridge_target_endpoint_params_raw') as UntypedFormArray;
  }

  bridgeTargetHeadersRAO(empIndex: number): UntypedFormArray {
    return this.restapiRows().at(empIndex).get('bridge_target_endpoint_headers') as UntypedFormArray;
  }

  docunderstandingOperationRow(empIndex: number): UntypedFormArray {
    return this.docunderstandingRows().at(empIndex).get('questions') as UntypedFormArray;
  }

  imgunderstandingOperationRow(empIndex: number): UntypedFormArray {
    return this.imgunderstandingRows().at(empIndex).get('questions') as UntypedFormArray;
  }


  addSourceValueParams(data: any): UntypedFormGroup {
    data = { paramKey: '', paramValue: '', paramDescription: '', ...data }
    return this._formBuilder.group({
      bridge_source_paramKey: data.key,
      bridge_source_paramValue: data.value,
      bridge_source_paramDescription: data.description
    })
  }

  addSourceValueHeaders(data: any): UntypedFormGroup {
    data = { headerKey: '', headerValue: '', headerDescription: '', ...data }
    return this._formBuilder.group({
      bridge_source_headerKey: data.key,
      bridge_source_headerValue: data.value,
      bridge_source_headerDescription: data.description
    })
  }

  addTargetValueParams(data: any): UntypedFormGroup {
    data = { paramKey: '', paramValue: '', paramDescription: '', ...data }
    return this._formBuilder.group({
      bridge_target_paramKey: data.key,
      bridge_target_paramValue: data.value,
      bridge_target_paramDescription: data.description
    })
  }

  addRestAPiOperationValueParams(data: any): UntypedFormGroup {
    data = { paramKey: '', paramValue: '', paramDescription: '', ...data }
    return this._formBuilder.group({
      bridge_target_paramKey: data.key,
      bridge_target_paramValue: data.value,
      bridge_target_paramDescription: data.description
    })
  }

  addRestAPiOperationValueHeaders(data: any): UntypedFormGroup {
    data = { headerKey: '', headerValue: '', headerDescription: '', ...data }
    return this._formBuilder.group({
      // bridge_target_headerKey: {"header_key": data.key},
      // bridge_target_headerValue: {"header_value": data.value},
      bridge_target_headerKey: data.key,
      bridge_target_headerValue: data.value,
      bridge_target_headerDescription: data.description
    })
  }

  addTargetValueHeaders(data: any): UntypedFormGroup {
    data = { headerKey: '', headerValue: '', headerDescription: '', ...data }
    return this._formBuilder.group({
      bridge_target_headerKey: data.key,
      bridge_target_headerValue: data.value,
      bridge_target_headerDescription: data.description
    })
  }

  addSourceParams(index) {
    this.bridgeSourceParams.push(
      this._formBuilder.group({
        'bridge_source_paramKey': [''],
        'bridge_source_paramValue': [''],
        'bridge_source_paramDescription': ['']
      })
    );
  }

  removeSourceParams(index) {
    if (this.bridgeSourceParams.value.length > 1) {
      this.bridgeSourceParams.removeAt(index);
      this.params_key.splice(index, 1);
      this.params_value.splice(index, 1);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }

  addSourceWsParams(index) {
    this.bridgeSourceWsParams.push(
      this._formBuilder.group({
        'bridge_source_ws_paramKey': [''],
        'bridge_source_ws_paramValue': [''],
        'bridge_source_ws_paramDescription': ['']
      })
    );
  }

  removeSourceWsParams(index) {
    if (this.bridgeSourceWsParams.value.length > 1) {
      this.bridgeSourceWsParams.removeAt(index);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }

  sourceHeaderKeysController(): UntypedFormArray {
    return this.dataSource.get("bridge_source_endpoint_headers") as UntypedFormArray
  }

  addSourceHeaders(index) {
    const controls = this.sourceHeaderKeysController().controls;
    this.bridgeSourceHeaders.push(
      this._formBuilder.group({
        'bridge_source_headerKey': [''],
        'bridge_source_headerValue': [''],
        'bridge_source_headerDescription': ['']
      })
    );
    this.getSourceHeaderKeys(controls.length - 1);
    this.getSourceHeaderValue(controls.length - 1);
  }

  removeSourceheader(index) {
    if (this.bridgeSourceHeaders.value.length > 1) {
      this.bridgeSourceHeaders.removeAt(index);
      this.headers_key.splice(index, 1);
      this.headers_value.splice(index, 1);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in headers", 2000);
    }
  }

  addSourceWsHeaders(index) {
    this.bridgeSourceWsHeaders.push(
      this._formBuilder.group({
        'bridge_source_ws_headerKey': [''],
        'bridge_source_ws_headerValue': [''],
        'bridge_source_ws_headerDescription': ['']
      })
    );
  }

  removeSourceWsheader(index) {
    if (this.bridgeSourceWsHeaders.value.length > 1) {
      this.bridgeSourceWsHeaders.removeAt(index);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in headers", 2000);
    }
  }

  // bridgeSourceEnvironments(): UntypedFormArray {
  //   return this.environmentSourceForm.get('bridge_source_endpoint_environments_raw') as UntypedFormArray;
  // }

  // envSourceData(index: number): UntypedFormArray {
  //   return this.bridgeSourceEnvironments().at(index).get('env_vars') as UntypedFormArray;
  // }

  // openSourceEnvironment() {
  //   const dialogRef = this._dialog.open(EnvironmentListPage, {
  //     data: { name: '' }
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.env_name = result.data.environment_name;
  //       this.addSourceTab(this.env_name);
  //       this.indexSelection = 5;
  //     }
  //   });
  // }

  // addSourceTab(tabName: string): void {
  //   this.sourceTabs.push(tabName);
  //   const envTabArray = this._formBuilder.array([this.newEnvironmentsSourceTab()]);
  //   const bridgeSourceEnvironmentsArray = this.environmentSourceForm.get('bridge_source_endpoint_environments_raw') as UntypedFormArray;
  //   bridgeSourceEnvironmentsArray.push(
  //     this._formBuilder.group({
  //       env_name: tabName,
  //       env_vars: envTabArray,
  //     })
  //   );
  // }

  // confirmSourceDelete(tabName) {
  //   const header = 'Confirm!';
  //   const msg = 'Are you sure you want to delete environment?';
  //   this.confirmSourceDeleteAlert(header, msg, tabName);
  // }

  // async confirmSourceDeleteAlert(header, msg, tabName) {
  //   const alert = await this.alertController.create({
  //     header: header,
  //     message: msg,
  //     buttons: [
  //       {
  //         text: 'CANCEL',
  //         cssClass: 'primary-text',
  //         handler: () => {
  //           alert.dismiss();
  //         },
  //       },
  //       {
  //         text: 'OK',
  //         cssClass: 'primary-text',
  //         handler: () => {
  //           this.deleteSourceEnv(tabName);
  //         },
  //       },
  //     ],
  //   });
  //   await alert.present();
  // }

  // deleteSourceEnv(tabName) {
  //   const tabIndex = this.sourceTabs.indexOf(tabName);
  //   if (tabIndex !== -1) {
  //     const currentValue = this.dataSource.get('bridge_source_endpoint_selected_environments_name').value;
  //     if (currentValue === tabName) {
  //       this.dataSource.patchValue({
  //         bridge_source_endpoint_selected_environments_name: ''
  //       });
  //     }
  //     this.sourceTabs.splice(tabIndex, 1);
  //     this.bridgeSourceEnvironments().removeAt(tabIndex);
  //   }
  // }

  // addSourceValueEnvironments(data: any): UntypedFormGroup {
  //   data = { environmentVariable: '', environmentType: '', environmentValue: '', ...data }
  //   return this._formBuilder.group({
  //     variable: data.variable,
  //     type: data.type,
  //     value: data.value,
  //     valueType: ['']
  //   });
  // }

  // newEnvironmentsSourceTab(): UntypedFormGroup {
  //   return this._formBuilder.group({
  //     variable: '',
  //     type: 'text',
  //     value: '',
  //     valueType: ['text']
  //   });
  // }

  // toggleSourcePassword(index: number, envIndex: number) {
  //   let valueTypeControl = this.envSourceData(index).at(envIndex).get('valueType');
  //   if (valueTypeControl.value === 'password') {
  //     valueTypeControl.setValue('text');
  //   } else {
  //     valueTypeControl.setValue('password');
  //   }
  // }

  // envSourceChangeType(e, i, index) {
  //   let valueTypeControl = this.envSourceData(index).at(i).get('valueType');
  //   if (e.value == 'password') {
  //     valueTypeControl.setValue('password');
  //   } else {
  //     valueTypeControl.setValue('text')
  //   }
  // }

  // addSourceEnvironmentsTab(index: number) {
  //   this.envSourceData(index).push(this.newEnvironmentsSourceTab());
  // }

  // // removeSourceEnvironmentsTab(index: number, envIndex: number): void {
  // //   const envTabArray = this.bridgeSourceEnvironments().at(index).get('env_vars') as UntypedFormArray;
  // //   envTabArray.removeAt(envIndex);
  // // }

  // removeSourceEnvironmentsTab(index: number, envIndex: number): void {
  //   const envTabArray = this.bridgeSourceEnvironments().at(index).get('env_vars') as UntypedFormArray;
  //   if (envTabArray.length > 1) {
  //     envTabArray.removeAt(envIndex);
  //   } else {
  //     this.helperService.presentToast("Not allowed to delete single row in environment variables ", 2000);
  //   }
  // }

  bridgeTargetEnvironments(): UntypedFormArray {
    return this.environmentTargetForm.get('bridge_endpoint_environments_raw') as UntypedFormArray;
  }

  envTargetData(index: number): UntypedFormArray {
    return this.bridgeTargetEnvironments().at(index).get('env_vars') as UntypedFormArray;
  }

  openTargetEnvironment(showEnvironmentTab: boolean) {
    this.addTargetTab();
    this.selectedTargetTabIndex = this.bridgeTargetEnvironments().value.length - 1;
    this.currentTargetDisplayedEnvIndex = this.selectedTargetTabIndex; // Update the displayed index
    this.showTargetEnvironmentTab = showEnvironmentTab;
    this.environmentTargetForm.patchValue({
      selected_environment: 'No Environment',
      bridge_endpoint_selected_environments_name: 'No Environment'
    })
  }


  addTargetTab(tabName?) {
    const envTabArray = this._formBuilder.array([this.newEnvironmentsTargetTab()]);
    const bridgeTargetEnvironmentsArray = this.environmentTargetForm.get('bridge_endpoint_environments_raw') as UntypedFormArray;
    const noCurlyBracesPattern = /^(?!.*[{}]).+$/;
  
    const newGroup = this._formBuilder.group({
      env_name: ['', [
        Validators.required,
        Validators.pattern(noCurlyBracesPattern)
      ]],
      env_vars: envTabArray,
    });
  
    const envNameControl = newGroup.get('env_name');

    envNameControl.statusChanges.subscribe(status => {
      if (status === 'INVALID' && envNameControl.dirty) {
        envNameControl.markAsTouched();
      }
    });
  
    bridgeTargetEnvironmentsArray.push(newGroup);
  }
  confirmTargetDelete(tabName, index) {
    const header = 'Confirm!';
    const msg = 'Are you sure you want to delete environment?';
    this.confirmTargetDeleteAlert(header, msg, tabName, index);
  }

  async confirmTargetDeleteAlert(header, msg, tabName, index) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteTargetEnv(tabName, index);
          },
        },
      ],
    });
    await alert.present();
  }

  deleteTargetEnv(tabName, index) {
    this.selectedTargetEnvTabs.splice(index, 1);
    this.bridgeTargetEnvironments().removeAt(index);
    this.currentTargetDisplayedEnvIndex = -1;
    this.environmentTargetForm.patchValue({
      selected_environment: 'No Environment',
      bridge_endpoint_selected_environments_name: 'No Environment'
    })
  }

  toggleTargetPassword(index: number, envIndex: number) {
    let valueTypeControl = this.envTargetData(index).at(envIndex).get('valueType');
    if (valueTypeControl.value === 'password') {
      valueTypeControl.setValue('text');
    } else {
      valueTypeControl.setValue('password');
    }
  }

  envTargetChangeType(e, i, index) {
    let valueTypeControl = this.envTargetData(index).at(i).get('valueType');
    if (e.value == 'password') {
      valueTypeControl.setValue('password');
    } else {
      valueTypeControl.setValue('text')
    }
  }

  addTargetEnvironmentsTab(index: number) {
    this.envTargetData(index).push(this.newEnvironmentsTargetTab());
  }

  removeTargetEnvironmentsTab(index: number, envIndex: number): void {
    const envTabArray = this.bridgeTargetEnvironments().at(index).get('env_vars') as UntypedFormArray;
    if (envTabArray.length > 1) {
      envTabArray.removeAt(envIndex);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in environment variables ", 2000);
    }
  }


  getTokenExpirationDate(token): Date {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    if (decoded.exp === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  async checkInvalidToken() {
    try {
      let token: string;
      if (this.type == 'data_source' && this.consoleType != "console_data") {
        token = await this.storage.get("pytoken_data_source");
        token = await this.storage.get("milestonetoken_console");
      } else if (this.type == 'data_operation') {
        token = await this.storage.get("pytoken_data_operation");
      } else if (this.type == 'email_operation') {
        token = await this.storage.get("pytoken_email_operation");
      } else if (this.type == 'pycode_operation') {
        token = await this.storage.get("pytoken_pycode_operation");
      } else if (this.type == 'jdbc_operation') {
        token = await this.storage.get("pytoken_jdbc_operation");
      } else if (this.consoleType == "console_data" && this.type == "data_source") {
        token = await this.storage.get("milestonetoken_console")
      }
      const date = this.getTokenExpirationDate(token);
      if (date === undefined) {
        return false;
      }
      return !(date.valueOf() > new Date().valueOf());
    } catch (error) {
      return true;
    }
  }

  checkToken() {
    return new Promise((resolve) => {
      this.checkInvalidToken().then(invalid => {
        if (!invalid) {
          resolve(true);
        }
        else {
          resolve(false);
        }
      })
    })
  }

  generateToken(type, ai_ops?) {
    this.type = type;
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        let payload = {
          type
        }
        this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
          (data) => {
            console.log(data);
            this.hass_pass = data['data'][0].hashed_password;
            if(ai_ops != undefined){
              this.getGenerateAPIKey(type, data['data'][0].username, data['data'][0].hashed_password).then((py_token) => {
                // let obj = { type, py_token }
                console.log(py_token);
                resolve(py_token);
              })
            }else{
              this.getGenerateToken(type, data['data'][0].username, data['data'][0].hashed_password).then((py_token) => {
                // let obj = { type, py_token }
                resolve(py_token);
              })
            }
            
          },
          (error) => {
            //console.log(error);
          }
        );
      });
    });
  }

  getGenerateToken(type, userName, password) {
    //console.log("getGenerateToken", this.consoleType)
    const payload = new FormData();
    payload.append('username', userName);
    payload.append('password', password);
    let python_base_url = environment.python_api_base_url + '/token';
    return new Promise((resolve) => {
      this.backendService.PostExternalTokenAPICall(python_base_url, payload).subscribe(
        (data) => {
          if (this.consoleType == "" && type == 'data_source') {
            //** USED FOR testSourceApi(), testSourceWsApi() */
            this.pythonTokenForDataSource = data.access_token;
            this.storage.set("pytoken_data_source", data.access_token);
          } else if (type == 'data_operation') {
            //** USED FOR testTargetApi(), testTargetRAO() */
            this.pythonTokenForDataOperation = data.access_token;
            this.storage.set("pytoken_data_operation", data.access_token);
          } else if (type == 'email_operation') {
            //** USED FOR testEmailApi(), testEmailApiDT() */
            this.pythonTokenForEmailOperation = data.access_token;
            this.storage.set("pytoken_email_operation", data.access_token);
          } else if (type == 'pycode_operation') {
            //** USED FOR testPycodeApi() */
            this.pythonTokenForPycodeOperation = data.access_token;
            this.storage.set("pytoken_pycode_operation", data.access_token);
          } else if (type == 'jdbc_operation') {
            //** USED FOR testJdbc(), testDataSourceJdbc(), testDataTargetJdbc(), testDataLakeSource() */
            this.pythonTokenForJdbcOperation = data.access_token;
            this.storage.set("pytoken_jdbc_operation", data.access_token);
          } else if (this.consoleType == "console_data" && type == 'data_source') {
            //** USED FOR milestoneapi */
            //console.log("Milestone Type" + data.access_token)
            this.consoleDataTokenForMilestoneAPI = data.access_token;
            this.storage.set("milestonetoken_console", data.access_token);
          }
          resolve(data.access_token);
        },
        (error) => {
          //console.log(error);
        });
    });
  }
  getGenerateAPIKey(type, userName, password) {
    const payload = new FormData();
    payload.append('username', userName);
    payload.append('password', password);
    let python_base_url = environment.python_api_base_url+"/ai/generate-api-key";
    return new Promise((resolve) => {
      this.backendService.PostExternalTokenAPICall(python_base_url, payload).subscribe(
        (data) => {
          // this.pythonTokenForDataOperation = data.access_token;
          this.pythonTokenForDataOperation = data.api_key;
          console.log(this.pythonTokenForDataOperation);
          this.storage.set("pytoken_data_operation", data.api_key);
          resolve(data.api_key);
        })
      })
  }
  onSourceEnvironmentChange(event: any) {
    // this.selectedSourceEnvironment = event.value;
    const selectedSourceEnvironment = event.value;
    this.selectedSourceTabIndex = this.sourceTabs.indexOf(selectedSourceEnvironment);
  }

  cancelSourceSpinner() {
    if (this.sourceTestApi) {
      this.sourceTestApi.unsubscribe();
    }
    this.resetSourceUIState();
  }

  resetSourceUIState() {
    this.spinnerSource = false;
    this.spinnerSourceShow = false;
  }


  checkTokenSessionBeforeTestSourceApi() {
    if(this.dataSource.controls.bridge_source_endpoint_authentication_type.value.id==4){
       if(this.dataSource.get('bridge_source_authentication_username').value==''||this.dataSource.get('bridge_source_authentication_password').value ==''){
        this.helperService.presentToast('DataSource form is incomplete',2000);
        let elem = document.getElementById('contentDevSourceAuthUser');
        if(this.dataSource.get('bridge_source_authentication_username').invalid){
         elem.setAttribute('class','userError')
       }
       let elem1 = document.getElementById('contentDevSourceAuthPassword');
       if(this.dataSource.get('bridge_source_authentication_password').invalid){
         elem1.setAttribute('class','passError')
       }
        return
      }
    }
    if(this.dataSource.controls.bridge_source_endpoint_authentication_type.value.id==6){
      if(this.dataSource.get('bridge_source_oauth_refresh_token_endpoint_method').value==''||this.dataSource.get('bridge_source_oauth_refresh_token_endpoint_url').value ==''){
        this.helperService.presentToast('DataSource form is incomplete',2000);
        this.dataSource.markAllAsTouched();
        let url=document.getElementById('contentDivSourceAuth');
        if(this.dataSource.get('bridge_source_oauth_refresh_token_endpoint_url').invalid){
        url.classList.add('passError');
      }
        return
      }
    }
    this.spinnerSource = true;
    this.spinnerSourceShow = true;
    this.isTesting = !this.isTesting;
    this.type = 'data_source';
    // this.helperService.loader();
    this.getStorage().then( (storage_data) => {
      this.pythonTokenForDataSource = storage_data.pytokenDataSource;
      if (storage_data.pytokenDataSource == null) {
        this.generateToken('data_source').then(async (res: any) => {
          this.pythonTokenForDataSource = res;
          await this.testSourceApi();
        })
      } else {
        this.checkToken().then(async (res: Boolean) => {
          if (res) {
            await this.testSourceApi();
          } else {
            this.generateToken('data_source').then(async (res: any) => {
              this.pythonTokenForDataSource = res;
              await this.testSourceApi();

            })
          }
        })
      }
    })
  }

  async testSourceApi() {
    this.spinnerSource = true;
    //console.log(this.pythonTokenForDataSource);
    this.closebubblecross();
    this.dataSource.controls['bridge_source_response'].reset();
    if (this.dataSource.value.bridge_source_endpoint_body_raw != '' && this.dataSource.value.bridge_source_endpoint_body_raw != undefined && JSON.stringify(this.dataSource.value.bridge_source_endpoint_body_raw) !== '{}') {
      if (this.dataSource.value.bridge_source_body_type == 'JSON') {
        if (this.helperService.isValidJSON(this.dataSource.value.bridge_source_endpoint_body_raw) == false) {
          this.helperService.presentToast('Please provide valid JSON Data', 2000);
          // this.helperService.closeLoader();
          return
        }
      }
      if (this.dataSource.value.bridge_source_body_type == 'XML') {
        if (this.helperService.isValidXML(this.dataSource.value.bridge_source_endpoint_body_raw) == false) {
          this.helperService.presentToast('Please provide valid XML Data', 2000);
          // this.helperService.closeLoader();
          return
        }
      }
    }

    let method = this.dataSource.value.bridge_source_endpoint_method.method;
    let auth_type = this.dataSource.value.bridge_source_endpoint_authentication_type.type;
    if (this.dataSource.value.bridge_source_body_type == 'JSON') {
      this.dataSource.value.bridge_source_endpoint_body_raw = (this.dataSource.value.bridge_source_endpoint_body_raw) ? this.helperService.isJsonString(this.dataSource.value.bridge_source_endpoint_body_raw) : {}
    } else {
      this.dataSource.value.bridge_source_endpoint_body_raw = (this.dataSource.value.bridge_source_endpoint_body_raw) ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_endpoint_body_raw) : ""
    }
    if (this.endpoint_url != "") {
      let eurl = this.endpoint_url.replace(/<[^>]*>/g, '');
      this.dataSource.controls['bridge_source_endpoint_url'].setValue(eurl);
    }
    if (this.params_key.length > 0) {
      let params = this.dataSource.value.bridge_source_endpoint_params_raw;
      if (params != undefined) {
        for (let i = 0; i < params.length; i++) {
          params[i].bridge_source_paramKey = this.params_key[i];
          params[i].bridge_source_paramValue = this.params_value[i];
          this.addSourceValueParams(params[i]);
        }
      }
    }
    if (this.headers_key.length > 0) {
      let headers = this.dataSource.value.bridge_source_endpoint_headers;
      if (headers != undefined) {
        for (let i = 0; i < headers.length; i++) {
          headers[i].bridge_source_headerKey = this.headers_key[i];
          headers[i].bridge_source_headerValue = this.headers_value[i];
          this.addSourceValueHeaders(headers[i]);
        }
      }
    }
    let params = this.dataSource.value.bridge_source_endpoint_params_raw;
    let headers = this.dataSource.value.bridge_source_endpoint_headers;
    let headersArr = [];
    let paramsArr = [];
    // let endpoint_url;
    let paramsClone = _.cloneDeep(this.dataSource.value.bridge_source_endpoint_params_raw);
    let headersClone = _.cloneDeep(this.dataSource.value.bridge_source_endpoint_headers);
    let bridge_source_endpoint_url = this.dataSource.value.bridge_source_endpoint_url;
    let bridge_source_endpoint_body_raw = this.dataSource.value.bridge_source_endpoint_body_raw;
    let pre_request_script = this.dataSource.value.pre_request_script
    let typeof_bridge_source_endpoint_body_raw = typeof this.dataSource.value.bridge_source_endpoint_body_raw;
    let bridge_source_endpoint_body_raw_tmp = JSON.stringify(this.dataSource.value.bridge_source_endpoint_body_raw);

    if (this.environmentForm.value.bridge_endpoint_environments_raw.length > 0) {
      for (let item of this.environmentForm.value.bridge_endpoint_environments_raw) {
        if (item.env_name == this.environmentForm.value.selected_environment) {
          for (let subItem of item.env_vars) {
            for (let object of paramsClone) {
              if (object.bridge_source_paramKey.includes(subItem.variable)) {
                object.bridge_source_paramKey = object.bridge_source_paramKey.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (object.bridge_source_paramValue.includes(subItem.variable)) {
                object.bridge_source_paramValue = object.bridge_source_paramValue.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
            for (let object of headersClone) {
              if (object.bridge_source_headerKey.includes(subItem.variable)) {
                object.bridge_source_headerKey = object.bridge_source_headerKey.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (object.bridge_source_headerValue.includes(subItem.variable)) {
                object.bridge_source_headerValue = object.bridge_source_headerValue.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }

            if (bridge_source_endpoint_url.includes(subItem.variable)) {
              bridge_source_endpoint_url = bridge_source_endpoint_url.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
            }

            if (typeof_bridge_source_endpoint_body_raw == 'object') {
              if (bridge_source_endpoint_body_raw_tmp.includes("{{" + subItem.variable + "}}")) {
                bridge_source_endpoint_body_raw_tmp = bridge_source_endpoint_body_raw_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                // refresh_token_body_tmp = refresh_token_body_tmp.replaceAll( "{{"+subItem.bridge_source_environmentVariable+"}}", subItem.bridge_source_environmentValue);
                bridge_source_endpoint_body_raw = JSON.parse(bridge_source_endpoint_body_raw_tmp);
              }
            } else {
              if (bridge_source_endpoint_body_raw.includes("{{" + subItem.variable + "}}")) {
                bridge_source_endpoint_body_raw = bridge_source_endpoint_body_raw.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }

            if (pre_request_script.includes(subItem.variable)) {
              pre_request_script = pre_request_script.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
            }
          }
        }
      }
    }

    if (paramsClone) {
      for (let object of paramsClone) {
        let paramsObj = new Object();
        if (object.bridge_source_paramKey) {
          paramsObj = {
            [object.bridge_source_paramKey]: object.bridge_source_paramValue
          }
          paramsArr.push(paramsObj);
        }
      }
    }

    if (headersClone) {
      for (let object of headersClone) {
        let headersObj = new Object();
        if (object.bridge_source_headerKey) {
          headersObj = {
            [object.bridge_source_headerKey]: object.bridge_source_headerValue
          }
          headersArr.push(headersObj);
        }
      }
    }

    let selectedEnvironment = '';
    if (this.environmentForm.value.selected_environment != 'No Environment') {
      selectedEnvironment = this.environmentForm.value.selected_environment;
    }

    // let regexNewLine = /\\n/g;
    // let pre_request_script = this.dataSource.value.pre_request_script.replace(regexNewLine, "\\\n");
    if (this.selectPaginationType == 8) {
      this.dataSource.value.custom_pagination_script = this.helperService.isString(this.dataSource.value.custom_pagination_script)
      if (this.dataSource.value.custom_pagination_script.includes('\\t')) {
        this.dataSource.value.custom_pagination_script = this.dataSource.value.custom_pagination_script.replaceAll(/\\t/g, '\t').replaceAll(/\\\t/g, '\\t');
      }
      if (this.dataSource.value.custom_pagination_script.includes('\\r')) {
        this.dataSource.value.custom_pagination_script = this.dataSource.value.custom_pagination_script.replaceAll(/\\r/g, '\r').replaceAll(/\\\r/g, '\\r');
      }
    }


    let payload = {
      "min_num": this.dataSource.value.min_number ? this.dataSource.value.min_number : 0,
      "max_num": this.dataSource.value.max_number ? this.dataSource.value.max_number : 1000,
      "authentication_type": "no_auth",
      'endpoint_url': bridge_source_endpoint_url,
      'endpoint_headers': this.arrayToObject(headersArr),
      'endpoint_method': method.toLowerCase(),
      'body_type': this.dataSource.value.bridge_source_body_type,
      'endpoint_body': bridge_source_endpoint_body_raw,
      'endpoint_params': this.arrayToObject(paramsArr),
      "pre_request_script": (pre_request_script) ? await this.helperService.encrypt(this.helperService.isString(pre_request_script)) : '',
      "response_parameters": "['items']",
      "another_response_parameter": "",
      "pagination_style": "no_pagination",
      "key_name_to_update": "offset",
      "user_key": "hasMore",
      "user_key_url": "Link",
      "response_type": this.dataSource.value.response_type,
      "custom_pagination_script": this.dataSource.value.custom_pagination_script ? this.dataSource.value.custom_pagination_script : "",
      // "timer_type":"schedule",
      // "interval_in_seconds":10,
      // "schedule":"*/1 * * * *",
      "username": "",
      "password": "",
      "refresh_token_body": "",
      "refresh_token_headers": "",
      "refresh_token_method": "",
      "refresh_token_params": "",
      "refresh_token_url": "",
      "target": "bizdata_dataset",
      "today_str": `datetime.now().strftime('${this.dataSource.value.today_str}')`,
      "yesterday_str": `(datetime.now() - timedelta(1)).strftime('${this.dataSource.value.yesterday_str}')`,
      "rolling_time_format": this.dataSource.value.rolling_time_format,
      "rolling_frequency": this.dataSource.value.rolling_frequency,
      "offset_value": this.dataSource.value.offset_value,
      "source_selected_environment_name": selectedEnvironment,
      "source_environment_variables": this.environmentForm.value.bridge_endpoint_environments_raw ? this.environmentForm.value.bridge_endpoint_environments_raw : [],
    }

    if (this.dataSource.value.bridge_source_endpoint_authentication_type.id == '4') {
      payload['authentication_type'] = 'basic_auth';
      let bridge_source_authentication_username = this.dataSource.value.bridge_source_authentication_username;
      let bridge_source_authentication_password = this.dataSource.value.bridge_source_authentication_password;
      if (this.environmentForm.value.bridge_endpoint_environments_raw.length > 0) {
        for (let item of this.environmentForm.value.bridge_endpoint_environments_raw) {
          if (item.env_name == this.environmentForm.value.selected_environment) {
            for (let subItem of item.env_vars) {
              if (bridge_source_authentication_username.includes("{{" + subItem.variable + "}}")) {
                bridge_source_authentication_username = bridge_source_authentication_username.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (bridge_source_authentication_password.includes("{{" + subItem.variable + "}}")) {
                bridge_source_authentication_password = bridge_source_authentication_password.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
          }
        }
      }
      payload['username'] = bridge_source_authentication_username;
      payload['password'] = await this.helperService.encrypt(bridge_source_authentication_password);
    }
    if (this.source_auth != "") {
      this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_url'].setValue(this.source_auth);
    }
    let refresh_token_endpoint_url = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_url) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_url : "";
    // let refresh_token_headers = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header : "";
    // let refresh_token_params = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params : "";
    // let refresh_token_body = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body : "";
    // let refresh_token_headers = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) : "";
    // let refresh_token_params = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) : "";
    // let refresh_token_body = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) : "";

    let refresh_token_body;
    if (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body != '' && this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body != undefined) {
      if (this.helperService.isValidJSON(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body)) {
        refresh_token_body = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body ? this.helperService.isJsonString(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) : {};
      } else {
        refresh_token_body = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body ?this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) : "";
      }      
    } else {
      refresh_token_body = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) : "";
    }
    //console.log(refresh_token_body);

    let refresh_token_headers;
    if (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header != '' && this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header != undefined) {
      if (this.helperService.isValidJSON(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header)) {
        refresh_token_headers = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header ? this.helperService.isJsonString(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) : {};
      } else {
        refresh_token_headers = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) : "";
      }
    } else {
      refresh_token_headers = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) : "";
    }

    let refresh_token_params;
    if (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params != '' && this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params != undefined) {
      if (this.helperService.isValidJSON(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params)) {
        refresh_token_params = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params ? this.helperService.isJsonString(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) : {};
      } else {
        refresh_token_params = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) : "";
      }
    } else {
      refresh_token_params = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) : "";
    }

    if (this.dataSource.value.bridge_source_endpoint_authentication_type.id == '6') {
      let refresh_token_endpoint_method = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_method.method;
      payload['authentication_type'] = 'oauth2.0';
      // payload['refresh_token_body'] = this.helperService.isJsonString(refresh_token_body);
      // if (refresh_token_headers) {
      //   payload['refresh_token_headers'] = this.helperService.isJsonString(refresh_token_headers);
      // } else {
      //   payload['refresh_token_headers'] = "";
      // }
      // if (refresh_token_params) {
      //   payload['refresh_token_params'] = this.helperService.isJsonString(refresh_token_params);
      // } else {
      //   payload['refresh_token_params'] = "";
      // }
      // //console.log(JSON.stringify({"username":"{{base_url}}","password":"{{base_url}}"}))

      if (this.environmentForm.value.bridge_endpoint_environments_raw.length > 0) {
        for (let item of this.environmentForm.value.bridge_endpoint_environments_raw) {
          if (item.env_name == this.environmentForm.value.selected_environment) {
            for (let subItem of item.env_vars) {
              let typeof_refresh_token_body = typeof refresh_token_body;
              let typeof_refresh_token_headers = typeof refresh_token_headers;
              let typeof_refresh_token_params = typeof refresh_token_params;

              if (typeof_refresh_token_body == 'object') {
                let refresh_token_body_tmp;
                refresh_token_body_tmp = JSON.stringify(refresh_token_body);
                if (refresh_token_body_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_body_tmp = refresh_token_body_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  // refresh_token_body_tmp = refresh_token_body_tmp.replaceAll( "{{"+subItem.bridge_source_environmentVariable+"}}", subItem.bridge_source_environmentValue);
                  refresh_token_body = JSON.parse(refresh_token_body_tmp);
                }
              } else {
                let refresh_token_body_tmp;
                refresh_token_body_tmp = refresh_token_body;
                if (refresh_token_body_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_body_tmp = refresh_token_body_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_body = refresh_token_body_tmp;
                }
              }
              if (typeof_refresh_token_headers == 'object') {
                let refresh_token_headers_tmp;
                refresh_token_headers_tmp = JSON.stringify(refresh_token_headers);
                if (refresh_token_headers_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_headers_tmp = refresh_token_headers_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_headers = JSON.parse(refresh_token_headers_tmp);
                }
              } else {
                let refresh_token_headers_tmp;
                refresh_token_headers_tmp = refresh_token_headers;
                if (refresh_token_headers_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_headers_tmp = refresh_token_headers_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_headers = refresh_token_headers_tmp;
                }
              }

              if (typeof_refresh_token_params == 'object') {
                let refresh_token_params_tmp;
                refresh_token_params_tmp = JSON.stringify(refresh_token_params);
                if (refresh_token_params_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_params_tmp = refresh_token_params_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_params = JSON.parse(refresh_token_params_tmp);
                }
              } else {
                let refresh_token_params_tmp;
                refresh_token_params_tmp = refresh_token_params;
                if (refresh_token_params_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_params_tmp = refresh_token_params_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_params = refresh_token_params_tmp;
                }
              }

              if (refresh_token_endpoint_url.includes(subItem.variable)) {
                refresh_token_endpoint_url = refresh_token_endpoint_url.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
          }
        }
      }
      payload['refresh_token_body'] = refresh_token_body?await this.helperService.encrypt(JSON.stringify(refresh_token_body)):"";
      payload['refresh_token_headers'] = refresh_token_headers;
      payload['refresh_token_params'] = refresh_token_params;
      payload['refresh_token_method'] = refresh_token_endpoint_method ? refresh_token_endpoint_method.toLowerCase() : "";
      payload['refresh_token_url'] = refresh_token_endpoint_url?await this.helperService.encrypt(refresh_token_endpoint_url):"";
    }
    // const variables = this.environmentSourceForm.get('bridge_source_endpoint_environments_raw').value;
    // Object.keys(payload).forEach(key => {
    //   let val = payload[key];
    //   if (val.includes("{{") && val.includes("}}")) {
    //     for (const v of variables) {
    //       if (val.includes(v.variables)) {
    //         val = val.replace(new RegExp(`{{${v.variables}}}`, "g"), v.value);
    //       }
    //     }
    //     payload[key] = val;
    //   }
    // });    

    // const variables = [];
    // Object.keys(payload).forEach(key => {
    //   let val = payload[key];
    //   if(val.includes("{{") && val.includes("}}")) {
    //     for(const v of variables) {
    //       if(val.includes(v.variables)) {
    //         val = val.replace(v.variables, v.value);
    //       }
    //     }
    //     payload[key] = val;
    //   }
    // });

    // this.helperService.loader();

    const api_endpoint = environment.python_api_base_url + this.helperService.sourceAPI;
    this.sourceTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForDataSource)
      .pipe(
        timeout(180000),
        catchError((err) => {
          if (err.name === 'TimeoutError') {
            this.spinnerSource = false;
            this.spinnerSourceShow = false;
            this.resetSourceUIState();
            this.helperService.presentToast("Request timed out. Please try again later.", 1000);
          } else if (err.status === 401) {
            this.storage.set('pytoken_data_source', null);
            this.checkTokenSessionBeforeTestSourceApi();
          } else {
            this.spinnerSource = false;
            this.spinnerSourceShow = false;
            this.resetSourceUIState();
            this.helperService.presentToast("An error occurred. Please try again later.", 1000);
          }
          return throwError(() => err);
        })
      )
      .subscribe(
        res => {
          this.bridgeSourceResponse = res;
          if (res?.items) {
            let data = res.items[0];
            let bridgeSourceResponseMapping: object[] = [];
            for (const key in data) {
              bridgeSourceResponseMapping.push({ "source_column": key, "source_value": data[key], "selected": false });
            }
            this.bridgeSourceResponseMapping = bridgeSourceResponseMapping;
            // //console.log("bridgeSourceResponseMapping", this.bridgeSourceResponseMapping);
          }

          if (res.bizdata_dataset) {
            this.dataSource.controls['bridge_source_response'].setValue(res.bizdata_dataset.bizdata_dataset_response);
            for (let i = 0; i < this.bridgeSourceResponseMapping.length; i++) {
              this.bridgeSourceResponseMapping[i]['type'] = typeof (this.bridgeSourceResponseMapping[i].source_value);
            }
            // //console.log(this.bridgeSourceResponseMapping);
            this.isMappingActive = true;
           
            for (let item of this.items.source) {
              item.subItems = []
            }
            this.items.source=[
              {
                name: 'Request Header',
                subItems: []
              }, {
                name: 'Request Params',
                subItems: []
              }, {
                name: 'Request Body',
                subItems: []
              }, {
                name: 'Pre Request Script',
                subItems: []
              },
              {
                requestMethod: '',
                requestUrl: ''
              }];
            if (res.bizdata_dataset.hasOwnProperty('bizdata_dataset_request_data')) {
              this.loadPostmanPreviewComponent(res.bizdata_dataset.bizdata_dataset_request_data,'source')
              this.copyPreviewDataSource = res.bizdata_dataset.bizdata_dataset_request_data;
            }
            this.spinnerSource = false;
            this.spinnerSourceShow = false;
            this.resetSourceUIState();
            // this.helperService.closeLoader();
          } else if (res.error_message == "'access_token'") {
            this.spinnerSource = false;
            this.spinnerSourceShow = false;
            this.resetSourceUIState();
            // this.helperService.closeLoader();
            this.helperService.presentAlert("Access Denied!", "Your oauth2.0 details are invalid");
          } else {
            this.spinnerSource = false;
            this.spinnerSourceShow = false;
            this.resetSourceUIState();
            // this.helperService.closeLoader();
            this.helperService.presentToast(res.error_message, 3000);
          }
        }
      )
      this.closetesturl();
  }

  checkTokenSessionBeforeTestSourceWsApi() {
    this.type = 'data_source';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForDataSource = storage_data.pytokenDataSource;
      if (storage_data.pytokenDataSource == null) {
        this.generateToken('data_source').then((res: string) => {
          this.pythonTokenForDataSource = res;
          this.testSourceWsApi();
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.generateToken('data_source').then((data: string) => {
              // this.pythonTokenForDataSource = res;
              this.testSourceWsApi();
            })
          } else {
            this.generateToken('data_source').then((res: string) => {
              this.pythonTokenForDataSource = res;
              this.testSourceWsApi();
            })
          }
        })
      }
    })
  }

  testSourceWsApi() {
    this.dataSource.controls['bridge_source_response'].reset();
    if (this.dataSource.value.bridge_source_ws_endpoint_url == '' || this.dataSource.value.bridge_source_ws_endpoint_url == undefined) {
      this.helperService.presentToast('Please provide valid request url', 2000);
      return
    };
    // this.helperService.loader();
    this.getStorage().then((res) => {
      // //console.log(this.dataSource.value);
      let params = this.dataSource.value.bridge_source_ws_endpoint_params_raw;
      let headers = this.dataSource.value.bridge_source_ws_endpoint_headers;
      let object = params.reduce((obj, item) => Object.assign(obj, {
        [item.bridge_source_ws_paramKey]: item.bridge_source_ws_paramValue
      }), {});
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          var value = object[key];
          if (value === null || value === undefined || value === '') {
            delete object[key];
          }
        }
      }
      let objectHeader = headers.reduce((obj, item) => Object.assign(obj, {
        [item.bridge_source_ws_headerKey]: item.bridge_source_ws_headerValue
      }), {});
      for (var key in objectHeader) {
        if (objectHeader.hasOwnProperty(key)) {
          var value = objectHeader[key];
          if (value === null || value === undefined || value === '') {
            delete objectHeader[key];
          }
        }
      }
      objectHeader["endpoint-url"] = this.dataSource.value.bridge_source_ws_endpoint_url;
      //console.log(objectHeader);
      if (Object.keys(object).length == 0) {
        object = ""
      }
      if (Object.keys(objectHeader).length == 0) {
        objectHeader = ""
      }
      try{
        this.dataSource.value.bridge_source_ws_message=JSON.parse(this.dataSource.value.bridge_source_ws_message)
      }
      catch(err){
      }
      let payload = {
        "headers": objectHeader,
        "message": this.dataSource.value.bridge_source_ws_message,
        "params": object,
        "url": this.dataSource.value.bridge_source_ws_endpoint_url,

      };
      this.webSocketService.initializeWebSocket("open", payload, object);
      this.wsconnectSpinner = true;
      //   const api_endpoint = environment.python_api_base_url + '/websocket/source';
      //   this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForDataSource)
      //     .subscribe(
      //       data => {
      //         this.bridgeSourceResponse = data;
      //         if (data.bizdata_dataset) {
      //           this.dataSource.controls['bridge_source_response'].setValue(data.bizdata_dataset.bizdata_dataset_response);
      //         } else {
      //           this.dataSource.controls['bridge_source_response'].setValue(JSON.parse(data.bizdata_dataset_response));
      //         }

      //         this.helperService.closeLoader();
      //       },
      //       error => {
      //         this.helperService.closeLoader();
      //         this.helperService.presentToast(error.error, 2000);
      //       })
    })
  }
  disconnectTestSourceWsApi() {
    this.wsconnect = false;
    this.wsconnectSpinner = false;
    this.wsresponse = [];
    this.webSocketService.initializeWebSocket("close");
  }
  arrayToObject(arr) {
    return Object.assign({}, ...arr);
  }

  checkAndRemoveBearerTokenSourceControl() {
    const is_authentication_token = this.dataSource.contains('bridge_source_authentication_token');
    if (is_authentication_token) this.dataSource.removeControl('bridge_source_authentication_token');
  }

  checkAndRemoveBasicTokenSourceControl() {
    const is_authentication_username = this.dataSource.contains('bridge_source_authentication_username');
    const is_authentication_password = this.dataSource.contains('bridge_source_authentication_password');
    if (is_authentication_username) this.dataSource.removeControl('bridge_source_authentication_username');
    if (is_authentication_password) this.dataSource.removeControl('bridge_source_authentication_password');
  }

  checkAndRefreshTokenSourceControl() {
    const is_refresh_token_endpoint_url = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_url');
    const is_refresh_token_endpoint_method = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_method');
    const is_refresh_token_endpoint_header = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_header');
    const is_refresh_token_endpoint_params = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_params');
    const is_refresh_token_endpoint_body = this.dataSource.contains('bridge_source_oauth_refresh_token_endpoint_body');
    if (is_refresh_token_endpoint_url) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_url');
    if (is_refresh_token_endpoint_method) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_method');
    if (is_refresh_token_endpoint_header) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_header');
    if (is_refresh_token_endpoint_params) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_params');
    if (is_refresh_token_endpoint_body) this.dataSource.removeControl('bridge_source_oauth_refresh_token_endpoint_body');
  }

  onChangeSourceAuthenticationtype(event) {
    let changedValue = event.value.id;
    this.selectSourceType = changedValue;
    this.source_auth = "";
    this.source_authUser = "";
    this.source_authPassword = "";
    if (changedValue == 3) {
      this.dataSource.addControl('bridge_source_authentication_token', new UntypedFormControl("", [Validators.required]));
      this.checkAndRemoveBasicTokenSourceControl();
      this.checkAndRefreshTokenSourceControl();
    } else if (changedValue == 4) {
      this.username = true;
      this.password = true;
      this.dataSource.addControl('bridge_source_authentication_username', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('bridge_source_authentication_password', new UntypedFormControl("", [Validators.required]));
      this.checkAndRemoveBearerTokenSourceControl();
      this.checkAndRefreshTokenSourceControl();
      setTimeout(() => {
      let dsuser = document.getElementById('contentDevSourceAuthUser');
      dsuser.setAttribute("style", "-webkit-text-security:none");  
      let dspass = document.getElementById('contentDevSourceAuthPassword');
      dspass.setAttribute("style", "-webkit-text-security:none");  
      }, 100);
    } else if (changedValue == 6) {
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
      this.dataSource.addControl('bridge_source_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
      let default_refresh_token_endpoint_header = { "Content-Type": "application/x-www-form-urlencoded" };
      this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_header'].setValue(JSON.stringify(default_refresh_token_endpoint_header));
      this.checkAndRemoveBearerTokenSourceControl();
      this.checkAndRemoveBasicTokenSourceControl();
    }
  }

  SourceBodyTypeChange(event) {
    // let changedValue = event.value;
    // if (changedValue == 'JSON') {
    //   if (this.body_source_raw_json != '' && this.body_source_raw_json != undefined) {
    //     this.dataSource.patchValue({
    //       bridge_source_endpoint_body_raw: this.body_source_raw_json
    //     })
    //   } else {
    //     this.dataSource.patchValue({
    //       bridge_source_endpoint_body_raw: ''
    //     })
    //   }
    // } else {
    //   if (this.body_source_raw_xml != '' && this.body_source_raw_xml != undefined) {
    //     this.dataSource.patchValue({
    //       bridge_source_endpoint_body_raw: this.body_source_raw_xml
    //     })
    //   } else {
    //     this.dataSource.patchValue({
    //       bridge_source_endpoint_body_raw: ''
    //     })
    //   }
    // }
  }

  onChangeSourcePaginationtype(event) {
    let changedValue = event.value.id;
    this.selectPaginationType = changedValue
    this.dataSource.patchValue({
      pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds,
      user_key_2: '',
      response_parameters_2: '',
      another_response_parameter_2: '',
      user_key_3: '',
      key_name_to_update_3: '',
      response_parameters_3: '',
      user_key_4: '',
      key_name_to_update_4: '',
      response_parameters_4: '',
      user_key_5: '',
      key_name_to_update_5: '',
      response_parameters_5: '',
      user_key_6: '',
      user_key_url_6: '',
      response_parameters_6: '',
      user_key_7: '',
      response_parameters_7: '',
      custom_pagination_script: ''
    })
    if (changedValue == 2) {
      this.dataSource.patchValue({
        user_key_2: this.user_key_2,
        response_parameters_2: this.response_parameters_2,
        another_response_parameter_2: this.another_response_parameter_2,
        pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
      })
    } else if (changedValue == 3) {
      this.dataSource.patchValue({
        user_key_3: this.user_key_3,
        key_name_to_update_3: this.key_name_to_update_3,
        response_parameters_3: this.response_parameters_3,
        pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
      })
    } else if (changedValue == 4) {
      this.dataSource.patchValue({
        user_key_4: this.user_key_4,
        key_name_to_update_4: this.key_name_to_update_4,
        response_parameters_4: this.response_parameters_4,
        pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
      })
    } else if (changedValue == 5) {
      this.dataSource.patchValue({
        user_key_5: this.user_key_5,
        key_name_to_update_5: this.key_name_to_update_5,
        response_parameters_5: this.response_parameters_5,
        pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
      })
    } else if (changedValue == 6) {
      this.dataSource.patchValue({
        user_key_6: this.user_key_6,
        user_key_url_6: this.user_key_url_6,
        response_parameters_6: this.response_parameters_6,
        pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
      })
    } else if (changedValue == 7) {
      this.dataSource.patchValue({
        user_key_7: this.user_key_7,
        response_parameters_7: this.response_parameters_7,
        pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
      })
    } else if (changedValue == 8) {
      this.dataSource.patchValue({
        custom_pagination_script: this.custom_pagination_script,
        pagination_retry_seconds: this.dataSource.value.pagination_retry_seconds
      })
    }
  }

  addTargetParams(index) {
    this.bridgeTargetParams.push(
      this._formBuilder.group({
        'bridge_target_paramKey': [''],
        'bridge_target_paramValue': [''],
        'bridge_target_paramDescription': ['']
      })
    );
  }

  restApi1Form(): UntypedFormGroup {
    return this._formBuilder.group({
      'bridge_target_paramKey': [''],
      'bridge_target_paramValue': [''],
      'bridge_target_paramDescription': ['']
    })
  }

  addTargetParamsRAO(pipeIndex?) {
    this.bridgeTargetParamsRAO(pipeIndex).push(this.restApi1Form())
  }

  removeTargetParams(index) {
    if (this.bridgeTargetParams.value.length > 1) {
      this.bridgeTargetParams.removeAt(index);
      this.params_target_key.splice(index, 1);
      this.params_target_value.splice(index, 1);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }

  removeTargetParamsRAO(index, subIndex) {
    let formarr = this.restapiRows().at(index).get('bridge_target_endpoint_params_raw') as UntypedFormArray
    if (formarr.value.length > 1) {
      this.bridgeTargetParamsRAO(index).removeAt(subIndex);
      this.params_ops_raw[index].splice(subIndex, 1);
      this.params_ops_key[index].splice(subIndex, 1);
      this.params_ops_value[index].splice(subIndex, 1);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }


  addDocunderstandingQuestionForm(): UntypedFormGroup {
    return this._formBuilder.group({
      'docunderstanding_question': [''],
      'docunderstanding_attribute': [''],
    })
  }

  addImgunderstandingQuestionForm(): UntypedFormGroup {
    return this._formBuilder.group({
      'imgunderstanding_question': [''],
      'imgunderstanding_attribute': [''],
    })
  }

  addDocunderstandingQuestion(pipeIndex?) {
    this.docunderstandingOperationRow(pipeIndex).push(this.addDocunderstandingQuestionForm())
  }

  addImgunderstandingQuestion(pipeIndex?) {
    this.imgunderstandingOperationRow(pipeIndex).push(this.addImgunderstandingQuestionForm())
  }

  removeDocunderstandingQuestion(index, subIndex) {
    let formarr = this.docunderstandingRows().at(index).get('questions') as UntypedFormArray
    if (formarr.value.length > 1) {
      this.docunderstandingOperationRow(index).removeAt(subIndex);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }

  removeImgunderstandingQuestion(index, subIndex) {
    let formarr = this.imgunderstandingRows().at(index).get('questions') as UntypedFormArray
    if (formarr.value.length > 1) {
      this.imgunderstandingOperationRow(index).removeAt(subIndex);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }

  targetHeaderKeysController(): UntypedFormArray {
    return this.dataTarget.get("bridge_target_endpoint_headers") as UntypedFormArray
  }

  addTargetHeaders(index) {
    const controls = this.targetHeaderKeysController().controls;
    this.bridgeTargetHeaders.push(
      this._formBuilder.group({
        'bridge_target_headerKey': [''],
        'bridge_target_headerValue': [''],
        'bridge_target_headerDescription': ['']
      })
    );
    this.getTargetHeaderKeys(controls.length - 1);
    this.getTargetHeaderValue(controls.length - 1);
  }

  restApitargetHeadersForm(): UntypedFormGroup {
    return this._formBuilder.group({
      'bridge_target_headerKey': [''],
      'bridge_target_headerValue': [''],
      'bridge_target_headerDescription': ['']
    })
  }

  addTargetHeadersRAO(pipeIndex?) {
    this.bridgeTargetHeadersRAO(pipeIndex).push(this.restApitargetHeadersForm())
    const controls = this.bridgeTargetHeadersRAO(pipeIndex).controls;
    this.getAPIOperationHeaderKeys(pipeIndex, controls.length - 1);
    this.getAPIOperationHeaderValue(pipeIndex, controls.length - 1);
  }

  removeTargetHeader(index) {
    if (this.bridgeTargetHeaders.value.length > 1) {
      this.bridgeTargetHeaders.removeAt(index);
      this.headers_target_key.splice(index, 1);
      this.headers_target_value.splice(index, 1);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in headers", 2000);
    }
  }

  removeTargetHeaderRestApi(index, subIndex) {
    let formarr = this.restapiRows().at(index).get('bridge_target_endpoint_headers') as UntypedFormArray
    if (formarr.value.length > 1) {
      this.bridgeTargetHeadersRAO(index).removeAt(subIndex);
      this.headers_ops_raw[index].splice(subIndex, 1);
      this.headers_ops_key[index].splice(subIndex, 1);
      this.headers_ops_value[index].splice(subIndex, 1);
    } else {
      this.helperService.presentToast("Not allowed to delete single row in params", 2000);
    }
  }


  clearDataSource() {
    // let bridge_source_endpoint_method_value = this.dataSource.get('bridge_source_endpoint_method').value;
    // let bridge_source_endpoint_authentication_type_value = this.dataSource.get('bridge_source_endpoint_authentication_type').value;
    // let bridge_source_pagination_type_value = this.dataSource.get('bridge_source_pagination_type').value;
    // this.dataSource.reset();
    this.dataSource.controls['bridge_source'].setValue("");
    this.dataSource.controls['bridge_source_business_object'].setValue("");
    this.sourceCatalogueId = "";
    this.resetSourcePostman();
    // this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_source_endpoint_method_value);
    // this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(bridge_source_endpoint_authentication_type_value);
    // this.dataSource.controls['bridge_source_pagination_type'].setValue(bridge_source_pagination_type_value);
  }

  clearDataTarget() {
    // let bridge_target_endpoint_method_value = this.dataTarget.get('bridge_target_endpoint_method').value;
    // let bridge_target_endpoint_authentication_type_value = this.dataTarget.get('bridge_target_endpoint_authentication_type').value;
    // this.dataTarget.reset();
    this.dataTarget.controls['bridge_target'].setValue("");
    this.dataTarget.controls['bridge_target_business_object'].setValue("");
    this.targetCatalogueId = "";
    this.resetTargetPostman()
    // this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_target_endpoint_method_value);
    // this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(bridge_target_endpoint_authentication_type_value);
  }

  clearSourceBusinessObject() {
    // let bridge_source_value = this.dataSource.get('bridge_source').value;
    // let bridge_source_endpoint_method_value = this.dataSource.get('bridge_source_endpoint_method').value;
    // let bridge_source_endpoint_authentication_type_value = this.dataSource.get('bridge_source_endpoint_authentication_type').value;
    // let bridge_source_pagination_type_value = this.dataSource.get('bridge_source_pagination_type').value;
    // this.dataSource.reset();
    this.dataSource.controls['bridge_source_business_object'].reset();
    this.sourceCatalogueId = "";
    // this.dataSource.controls['bridge_source'].setValue(bridge_source_value);
    // this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_source_endpoint_method_value);
    // this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(bridge_source_endpoint_authentication_type_value);
    // this.dataSource.controls['bridge_source_pagination_type'].setValue(bridge_source_pagination_type_value);
  }

  clearTargetBusinessObject() {
    // let bridge_target_value = this.dataTarget.get('bridge_target').value;
    // let bridge_target_endpoint_method_value = this.dataTarget.get('bridge_target_endpoint_method').value;
    // let bridge_target_endpoint_authentication_type_value = this.dataTarget.get('bridge_target_endpoint_authentication_type').value;
    // this.dataTarget.reset();
    this.dataTarget.controls['bridge_target_business_object'].reset();
    this.targetCatalogueId = "";
    // this.dataTarget.controls['bridge_target'].setValue(bridge_target_value);
    // this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_target_endpoint_method_value);
    // this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(bridge_target_endpoint_authentication_type_value);
  }

  clearTargetBusinessObjectRAO(index){
    this.enableTargetRAOBusinessObjectClearIcon=false;
    this.restapiRows().controls[index].get('bridge_target_business_object').reset();
    this.opsData[index]={"input_structure_json":{"input":{"bizdata_rest":{"endpoint_url":"","endpoint_method":{"id":1,"method":"GET"},"endpoint_headers":[],"endpoint_params":[],"authentication_type":{"id":1,"type":"No Auth"},"username":"","password":"","refresh_token_url":"","refresh_token_headers":{},"refresh_token_params":{},"refresh_token_method":"","refresh_token_body":"","body_type":"TEXT","endpoint_body":" ","pre_request_script":"","response_type":"","selected_environment":"","environment_variables":[]}}}};
  }

  clearRAODataTarget(i) {
    this.restapiRows().at(i).patchValue({
      bridge_target: '',
      bridge_target_business_object:''
    });
    this.opsData[i]={"input_structure_json":{"input":{"bizdata_rest":{"endpoint_url":"","endpoint_method":{"id":1,"method":"GET"},"endpoint_headers":[],"endpoint_params":[],"authentication_type":{"id":1,"type":"No Auth"},"username":"","password":"","refresh_token_url":"","refresh_token_headers":{},"refresh_token_params":{},"refresh_token_method":"","refresh_token_body":"","body_type":"TEXT","endpoint_body":" ","pre_request_script":"","response_type":"","selected_environment":"","environment_variables":[]}}}};
  }

  // bridgeTargetEnvironmentsRAO(): UntypedFormArray {
  //   return this.environmentTargetForm.get('bridge_target_endpoint_environments_raw') as UntypedFormArray;
  // }

  // envTargetDataRAO(index: number): UntypedFormArray {
  //   return this.bridgeTargetEnvironmentsRAO().at(index).get('env_vars') as UntypedFormArray;
  // }

  // openTargetEnvironmentRAO() {
  //   const dialogRef = this._dialog.open(EnvironmentListPage, {
  //     data: { name: '' }
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.env_name = result.data.environment_name;
  //       this.addTargetTab(this.env_name);
  //     }
  //   });
  // }

  // addTargetTabRAO(tabName: string): void {
  //   this.targetTabs.push(tabName);
  //   const envTabArray = this._formBuilder.array([this.newEnvironmentsTargetTabRAO()]);
  //   const bridgeTargetEnvironmentsArray = this.environmentTargetForm.get('bridge_target_endpoint_environments_raw') as UntypedFormArray;
  //   bridgeTargetEnvironmentsArray.push(
  //     this._formBuilder.group({
  //       env_name: tabName,
  //       env_vars: envTabArray,
  //     })
  //   );
  // }

  // confirmTargetDeleteRAO(tabIndex) {
  //   const header = 'Confirm!';
  //   const msg = 'Are you sure you want to delete environment?';
  //   this.confirmTargetDeleteAlertRAO(header, msg, tabIndex);
  // }

  // async confirmTargetDeleteAlertRAO(header, msg, tabIndex) {
  //   const alert = await this.alertController.create({
  //     header: header,
  //     message: msg,
  //     buttons: [
  //       {
  //         text: 'CANCEL',
  //         cssClass: 'primary-text',
  //         handler: () => {
  //           alert.dismiss();
  //         },
  //       },
  //       {
  //         text: 'OK',
  //         cssClass: 'primary-text',
  //         handler: () => {
  //           this.deleteTargetEnvRAO(tabIndex);
  //         },
  //       },
  //     ],
  //   });
  //   await alert.present();
  // }

  // deleteTargetEnvRAO(tabName) {
  //   this.targetTabs = this.targetTabs.filter(tab => tab !== tabName);
  //   let index = this.bridgeTargetEnvironments().value.findIndex(tab => tab.bridge_target_endpoint_selected_environments_name == tabName);
  //   this.bridgeTargetEnvironments().removeAt(index);
  //   this.dataTarget.patchValue({
  //     bridge_target_endpoint_selected_environments_name: ''
  //   })
  // }

  // addTargetValueEnvironmentsRAO(data: any): UntypedFormGroup {
  //   data = { environmentVariable: '', environmentType: '', environmentValue: '', ...data }
  //   return this._formBuilder.group({
  //     variable: data.variable,
  //     type: data.type,
  //     value: data.value,
  //     valueType: ['']
  //   });
  // }

  // newEnvironmentsTargetTabRAO(): UntypedFormGroup {
  //   return this._formBuilder.group({
  //     variable: '',
  //     type: 'text',
  //     value: '',
  //     valueType: ['']
  //   });
  // }

  // toggleTargetPasswordRAO(index: number, envIndex: number) {
  //   let valueTypeControl = this.envTargetData(index).at(envIndex).get('valueType');
  //   if (valueTypeControl.value === 'password') {
  //     valueTypeControl.setValue('text');
  //   } else {
  //     valueTypeControl.setValue('password');
  //   }
  // }

  // envTargetChangeTypeRAO(e, i, index) {
  //   let valueTypeControl = this.envTargetData(index).at(i).get('valueType');
  //   if (e.value == 'password') {
  //     valueTypeControl.setValue('password');
  //   } else {
  //     valueTypeControl.setValue('text')
  //   }
  // }

  // addTargetEnvironmentsTabRAO(index: number) {
  //   this.envTargetData(index).push(this.newEnvironmentsTargetTab());
  // }

  // removeTargetEnvironmentsTabRAO(index: number, envIndex: number): void {
  //   const envTabArray = this.bridgeTargetEnvironments().at(index).get('env_vars') as UntypedFormArray;
  //   envTabArray.removeAt(envIndex);
  // }

  // testTargetApi(){
  //   let params = this.dataTarget.value.bridge_target_endpoint_params_raw;
  //   let headers = this.dataTarget.value.bridge_target_endpoint_headers;
  //   let headersArr = [];
  //   let paramsArr = [];

  //   if(params) {
  //     for(let object of params) {
  //       let paramsObj = new Object();
  //       paramsObj = {
  //         [object.bridge_target_paramKey]: object.bridge_target_paramValue
  //       }
  //       paramsArr.push(paramsObj);
  //     }
  //   }

  //   if(headers) {
  //     for(let object of headers) {
  //       let headersObj = new Object();
  //       headersObj = {
  //         [object.bridge_target_headerKey]: object.bridge_target_headerValue
  //       }
  //       headersArr.push(headersObj);
  //     }
  //   }

  //   let payload = {
  //     'endpointUrl': this.dataTarget.value.bridge_target_endpoint_url,
  //     'method': this.dataTarget.value.bridge_target_endpoint_method,
  //     'payload': (this.dataTarget.value.bridge_target_endpoint_body_raw) ? this.dataTarget.value.bridge_target_endpoint_body_raw : {},
  //     'authType': this.dataTarget.value.bridge_target_endpoint_authentication_type,
  //     'params': paramsArr
  //   }

  //   if(this.dataTarget.value.bridge_target_endpoint_authentication_type.id == '3'){
  //     payload['auth'] = 'Bearer' + " " + this.dataTarget.value.authentication_token;
  //   }
  //   if(this.dataTarget.value.bridge_target_endpoint_authentication_type.id == '4'){
  //     let enc = btoa(this.dataTarget.value.authentication_username + ":" + this.dataTarget.value.authentication_password);
  //     payload['auth'] = 'Basic' + " " + enc;
  //   }


  //   this.helperService.loader();
  //   this.getStorage().then((res)=>{
  //     this.backendService.PostAPICall('apiCatalogCall', payload, res.token)
  //       .subscribe(
  //         res => {
  //           //console.log(res);
  //           this.bridgeTargetResponse = res;
  //           this.dataTarget.controls['bridge_target_response'].setValue(res.data);
  //           this.helperService.closeLoader();
  //         },
  //         error => {
  //           this.helperService.closeLoader();
  //       })
  //     })
  // }

  cancelTargetRAOSpinner() {
    this.resetTargetRAOUIState();
    this.targetRAOTestApi.unsubscribe();
  }

  resetTargetRAOUIState() {
    this.spinnerTargetRAO = false;
    this.spinnerTargetRAOShow = false;
  }

  checkTokenSessionBeforeTestTargetRAO(formdata, ind?) {
    if(formdata.controls.bridge_target_endpoint_authentication_type.value.id==4){
      if(formdata.get('bridge_target_authentication_username').value ==''||formdata.get('bridge_target_authentication_password').value ==''){
        this.helperService.presentToast('Data operation form is incomplete',2000);
        this.bizdata_ops_restapi_fb.markAllAsTouched();
        return
      }
    }
    if(formdata.controls.bridge_target_endpoint_authentication_type.value.id==6){
      if(formdata.get('bridge_target_oauth_refresh_token_endpoint_method').value ==''||formdata.get('bridge_target_oauth_refresh_token_endpoint_url').value ==''){
        this.helperService.presentToast('Data operation form is incomplete',2000);
        this.bizdata_ops_restapi_fb.markAllAsTouched();
        return
      }
    }

    this.spinnerTargetRAO = true;
    this.spinnerTargetRAOShow = true;
    this.type = 'data_operation';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForDataOperation = storage_data.pytokenDataOperation;
      if (storage_data.pytokenDataOperation == null) {
        this.generateToken('data_operation').then(async (res: string) => {
          this.pythonTokenForDataOperation = res;
          await this.testTargetRAO(formdata, ind);
        })
      } else {
        this.checkToken().then(async (res: Boolean) => {
          if (res) {
            await this.testTargetRAO(formdata,ind);
          } else {
            this.generateToken('data_operation').then(async (res: string) => {
              this.pythonTokenForDataOperation = res;
              await this.testTargetRAO(formdata,ind);
            })
          }
        })
      }
    })
  }
  
  async testTargetRAO(formdata, ind?) {
    this.spinnerTargetRAO = true;
    formdata.controls['bridge_target_response'].reset();
    if (formdata.value.bridge_target_endpoint_body_raw != '' && formdata.value.bridge_target_endpoint_body_raw != undefined && JSON.stringify(formdata.value.bridge_target_endpoint_body_raw) !== '{}') {
      if (formdata.value.bridge_target_body_type == 'JSON') {
        if (this.helperService.isValidJSON(formdata.value.bridge_target_endpoint_body_raw) == false) {
          this.helperService.presentToast('Please provide valid JSON Data', 2000);
          // this.helperService.closeLoader()
          return
        }
      }
      if (formdata.value.bridge_target_body_type == 'XML') {
        if (this.helperService.isValidXML(formdata.value.bridge_target_endpoint_body_raw) == false) {
          this.helperService.presentToast('Please provide valid XML Data', 2000);
          // this.helperService.closeLoader()
          return
        }
      }
    }

    let method = formdata.value.bridge_target_endpoint_method.method;
    let auth_type = formdata.value.bridge_target_endpoint_authentication_type.type;

    if (this.endpoint_ops_url[ind] != "") {
      let eurl = this.endpoint_ops_url[ind].replace(/<[^>]*>/g, '');
      (<UntypedFormGroup>this.restapiRows().at(ind)).controls['bridge_target_endpoint_url'].setValue(eurl);
      formdata.value.bridge_target_endpoint_url = eurl;
    }
    if((<UntypedFormGroup>this.restapiRows().at(ind)).controls['bridge_target_endpoint_params_raw'] != undefined){
      let params = (<UntypedFormGroup>this.restapiRows().at(ind)).controls['bridge_target_endpoint_params_raw']!.value;
      if(params[0].bridge_target_paramKey != null){
        this.params_ops_raw[ind] = params;
      }
    }
    if((<UntypedFormGroup>this.restapiRows().at(ind)).controls['bridge_target_endpoint_headers'] != undefined){
      let headers = (<UntypedFormGroup>this.restapiRows().at(ind)).controls['bridge_target_endpoint_headers']!.value;
      if(headers[0].bridge_target_headerKey != null){
        this.headers_ops_raw[ind] = headers;
      }
    }
    if (this.params_ops_raw[ind].length > 0) {
      if (this.params_ops_raw[ind][0]?.bridge_target_paramKey != undefined && this.params_ops_raw[ind][0]?.bridge_target_paramKey != "") {
        for (let j=0; j <= this.params_ops_raw[ind].length;j++) {
          this.params_ops_key[ind][j] = this.params_ops_raw[ind][j]?.bridge_target_paramKey;
          this.params_ops_value[ind][j] = this.params_ops_raw[ind][j]?.bridge_target_paramValue;    
          this.addRestAPiOperationValueParams(this.params_ops_raw[ind][j]);
        }
      }
    }
    if (this.headers_ops_raw[ind].length > 0) {
      if (this.headers_ops_raw[ind][0]?.bridge_target_headerKey != undefined && this.headers_ops_raw[ind][0]?.bridge_target_headerKey != "") {
        for (let j=0; j <= this.headers_ops_raw[ind].length-1;j++) {
          this.headers_ops_key[ind][j] = this.headers_ops_raw[ind][j]?.bridge_target_headerKey;
          this.headers_ops_value[ind][j] = this.headers_ops_raw[ind][j]?.bridge_target_headerValue;    
          this.addRestAPiOperationValueHeaders(this.headers_ops_raw[ind][j]);
        }
      }
    }
    if(formdata.value.bridge_target_endpoint_params_raw == undefined || formdata.value.bridge_target_endpoint_params_raw == null){
      formdata.value.bridge_target_endpoint_params_raw = this.params_ops_raw;
    }
    if(formdata.value.bridge_target_endpoint_headers == undefined || formdata.value.bridge_target_endpoint_headers == null){
      formdata.value.bridge_target_endpoint_headers = this.headers_ops_raw;
    }
    if (formdata.value.bridge_target_body_type == 'JSON') {
      formdata.value.bridge_target_endpoint_body_raw = (formdata.value.bridge_target_endpoint_body_raw) ? this.helperService.isJsonString(formdata.value.bridge_target_endpoint_body_raw) : {}
    } else {
      formdata.value.bridge_target_endpoint_body_raw = (formdata.value.bridge_target_endpoint_body_raw) ? this.helperService.isString(formdata.value.bridge_target_endpoint_body_raw) : ""
    }

    let params = formdata.value.bridge_target_endpoint_params_raw;
    let headers = formdata.value.bridge_target_endpoint_headers;
    let headersArr = [];
    let paramsArr = [];
    let paramsClone = _.cloneDeep(formdata.value.bridge_target_endpoint_params_raw);
    let headersClone = _.cloneDeep(formdata.value.bridge_target_endpoint_headers);
    let bridge_target_endpoint_url = formdata.value.bridge_target_endpoint_url
    let bridge_target_endpoint_body_raw = formdata.value.bridge_target_endpoint_body_raw
    let pre_request_script = formdata.value.pre_request_script
    let typeof_bridge_target_endpoint_body_raw = typeof formdata.value.bridge_target_endpoint_body_raw;
    let bridge_target_endpoint_body_raw_tmp = JSON.stringify(formdata.value.bridge_target_endpoint_body_raw);

    if (formdata.value.bridge_endpoint_environments_raw.length > 0) {
      for (let item of formdata.value.bridge_endpoint_environments_raw) {
        if (item.env_name == formdata.value.selected_environment) {
          for (let subItem of item.env_vars) {
            for (let object of paramsClone) {
              if (object.bridge_target_paramKey.includes(subItem.variable)) {
                object.bridge_target_paramKey = object.bridge_target_paramKey.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (object.bridge_target_paramValue.includes(subItem.variable)) {
                object.bridge_target_paramValue = object.bridge_target_paramValue.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
            for (let object of headersClone) {
              if (object.bridge_target_headerKey.includes(subItem.variable)) {
                object.bridge_target_headerKey = object.bridge_target_headerKey.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (object.bridge_target_headerValue.includes(subItem.variable)) {
                object.bridge_target_headerValue = object.bridge_target_headerValue.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
            if (bridge_target_endpoint_url.includes(subItem.variable)) {
              bridge_target_endpoint_url = bridge_target_endpoint_url.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
            }

            if (typeof_bridge_target_endpoint_body_raw == 'object') {
              if (bridge_target_endpoint_body_raw_tmp.includes("{{" + subItem.variable + "}}")) {
                bridge_target_endpoint_body_raw_tmp = bridge_target_endpoint_body_raw_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                // refresh_token_body_tmp = refresh_token_body_tmp.replaceAll( "{{"+subItem.bridge_source_environmentVariable+"}}", subItem.bridge_source_environmentValue);
                bridge_target_endpoint_body_raw = JSON.parse(bridge_target_endpoint_body_raw_tmp);
              }
            } else {
              if (bridge_target_endpoint_body_raw.includes("{{" + subItem.variable + "}}")) {
                bridge_target_endpoint_body_raw = bridge_target_endpoint_body_raw.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }

            if (pre_request_script.includes(subItem.variable)) {
              pre_request_script = pre_request_script.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
            }
          }
        }
      }
    }

    if (paramsClone) {
      for (let object of paramsClone) {
        let paramsObj = new Object();
        if (object.bridge_target_paramKey) {
          paramsObj = {
            [object.bridge_target_paramKey]: object.bridge_target_paramValue
          }
          paramsArr.push(paramsObj);
        }
      }
    }

    if (headersClone) {
      for (let object of headersClone) {
        let headersObj = new Object();
        if(typeof object.bridge_target_headerKey !== 'object' && typeof object.bridge_target_headerValue !== 'object' && object.bridge_target_headerKey && object.bridge_target_headerValue){
          headersObj = {
            [object.bridge_target_headerKey]: object.bridge_target_headerValue
          }
          headersArr.push(headersObj);
        }
      }
    }

    let selectedEnvironment = '';
    if (formdata.value.selected_environment != 'No Environment') {
      selectedEnvironment = formdata.value.selected_environment;
    }

    // let regexNewLine = /\\n/g;
    // let pre_request_script = formdata.value.pre_request_script.replace(regexNewLine, "\\\n");

    let payload = {
      "min_num": 0,
      "max_num": 1000,
      "authentication_type": "no_auth",
      'endpoint_url': bridge_target_endpoint_url,
      'endpoint_headers': this.arrayToObject(headersArr),
      'endpoint_method': method.toLowerCase(),
      'body_type': formdata.value.bridge_target_body_type,
      'endpoint_body': bridge_target_endpoint_body_raw,
      'endpoint_params': this.arrayToObject(paramsArr),
      "pre_request_script": (pre_request_script) ? await this.helperService.encrypt(this.helperService.isString(pre_request_script)) : '',
      "response_parameters": "['items']",
      "another_response_parameter": "",
      "pagination_style": "no_pagination",
      "key_name_to_update": "offset",
      "user_key": "hasMore",
      "user_key_url": "Link",
      "response_type": formdata.value.response_type,
      // "timer_type":"schedule",
      // "interval_in_seconds":10,
      // "schedule":"*/1 * * * *",
      "username": "",
      "password": "",
      "refresh_token_body": "",
      "refresh_token_headers": "",
      "refresh_token_method": "",
      "refresh_token_params": "",
      "refresh_token_url": "",
      "target": "bizdata_dataset",
      "selected_environment": selectedEnvironment,
      "environment_variables": formdata.value.bridge_endpoint_environments_raw ? formdata.value.bridge_endpoint_environments_raw : "",
    }

    if (formdata.value.bridge_target_endpoint_authentication_type.id == '4') {
      payload['authentication_type'] = 'basic_auth';
      let bridge_target_authentication_username = formdata.value.bridge_target_authentication_username;
      let bridge_target_authentication_password = formdata.value.bridge_target_authentication_password;
      if (formdata.value.bridge_endpoint_environments_raw.length > 0) {
        for (let item of formdata.value.bridge_endpoint_environments_raw) {
          if (item.env_name == formdata.value.selected_environment) {
            for (let subItem of item.env_vars) {
              if (bridge_target_authentication_username.includes("{{" + subItem.variable + "}}")) {
                bridge_target_authentication_username = bridge_target_authentication_username.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (bridge_target_authentication_password.includes("{{" + subItem.variable + "}}")) {
                bridge_target_authentication_password = bridge_target_authentication_password.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
          }
        }
      }
      payload['username'] = bridge_target_authentication_username;
      payload['password'] = bridge_target_authentication_password?await this.helperService.encrypt(bridge_target_authentication_password):"";
    }

    let refresh_token_endpoint_url = (formdata.value.bridge_target_oauth_refresh_token_endpoint_url) ? formdata.value.bridge_target_oauth_refresh_token_endpoint_url : "";
    // let refresh_token_headers = (formdata.value.bridge_target_oauth_refresh_token_endpoint_header) ? formdata.value.bridge_target_oauth_refresh_token_endpoint_header : "";
    // let refresh_token_params = (formdata.value.bridge_target_oauth_refresh_token_endpoint_params) ? formdata.value.bridge_target_oauth_refresh_token_endpoint_params : "";
    // let refresh_token_body = (formdata.value.bridge_target_oauth_refresh_token_endpoint_body) ? formdata.value.bridge_target_oauth_refresh_token_endpoint_body : "";
    // let refresh_token_headers = (formdata.value.bridge_target_oauth_refresh_token_endpoint_header) ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_header) : "";
    // let refresh_token_params = (formdata.value.bridge_target_oauth_refresh_token_endpoint_params) ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_params) : "";
    // let refresh_token_body = (formdata.value.bridge_target_oauth_refresh_token_endpoint_body) ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_body) : "";

    let refresh_token_body;
    if (formdata.value.bridge_target_oauth_refresh_token_endpoint_body != '' && formdata.value.bridge_target_oauth_refresh_token_endpoint_body != undefined) {
      if (this.helperService.isValidJSON(formdata.value.bridge_target_oauth_refresh_token_endpoint_body)) {
        refresh_token_body = formdata.value.bridge_target_oauth_refresh_token_endpoint_body ? this.helperService.isJsonString(formdata.value.bridge_target_oauth_refresh_token_endpoint_body) : {};
      } else {
        refresh_token_body = formdata.value.bridge_target_oauth_refresh_token_endpoint_body ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_body) : "";
      }
    } else {
      refresh_token_body = formdata.value.bridge_target_oauth_refresh_token_endpoint_body ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_body) : "";
    }

    let refresh_token_headers;
    if (formdata.value.bridge_target_oauth_refresh_token_endpoint_header != '' && formdata.value.bridge_target_oauth_refresh_token_endpoint_header != undefined) {
      if (this.helperService.isValidJSON(formdata.value.bridge_target_oauth_refresh_token_endpoint_header)) {
        refresh_token_headers = formdata.value.bridge_target_oauth_refresh_token_endpoint_header ? this.helperService.isJsonString(formdata.value.bridge_target_oauth_refresh_token_endpoint_header) : {};
      } else {
        refresh_token_headers = formdata.value.bridge_target_oauth_refresh_token_endpoint_header ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_header) : "";
      }
    } else {
      refresh_token_headers = formdata.value.bridge_target_oauth_refresh_token_endpoint_header ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_header) : "";
    }

    let refresh_token_params;
    if (formdata.value.bridge_target_oauth_refresh_token_endpoint_params != '' && formdata.value.bridge_target_oauth_refresh_token_endpoint_params != undefined) {
      if (this.helperService.isValidJSON(formdata.value.bridge_target_oauth_refresh_token_endpoint_params)) {
        refresh_token_params = formdata.value.bridge_target_oauth_refresh_token_endpoint_params ? this.helperService.isJsonString(formdata.value.bridge_target_oauth_refresh_token_endpoint_params) : {};
      } else {
        refresh_token_params = formdata.value.bridge_target_oauth_refresh_token_endpoint_params ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_params) : "";
      }
    } else {
      refresh_token_params = formdata.value.bridge_target_oauth_refresh_token_endpoint_params ? this.helperService.stringToObjectConverter("String", formdata.value.bridge_target_oauth_refresh_token_endpoint_params) : "";
    }

    if (formdata.value.bridge_target_endpoint_authentication_type.id == '6') {
      let refresh_token_endpoint_method = formdata.value.bridge_target_oauth_refresh_token_endpoint_method.method;
      payload['authentication_type'] = 'oauth2.0';
      // payload['refresh_token_body'] = this.helperService.isJsonString(refresh_token_body);
      // if (refresh_token_headers) {
      //   payload['refresh_token_headers'] = this.helperService.isJsonString(refresh_token_headers);
      // } else {
      //   payload['refresh_token_headers'] = "";
      // }
      // if (refresh_token_params) {
      //   payload['refresh_token_params'] = this.helperService.isJsonString(refresh_token_params);
      // } else {
      //   payload['refresh_token_params'] = "";
      // }
      if (formdata.value.bridge_endpoint_environments_raw.length > 0) {
        for (let item of formdata.value.bridge_endpoint_environments_raw) {
          if (item.env_name == formdata.value.selected_environment) {
            for (let subItem of item.env_vars) {
              let typeof_refresh_token_body = typeof refresh_token_body;
              let typeof_refresh_token_headers = typeof refresh_token_headers;
              let typeof_refresh_token_params = typeof refresh_token_params;

              if (typeof_refresh_token_body == 'object') {
                let refresh_token_body_tmp;
                refresh_token_body_tmp = JSON.stringify(refresh_token_body);
                if (refresh_token_body_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_body_tmp = refresh_token_body_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_body = JSON.parse(refresh_token_body_tmp);
                }
              } else {
                let refresh_token_body_tmp;
                refresh_token_body_tmp = refresh_token_body;
                if (refresh_token_body_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_body_tmp = refresh_token_body_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_body = refresh_token_body_tmp;
                }
              }
              if (typeof_refresh_token_headers == 'object') {
                let refresh_token_headers_tmp;
                refresh_token_headers_tmp = JSON.stringify(refresh_token_headers);
                if (refresh_token_headers_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_headers_tmp = refresh_token_headers_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_headers = JSON.parse(refresh_token_headers_tmp);
                }
              } else {
                let refresh_token_headers_tmp;
                refresh_token_headers_tmp = refresh_token_headers;
                if (refresh_token_headers_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_headers_tmp = refresh_token_headers_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_headers = refresh_token_headers_tmp;
                }
              }
              if (typeof_refresh_token_params == 'object') {
                let refresh_token_params_tmp;
                refresh_token_params_tmp = JSON.stringify(refresh_token_params);
                if (refresh_token_params_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_params_tmp = refresh_token_params_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_params = JSON.parse(refresh_token_params_tmp);
                }
              } else {
                let refresh_token_params_tmp;
                refresh_token_params_tmp = refresh_token_params;
                if (refresh_token_params_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_params_tmp = refresh_token_params_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_params = refresh_token_params_tmp;
                }
              }

              if (refresh_token_endpoint_url.includes(subItem.variable)) {
                refresh_token_endpoint_url = refresh_token_endpoint_url.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
          }
        }
      }

      payload['refresh_token_body'] = refresh_token_body?await this.helperService.encrypt(JSON.stringify(refresh_token_body)):""
      payload['refresh_token_headers'] = refresh_token_headers;
      payload['refresh_token_params'] = refresh_token_params;
      payload['refresh_token_method'] = refresh_token_endpoint_method ? refresh_token_endpoint_method.toLowerCase() : "";
      payload['refresh_token_url'] = refresh_token_endpoint_url?await this.helperService.encrypt(refresh_token_endpoint_url):""
    }

    // this.helperService.loader();

    const api_endpoint = environment.python_api_base_url + this.helperService.targetAPI;
    this.targetRAOTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForDataOperation)
      .pipe(
        timeout(180000),
        catchError((err) => {
          if (err.name === 'TimeoutError') {
            this.spinnerTargetRAO = false;
            this.spinnerTargetRAOShow = false;
            this.resetTargetRAOUIState();
            this.helperService.presentToast("Request timed out. Please try again later.", 1000);
          } else if (err.status === 401) {
            this.storage.set('pytoken_data_operation', null);
            this.checkTokenSessionBeforeTestTargetRAO(formdata, ind);
          } else {
            this.spinnerTargetRAO = false;
            this.spinnerTargetRAOShow = false;
            this.resetTargetRAOUIState();
            this.helperService.presentToast("An error occurred. Please try again later.", 1000);
          }
          return throwError(() => err);
        })
      )
      .subscribe(
        res => {
          this.visibleIndex=-1;
          this.bridgeTargetResponse = res;
          if (res?.items) {
            let data = res.items[0];
            let bridgeTargetResponseMapping: object[] = [];
            for (const key in data) {
              bridgeTargetResponseMapping.push({ "target_column": key, "target_value": data[key], "mapping_source_column": "", "mapping_source_value": "", "isMapped": false });
            }
            this.bridgeTargetResponseMapping = bridgeTargetResponseMapping;
          }
          if (res.bizdata_dataset) {
            formdata.controls['bridge_target_response'].setValue(res.bizdata_dataset.bizdata_dataset_response);
            if (this.bridgeTargetResponse.bizdata_dataset.hasOwnProperty('bizdata_dataset_status')) {
              formdata.controls['bizdata_dataset_status'].setValue(this.bridgeTargetResponse.bizdata_dataset.bizdata_dataset_status)
            }            
            for (let i = 0; i < this.bridgeTargetResponseMapping.length; i++) {
              this.bridgeTargetResponseMapping[i]['type'] = typeof (this.bridgeTargetResponseMapping[i].target_value);
            }

            this.isMappingActive = true;
            this.spinnerTargetRAO = false;
            for (let item of formdata.value.preview_postman_data) {
              item.subItems = []
            }
            if (res.bizdata_dataset.hasOwnProperty('bizdata_dataset_request_data')) {
              this.loadAPIPostmanPreviewComponent(res.bizdata_dataset.bizdata_dataset_request_data, formdata.value.id)
              this.copyPreviewData = res.bizdata_dataset.bizdata_dataset_request_data;
            }
            this.spinnerTargetRAOShow == false;
            this.resetTargetRAOUIState();
            // this.helperService.closeLoader();
          } else if (res.error_message == "'access_token'") {
            this.spinnerTargetRAO = false;
            this.spinnerTargetRAOShow = false;
            this.resetTargetRAOUIState();
            // this.helperService.closeLoader();
            this.helperService.presentAlert("Access Denied!", "Your oauth2.0 details are invalid");
          } else {
            this.spinnerTargetRAO = false;
            this.spinnerTargetRAOShow = false;
            this.resetTargetRAOUIState();
            // this.helperService.closeLoader();
            this.helperService.presentToast(res.error_message, 3000);
          }
        }
      )
      this.closetesturltarget();
  }

  cancelTargetSpinner() {
    this.targetTestApi.unsubscribe();
    this.resetTargetUIState();
  }

  resetTargetUIState() {
    this.spinnerTarget = false;
    this.spinnerTargetShow = false;
  }

  checkTokenSessionBeforeTestTargetApi() {
    if(this.dataTarget.controls.bridge_target_endpoint_authentication_type.value.id==4){
      if(this.dataTarget.get('bridge_target_authentication_username').value==''||this.dataTarget.get('bridge_target_authentication_password').value ==''){
        this.helperService.presentToast('DataTarget form is incomplete',2000);
        let elem = document.getElementById('contentDevTargetAuthUser');
        if(this.dataTarget.get('bridge_target_authentication_username').invalid){
         elem.setAttribute('class','userError')
       }
       let elem1 = document.getElementById('contentDevTargetAuthPassword');
       if(this.dataTarget.get('bridge_target_authentication_password').invalid){
         elem1.setAttribute('class','passError')
       }
        return
      }
    }
    if(this.dataTarget.controls.bridge_target_endpoint_authentication_type.value.id==6){
      if(this.dataTarget.get('bridge_target_endpoint_method').value==''||this.dataTarget.get('bridge_target_endpoint_url').value ==''){
        this.helperService.presentToast('DataTarget form is incomplete',2000);
        this.dataTarget.markAllAsTouched();
        let url=document.getElementById('contentDivTargetAuth');
        if(this.dataTarget.get('bridge_target_endpoint_url').invalid){
        url.classList.add('passError');
      }
        return
      }
    }
    this.spinnerTarget = true;
    this.spinnerTargetShow = true;
    this.type = 'data_operation';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForDataOperation = storage_data.pytokenDataOperation;
      if (storage_data.pytokenDataOperation == null) {
        this.generateToken('data_operation').then(async (res: string) => {
          this.pythonTokenForDataOperation = res;
          await this.testTargetApi();
        })
      } else {
        this.checkToken().then(async (res: Boolean) => {
          if (res) {
            await this.testTargetApi();
          } else {
            this.generateToken('data_operation').then(async (res: string) => {
              this.pythonTokenForDataOperation = res;
              await this.testTargetApi();
            })
          }
        })
      }
    })
  }

  async testTargetApi() {
    this.spinnerTarget = true;
    this.dataTarget.controls['bridge_target_response'].reset();
    if (this.dataTarget.value.bridge_target_endpoint_body_raw != '' && this.dataTarget.value.bridge_target_endpoint_body_raw != undefined && JSON.stringify(this.dataTarget.value.bridge_target_endpoint_body_raw) !== '{}') {
      if (this.dataTarget.value.bridge_target_body_type == 'JSON') {
        if (this.helperService.isValidJSON(this.dataTarget.value.bridge_target_endpoint_body_raw) == false) {
          this.helperService.presentToast('Please provide valid JSON Data', 2000);
          // this.helperService.closeLoader()
          return
        }
      }
      if (this.dataTarget.value.bridge_target_body_type == 'XML') {
        if (this.helperService.isValidXML(this.dataTarget.value.bridge_target_endpoint_body_raw) == false) {
          this.helperService.presentToast('Please provide valid XML Data', 2000);
          // this.helperService.closeLoader()
          return
        }
      }
    }

    let method = this.dataTarget.value.bridge_target_endpoint_method.method;
    let auth_type = this.dataTarget.value.bridge_target_endpoint_authentication_type.type;
    if (this.dataTarget.value.bridge_target_body_type == 'JSON') {
      this.dataTarget.value.bridge_target_endpoint_body_raw = (this.dataTarget.value.bridge_target_endpoint_body_raw) ? this.helperService.isJsonString(this.dataTarget.value.bridge_target_endpoint_body_raw) : {}
    } else {
      // this.dataTarget.value.bridge_target_endpoint_body_raw = (this.dataTarget.value.bridge_target_endpoint_body_raw) ? this.dataTarget.value.bridge_target_endpoint_body_raw : ""
      this.dataTarget.value.bridge_target_endpoint_body_raw = (this.dataTarget.value.bridge_target_endpoint_body_raw) ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_endpoint_body_raw) : ""
    }

    if (this.endpoint_target_url != "") {
      let eurl = this.endpoint_target_url.replace(/<[^>]*>/g, '');
      this.dataTarget.controls['bridge_target_endpoint_url'].setValue(eurl);
    }
    if (this.params_target_key.length > 0) {
      let params = this.dataTarget.value.bridge_target_endpoint_params_raw;
      if (params != undefined) {
        for (let i = 0; i < params.length; i++) {
          params[i].bridge_target_paramKey = this.params_target_key[i];
          params[i].bridge_target_paramValue = this.params_target_value[i];
          this.addTargetValueParams(params[i]);
        }
      }
    }
    if (this.headers_target_key.length > 0) {
      let headers = this.dataTarget.value.bridge_target_endpoint_headers;
      if (headers != undefined) {
        for (let i = 0; i < headers.length; i++) {
          headers[i].bridge_target_headerKey = this.headers_target_key[i];
          headers[i].bridge_target_headerValue = this.headers_target_value[i];
          this.addTargetValueHeaders(headers[i]);
        }
      }
    }
    let params = this.dataTarget.value.bridge_target_endpoint_params_raw;
    let headers = this.dataTarget.value.bridge_target_endpoint_headers;
    let headersArr = [];
    let paramsArr = [];
    let paramsClone = _.cloneDeep(this.dataTarget.value.bridge_target_endpoint_params_raw);
    let headersClone = _.cloneDeep(this.dataTarget.value.bridge_target_endpoint_headers);
    let bridge_target_endpoint_url = this.dataTarget.value.bridge_target_endpoint_url
    let bridge_target_endpoint_body_raw = this.dataTarget.value.bridge_target_endpoint_body_raw
    let pre_request_script = this.dataTarget.value.pre_request_script
    let typeof_bridge_target_endpoint_body_raw = typeof this.dataTarget.value.bridge_target_endpoint_body_raw
    let bridge_target_endpoint_body_raw_tmp = JSON.stringify(this.dataTarget.value.bridge_target_endpoint_body_raw);

    if (this.environmentTargetForm.value.bridge_endpoint_environments_raw.length > 0) {
      for (let item of this.environmentTargetForm.value.bridge_endpoint_environments_raw) {
        if (item.env_name == this.environmentTargetForm.value.selected_environment) {
          for (let subItem of item.env_vars) {
            for (let object of paramsClone) {
              if (object.bridge_target_paramKey.includes("{{" + subItem.variable + "}}")) {
                object.bridge_target_paramKey = object.bridge_target_paramKey.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (object.bridge_target_paramValue.includes("{{" + subItem.variable + "}}")) {
                object.bridge_target_paramValue = object.bridge_target_paramValue.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
            for (let object of headersClone) {
              if (object.bridge_target_headerKey.includes("{{" + subItem.variable + "}}")) {
                object.bridge_target_headerKey = object.bridge_target_headerKey.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (object.bridge_target_headerValue.includes("{{" + subItem.variable + "}}")) {
                object.bridge_target_headerValue = object.bridge_target_headerValue.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
            if (bridge_target_endpoint_url.includes("{{" + subItem.variable + "}}")) {
              bridge_target_endpoint_url = bridge_target_endpoint_url.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
            }

            if (typeof_bridge_target_endpoint_body_raw == 'object') {
              if (bridge_target_endpoint_body_raw_tmp.includes("{{" + subItem.variable + "}}")) {
                bridge_target_endpoint_body_raw_tmp = bridge_target_endpoint_body_raw_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                // refresh_token_body_tmp = refresh_token_body_tmp.replaceAll( "{{"+subItem.bridge_source_environmentVariable+"}}", subItem.bridge_source_environmentValue);
                bridge_target_endpoint_body_raw = JSON.parse(bridge_target_endpoint_body_raw_tmp);
              }
            } else {
              if (bridge_target_endpoint_body_raw.includes("{{" + subItem.variable + "}}")) {
                bridge_target_endpoint_body_raw = bridge_target_endpoint_body_raw.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
            if (pre_request_script.includes("{{" + subItem.variable + "}}")) {
              pre_request_script = pre_request_script.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
            }
          }
        }
      }
    }


    if (paramsClone) {
      for (let object of paramsClone) {
        let paramsObj = new Object();
        if (object.bridge_target_paramKey) {
          paramsObj = {
            [object.bridge_target_paramKey]: object.bridge_target_paramValue
          }
          paramsArr.push(paramsObj);
        }
      }
    }

    if (headersClone) {
      for (let object of headersClone) {
        let headersObj = new Object();
        if (object.bridge_target_headerKey && object.bridge_target_headerValue) {
          headersObj = {
            [object.bridge_target_headerKey]: object.bridge_target_headerValue
          }
          headersArr.push(headersObj);
        }
      }
    }

    let selectedEnvironment = '';
    if (this.environmentTargetForm.value.selected_environment != 'No Environment') {
      selectedEnvironment = this.environmentTargetForm.value.selected_environment;
    }

    // let regexNewLine = /\\n/g;
    // let pre_request_script = this.dataTarget.value.pre_request_script.replace(regexNewLine, "\\\n");
    let payload = {
      // "min_num": 0,
      // "max_num": 1000,
      "authentication_type": "no_auth",
      'endpoint_url': bridge_target_endpoint_url,
      'endpoint_headers': this.arrayToObject(headersArr),
      'endpoint_method': method.toLowerCase(),
      'body_type': this.dataTarget.value.bridge_target_body_type,
      'endpoint_body': bridge_target_endpoint_body_raw,
      'endpoint_params': this.arrayToObject(paramsArr),
      "pre_request_script": (pre_request_script) ? await this.helperService.encrypt(this.helperService.isString(pre_request_script)) : '',
      "response_type": this.dataTarget.value.response_type,
      // "response_parameters": "['items']",
      // "another_response_parameter": "",
      // "pagination_style": "no_pagination",
      // "key_name_to_update": "offset",
      // "user_key": "hasMore",
      // "user_key_url": "Link",
      // // "timer_type":"schedule",
      // // "interval_in_seconds":10,
      // // "schedule":"*/1 * * * *",
      "username": "",
      "password": "",
      "refresh_token_body": "",
      "refresh_token_headers": "",
      "refresh_token_method": "",
      "refresh_token_params": "",
      "refresh_token_url": "",
      "target": "bizdata_dataset",
      "target_selected_environment_name": selectedEnvironment,
      "target_environment_variables": this.environmentTargetForm.value.bridge_endpoint_environments_raw ? this.environmentTargetForm.value.bridge_endpoint_environments_raw : [],
    }

    if (this.dataTarget.value.bridge_target_endpoint_authentication_type.id == '4') {
      payload['authentication_type'] = 'basic_auth';
      let bridge_target_authentication_username = this.dataTarget.value.bridge_target_authentication_username;
      let bridge_target_authentication_password = this.dataTarget.value.bridge_target_authentication_password;
      if (this.environmentTargetForm.value.bridge_endpoint_environments_raw.length > 0) {
        for (let item of this.environmentTargetForm.value.bridge_endpoint_environments_raw) {
          if (item.env_name == this.environmentTargetForm.value.selected_environment) {
            for (let subItem of item.env_vars) {
              if (bridge_target_authentication_username.includes("{{" + subItem.variable + "}}")) {
                bridge_target_authentication_username = bridge_target_authentication_username.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
              if (bridge_target_authentication_password.includes("{{" + subItem.variable + "}}")) {
                bridge_target_authentication_password = bridge_target_authentication_password.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
          }
        }
      }
      payload['username'] = bridge_target_authentication_username;
      payload['password'] = bridge_target_authentication_password?await this.helperService.encrypt(bridge_target_authentication_password):"";
    }
    if (this.target_auth != "") {
      this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(this.target_auth);
    }
    let refresh_token_endpoint_url = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_url) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_url : "";
    // let refresh_token_headers = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header : "";
    // let refresh_token_params = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params : "";
    // let refresh_token_body = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body : "";
    // let refresh_token_headers = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) : "";
    // let refresh_token_params = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) : "";
    // let refresh_token_body = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) : "";


    let refresh_token_body;
    if (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body != '' && this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body != undefined) {
      if (this.helperService.isValidJSON(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body)) {
        refresh_token_body = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body ? this.helperService.isJsonString(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) : {};
      } else {
        refresh_token_body = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) : "";
      }
    } else {
      refresh_token_body = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) : "";
    }

    let refresh_token_headers;
    if (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header != '' && this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header != undefined) {
      if (this.helperService.isValidJSON(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header)) {
        refresh_token_headers = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header ? this.helperService.isJsonString(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) : {};
      } else {
        refresh_token_headers = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) : "";
      }
    } else {
      refresh_token_headers = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) : "";
    }

    let refresh_token_params;
    if (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params != '' && this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params != undefined) {
      if (this.helperService.isValidJSON(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params)) {
        refresh_token_params = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params ? this.helperService.isJsonString(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) : {};
      } else {
        refresh_token_params = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) : "";
      }
    } else {
      refresh_token_params = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) : "";
    }

    if (this.dataTarget.value.bridge_target_endpoint_authentication_type.id == '6') {
      let refresh_token_endpoint_method = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_method.method;
      payload['authentication_type'] = 'oauth2.0';
      // payload['refresh_token_body'] = this.helperService.isJsonString(refresh_token_body);
      // if (refresh_token_headers) {
      //   payload['refresh_token_headers'] = this.helperService.isJsonString(refresh_token_headers);
      // } else {
      //   payload['refresh_token_headers'] = "";
      // }
      // if (refresh_token_params) {
      //   payload['refresh_token_params'] = this.helperService.isJsonString(refresh_token_params);
      // } else {
      //   payload['refresh_token_params'] = "";
      // }
      if (this.environmentTargetForm.value.bridge_endpoint_environments_raw.length > 0) {
        for (let item of this.environmentTargetForm.value.bridge_endpoint_environments_raw) {
          if (item.env_name == this.environmentTargetForm.value.selected_environment) {
            for (let subItem of item.env_vars) {
              let typeof_refresh_token_body = typeof refresh_token_body;
              let typeof_refresh_token_headers = typeof refresh_token_headers;
              let typeof_refresh_token_params = typeof refresh_token_params;

              if (typeof_refresh_token_body == 'object') {
                let refresh_token_body_tmp;
                refresh_token_body_tmp = JSON.stringify(refresh_token_body);
                if (refresh_token_body_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_body_tmp = refresh_token_body_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_body = JSON.parse(refresh_token_body_tmp);
                }
              } else {
                let refresh_token_body_tmp;
                refresh_token_body_tmp = refresh_token_body;
                if (refresh_token_body_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_body_tmp = refresh_token_body_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_body = refresh_token_body_tmp;
                }
              }
              if (typeof_refresh_token_headers == 'object') {
                let refresh_token_headers_tmp;
                refresh_token_headers_tmp = JSON.stringify(refresh_token_headers);
                if (refresh_token_headers_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_headers_tmp = refresh_token_headers_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_headers = JSON.parse(refresh_token_headers_tmp);
                }
              } else {
                let refresh_token_headers_tmp;
                refresh_token_headers_tmp = refresh_token_headers;
                if (refresh_token_headers_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_headers_tmp = refresh_token_headers_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_headers = refresh_token_headers_tmp;
                }
              }
              if (typeof_refresh_token_params == 'object') {
                let refresh_token_params_tmp;
                refresh_token_params_tmp = JSON.stringify(refresh_token_params);
                if (refresh_token_params_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_params_tmp = refresh_token_params_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_params = JSON.parse(refresh_token_params_tmp);
                }
              } else {
                let refresh_token_params_tmp;
                refresh_token_params_tmp = refresh_token_params;
                if (refresh_token_params_tmp.includes("{{" + subItem.variable + "}}")) {
                  refresh_token_params_tmp = refresh_token_params_tmp.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
                  refresh_token_params = refresh_token_params_tmp;
                }
              }

              if (refresh_token_endpoint_url.includes(subItem.variable)) {
                refresh_token_endpoint_url = refresh_token_endpoint_url.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
              }
            }
          }
        }
      }
      payload['refresh_token_body'] = refresh_token_body?await this.helperService.encrypt(JSON.stringify(refresh_token_body)):"";
      payload['refresh_token_headers'] = refresh_token_headers;
      payload['refresh_token_params'] = refresh_token_params;
      payload['refresh_token_method'] = refresh_token_endpoint_method? refresh_token_endpoint_method.toLowerCase() : "";  
      payload['refresh_token_url'] = refresh_token_endpoint_url?await this.helperService.encrypt(refresh_token_endpoint_url):"";
    }

    // this.helperService.loader();

    const api_endpoint = environment.python_api_base_url + this.helperService.targetAPI;
    this.targetTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForDataOperation)
      .pipe(
        timeout(180000),
        catchError((err) => {
          if (err.name === 'TimeoutError') {
            this.spinnerTarget = false;
            this.spinnerTargetShow == false;
            this.resetTargetUIState();
            this.helperService.presentToast("Request timed out. Please try again later.", 1000);
          } else if (err.status === 401) {
            this.storage.set('pytoken_data_operation', null);
            this.checkTokenSessionBeforeTestTargetApi();
          } else {
            this.spinnerTarget = false;
            this.spinnerTargetShow == false;
            this.resetTargetUIState();
            this.helperService.presentToast("An error occurred. Please try again later.", 1000);
          }
          return throwError(() => err);
        })
      ).subscribe(
        res => {
          this.bridgeTargetResponse = res;
          if (res?.items) {
            console.log(res)
            let data = res.items[0];
            let bridgeTargetResponseMapping: object[] = [];
            for (const key in data) {
              bridgeTargetResponseMapping.push({ "target_column": key, "target_value": data[key], "mapping_source_column": "", "mapping_source_value": "", "isMapped": false });
            }
            this.bridgeTargetResponseMapping = bridgeTargetResponseMapping;
          }
          if (res.bizdata_dataset) {
            this.dataTarget.controls['bridge_target_response'].setValue(res.bizdata_dataset.bizdata_dataset_response);
            if (res.bizdata_dataset.hasOwnProperty('bizdata_dataset_status')) {
              this.dataTarget.controls['bizdata_dataset_status'].setValue(res.bizdata_dataset.bizdata_dataset_status)
            }
            for (let i = 0; i < this.bridgeTargetResponseMapping.length; i++) {
              this.bridgeTargetResponseMapping[i]['type'] = typeof (this.bridgeTargetResponseMapping[i].target_value);
            }
            this.isMappingActive = true;
            this.spinnerTarget = false;
            for (let item of this.items.target) {
              item.subItems = []
            }
            this.items.target=[
              {
                name: 'Request Header',
                subItems: []
              }, {
                name: 'Request Params',
                subItems: []
              }, {
                name: 'Request Body',
                subItems: []
              }, {
                name: 'Pre Request Script',
                subItems: []
              },
              {
                requestMethod: '',
                requestUrl: ''
              }];
            if (res.bizdata_dataset.hasOwnProperty('bizdata_dataset_request_data')) {
              this.loadPostmanPreviewComponent(res.bizdata_dataset.bizdata_dataset_request_data,'target')
              this.copyPreviewData = res.bizdata_dataset.bizdata_dataset_request_data;
            }
            this.spinnerTargetShow == false;
            this.resetTargetUIState()
            // this.helperService.closeLoader();
          }else if (res.error_message == "'access_token'") {
            this.spinnerTarget = false;
            this.spinnerTargetShow == false;
            this.resetTargetUIState();
            // this.helperService.closeLoader();
            this.helperService.presentAlert("Access Denied!", "Your oauth2.0 details are invalid");
          } else {
            this.spinnerTarget = false;
            this.spinnerTargetShow == false;
            this.resetTargetUIState();
            // this.helperService.closeLoader();
            this.helperService.presentToast(res.error_message, 3000);
          }
        }
      )
      this.closetesturltarget();
  }

  checkAndRemoveBearerTokenTargetControl() {
    const is_authentication_token = this.dataTarget.contains('bridge_target_authentication_token');
    if (is_authentication_token) this.dataTarget.removeControl('bridge_target_authentication_token');
  }

  checkAndRemoveBasicTokenTargetControl() {
    const is_authentication_username = this.dataTarget.contains('bridge_target_authentication_username');
    const is_authentication_password = this.dataTarget.contains('bridge_target_authentication_password');
    if (is_authentication_username) this.dataTarget.removeControl('bridge_target_authentication_username');
    if (is_authentication_password) this.dataTarget.removeControl('bridge_target_authentication_password');
  }

  checkAndRefreshTokenTargetControl() {
    const is_refresh_token_endpoint_url = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_url');
    const is_refresh_token_endpoint_method = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_method');
    const is_refresh_token_endpoint_header = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_header');
    const is_refresh_token_endpoint_params = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_params');
    const is_refresh_token_endpoint_body = this.dataTarget.contains('bridge_target_oauth_refresh_token_endpoint_body');
    if (is_refresh_token_endpoint_url) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_url');
    if (is_refresh_token_endpoint_method) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_method');
    if (is_refresh_token_endpoint_header) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_header');
    if (is_refresh_token_endpoint_params) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_params');
    if (is_refresh_token_endpoint_body) this.dataTarget.removeControl('bridge_target_oauth_refresh_token_endpoint_body');
  }

  onChangeTargetAuthenticationtype(event) {
    let changedValue = event.value.id;
    this.selectTargetType = changedValue;
    this.target_auth = "";
    this.target_authUser = "";
    this.target_authPassword = "";
    if (changedValue == 3) {
      this.dataTarget.addControl('bridge_target_authentication_token', new UntypedFormControl("", [Validators.required]));
      this.checkAndRemoveBasicTokenTargetControl();
      this.checkAndRefreshTokenTargetControl();
    } else if (changedValue == 4) {
      this.dataTarget.addControl('bridge_target_authentication_username', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('bridge_target_authentication_password', new UntypedFormControl("", [Validators.required]));
      this.checkAndRemoveBearerTokenTargetControl();
      this.checkAndRefreshTokenTargetControl();
      setTimeout(() => {
        let dsuser = document.getElementById('contentDevTargetAuthUser');
        dsuser.setAttribute("style", "-webkit-text-security:none");  
        let dspass = document.getElementById('contentDevTargetAuthPassword');
        dspass.setAttribute("style", "-webkit-text-security:none");  
        }, 100);
    } else if (changedValue == 6) {
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_url', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_method', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
      this.dataTarget.addControl('bridge_target_oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
      let default_refresh_token_endpoint_header = { "Content-Type": "application/x-www-form-urlencoded" };
      this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_header'].setValue(JSON.stringify(default_refresh_token_endpoint_header));
      this.checkAndRemoveBearerTokenTargetControl();
      this.checkAndRemoveBasicTokenTargetControl();
    }
  }

  onChangeRestApiAuthenticationtype(event, index) {
    // //console.log(this.restapiRows().at(index))
    let changedValue = event.value.id;
    this.selectTargetRestApiType = changedValue;
    this.ops_auth[index] = "";
    this.ops_authUser[index]="";
    this.ops_authPassword[index]="";
    // //console.log(this.restapiRows().at(index))
    this.ops_authUser[index]="";
    this.ops_authPassword[index]="";
    this.ops_auth[index]="";
    if (changedValue == 3) {
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_authentication_token', this._formBuilder.control("", [Validators.required]));
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_authentication_username');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_authentication_password');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_url');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_method');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_header');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_params');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_body');
    } else if (changedValue == 4) {
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_authentication_username', this._formBuilder.control("", [Validators.required]));
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_authentication_password', this._formBuilder.control("", [Validators.required]));;
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_url');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_method');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_header');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_params');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_oauth_refresh_token_endpoint_body');
      setTimeout(() => {
        let dsuser = document.getElementById('contentDevOpsAuthUser'+index);
        dsuser.setAttribute("style", "-webkit-text-security:none");  
        let dspass = document.getElementById('contentDevOpsAuthPassword'+index);
        dspass.setAttribute("style", "-webkit-text-security:none");  
        }, 100);
    } else if (changedValue == 6) {
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_oauth_refresh_token_endpoint_url', this._formBuilder.control("", [Validators.required]));
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_oauth_refresh_token_endpoint_method', this._formBuilder.control("", [Validators.required]));;
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_oauth_refresh_token_endpoint_header', this._formBuilder.control(""));
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_oauth_refresh_token_endpoint_params', this._formBuilder.control(""));
      (<UntypedFormGroup>this.restapiRows().at(index)).addControl('bridge_target_oauth_refresh_token_endpoint_body', this._formBuilder.control(""));
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_authentication_username');
      (<UntypedFormGroup>this.restapiRows().at(index)).removeControl('bridge_target_authentication_password');
    }
  }

  selectionChange(e) {
    this.isPreviewRequestShow = false;
    this.visibleIndex=-1;
    this.selectedIndex=e.selectedIndex;
    if (e.selectedIndex == 0) {
      if (this.bridge_source_type == 1) {
        this.isPreviewRequestShow = true;
      }
    }
    if (e.selectedIndex == 2) {
      if (this.bridge_target_type == 1) {
        this.isPreviewRequestShow = true;
      }
    }
    if (e.selectedIndex == 1) {
      this.noAbout = true;
    } else {
      this.noAbout = false;
    }
    if (e.selectedIndex == 3) {
      this.isConsole = false;
      this.selectedIndex = 3;
      // this.testSourceApi();
      // this.testTargetApi();
      // if (this.bridge_source_type == 3) {
      //   this.bridge_summary_source_name = "Bizintel360 Data Lake Source";
      //   this.bridge_summary_source_bobj = "-";
      // }
      // if (this.bridge_target_type == 3) {
      //   this.bridge_summary_target_name = "Bizintel360 Data Lake Ingestion";
      //   this.bridge_summary_target_bobj = "-";
      // }
    }
  }

  getSourceInvalidControls() {
    const invalid = [];
    const controls = this.dataSource.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  getTargetInvalidControls() {
    const invalid = [];
    const controls = this.dataTarget.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  async submit() {
    this.isConsole = false;
    const user_key_2 = this.dataSource.contains('user_key_2');
    const response_parameters_2 = this.dataSource.contains('response_parameters_2');
    const another_response_parameter_2 = this.dataSource.contains('another_response_parameter_2');
    const user_key_3 = this.dataSource.contains('user_key_3');
    const key_name_to_update_3 = this.dataSource.contains('key_name_to_update_3');
    const response_parameters_3 = this.dataSource.contains('response_parameters_3');
    const user_key_4 = this.dataSource.contains('user_key_4');
    const key_name_to_update_4 = this.dataSource.contains('key_name_to_update_4');
    const response_parameters_4 = this.dataSource.contains('response_parameters_4');
    const user_key_5 = this.dataSource.contains('user_key_5');
    const key_name_to_update_5 = this.dataSource.contains('key_name_to_update_5');
    const response_parameters_5 = this.dataSource.contains('response_parameters_5');
    const user_key_6 = this.dataSource.contains('user_key_6');
    const user_key_url_6 = this.dataSource.contains('user_key_url_6');
    const response_parameters_6 = this.dataSource.contains('response_parameters_6');
    const user_key_7 = this.dataSource.contains('user_key_7');
    const response_parameters_7 = this.dataSource.contains('response_parameters_7');
    const custom_pagination_script = this.dataSource.contains('custom_pagination_script');

    let pagination_style = '';
    let user_key_url = '', response_parameters = '', user_key = '', key_name_to_update = '', another_response_parameter = '', custom_pagination_script_tmp = '', pagination_retry_seconds: '';;
    if (this.selectPaginationType == 2) {
      user_key = this.dataSource.value.user_key_2;
      response_parameters = this.dataSource.value.response_parameters_2;
      another_response_parameter = this.dataSource.value.another_response_parameter_2;
      pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds;
      if (user_key_3) this.dataSource.removeControl('user_key_3');
      if (key_name_to_update_3) this.dataSource.removeControl('key_name_to_update_3');
      if (response_parameters_3) this.dataSource.removeControl('response_parameters_3');
      if (user_key_4) this.dataTarget.removeControl('user_key_4');
      if (key_name_to_update_4) this.dataSource.removeControl('key_name_to_update_4');
      if (response_parameters_4) this.dataSource.removeControl('response_parameters_4');
      if (user_key_5) this.dataSource.removeControl('user_key_5');
      if (key_name_to_update_5) this.dataSource.removeControl('key_name_to_update_5');
      if (response_parameters_5) this.dataSource.removeControl('response_parameters_5');
      if (user_key_6) this.dataSource.removeControl('user_key_6');
      if (user_key_url_6) this.dataSource.removeControl('user_key_url_6');
      if (response_parameters_6) this.dataSource.removeControl('response_parameters_6');
      if (user_key_7) this.dataSource.removeControl('user_key_7');
      if (response_parameters_7) this.dataSource.removeControl('response_parameters_7');
      if (custom_pagination_script) this.dataSource.removeControl('custom_pagination_script');
    } else if (this.selectPaginationType == 3) {
      user_key = this.dataSource.value.user_key_3;
      key_name_to_update = this.dataSource.value.key_name_to_update_3;
      response_parameters = this.dataSource.value.response_parameters_3;
      pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds;
      if (user_key_2) this.dataSource.removeControl('user_key_2');
      if (response_parameters_2) this.dataSource.removeControl('response_parameters_2');
      if (another_response_parameter_2) this.dataSource.removeControl('another_response_parameter_2');
      if (user_key_4) this.dataSource.removeControl('user_key_4');
      if (key_name_to_update_4) this.dataSource.removeControl('key_name_to_update_4');
      if (response_parameters_4) this.dataSource.removeControl('response_parameters_4');
      if (user_key_5) this.dataSource.removeControl('user_key_5');
      if (key_name_to_update_5) this.dataSource.removeControl('key_name_to_update_5');
      if (response_parameters_5) this.dataSource.removeControl('response_parameters_5');
      if (user_key_6) this.dataSource.removeControl('user_key_6');
      if (user_key_url_6) this.dataSource.removeControl('user_key_url_6');
      if (response_parameters_6) this.dataSource.removeControl('response_parameters_6');
      if (user_key_7) this.dataSource.removeControl('user_key_7');
      if (response_parameters_7) this.dataSource.removeControl('response_parameters_7');
      if (custom_pagination_script) this.dataSource.removeControl('custom_pagination_script');
    } else if (this.selectPaginationType == 4) {
      user_key = this.dataSource.value.user_key_4;
      key_name_to_update = this.dataSource.value.key_name_to_update_4;
      response_parameters = this.dataSource.value.response_parameters_4;
      pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds;
      if (user_key_3) this.dataSource.removeControl('user_key_3');
      if (key_name_to_update_3) this.dataSource.removeControl('key_name_to_update_3');
      if (response_parameters_3) this.dataSource.removeControl('response_parameters_3');
      if (user_key_2) this.dataSource.removeControl('user_key_2');
      if (response_parameters_2) this.dataSource.removeControl('response_parameters_2');
      if (another_response_parameter_2) this.dataSource.removeControl('another_response_parameter_2');
      if (user_key_5) this.dataSource.removeControl('user_key_5');
      if (key_name_to_update_5) this.dataSource.removeControl('key_name_to_update_5');
      if (response_parameters_5) this.dataSource.removeControl('response_parameters_5');
      if (user_key_6) this.dataSource.removeControl('user_key_6');
      if (user_key_url_6) this.dataSource.removeControl('user_key_url_6');
      if (response_parameters_6) this.dataSource.removeControl('response_parameters_6');
      if (user_key_7) this.dataSource.removeControl('user_key_7');
      if (response_parameters_7) this.dataSource.removeControl('response_parameters_7');
      if (custom_pagination_script) this.dataSource.removeControl('custom_pagination_script');
    } else if (this.selectPaginationType == 5) {
      user_key = this.dataSource.value.user_key_5;
      key_name_to_update = this.dataSource.value.key_name_to_update_5;
      response_parameters = this.dataSource.value.response_parameters_5;
      pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds;
      if (user_key_3) this.dataSource.removeControl('user_key_3');
      if (key_name_to_update_3) this.dataSource.removeControl('key_name_to_update_3');
      if (response_parameters_3) this.dataSource.removeControl('response_parameters_3');
      if (user_key_2) this.dataTarget.removeControl('user_key_2');
      if (response_parameters_2) this.dataSource.removeControl('response_parameters_2');
      if (another_response_parameter_2) this.dataSource.removeControl('another_response_parameter_2');
      if (user_key_4) this.dataSource.removeControl('user_key_4');
      if (key_name_to_update_4) this.dataSource.removeControl('key_name_to_update_4');
      if (response_parameters_4) this.dataSource.removeControl('response_parameters_4');
      if (user_key_6) this.dataSource.removeControl('user_key_6');
      if (user_key_url_6) this.dataSource.removeControl('user_key_url_6');
      if (response_parameters_6) this.dataSource.removeControl('response_parameters_6');
      if (user_key_7) this.dataSource.removeControl('user_key_7');
      if (response_parameters_7) this.dataSource.removeControl('response_parameters_7');
      if (custom_pagination_script) this.dataSource.removeControl('custom_pagination_script');
    } else if (this.selectPaginationType == 6) {
      user_key = this.dataSource.value.user_key_6;
      user_key_url = this.dataSource.value.user_key_url_6;
      response_parameters = this.dataSource.value.response_parameters_6;
      pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds;
      if (user_key_3) this.dataSource.removeControl('user_key_3');
      if (key_name_to_update_3) this.dataSource.removeControl('key_name_to_update_3');
      if (response_parameters_3) this.dataSource.removeControl('response_parameters_3');
      if (user_key_2) this.dataTarget.removeControl('user_key_2');
      if (response_parameters_2) this.dataSource.removeControl('response_parameters_2');
      if (another_response_parameter_2) this.dataSource.removeControl('another_response_parameter_2');
      if (user_key_4) this.dataSource.removeControl('user_key_4');
      if (key_name_to_update_4) this.dataSource.removeControl('key_name_to_update_4');
      if (response_parameters_4) this.dataSource.removeControl('response_parameters_4');
      if (user_key_5) this.dataSource.removeControl('user_key_5');
      if (key_name_to_update_5) this.dataSource.removeControl('key_name_to_update_5');
      if (response_parameters_5) this.dataSource.removeControl('response_parameters_5');
      if (user_key_7) this.dataSource.removeControl('user_key_7');
      if (response_parameters_7) this.dataSource.removeControl('response_parameters_7');
      if (custom_pagination_script) this.dataSource.removeControl('custom_pagination_script');
    } else if (this.selectPaginationType == 7) {
      user_key = this.dataSource.value.user_key_7;
      response_parameters = this.dataSource.value.response_parameters_7;
      pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds;
      if (user_key_3) this.dataSource.removeControl('user_key_3');
      if (key_name_to_update_3) this.dataSource.removeControl('key_name_to_update_3');
      if (response_parameters_3) this.dataSource.removeControl('response_parameters_3');
      if (user_key_2) this.dataTarget.removeControl('user_key_2');
      if (response_parameters_2) this.dataSource.removeControl('response_parameters_2');
      if (another_response_parameter_2) this.dataSource.removeControl('another_response_parameter_2');
      if (user_key_4) this.dataSource.removeControl('user_key_4');
      if (key_name_to_update_4) this.dataSource.removeControl('key_name_to_update_4');
      if (response_parameters_4) this.dataSource.removeControl('response_parameters_4');
      if (user_key_5) this.dataSource.removeControl('user_key_5');
      if (key_name_to_update_5) this.dataSource.removeControl('key_name_to_update_5');
      if (response_parameters_5) this.dataSource.removeControl('response_parameters_5');
      if (user_key_6) this.dataSource.removeControl('user_key_6');
      if (user_key_url_6) this.dataSource.removeControl('user_key_url_6');
      if (response_parameters_6) this.dataSource.removeControl('response_parameters_6');
      if (custom_pagination_script) this.dataSource.removeControl('custom_pagination_script');
    } else if (this.selectPaginationType == 8) {
      custom_pagination_script_tmp = this.dataSource.value.custom_pagination_script;
      pagination_retry_seconds = this.dataSource.value.pagination_retry_seconds;
      if (user_key_3) this.dataSource.removeControl('user_key_3');
      if (key_name_to_update_3) this.dataSource.removeControl('key_name_to_update_3');
      if (response_parameters_3) this.dataSource.removeControl('response_parameters_3');
      if (user_key_2) this.dataTarget.removeControl('user_key_2');
      if (response_parameters_2) this.dataSource.removeControl('response_parameters_2');
      if (another_response_parameter_2) this.dataSource.removeControl('another_response_parameter_2');
      if (user_key_4) this.dataSource.removeControl('user_key_4');
      if (key_name_to_update_4) this.dataSource.removeControl('key_name_to_update_4');
      if (response_parameters_4) this.dataSource.removeControl('response_parameters_4');
      if (user_key_5) this.dataSource.removeControl('user_key_5');
      if (key_name_to_update_5) this.dataSource.removeControl('key_name_to_update_5');
      if (response_parameters_5) this.dataSource.removeControl('response_parameters_5');
      if (user_key_6) this.dataSource.removeControl('user_key_6');
      if (user_key_url_6) this.dataSource.removeControl('user_key_url_6');
      if (response_parameters_6) this.dataSource.removeControl('response_parameters_6');
      if (user_key_7) this.dataSource.removeControl('user_key_7');
      if (response_parameters_7) this.dataSource.removeControl('response_parameters_7');
    } else {
      if (user_key_3) this.dataSource.removeControl('user_key_3');
      if (key_name_to_update_3) this.dataSource.removeControl('key_name_to_update_3');
      if (response_parameters_3) this.dataSource.removeControl('response_parameters_3');
      if (user_key_2) this.dataSource.removeControl('user_key_2');
      if (response_parameters_2) this.dataSource.removeControl('response_parameters_2');
      if (another_response_parameter_2) this.dataSource.removeControl('another_response_parameter_2');
      if (user_key_4) this.dataSource.removeControl('user_key_4');
      if (key_name_to_update_4) this.dataSource.removeControl('key_name_to_update_4');
      if (response_parameters_4) this.dataSource.removeControl('response_parameters_4');
      if (user_key_5) this.dataSource.removeControl('user_key_5');
      if (key_name_to_update_5) this.dataSource.removeControl('key_name_to_update_5');
      if (response_parameters_5) this.dataSource.removeControl('response_parameters_5');
      if (user_key_6) this.dataSource.removeControl('user_key_6');
      if (user_key_url_6) this.dataSource.removeControl('user_key_url_6');
      if (response_parameters_6) this.dataSource.removeControl('response_parameters_6');
      if (user_key_7) this.dataSource.removeControl('user_key_7');
      if (response_parameters_7) this.dataSource.removeControl('response_parameters_7');
    }

    let sourcePostmanFormData;
    if (this.bridge_source_type == 1) {
      for (const component of this.postmanuiComponents.toArray()) {
        if (component.apiCatalogFormType === 'source') {
          sourcePostmanFormData = await component.getApiCatalogPostmanData();
        }
      }
      // console.log(sourcePostmanFormData);
      // if (this.endpoint_url != "") {
      //   let eurl = this.endpoint_url.replace(/<[^>]*>/g, '');
      //   this.dataSource.controls['bridge_source_endpoint_url'].setValue(eurl);
      // }

      // if (this.source_auth != "") {
      //   this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_url'].setValue(this.source_auth);
      // }
      if (this.dataSource.invalid) {
        console.log("Invalid form controls:", this.getSourceInvalidControls());
        this.helperService.presentToast("Data Source form incomplete", 2000);
        return;
      }

      if(sourcePostmanFormData.sourcePostmanFormInvalid) {
        return;
      }
      pagination_style = this.dataSource.value.bridge_source_pagination_type.type_value;

      // if (this.dataSource.value.bridge_source_endpoint_body_raw != '' && this.dataSource.value.bridge_source_endpoint_body_raw != undefined && JSON.stringify(this.dataSource.value.bridge_source_endpoint_body_raw) !== '{}') {
      //   if (this.dataSource.value.bridge_source_body_type == 'JSON') {
      //     if (this.helperService.isValidJSON(this.dataSource.value.bridge_source_endpoint_body_raw) == false) {
      //       this.helperService.presentToast('Please provide valid source body JSON Data', 2000);
      //       return
      //     }
      //   }
      //   if (this.dataSource.value.bridge_source_body_type == 'XML') {
      //     if (this.helperService.isValidXML(this.dataSource.value.bridge_source_endpoint_body_raw) == false) {
      //       this.helperService.presentToast('Please provide valid source body XML Data', 2000);
      //       return
      //     }
      //   }
      // }
    } else {
      if (this.dataSource.invalid) {
        this.helperService.presentToast("Data Source form incomplete", 2000);
        return;
      }
    }

    // this.hideAllOpsForms()
    this.selectedOperationId = '';
    let formId = []
    for (let item of this.finalBlocks) {
      //console.log(item)
      if (item.isMute == false) {
        if (item.title == 'Data types') {
          let dataTypeArr = this.datatypesRows().value
          for (let i = 0; i < dataTypeArr.length; i++) {
            let incompleteBlocks = Object.keys(dataTypeArr[i])
            if (item.id == dataTypeArr[i].id) {
              if ((dataTypeArr[i].boolean_operator == '' || dataTypeArr[i].boolean_operator == undefined) &&
                (dataTypeArr[i].float_operator == '' || dataTypeArr[i].float_operator == undefined) &&
                (dataTypeArr[i].integer_operator == '' || dataTypeArr[i].integer_operator == undefined) &&
                (dataTypeArr[i].datetime_operator == '' || dataTypeArr[i].datetime_operator == undefined)) {
                formId.push({ id: dataTypeArr[i].id })
              } else {
                const getstr = dataTypeArr[i];
                if(getstr.boolean_operator ||getstr.float_operator||getstr.integer_operator||getstr.datetime_operator){
                  let id=getstr.id;
                  let mute=getstr.isMute;
                  delete getstr.id;
                  delete getstr.isMute;
                  if(Object.keys(getstr).map(key=>{
                    if(getstr[key].length>0){
                      if(this.helperService.isValidString(getstr[key])){
                        return true;
                      }
                      return false;
                    }
                  }).includes(false)){
                    this.helperService.presentToast('Please provide valid STRING - Data types Operation', 2000);
                    getstr.id=id;
                    getstr.isMute=mute;
                    formId.push({ id: dataTypeArr[i].id });
                    item.isValid = false;
                    return;
                  }
                  getstr.id=id;
                  getstr.isMute=mute;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Append') {
          let appendArr = this.appendRows().value;
          for (let i = 0; i < appendArr.length; i++) {
            if (item.id == appendArr[i].id) {
              if (appendArr[i].append == '' || appendArr[i].append == undefined) {
                // this.helperService.presentToast("Data operation: Append form incomplete", 2000);
                // this.selectedOperationId = appendArr[i].id
                formId.push({ id: appendArr[i].id })
                // this.isAppendFromEnabled = true;
                // return
              } else {
                var getstr = "{" + appendArr[i].append + "}";
                if (this.helperService.isValidJSON(getstr) == false) {
                  this.helperService.presentToast('Please provide valid JSON - Append Operation', 2000);
                  formId.push({ id: appendArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Titlecase') {
          let titleArr = this.titlecaseRows().value;
          for (let i = 0; i < titleArr.length; i++) {
            if (item.id == titleArr[i].id) {
              if (titleArr[i].titlecase == '' || titleArr[i].titlecase == undefined) {
                // this.helperService.presentToast("Data operation: Titlecase form incomplete", 2000);
                // this.selectedOperationId = titleArr[i].id
                // this.isTitlecaseFromEnabled = true;
                // this.type = 'inValid';
                formId.push({ id: titleArr[i].id })
                // return
              } else {
                const getstr = titleArr[i].titlecase;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Titlecase Operation', 2000);
                  formId.push({ id: titleArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Uppercase') {
          let upperCaseArr = this.uppercaseRows().value;
          for (let i = 0; i < upperCaseArr.length; i++) {
            if (item.id == upperCaseArr[i].id) {
              if (upperCaseArr[i].uppercase == '' || upperCaseArr[i].uppercase == undefined) {
                // this.helperService.presentToast("Data operation: Uppercase form incomplete", 2000);
                // this.selectedOperationId = upperCaseArr[i].id
                // this.isUppercaseFromEnabled = true;
                // this.type = 'inValid';
                formId.push({ id: upperCaseArr[i].id })
                // return
              } else {
                const getstr = upperCaseArr[i].uppercase;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Uppercase Operation', 2000);
                  formId.push({ id: upperCaseArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Lowercase') {
          let lowerCaseArr = this.lowercaseRows().value;
          for (let i = 0; i < lowerCaseArr.length; i++) {
            if (item.id == lowerCaseArr[i].id) {
              if (lowerCaseArr[i].lowercase == '' || lowerCaseArr[i].lowercase == undefined) {
                // this.helperService.presentToast("Data operation: Lowercase form incomplete", 2000);
                // this.selectedOperationId = lowerCaseArr[i].id
                // this.isLowercaseFromEnabled = true;
                // this.type = 'inValid';
                formId.push({ id: lowerCaseArr[i].id })
                // return
              } else {
                const getstr = lowerCaseArr[i].lowercase;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Lowercase Operation', 2000);
                  formId.push({ id: lowerCaseArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Data extractor') {
          let dataExtractorArr = this.dataextractorRows().value;
          for (let i = 0; i < dataExtractorArr.length; i++) {
            if (item.id == dataExtractorArr[i].id) {
              if (dataExtractorArr[i].data_extractor == '' || dataExtractorArr[i].data_extractor == undefined) {
                // this.helperService.presentToast("Data operation: Data extractor form incomplete", 2000);
                // this.selectedOperationId = dataExtractorArr[i].id
                // this.isData_extractorFromEnabled = true;
                // this.type = 'inValid';
                // return
                formId.push({ id: dataExtractorArr[i].id })
              } else {
                item.isValid = true;
              }
              // if(dataExtractorArr[i].data_extractor_keys == '' || dataExtractorArr[i].data_extractor_keys == undefined){
              //   formId.push({id:dataExtractorArr[i].id})
              // } else {
              //   item.isValid = true;
              // }
            }
          }
        } else if (item.title == 'Trim') {
          let trimArr = this.trimRows().value;
          for (let i = 0; i < trimArr.length; i++) {
            if (trimArr[i].trim_keys == '' || trimArr[i].trim_keys == undefined) {
              if (item.id == trimArr[i].id) {
                // this.helperService.presentToast("Data operation: Trim form incomplete", 2000);
                // this.selectedOperationId = trimArr[i].id
                // this.isTrimFromEnabled = true;
                // return
                formId.push({ id: trimArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON to String') {
          let json2stringArr = this.json2stringRows().value;
          for (let i = 0; i < json2stringArr.length; i++) {
            if (json2stringArr[i].json2string == '' || json2stringArr[i].json2string == undefined) {
              if (item.id == json2stringArr[i].id) {
                formId.push({ id: json2stringArr[i].id })
              } else {
                item.isValid = true;
              }
            }else{
              const getstr = json2stringArr[i].json2string;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - JSON to String Operation', 2000);
                  formId.push({ id: json2stringArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
            }
          }
        } else if (item.title == 'String to JSON') {
          let string2jsonArr = this.string2jsonRows().value;
          for (let i = 0; i < string2jsonArr.length; i++) {
            if (string2jsonArr[i].string2json == '' || string2jsonArr[i].string2json == undefined) {
              if (item.id == string2jsonArr[i].id) {
                formId.push({ id: string2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON to XML') {
          let jsontoxmlArr = this.jsontoxmlRows().value;
          for (let i = 0; i < jsontoxmlArr.length; i++) {
            if (item.id == jsontoxmlArr[i].id) {
              if (jsontoxmlArr[i].key_data == '' || jsontoxmlArr[i].key_data == undefined) {
                formId.push({ id: jsontoxmlArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsontoxmlArr[i].response_key == '' || jsontoxmlArr[i].response_key == undefined) {
                formId.push({ id: jsontoxmlArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'XML to JSON') {
          let xmlToJsonArr = this.xmltojsonRows().value;
          for (let i = 0; i < xmlToJsonArr.length; i++) {
            if (item.id == xmlToJsonArr[i].id) {
              if (xmlToJsonArr[i].get_key == '' || xmlToJsonArr[i].get_key == undefined) {
                formId.push({ id: xmlToJsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (xmlToJsonArr[i].response_key == '' || xmlToJsonArr[i].response_key == undefined) {
                formId.push({ id: xmlToJsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Base64 encoding') {
          let base64EncodingArr = this.base64encodingRows().value;
          for (let i = 0; i < base64EncodingArr.length; i++) {
            if (base64EncodingArr[i].base64_encode == '' || base64EncodingArr[i].base64_encode == undefined) {
              if (item.id == base64EncodingArr[i].id) {
                // this.helperService.presentToast("Data operation: Base64 encoding form incomplete", 2000);
                // this.selectedOperationId = base64EncodingArr[i].id
                // this.isBase64encodingFromEnabled = true;
                // this.type = 'inValid';
                // return
                formId.push({ id: base64EncodingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Base64 decoding') {
          let base64DecodingArr = this.base64decodingRows().value;
          for (let i = 0; i < base64DecodingArr.length; i++) {
            if (base64DecodingArr[i].base64_decode == '' || base64DecodingArr[i].base64_decode == undefined) {
              if (item.id == base64DecodingArr[i].id) {
                // this.helperService.presentToast("Data operation: Base64 decoding form incomplete", 2000);
                // this.selectedOperationId = base64DecodingArr[i].id
                // this.isBase64decodingFromEnabled = true;
                // this.type = 'inValid';
                // return
                formId.push({ id: base64DecodingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Generate Array Sequence Number') {
          let generatesequenceArr = this.generatesequenceRows().value;
          for (let i = 0; i < generatesequenceArr.length; i++) {
            if (item.id == generatesequenceArr[i].id) {
              if (generatesequenceArr[i].sequence_key == '' || generatesequenceArr[i].sequence_key == undefined) {
                formId.push({ id: generatesequenceArr[i].id })
              } else {
                item.isValid = true;
              }
              if (generatesequenceArr[i].sequence_number_key == '' || generatesequenceArr[i].sequence_number_key == undefined) {
                formId.push({ id: generatesequenceArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Send Keys Top of Root') {
          let toplevelArr = this.toplevelRows().value;
          for (let i = 0; i < toplevelArr.length; i++) {
            if (toplevelArr[i].column_to_root == '' || toplevelArr[i].column_to_root == undefined) {
              if (item.id == toplevelArr[i].id) {
                formId.push({ id: toplevelArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Today Timestamp') {
          let datetimestampArr = this.datetimestampRows().value;
          for (let i = 0; i < datetimestampArr.length; i++) {
            if (item.id == datetimestampArr[i].id) {
              if (datetimestampArr[i].date_format == '' || datetimestampArr[i].date_format == undefined) {
                formId.push({ id: datetimestampArr[i].id })
              } else {
                item.isValid = true;
              }
              if (datetimestampArr[i].datetime_key == '' || datetimestampArr[i].datetime_key == undefined) {
                formId.push({ id: datetimestampArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Repeat First Row Values') {
          let repeatfirstrowArr = this.repeatfirstrowRows().value;
          for (let i = 0; i < repeatfirstrowArr.length; i++) {
            if (item.id == repeatfirstrowArr[i].id) {
              if (repeatfirstrowArr[i].source_key == '' || repeatfirstrowArr[i].source_key == undefined) {
                formId.push({ id: repeatfirstrowArr[i].id })
              } else {
                item.isValid = true;
              }
              if (repeatfirstrowArr[i].fields_to_repeat_value == '' || repeatfirstrowArr[i].fields_to_repeat_value == undefined) {
                formId.push({ id: repeatfirstrowArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Encode Decode') {
          let encodedecodeArr = this.encodedecodeRows().value;
          for (let i = 0; i < encodedecodeArr.length; i++) {
            if (item.id == encodedecodeArr[i].id) {
              if (encodedecodeArr[i].response_key == '' || encodedecodeArr[i].response_key == undefined) {
                formId.push({ id: encodedecodeArr[i].id })
              } else {
                item.isValid = true;
              }
              if (encodedecodeArr[i].method_type == '' || encodedecodeArr[i].method_type == undefined) {
                formId.push({ id: encodedecodeArr[i].id })
              } else {
                item.isValid = true;
              }
              if (encodedecodeArr[i].process == '' || encodedecodeArr[i].process == undefined) {
                formId.push({ id: encodedecodeArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Zipfile in Base64') {
          let zipfileinbase64Arr = this.zipfileinbase64Rows().value;
          for (let i = 0; i < zipfileinbase64Arr.length; i++) {
            if (item.id == zipfileinbase64Arr[i].id) {
              if (zipfileinbase64Arr[i].source_key == '' || zipfileinbase64Arr[i].source_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
              if (zipfileinbase64Arr[i].file_name_key == '' || zipfileinbase64Arr[i].file_name_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
              if (zipfileinbase64Arr[i].file_extension_key == '' || zipfileinbase64Arr[i].file_extension_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
              if (zipfileinbase64Arr[i].file_data_key == '' || zipfileinbase64Arr[i].file_data_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
              if (zipfileinbase64Arr[i].base64_response_key == '' || zipfileinbase64Arr[i].base64_response_key == undefined) {
                formId.push({ id: zipfileinbase64Arr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'PDF Extractor') {
          let pdfextractorArr = this.pdfextractorRows().value;
          for (let i = 0; i < pdfextractorArr.length; i++) {
            if (item.id == pdfextractorArr[i].id) {
              if (pdfextractorArr[i].pdfLocationToggle == 'file_url') {
                if (pdfextractorArr[i].file_url == '' || pdfextractorArr[i].file_url == undefined) {
                  formId.push({ id: pdfextractorArr[i].id })
                } else {
                  item.isValid = true;
                }
                pdfextractorArr[i].base64_key = ''
              } else {
                if (pdfextractorArr[i].base64_key == '' || pdfextractorArr[i].base64_key == undefined) {
                  formId.push({ id: pdfextractorArr[i].id })
                } else {
                  item.isValid = true;
                }
                pdfextractorArr[i].file_url = ''
              }
            }
          }
        } else if (item.title == 'File Extractor') {
          let fileextractorArr = this.fileextractorRows().value;
          for (let i = 0; i < fileextractorArr.length; i++) {
            if (item.id == fileextractorArr[i].id) {
              if (fileextractorArr[i].file_data_key == '' || fileextractorArr[i].file_data_key == undefined) {
                formId.push({ id: fileextractorArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Grok Pattern') {
          let grokpatternArr = this.grokpatternRows().value;
          for (let i = 0; i < grokpatternArr.length; i++) {
            if (item.id == grokpatternArr[i].id) {
              if (grokpatternArr[i].input_key == '' || grokpatternArr[i].input_key == undefined) {
                formId.push({ id: grokpatternArr[i].id })
              } else {
                item.isValid = true;
              }
              if (grokpatternArr[i].grok_pattern == '' || grokpatternArr[i].grok_pattern == undefined) {
                formId.push({ id: grokpatternArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Raw Sentence Generator') {
          let rawsentencegeneratorArr = this.rawsentencegeneratorRows().value;
          for (let i = 0; i < rawsentencegeneratorArr.length; i++) {
            if (item.id == rawsentencegeneratorArr[i].id) {
              if (rawsentencegeneratorArr[i].raw_response_key == '' || rawsentencegeneratorArr[i].raw_response_key == undefined) {
                formId.push({ id: rawsentencegeneratorArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Array Count') {
          let arraycountArr = this.arraycountRows().value;
          for (let i = 0; i < arraycountArr.length; i++) {
            if (item.id == arraycountArr[i].id) {
              if (arraycountArr[i].array_key_name == '' || arraycountArr[i].array_key_name == undefined) {
                formId.push({ id: arraycountArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Single Line to Multiline') {
          let chopArr = this.chopRows().value;
          for (let i = 0; i < chopArr.length; i++) {
            if (item.id == chopArr[i].id) {
              if (chopArr[i].chopkey == '' || chopArr[i].chopkey == undefined) {
                formId.push({ id: chopArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON to delimiter') {
          let json2dlArr = this.json2dlRows().value;
          for (let i = 0; i < json2dlArr.length; i++) {
            if (item.id == json2dlArr[i].id) {
              // dl2jsonArr[i].autodetect_column_names = dl2jsonArr[i].autodetect_column_names.toString();
              // dl2jsonArr[i].skip_header = dl2jsonArr[i].skip_header.toString();
              if (json2dlArr[i].key_data == '' || json2dlArr[i].key_data == undefined) {
                formId.push({ id: json2dlArr[i].id })
              } else {
                item.isValid = true;
              }
              if (json2dlArr[i].delimiter == '' || json2dlArr[i].delimiter == undefined) {
                formId.push({ id: json2dlArr[i].id })
              } else {
                item.isValid = true;
              }
              // if(json2dlArr[i].fields == '' || json2dlArr[i].fields == undefined){
              //   formId.push({id:json2dlArr[i].id})
              // } else {
              //   item.isValid = true;
              // }
              // if (json2dlArr[i].autodetect_column_names == '' || json2dlArr[i].autodetect_column_names == undefined) {
              //   formId.push({ id: json2dlArr[i].id })
              // } else {
              //   item.isValid = true;
              // }
              // if (json2dlArr[i].skip_header == '' || json2dlArr[i].skip_header == undefined) {
              //   formId.push({ id: json2dlArr[i].id })
              // } else {
              //   item.isValid = true;
              // }
              if (json2dlArr[i].response_key == '' || json2dlArr[i].response_key == undefined) {
                formId.push({ id: json2dlArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Delimiter to JSON') {
          let dl2jsonArr = this.dl2jsonRows().value;
          for (let i = 0; i < dl2jsonArr.length; i++) {
            if (item.id == dl2jsonArr[i].id) {
              dl2jsonArr[i].autodetect_column_names = dl2jsonArr[i].autodetect_column_names.toString();
              dl2jsonArr[i].skip_header = dl2jsonArr[i].skip_header.toString();
              if (dl2jsonArr[i].key_data == '' || dl2jsonArr[i].key_data == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2jsonArr[i].delimiter == '' || dl2jsonArr[i].delimiter == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2jsonArr[i].autodetect_column_names == '' || dl2jsonArr[i].autodetect_column_names == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2jsonArr[i].skip_header == '' || dl2jsonArr[i].skip_header == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2jsonArr[i].response_key == '' || dl2jsonArr[i].response_key == undefined) {
                formId.push({ id: dl2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Delimiter to Array') {
          let dl2arrayArr = this.dl2arrayRows().value;
          for (let i = 0; i < dl2arrayArr.length; i++) {
            if (item.id == dl2arrayArr[i].id) {
              if (dl2arrayArr[i].dl_key == '' || dl2arrayArr[i].dl_key == undefined) {
                formId.push({ id: dl2arrayArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dl2arrayArr[i].delimiter == '' || dl2arrayArr[i].delimiter == undefined) {
                formId.push({ id: dl2arrayArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Data aggregation') {
          let dataAggregationArr = this.dataaggregationRows().value;
          for (let i = 0; i < dataAggregationArr.length; i++) {
            if (item.id == dataAggregationArr[i].id) {
              if (dataAggregationArr[i].groupby_key == '' || dataAggregationArr[i].groupby_key == undefined) {
                formId.push({ id: dataAggregationArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dataAggregationArr[i].array_key == '' || dataAggregationArr[i].array_key == undefined) {
                formId.push({ id: dataAggregationArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Unpivot') {
          let unPivotArr = this.unpivotRows().value;
          for (let i = 0; i < unPivotArr.length; i++) {
            if (item.id == unPivotArr[i].id) {
              if (unPivotArr[i].transpose_key_name == '' || unPivotArr[i].transpose_key_name == undefined) {
                formId.push({ id: unPivotArr[i].id })
              } else {
                item.isValid = true;
              }
              if (unPivotArr[i].transpose_value == '' || unPivotArr[i].transpose_value == undefined) {
                formId.push({ id: unPivotArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Pivot') {
          let PivotArr = this.pivotRows().value;
          for (let i = 0; i < PivotArr.length; i++) {
            if (item.id == PivotArr[i].id) {
              if (PivotArr[i].get_key == '' || PivotArr[i].get_key == undefined) {
                formId.push({ id: PivotArr[i].id })

              } else {
                item.isValid = true;
              }
              if (PivotArr[i].transposed_key_name == '' || PivotArr[i].transposed_key_name == undefined) {
                formId.push({ id: PivotArr[i].id })
              } else {
                item.isValid = true;
              }
              if (PivotArr[i].transposed_value == '' || PivotArr[i].transposed_value == undefined) {
                formId.push({ id: PivotArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Single Line to Tuple') {
          let singleline2tupleArr = this.singleline2tupleRows().value;
          for (let i = 0; i < singleline2tupleArr.length; i++) {
            if (item.id == singleline2tupleArr[i].id) {
              if (singleline2tupleArr[i].singleline_key == '' || singleline2tupleArr[i].singleline_key == undefined) {
                formId.push({ id: singleline2tupleArr[i].id })
              } else {
                item.isValid = true;
              }
              if (singleline2tupleArr[i].table_headers == '' || singleline2tupleArr[i].table_headers == undefined) {
                formId.push({ id: singleline2tupleArr[i].id })
              } else {
                item.isValid = true;
              }
              if (singleline2tupleArr[i].tuple_key == '' || singleline2tupleArr[i].tuple_key == undefined) {
                formId.push({ id: singleline2tupleArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Tuple to Single Line') {
          let tuple2singlelineArr = this.tuple2singlelineRows().value;
          for (let i = 0; i < tuple2singlelineArr.length; i++) {
            if (item.id == tuple2singlelineArr[i].id) {
              if (tuple2singlelineArr[i].tuple_key == '' || tuple2singlelineArr[i].tuple_key == undefined) {
                formId.push({ id: tuple2singlelineArr[i].id })
              } else {
                item.isValid = true;
              }
              if (tuple2singlelineArr[i].headers == '' || tuple2singlelineArr[i].headers == undefined) {
                formId.push({ id: tuple2singlelineArr[i].id })
              } else {
                item.isValid = true;
              }
              if (tuple2singlelineArr[i].singleline_key == '' || tuple2singlelineArr[i].singleline_key == undefined) {
                formId.push({ id: tuple2singlelineArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Drop all events to start with') {
          let dropeventsstartswithArr = this.dropeventsstartswithRows().value;
          for (let i = 0; i < dropeventsstartswithArr.length; i++) {
            if (item.id == dropeventsstartswithArr[i].id) {
              if (dropeventsstartswithArr[i].drop_all_event_to_start_with == '' || dropeventsstartswithArr[i].drop_all_event_to_start_with == undefined) {
                formId.push({ id: dropeventsstartswithArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Drop all events for value') {
          let dropalleventvaluesArr = this.dropalleventvaluesRows().value;
          for (let i = 0; i < dropalleventvaluesArr.length; i++) {
            if (item.id == dropalleventvaluesArr[i].id) {
              if (dropalleventvaluesArr[i].drop_all_event_for_value == '' || dropalleventvaluesArr[i].drop_all_event_for_value == undefined) {
                formId.push({ id: dropalleventvaluesArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Eliminate') {
          let eliminateArr = this.eliminateRows().value;
          for (let i = 0; i < eliminateArr.length; i++) {
            if (item.id == eliminateArr[i].id) {
              if (eliminateArr[i].eliminate == '' || eliminateArr[i].eliminate == undefined) {
                formId.push({ id: eliminateArr[i].id })
              } else {
                const getstr = eliminateArr[i].eliminate;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Eliminate Operation', 2000);
                  formId.push({ id: eliminateArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Round') {
          let roundArr = this.roundRows().value;
          for (let i = 0; i < roundArr.length; i++) {
            if (item.id == roundArr[i].id) {
              if (roundArr[i].round_keys == '' || roundArr[i].round_keys == undefined) {
                formId.push({ id: roundArr[i].id })
              } else {
                const getstr = roundArr[i].round_keys;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Round Operation', 2000);
                  formId.push({ id: roundArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
              if (roundArr[i].decimal_key_number == '' || roundArr[i].decimal_key_number == undefined) {
                formId.push({ id: roundArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Calculator') {
          let calculaterArr = this.calculaterRows().value;
          for (let i = 0; i < calculaterArr.length; i++) {
            if (item.id == calculaterArr[i].id) {
              if (calculaterArr[i].calculation_keys == '' || calculaterArr[i].calculation_keys == undefined) {
                formId.push({ id: calculaterArr[i].id })
              } else {
                item.isValid = true;
              }
              if (calculaterArr[i].new_calculation_keys == '' || calculaterArr[i].new_calculation_keys == undefined) {
                formId.push({ id: calculaterArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Date Analytics') {
          let dateanalyticsArr = this.dateanalyticsRows().value;
          for (let i = 0; i < dateanalyticsArr.length; i++) {
            if (item.id == dateanalyticsArr[i].id) {
              if (dateanalyticsArr[i].date_field_key == '' || dateanalyticsArr[i].date_field_key == undefined) {
                formId.push({ id: dateanalyticsArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dateanalyticsArr[i].fiscal_month_start == '' || dateanalyticsArr[i].fiscal_month_start == undefined) {
                formId.push({ id: dateanalyticsArr[i].id })
              } else {
                item.isValid = true;
              }
              if (dateanalyticsArr[i].weekday == '' || dateanalyticsArr[i].weekday == undefined) {
                formId.push({ id: dateanalyticsArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Substitute') {
          let substituteArr = this.substituteRows().value;
          for (let i = 0; i < substituteArr.length; i++) {
            if (item.id == substituteArr[i].id) {
              if (substituteArr[i].substitute == '' || substituteArr[i].substitute == undefined) {
                formId.push({ id: substituteArr[i].id })
              } else {
                const getstr = substituteArr[i].substitute;
                if(this.helperService.isValidString(getstr) == false){
                  this.helperService.presentToast('Please provide valid STRING - Substitute Operation', 2000);
                  formId.push({ id: substituteArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Rename') {
          let renameArr = this.renameRows().value;
          for (let i = 0; i < renameArr.length; i++) {
            if (item.id == renameArr[i].id) {
              if (renameArr[i].rename == '' || renameArr[i].rename == undefined) {
                formId.push({ id: renameArr[i].id })
              } else {
                var getstr = "{" + renameArr[i].rename + "}";
                if (this.helperService.isValidJSON(getstr) == false) {
                  this.helperService.presentToast('Please provide valid JSON - Rename Operation', 2000);
                  formId.push({ id: renameArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Strip') {
          let stripArr = this.stripRows().value;
          for (let i = 0; i < stripArr.length; i++) {
            if (item.id == stripArr[i].id) {
              if (stripArr[i].strip == '' || stripArr[i].strip == undefined) {
                formId.push({ id: stripArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Substring') {
          let substringArr = this.substringRows().value;
          for (let i = 0; i < substringArr.length; i++) {
            if (item.id == substringArr[i].id) {
              if (substringArr[i].substring == '' || substringArr[i].substring == undefined) {
                formId.push({ id: substringArr[i].id })
              } else {
                var getstr = "{" + substringArr[i].substring + "}";
                if (this.helperService.isValidJSON(getstr) == false) {
                  this.helperService.presentToast('Please provide valid JSON - Substring Operation', 2000);
                  formId.push({ id: substringArr[i].id });
                  item.isValid = false;
                  return;
                }
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'API') {
          
            
        
        // console.log(opsParams);
        // console.log(opsHeaders);
        // console.log("------------------------");
            // this.callChildMethod(this.opsData[count]);
        let restapiArr = this.restapiRows().value;
        for (let i = 0; i < restapiArr.length; i++){
          if (item.id == restapiArr[i].id) {
            let count = item.count-1;
            let params = this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.endpoint_params;
            let headers = this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.endpoint_headers;
            let opsParams=[];
            if(params != undefined){
              if(params.length > 0){
                for(let ops of params){
                  if(ops.paramKey != "" && ops.paramValue != ""){
                    let obj = {
                      key: ops.paramKey,
                      value: ops.paramValue,
                      description: ops.paramDescription
                    }
                    opsParams.push(obj);
                  }else if((ops.key != "" && ops.key != undefined) && (ops.value != "" && ops.value != undefined)){
                    opsParams.push(ops);
                  }          
                }
              }
            }

            let opsHeaders=[];
            if(headers != undefined){
              if(headers.length > 0){
                for(let ops of headers){
                  if(ops.headerKey != "" && ops.headerValue != ""){
                    let obj = {
                      key: ops.headerKey,
                      value: ops.headerValue,
                      description: ops.headerDescription
                    }
                    opsHeaders.push(obj);
                  }else if((ops.key != "" && ops.key != undefined) && (ops.value != "" && ops.value != undefined)){
                    opsHeaders.push(ops);
                  }          
                }
              }
            }
            if(this.opsData[i] != undefined && this.opsData[i].length > 0){
              this.opsData[i].input_structure_json.input.bizdata_rest.endpoint_params = opsParams;
              this.opsData[i].input_structure_json.input.bizdata_rest.endpoint_headers = opsHeaders;
            }
            

            if(restapiArr[i].is_new_target){
              if(restapiArr[i].new_bridge_target == '' || restapiArr[i].new_bridge_target == undefined){
                formId.push({ id: restapiArr[i].id })
              } else {
                item.isValid = true;
              }
              if(restapiArr[i].new_bridge_target_business_object == '' || restapiArr[i].new_bridge_target_business_object == undefined){
                formId.push({ id: restapiArr[i].id })
              } else {
                item.isValid = true;
              }
            } else {
              if(restapiArr[i].bridge_target == '' || restapiArr[i].bridge_target == undefined){
                formId.push({ id: restapiArr[i].id })
              } else {
                item.isValid = true;
              }
              if(restapiArr[i].bridge_target_business_object == '' || restapiArr[i].bridge_target_business_object == undefined){
                formId.push({ id: restapiArr[i].id })
              } else {
                item.isValid = true;
              }
            }
            if(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.endpoint_url == '' || this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.endpoint_url == undefined){
              formId.push({ id: restapiArr[i].id })
            } else {
              item.isValid = true;
            }
            if(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.authentication_type.id == 4){
              if(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.username == '' || this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.username== undefined){
                formId.push({ id: restapiArr[i].id })
              }
              if(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.password == '' || this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.password == undefined){
                formId.push({ id: restapiArr[i].id })
              } else {
                item.isValid = true;
              }
            }
            if(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.authentication_type.id == 6){
              if(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.refresh_token_endpoint_method == '' || this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.refresh_token_endpoint_method == undefined){
              formId.push({ id: restapiArr[i].id })
            }
            if(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.refresh_token_endpoint_url == '' || this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.refresh_token_endpoint_url == undefined){
              formId.push({ id: restapiArr[i].id })
            } else {
              item.isValid = true;
            }
          };

            const body_rawJsonString     = this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.endpoint_body_raw;
            const body_raw_cleanedString = body_rawJsonString ? body_rawJsonString.trim() : null;
            if (body_raw_cleanedString   == null || body_raw_cleanedString == "") {
              continue;
            };
            if (this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.body_type == 'JSON') {
              if (this.helperService.isValidJSON(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.endpoint_body_raw) == false) {
                this.helperService.presentToast('Please provide valid target body JSON Data', 2000);
                return
              }else{
                item.valid=true
              }
            }
            if (this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.body_type == 'XML') {
              if (this.helperService.isValidXML(this.opsData[i]?.input_structure_json?.input?.bizdata_rest?.endpoint_body_raw) == false) {
                this.helperService.presentToast('Please provide valid target body XML Data', 2000);
                return
              }
              else{
                item.valid=true
              }
            }
          };
        }
        } else if (item.title == "DL Ingestion") {
          let dlIngestionArr = this.dlIngestionRows().value;
          for (let i = 0; i < dlIngestionArr.length; i++) {
            if (item.id == dlIngestionArr[i].id) {
              if (dlIngestionArr[i].index_name == '' || dlIngestionArr[i].index_name == undefined) {
                formId.push({ id: dlIngestionArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == "DataLake Search") {
          let dlsearchArr = this.dlsearchRows().value;
          for (let i = 0; i < dlsearchArr.length; i++) {
            if (item.id == dlsearchArr[i].id) {
              if (dlsearchArr[i].dlsearch_index_name == '' || dlsearchArr[i].dlsearch_index_name == undefined) {
                formId.push({ id: dlsearchArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Sleep time') {
          let sleepArr = this.sleepRows().value;
          for (let i = 0; i < sleepArr.length; i++) {
            if (item.id == sleepArr[i].id) {
              if (sleepArr[i].sleep_time == '' || sleepArr[i].sleep_time == undefined) {
                formId.push({ id: sleepArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Python') {
          let pycodeArr = this.pycodeRows().value;
          for (let i = 0; i < pycodeArr.length; i++) {
            if (item.id == pycodeArr[i].id) {
              if (pycodeArr[i].pycode == '' || pycodeArr[i].pycode == undefined) {
                formId.push({ id: pycodeArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        }else if (item.title == 'Filter') {
          let filterArr = this.filterRows().value;
          for (let i = 0; i < filterArr.length; i++) {
            if (item.id == filterArr[i].id) {
              if (filterArr[i].conditional_statement == '' || filterArr[i].conditional_statement == undefined) {
                formId.push({ id: filterArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Email') {
          let emailArr = this.emailRows().value;
          for (let i = 0; i < emailArr.length; i++) {
            if (item.id == emailArr[i].id) {
              if (emailArr[i].From == '' || emailArr[i].From == undefined) {
                formId.push({ id: emailArr[i].id })
              } else {
                item.isValid = true;
              }
              if (emailArr[i].password == '' || emailArr[i].password == undefined) {
                formId.push({ id: emailArr[i].id })
              } else {
                item.isValid = true;
              }
              if (emailArr[i].mailserver == '' || emailArr[i].mailserver == undefined) {
                formId.push({ id: emailArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'JSON') {
          let jsonArr = this.jsonRows().value;
          for (let i = 0; i < jsonArr.length; i++) {
            if (item.id == jsonArr[i].id) {
              if (jsonArr[i].jdbc_driver == '' || jsonArr[i].jdbc_driver == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].jdbc_string == '' || jsonArr[i].jdbc_string == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].jdbc_jar_file == '' || jsonArr[i].jdbc_jar_file == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].username == '' || jsonArr[i].username == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].password == '' || jsonArr[i].password == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].unique_key == '' || jsonArr[i].unique_key == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].query == '' || jsonArr[i].query == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].response_parameter == '' || jsonArr[i].response_parameter == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].timer_type == '' || jsonArr[i].timer_type == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].schedule == '' || jsonArr[i].schedule == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].interval_in_seconds == '' || jsonArr[i].interval_in_seconds == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jsonArr[i].multiline == '' || jsonArr[i].multiline == undefined) {
                formId.push({ id: jsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
          // } else if (item.title == 'File') {
          //   let fileArr = this.fileRows().value;
          //   for (let i = 0; i < fileArr.length; i++) {
          //     if (item.id == fileArr[i].id) {
          //       if (fileArr[i].target_location == '' || fileArr[i].target_location == undefined) {
          //         formId.push({ id: fileArr[i].id })
          //       } else {
          //         item.isValid = true;
          //       }
          //       if (fileArr[i].extension == '' || fileArr[i].extension == undefined) {
          //         formId.push({ id: fileArr[i].id })
          //       } else {
          //         item.isValid = true;
          //       }
          //       if (fileArr[i].write_mode == '' || fileArr[i].write_mode == undefined) {
          //         formId.push({ id: fileArr[i].id })
          //       } else {
          //         item.isValid = true;
          //       }
          //     }
          //   }
        } else if (item.title == 'Database') {
          let jdbcArr = this.jdbcoutputRows().value;
          for (let i = 0; i < jdbcArr.length; i++) {
            if (item.id == jdbcArr[i].id) {
              if (jdbcArr[i].query == '' || jdbcArr[i].query == undefined) {
                formId.push({ id: jdbcArr[i].id })
              }else{
                jdbcArr[i].query = jdbcArr[i].query.trim().replace(/^\"(.*)\"$/, "$1");
              }
              if (jdbcArr[i].db_version == '' || jdbcArr[i].db_version == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].host_ip == '' || jdbcArr[i].host_ip == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              let numericRegex=/^[0-9]+$/
              if (jdbcArr[i].port_number == '' || jdbcArr[i].port_number == undefined || !(numericRegex.test(jdbcArr[i].port_number))) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].schema_name == '' || jdbcArr[i].schema_name == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].username == '' || jdbcArr[i].username == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].password == '' || jdbcArr[i].password == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
              if (jdbcArr[i].query == '' || jdbcArr[i].query == undefined) {
                formId.push({ id: jdbcArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        }else if (item.title == 'AI Operation') {
          let aiopsArr = this.aiopsRows().value;
          for (let i = 0; i < aiopsArr.length; i++) {
            if (item.id == aiopsArr[i].id) {
              if (aiopsArr[i].question == '' || aiopsArr[i].question == undefined) {
                formId.push({ id: aiopsArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          } 
        }else if (item.title == 'Document Understanding') {
          let docunderstandingArr = this.docunderstandingRows().value;
          for (let i = 0; i < docunderstandingArr.length; i++) {
            if (item.id == docunderstandingArr[i].id) {
              if (docunderstandingArr[i].text_key == '' || docunderstandingArr[i].text_key == undefined) {
                formId.push({ id: docunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (docunderstandingArr[i].questions[0].docunderstanding_question == '' || docunderstandingArr[i].questions[0].docunderstanding_question == undefined) {
                formId.push({ id: docunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (docunderstandingArr[i].questions[0].docunderstanding_attribute == '' || docunderstandingArr[i].questions[0].docunderstanding_attribute == undefined) {
                formId.push({ id: docunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (docunderstandingArr[i].output_key == '' || docunderstandingArr[i].output_key == undefined) {
                formId.push({ id: docunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Image Understanding') {
          let imgunderstandingArr = this.imgunderstandingRows().value;
          for (let i = 0; i < imgunderstandingArr.length; i++) {
            if (item.id == imgunderstandingArr[i].id) {
              if (imgunderstandingArr[i].img_key == '' || imgunderstandingArr[i].img_key == undefined) {
                formId.push({ id: imgunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (imgunderstandingArr[i].questions[0].imgunderstanding_question == '' || imgunderstandingArr[i].questions[0].imgunderstanding_question == undefined) {
                formId.push({ id: imgunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (imgunderstandingArr[i].questions[0].imgunderstanding_attribute == '' || imgunderstandingArr[i].questions[0].imgunderstanding_attribute == undefined) {
                formId.push({ id: imgunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (imgunderstandingArr[i].output_key == '' || imgunderstandingArr[i].output_key == undefined) {
                formId.push({ id: imgunderstandingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'Data Chunking') {
          let datachunkingArr = this.datachunkingRows().value;
          for (let i = 0; i < datachunkingArr.length; i++) {
            if (item.id == datachunkingArr[i].id) {
              if (datachunkingArr[i].process_key == '' || datachunkingArr[i].process_key == undefined) {
                formId.push({ id: datachunkingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (datachunkingArr[i].chunk_key == '' || datachunkingArr[i].chunk_key == undefined) {
                formId.push({ id: datachunkingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (datachunkingArr[i].token_size == '' || datachunkingArr[i].token_size == undefined) {
                formId.push({ id: datachunkingArr[i].id })
              } else {
                item.isValid = true;
              }
              if (datachunkingArr[i].group_by_chunk == '' || datachunkingArr[i].group_by_chunk == undefined) {
                formId.push({ id: datachunkingArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        } else if (item.title == 'HTML Extractor') {
          let htmlextractorArr = this.htmlExtractorRows().value;
          for (let i = 0; i < htmlextractorArr.length; i++) {
            if (item.id == htmlextractorArr[i].id) {
              if (htmlextractorArr[i].input_html_key == '' || htmlextractorArr[i].input_html_key == undefined) {
                formId.push({ id: htmlextractorArr[i].id })
              } else {
                item.isValid = true;
              }
              if (htmlextractorArr[i].output_data_key == '' || htmlextractorArr[i].output_data_key == undefined) {
                formId.push({ id: htmlextractorArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        }
        else if (item.title == 'JSON to AVRO') {
          let json2avroArr = this.jason2avroRows().value;
          for (let i = 0; i < json2avroArr.length; i++) {
            if (item.id == json2avroArr[i].id) {
              if (json2avroArr[i].jsondata_key == '' || json2avroArr[i].jsondata_key == undefined) {
                formId.push({ id: json2avroArr[i].id })
              } else {
                item.isValid = true;
              }
              if (json2avroArr[i].avro_schema == '' || json2avroArr[i].avro_schema == undefined) {
                formId.push({ id: json2avroArr[i].id })
              } else {
                var getstr = "{" + json2avroArr[i].avro_schema + "}";
                if (this.helperService.isValidJSON(getstr) == false) {
                  this.helperService.presentToast('Please provide valid JSON - JSON to AVRO Operation', 2000);
                  formId.push({ id: json2avroArr[i].id });
                  item.isValid = false;
                  return;
                }    
                item.isValid = true;
              }
              if (json2avroArr[i].response_key == '' || json2avroArr[i].response_key == undefined) {
                formId.push({ id: json2avroArr[i].id })
              } else {
                item.isValid = true;
              }

            }
          }
        }
        else if (item.title == 'AVRO to JSON') {
          let avro2jsonArr = this.avro2jsonRows().value;
          for (let i = 0; i < avro2jsonArr.length; i++) {
            if (item.id == avro2jsonArr[i].id) {
              if (avro2jsonArr[i].avro_data == '' || avro2jsonArr[i].avro_data == undefined) {
                formId.push({ id: avro2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
              if (avro2jsonArr[i].json_data_key == '' || avro2jsonArr[i].json_data_key == undefined) {
                formId.push({ id: avro2jsonArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        }else if (item.title == 'Extract to Array') {
          let extract2ArrayArr = this.extract2ArrayRows().value;
          for (let i = 0; i < extract2ArrayArr.length; i++) {
            if (item.id == extract2ArrayArr[i].id) {
              if (extract2ArrayArr[i].list_object_key == '' || extract2ArrayArr[i].list_object_key == undefined) {
                formId.push({ id: extract2ArrayArr[i].id })
              } else {
                item.isValid = true;
              }
              if (extract2ArrayArr[i].extraction_key == '' || extract2ArrayArr[i].extraction_key == undefined) {
                formId.push({ id: extract2ArrayArr[i].id })
              } else {
                item.isValid = true;
              }
              if (extract2ArrayArr[i].array_collection_key == '' || extract2ArrayArr[i].array_collection_key == undefined) {
                formId.push({ id: extract2ArrayArr[i].id })
              } else {
                item.isValid = true;
              }
            }
          }
        }
      }
    }

    const uniqueId = [...new Set(formId.map(x => x.id))]
    for (let item of this.finalBlocks) {
      for (let id of uniqueId) {
        if (item.id == id) {
          item.isValid = false;
        }
      }
    }

    if (uniqueId.length > 0) {
      this.helperService.presentToast("Data operation form incomplete", 2000);
      return
    }
    let targetPostmanFormData;
    if (this.bridge_target_type == 1) {
      for (const component of this.postmanuiComponents.toArray()) {
        if (component.apiCatalogFormType === 'target') {
          targetPostmanFormData = await component.getApiCatalogPostmanData();
        }
      }
      // console.log(targetPostmanFormData);
      // if (this.endpoint_target_url != "") {
      //   let eurl = this.endpoint_target_url.replace(/<[^>]*>/g, '');
      //   this.dataTarget.controls['bridge_target_endpoint_url'].setValue(eurl);
      // }
      // if (this.target_auth != "") {
      //   this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(this.target_auth);
      // }
      if (this.dataTarget.invalid) {
        console.log("Invalid form controls:", this.getTargetInvalidControls());
        this.helperService.presentToast("Data Target form incomplete", 2000);
        return;
      }
      if(targetPostmanFormData.targetPostmanFormInvalid) {
        return;
      }
      // if (this.dataTarget.value.bridge_target_endpoint_body_raw != '' && this.dataTarget.value.bridge_target_endpoint_body_raw != undefined && JSON.stringify(this.dataTarget.value.bridge_target_endpoint_body_raw) !== '{}') {
      //   if (this.dataTarget.value.bridge_target_body_type == 'JSON') {
      //     if (this.helperService.isValidJSON(this.dataTarget.value.bridge_target_endpoint_body_raw) == false) {
      //       this.helperService.presentToast('Please provide valid target body JSON Data', 2000);
      //       return
      //     }
      //   }
      //   if (this.dataTarget.value.bridge_target_body_type == 'XML') {
      //     if (this.helperService.isValidXML(this.dataTarget.value.bridge_target_endpoint_body_raw) == false) {
      //       this.helperService.presentToast('Please provide valid target body XML Data', 2000);
      //       return
      //     }
      //   }
      // }
    } else {
      if (this.dataTarget.invalid) {
        this.helperService.presentToast("Data Target form incomplete", 2000);
        return;
      }
    }
    if (this.summary.value.bridge_name == '' || this.summary.value.bridge_name == undefined) {
      this.helperService.presentToast("Configuration Incomplete", 2000);
      return;
    }

    if (this.summary.value.bridge_description == '' || this.summary.value.bridge_description == undefined) {
      this.helperService.presentToast("Configuration Incomplete", 2000);
      return;
    }

    if (this.timertypeval == "schedule") {
      // //console.log(this.timertypeval);
      // this.summary.controls['schedule'].setValidators([Validators.required, Validators.pattern('^[^-]*$')]);
      this.summary.controls['schedule'].setValidators([Validators.required]);
      this.summary.controls['schedule'].updateValueAndValidity();
      if (this.summary.value.schedule == "" || this.summary.value.schedule == undefined) {
        this.helperService.presentToast("Schedule incomplete", 2000);
        return;
      }
    } else if (this.timertypeval == "interval") {
      this.summary.controls['interval'].setValidators([Validators.required, Validators.min(1), Validators.pattern('^([1-9][0-9]*)$')]);
      // this.summary.controls['interval'].setValidators([Validators.required, Validators.min(1),  Validators.pattern('/^-?(0|[1-9]\d*)?$/')]);
      this.summary.controls['interval'].updateValueAndValidity();
      if (this.summary.value.interval == "" || this.summary.value.interval == undefined) {
        this.helperService.presentToast("Interval incomplete", 2000);
        return;
      }
    }
    if (this.summary.invalid) {
      this.helperService.presentToast("Summary form incomplete", 2000);
      return;
    }
    if (this.params_key.length > 0) {
      let params = this.dataSource.value.bridge_source_endpoint_params_raw;
      if (params != undefined) {
        for (let i = 0; i < params.length; i++) {
          // params[i].bridge_source_paramKey = this.params_key[i].replace(/<[^>]*>/g, '');
          // params[i].bridge_source_paramValue = this.params_value[i].replace(/<[^>]*>/g, '');
          params[i].bridge_source_paramKey = this.params_key[i];
          params[i].bridge_source_paramValue = this.params_value[i];
          this.addSourceValueParams(params[i]);
        }
      }
    }
    if (this.headers_key.length > 0) {
      let headers = this.dataSource.value.bridge_source_endpoint_headers;
      if (headers != undefined) {
        for (let i = 0; i < headers.length; i++) {
          headers[i].bridge_source_headerKey = this.headers_key[i];
          headers[i].bridge_source_headerValue = this.headers_value[i];
          this.addSourceValueHeaders(headers[i]);
        }
      }
    }
    if (this.params_target_key.length > 0) {
      let params = this.dataTarget.value.bridge_target_endpoint_params_raw;
      if (params != undefined) {
        for (let i = 0; i < params.length; i++) {
          params[i].bridge_target_paramKey = this.params_target_key[i];
          params[i].bridge_target_paramValue = this.params_target_value[i];
          this.addTargetValueParams(params[i]);
        }
      }
    }
    if (this.headers_target_key.length > 0) {
      let headers = this.dataTarget.value.bridge_target_endpoint_headers;
      if (headers != undefined) {
        for (let i = 0; i < headers.length; i++) {
          headers[i].bridge_target_headerKey = this.headers_target_key[i];
          headers[i].bridge_target_headerValue = this.headers_target_value[i];
          this.addTargetValueHeaders(headers[i]);
        }
      }
    }
    let sourceParams = this.dataSource.value.bridge_source_endpoint_params_raw;
    let sourceHeaders = this.dataSource.value.bridge_source_endpoint_headers;
    let sourceHeadersArr = [];
    let sourceParamsArr = [];
    let intBridgeName = this.summary.value.bridge_name.trim();
    let intBridgeDescription = this.summary.value.bridge_description.trim();
    let targetParams = this.dataTarget.value.bridge_target_endpoint_params_raw;
    let targetHeaders = this.dataTarget.value.bridge_target_endpoint_headers;
    let targetHeadersArr = [];
    let targetParamsArr = [];

    if (sourceParams) {
      for (let index in sourceParams) {
        let data;
        if (sourceParams[index].bridge_source_paramKey) {
          data = {
            'key': sourceParams[index].bridge_source_paramKey,
            'value': sourceParams[index].bridge_source_paramValue,
            'description': sourceParams[index].bridge_source_paramDescription
          }
          sourceParamsArr.push(data);
        }

      }
    }
    if (sourceHeaders) {
      for (let index in sourceHeaders) {
        let data;
        if (sourceHeaders[index].bridge_source_headerKey) {
          data = {
            'key': sourceHeaders[index].bridge_source_headerKey,
            'value': sourceHeaders[index].bridge_source_headerValue,
            'description': sourceHeaders[index].bridge_source_headerDescription
          }
          sourceHeadersArr.push(data);
        }

      }
    }

    if (targetParams) {
      for (let index in targetParams) {
        let data;
        if (targetParams[index].bridge_target_paramKey) {
          data = {
            'key': targetParams[index].bridge_target_paramKey,
            'value': targetParams[index].bridge_target_paramValue,
            'description': targetParams[index].bridge_target_paramDescription
          }
          targetParamsArr.push(data);
        }

      }
    }
    if (targetHeaders) {
      for (let index in targetHeaders) {
        let data;
        if (targetHeaders[index].bridge_target_headerKey) {
          data = {
            'key': targetHeaders[index].bridge_target_headerKey,
            'value': targetHeaders[index].bridge_target_headerValue,
            'description': targetHeaders[index].bridge_target_headerDescription
          }
          targetHeadersArr.push(data);
        }

      }
    }


    // let source_postman_params = {
    //   'endpoint_url': this.dataSource.value.bridge_source_endpoint_url,
    //   'endpoint_method': this.dataSource.value.bridge_source_endpoint_method,
    //   'authentication_type': this.dataSource.value.bridge_source_endpoint_authentication_type,
    //   'authentication_token': (this.dataSource.value.bridge_source_authentication_token) ? this.dataSource.value.bridge_source_authentication_token : '',
    //   'username': (this.dataSource.value.bridge_source_authentication_username) ? this.dataSource.value.bridge_source_authentication_username : '',
    //   'password': (this.dataSource.value.bridge_source_authentication_password) ? this.dataSource.value.bridge_source_authentication_password : '',
    //   'refresh_token_endpoint_url': (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_url) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_url : '',
    //   'refresh_token_endpoint_header': (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header : '',
    //   'refresh_token_endpoint_method': (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_method) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_method : '',
    //   'refresh_token_endpoint_body': (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body : '',
    //   'endpoint_headers': sourceHeadersArr,
    //   'endpoint_params_raw': sourceParamsArr,
    //   'endpoint_body_raw': (this.dataSource.value.bridge_source_endpoint_body_raw) ? this.dataSource.value.bridge_source_endpoint_body_raw : {}
    // }

    // let target_postman_params = {
    //   'endpoint_url': this.dataTarget.value.bridge_target_endpoint_url,
    //   'endpoint_method': this.dataTarget.value.bridge_target_endpoint_method,
    //   'authentication_type': this.dataTarget.value.bridge_target_endpoint_authentication_type,
    //   'authentication_token': (this.dataTarget.value.bridge_target_authentication_token) ? this.dataTarget.value.bridge_target_authentication_token : '',
    //   'username': (this.dataTarget.value.bridge_target_authentication_username) ? this.dataTarget.value.bridge_target_authentication_username : '',
    //   'password': (this.dataTarget.value.bridge_target_authentication_password) ? this.dataTarget.value.bridge_target_authentication_password : '',
    //   'refresh_token_endpoint_url': (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_url) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_url : '',
    //   'refresh_token_endpoint_header': (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header : '',
    //   'refresh_token_endpoint_method': (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_method) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_method : '',
    //   'refresh_token_endpoint_body': (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body : '',
    //   'endpoint_headers': targetHeadersArr,
    //   'endpoint_params_raw': targetParamsArr,
    //   'endpoint_body_raw': (this.dataTarget.value.bridge_target_endpoint_body_raw) ? this.dataTarget.value.bridge_target_endpoint_body_raw : {}
    // }

    let bridge_source_refresh_token_endpoint_method = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_method) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_method : "";
    let bridge_source_refresh_token_endpoint_url = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_url) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_url : "";
    // let bridge_source_refresh_token_headers = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header : "";
    // let bridge_source_refresh_token_params = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params : "";
    // let bridge_source_refresh_token_body = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) ? this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body : "";
    // let bridge_source_refresh_token_headers = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) : "";
    // let bridge_source_refresh_token_params = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) : "";
    // let bridge_source_refresh_token_body = (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) : "";

    // if (bridge_source_refresh_token_body == "" || bridge_source_refresh_token_body == null) {
    //   bridge_source_refresh_token_body = bridge_source_refresh_token_body
    // } else {
    //   bridge_source_refresh_token_body = bridge_source_refresh_token_body
    // }

    let bridge_source_refresh_token_body='';
    if (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body != '' && this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body != undefined) {
      if (this.helperService.isValidJSON(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body)) {
        bridge_source_refresh_token_body = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body ? this.helperService.isJsonString(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) : {};
      } else {
        bridge_source_refresh_token_body = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_body) : "";
      }
    }

    let bridge_source_refresh_token_headers;
    if (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header != '' && this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header != undefined) {
      if (this.helperService.isValidJSON(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header)) {
        bridge_source_refresh_token_headers = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header ? this.helperService.isJsonString(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) : {};
      } else {
        bridge_source_refresh_token_headers = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_header) : "";
      }
    }

    let bridge_source_refresh_token_params;
    if (this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params != '' && this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params != undefined) {
      if (this.helperService.isValidJSON(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params)) {
        bridge_source_refresh_token_params = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params ? this.helperService.isJsonString(this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) : {};
      } else {
        bridge_source_refresh_token_params = this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_oauth_refresh_token_endpoint_params) : "";
      }
    }

    if (this.dataSource.value.bridge_source_body_type == 'JSON') {
      this.dataSource.value.bridge_source_endpoint_body_raw = (this.dataSource.value.bridge_source_endpoint_body_raw) ? this.helperService.isJsonString(this.dataSource.value.bridge_source_endpoint_body_raw) : {}
    } else {
      this.dataSource.value.bridge_source_endpoint_body_raw = (this.dataSource.value.bridge_source_endpoint_body_raw) ? this.dataSource.value.bridge_source_endpoint_body_raw : "";
      // this.dataSource.value.bridge_source_endpoint_body_raw = (this.dataSource.value.bridge_source_endpoint_body_raw) ? this.helperService.stringToObjectConverter("String", this.dataSource.value.bridge_source_endpoint_body_raw) : ""
    }


    // if (this.environmentForm.value.bridge_endpoint_selected_environments_name != 'No Environment') {
    //   for (let item of this.environmentForm.value.bridge_endpoint_environments_raw) {
    //     if (item.env_name == this.environmentForm.value.selected_environment) {
    //       for (let subItem of item.env_vars) {
    //         for (let object of sourceParams) {
    //           if (object.bridge_source_paramKey.includes("{{" + subItem.variable + "}}")) {
    //             object.bridge_source_paramKey = object.bridge_source_paramKey.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
    //           }
    //           if (object.bridge_source_paramValue.includes("{{" + subItem.variable + "}}")) {
    //             object.bridge_source_paramValue = object.bridge_source_paramValue.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
    //           }
    //         }
    //         for (let object of sourceHeaders) {
    //           if (object.bridge_source_headerKey.includes("{{" + subItem.variable + "}}")) {
    //             object.bridge_source_headerKey = object.bridge_source_headerKey.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
    //           }
    //           if (object.bridge_source_headerValue.includes("{{" + subItem.variable + "}}")) {
    //             object.bridge_source_headerValue = object.bridge_source_headerValue.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
    //           }
    //         }
    //         if (this.dataSource.value.bridge_source_endpoint_url.includes("{{" + subItem.variable + "}}")) {
    //           this.dataSource.value.bridge_source_endpoint_url = this.dataSource.value.bridge_source_endpoint_url.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
    //         }
    //         if (this.dataSource.value.bridge_source_endpoint_body_raw.includes("{{" + subItem.variable + "}}")) {
    //           this.dataSource.value.bridge_source_endpoint_body_raw = this.dataSource.value.bridge_source_endpoint_body_raw.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
    //         }
    //         if (this.dataSource.value.pre_request_script.includes("{{" + subItem.variable + "}}")) {
    //           this.dataSource.value.pre_request_script = this.dataSource.value.pre_request_script.replace(new RegExp("{{" + subItem.variable + "}}", 'g'), subItem.value);
    //         }
    //       }
    //     }
    //   }
    // }

    let time_zone;
    if (this.timertypeval == "interval") {
      time_zone = '';
      this.summary.value.schedule = "* * * * *"
    } else {
      time_zone = this.summary.value.time_zone;
      time_zone = time_zone.timezone;
    }

    let source_postman_params = {};

    if (this.bridge_source_type == 1) {
      // let regexNewLineSource = /\\n/g;
      // let pre_request_script_source;
      // if (this.dataSource.value.pre_request_script != '' && this.dataSource.value.pre_request_script != undefined) {
      //   pre_request_script_source = this.dataSource.value.pre_request_script.replace(regexNewLineSource, "\\\n");
      // }
     
      source_postman_params = {
        "input": {
          "bizdata_rest": {
            'endpoint_url': sourcePostmanFormData?.sourceApiEndpointUrl,
            'endpoint_method': sourcePostmanFormData?.sourceEndpointMethod,
            'endpoint_headers': sourcePostmanFormData?.sourceHeadersData,
            'endpoint_params_raw': sourcePostmanFormData?.sourceParamsData,
            'authentication_type': sourcePostmanFormData?.sourceAuthType,
            'authentication_token': "",
            'username': sourcePostmanFormData?.sourceAuthUsername,
            'password': sourcePostmanFormData?.sourceAuthPassword,
            'refresh_token_endpoint_url':sourcePostmanFormData?.sourceAuthRteurl,
            'refresh_token_endpoint_headers': sourcePostmanFormData?.sourceAuthRteheaders,
            'refresh_token_endpoint_params': sourcePostmanFormData?.sourceAuthRteparams,
            'refresh_token_endpoint_method': sourcePostmanFormData?.sourceAuthRtemethod,
            'refresh_token_endpoint_body': sourcePostmanFormData?.sourceAuthRtebody,
            // 'refresh_token_params': {},
            'query_type_auth': ':form',
            'query_type_raw': ':json',
            'body_type': sourcePostmanFormData?.sourceEndpointBodyType,
            'endpoint_body_raw': sourcePostmanFormData?.sourceEndpointBodyData,
            "pre_request_script": sourcePostmanFormData?.sourcePreRequestScript,
            "response_type": sourcePostmanFormData?.sourceResponseType,
          }
        }
      }
    } else if (this.bridge_source_type == 2) {
      if (this.dataSource.value.jdbc_string.includes('host_ip')) {
        this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('host_ip', this.dataSource.value.host_ip)
      }
      if (this.dataSource.value.jdbc_string.includes('port_number')) {
        this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('port_number', this.dataSource.value.port_number)
      }
      if (this.dataSource.value.jdbc_string.includes('schema_name')) {
        this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('schema_name', this.dataSource.value.schema_name)
      }
      source_postman_params = {
        "bizdata_ops_jdbcsource": {
          "source": "bizdata_dataset",
          "storage_name": this.dataSource.value.storage_name,
          "db_version": this.dataSource.value.db_version,
          "host_ip": this.dataSource.value.host_ip,
          "port_number": this.dataSource.value.port_number,
          "schema_name": this.dataSource.value.schema_name,
          // "tuple_key": this.dataSource.value.tuple_key,
          // "batch_size": this.dataSource.value.batch_size,
          "jdbc_driver": this.dataSource.value.jdbc_driver,
          "jdbc_string": this.dataSource.value.jdbc_string,
          "jdbc_jar_file": this.dataSource.value.jdbc_jar_file,
          "username": this.dataSource.value.username,
          "password": await this.helperService.encrypt(this.dataSource.value.password),
          "query": this.dataSource.value.query,
          // "unique_key": this.dataSource.value.unique_key,
          "response_parameter": this.dataSource.value.response_parameter,
          // "timer_type": "interval",
          // "schedule": "*/30 * * * *",
          "timer_type": this.timertypeval,
          "interval_in_seconds": this.summary.value.interval ? this.summary.value.interval : 60,
          "schedule": this.summary.value.schedule ? this.summary.value.schedule : "* * * * *",
          "time_zone": time_zone,
          // "interval_in_seconds": 1800000,
          // "multiline": this.dataSource.value.multiline,
          "chunks_size": this.dataSource.value.chunks_size,
          "target": "bizdata_dataset"
        }

      }
    } else if (this.bridge_source_type == 3) {
      //console.log(this.dataSource.value);
      source_postman_params[this.sourceDLListOpName.op_name] = {
          "version": this.dataSource.value.version,
          "dlsource_host": this.dataSource.value.dlsource_host,
          "dlsource_port": this.dataSource.value.dlsource_port,
          "dlsource_username": this.dataSource.value.dlsource_username,
          "dlsource_password": this.dataSource.value.dlsource_password?await this.helperService.encrypt(this.dataSource.value.dlsource_password):"",
          "dlsource_ca_certs_path": this.dataSource.value.dlsource_ca_certs_path,
          "dlsource_index_name": `bizintel360-${this.dataSource.value.dlsource_index_name}`,
          "scroll": this.dataSource.value.scroll,
          "dlsource_timeout": this.dataSource.value.dlsource_timeout,
          "dlsource_batch_size": this.dataSource.value.dlsource_batch_size,
          "dlsource_body": this.dataSource.value.dlsource_body,
          "timer_type": this.timertypeval,
          "interval_in_seconds": this.summary.value.interval ? this.summary.value.interval : 60,
          "schedule": this.summary.value.schedule ? this.summary.value.schedule : "* * * * *",
          "time_zone": time_zone,
          "target": "bizdata_dataset"
        }
    } else if (this.bridge_source_type == 4) {
      let sourceWsParams = this.dataSource.value.bridge_source_ws_endpoint_params_raw;
      let sourceWsHeaders = this.dataSource.value.bridge_source_ws_endpoint_headers;
      let sourceWsHeadersArr = [];
      let sourceWsParamsArr = [];
      if (sourceWsParams) {
        for (let index in sourceWsParams) {
          let data;
          if (sourceWsParams[index].bridge_source_ws_paramKey) {
            data = {
              'key': sourceWsParams[index].bridge_source_ws_paramKey,
              'value': sourceWsParams[index].bridge_source_ws_paramValue,
              'description': sourceWsParams[index].bridge_source_ws_paramDescription
            }
            sourceWsParamsArr.push(data);
          }

        }
      }
      if (sourceWsHeaders) {
        for (let index in sourceWsHeaders) {
          let data;
          if (sourceWsHeaders[index].bridge_source_ws_headerKey) {
            data = {
              'key': sourceWsHeaders[index].bridge_source_ws_headerKey,
              'value': sourceWsHeaders[index].bridge_source_ws_headerValue,
              'description': sourceWsHeaders[index].bridge_source_ws_headerDescription
            }
            sourceWsHeadersArr.push(data);
          }

        }
      }
      try{
        if(JSON.stringify(this.dataSource.value.bridge_source_ws_message)){
          this.dataSource.value.bridge_source_ws_message=JSON.parse(this.dataSource.value.bridge_source_ws_message);
        }
      }
      catch{}
      source_postman_params = {
        "bizdata_ops_websocketsource": {
          "endpoint_url": this.dataSource.value.bridge_source_ws_endpoint_url,
          "params": sourceWsParamsArr,
          "headers": sourceWsHeadersArr,
          "message": this.dataSource.value.bridge_source_ws_message,
          "timer_type": this.timertypeval,
          "interval_in_seconds": this.summary.value.interval ? this.summary.value.interval : 60,
          "schedule": this.summary.value.schedule ? this.summary.value.schedule : "* * * * *",
          "time_zone": time_zone,
          "target": "bizdata_dataset"
        }

      }
    }
    else if (this.bridge_source_type == 5) {
      source_postman_params = {
        "bizdata_ops_emailsource": {
          "user_email": this.dataSource.value.user_email,
          "password": await this.helperService.encrypt(this.dataSource.value.email_password),
          "mail_server": this.dataSource.value.mail_server,
          "out_type": this.dataSource.value.out_type,
          "port_number": Number(this.dataSource.value.email_port_number),
          "timer_type": this.timertypeval,
          "interval_in_seconds": this.summary.value.interval ? this.summary.value.interval : 60,
          "schedule": this.summary.value.schedule ? this.summary.value.schedule : "* * * * *",
          "target": "bizdata_dataset"
        }
      }
    }

    let bridge_target_refresh_token_endpoint_method = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_method) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_method : ""
    let bridge_target_refresh_token_endpoint_url = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_url) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_url : "";
    // let bridge_target_refresh_token_headers = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header : "";
    // let bridge_target_refresh_token_params = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params : "";
    // let bridge_target_refresh_token_body = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) ? this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body : "";
    // let bridge_target_refresh_token_headers = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) : "";
    // let bridge_target_refresh_token_params = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) : "";
    // let bridge_target_refresh_token_body = (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) : "";
    // if (bridge_target_refresh_token_body == "" || bridge_target_refresh_token_body == null) {
    //   bridge_target_refresh_token_body = bridge_target_refresh_token_body
    // } else {
    //   bridge_target_refresh_token_body = bridge_target_refresh_token_body
    // }

    let bridge_target_refresh_token_body;
    if (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body != '' && this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body != undefined) {
      if (this.helperService.isValidJSON(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body)) {
        bridge_target_refresh_token_body = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body ? this.helperService.isJsonString(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) : {};
      } else {
        bridge_target_refresh_token_body = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_body) : "";
      }
    }

    let bridge_target_refresh_token_headers;
    if (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header != '' && this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header != undefined) {
      if (this.helperService.isValidJSON(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header)) {
        bridge_target_refresh_token_headers = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header ? this.helperService.isJsonString(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) : {};
      } else {
        bridge_target_refresh_token_headers = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_header) : "";
      }
    }

    let bridge_target_refresh_token_params;
    if (this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params != '' && this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params != undefined) {
      if (this.helperService.isValidJSON(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params)) {
        bridge_target_refresh_token_params = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params ? this.helperService.isJsonString(this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) : {};
      } else {
        bridge_target_refresh_token_params = this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_oauth_refresh_token_endpoint_params) : "";
      }
    }

    if (this.dataTarget.value.bridge_target_body_type == 'JSON') {
      this.dataTarget.value.bridge_target_endpoint_body_raw = (this.dataTarget.value.bridge_target_endpoint_body_raw) ? this.helperService.isJsonString(this.dataTarget.value.bridge_target_endpoint_body_raw) : {}
    } else {
      this.dataTarget.value.bridge_target_endpoint_body_raw = (this.dataTarget.value.bridge_target_endpoint_body_raw) ? this.dataTarget.value.bridge_target_endpoint_body_raw : ""
      // this.dataTarget.value.bridge_target_endpoint_body_raw = (this.dataTarget.value.bridge_target_endpoint_body_raw) ? this.helperService.stringToObjectConverter("String", this.dataTarget.value.bridge_target_endpoint_body_raw) : ""
    }

    let target_postman_params = {};

    if (this.bridge_target_type == 1) {
      // let regexNewLineTarget = /\\n/g;
      // let pre_request_script_target;
      // if (this.dataTarget.value.pre_request_script != '' && this.dataTarget.value.pre_request_script != undefined) {
      //   pre_request_script_target = this.dataTarget.value.pre_request_script.replace(regexNewLineTarget, "\\\n");
      // }
      // console.log(this.dataTarget.value.bridge_target_endpoint_headers);
      // console.log(this.dataTarget.value.bridge_target_endpoint_headers_raw_array);
      // console.log(targetParamsArr);

      target_postman_params = {
        "input": {
          "bizdata_rest": {
            'endpoint_url': targetPostmanFormData.targetApiEndpointUrl,
            'endpoint_method': targetPostmanFormData.targetEndpointMethod,
            'endpoint_headers': targetPostmanFormData.targetHeadersData,
            'endpoint_params_raw': targetPostmanFormData.targetParamsData,
            'authentication_type': targetPostmanFormData.targetAuthType,
            'authentication_token': '',
            'username': targetPostmanFormData.targetAuthUsername,
            'password': targetPostmanFormData.targetAuthPassword,
            'refresh_token_endpoint_url': targetPostmanFormData.targetAuthRteurl,
            'refresh_token_endpoint_headers': targetPostmanFormData.targetAuthRteheaders,
            'refresh_token_endpoint_params': targetPostmanFormData.targetAuthRteparams,
            'refresh_token_endpoint_method': targetPostmanFormData.targetAuthRtemethod,
            'refresh_token_endpoint_body': targetPostmanFormData.targetAuthRtebody,
            // 'refresh_token_params': {},
            'query_type_auth': ':form',
            'query_type_raw': ':json',
            'body_type': targetPostmanFormData.targetEndpointBodyType,
            'endpoint_body_raw': targetPostmanFormData.targetEndpointBodyData,
            "pre_request_script": targetPostmanFormData.targetPreRequestScript,
            "response_type": targetPostmanFormData.targetResponseType,
          }
        }
      }
    } else if (this.bridge_target_type == 2) {
      if (this.dataTarget.value.jdbc_string.includes('host_ip')) {
        this.dataTarget.value.jdbc_string = this.dataTarget.value.jdbc_string.replace('host_ip', this.dataTarget.value.host_ip)
      }
      if (this.dataTarget.value.jdbc_string.includes('port_number')) {
        this.dataTarget.value.jdbc_string = this.dataTarget.value.jdbc_string.replace('port_number', this.dataTarget.value.port_number)
      }
      if (this.dataTarget.value.jdbc_string.includes('schema_name')) {
        this.dataTarget.value.jdbc_string = this.dataTarget.value.jdbc_string.replace('schema_name', this.dataTarget.value.schema_name)
      }

      if (this.dataTarget.value.tuple_key == '' || this.dataTarget.value.tuple_key == undefined) {
        this.dataTarget.value.tuple_key = []
      } else {
        this.dataTarget.value.tuple_key = this.dataTarget.value.tuple_key//this.helperService.stringToObjectConverter("Array", this.dataTarget.value.tuple_key);
      }
      let query;
      if (this.dataTarget.value.query == '' || this.dataTarget.value.query == undefined) {
        query = []
      } else {
        query = this.dataTarget.value.query.substring(1, this.dataTarget.value.query.length - 1);//this.helperService.stringToObjectConverter('Array', this.dataTarget.value.query)
      }

      target_postman_params = {
        "bizdata_ops_jdbcoutput": {
          "source": "bizdata_dataset",
          "storage_name": this.dataTarget.value.storage_name,
          "db_version": this.dataTarget.value.db_version,
          "host_ip": this.dataTarget.value.host_ip,
          "port_number": this.dataTarget.value.port_number,
          "schema_name": this.dataTarget.value.schema_name,
          "tuple_key": this.dataTarget.value.tuple_key,
          "batch_size": this.dataTarget.value.batch_size,
          "jdbc_driver": this.dataTarget.value.jdbc_driver,
          "jdbc_string": this.dataTarget.value.jdbc_string,
          "jar_file": this.dataTarget.value.jar_file,
          "username": this.dataTarget.value.username,
          "password": await this.helperService.encrypt(this.dataTarget.value.password),
          "query": query,
          "target": "bizdata_dataset"
        }
      }
    } else if (this.bridge_target_type == 3) {
      let primary_key = "";
      if (this.dataTarget.value.action_type == 'upsert' || this.dataTarget.value.action_type == 'update' || this.dataTarget.value.action_type == 'delete') {
        primary_key = this.dataTarget.value.primary_key;
      } else {
        primary_key = "";
      }
      if (this.dataTarget.value.version.op_name == 'bizdata_ops_bizintel360ingestion') {
        target_postman_params = {
          "bizdata_ops_bizintel360ingestion": {
            "source": "bizdata_dataset",
            "version": this.dataTarget.value.version,
            "dlake_host": this.dataTarget.value.dlake_host,
            "dlake_port": this.dataTarget.value.dlake_port,
            "dlusername": this.dataTarget.value.dlusername,
            "dlpassword": this.dataTarget.value.dlpassword?await this.helperService.encrypt(this.dataTarget.value.dlpassword):"",
            "ca_certs_path": this.dataTarget.value.dl_ca_certs_path,
            "index_name": `bizintel360-${this.dataTarget.value.index_name.trim()}`,
            "action_type": this.dataTarget.value.action_type,
            "primary_key": primary_key,
            "indexing_type": this.dataTarget.value.indexing_type,
            "target": "bizdata_dataset"
          }
        }
      } else if (this.dataTarget.value.version.op_name == 'bizdata_ops_dlakeingestion') {
        target_postman_params = {
          "bizdata_ops_dlakeingestion": {
            "source": "bizdata_dataset",
            "version": this.dataTarget.value.version,
            "dlake_host": this.dataTarget.value.dlake_host,
            "dlake_port": this.dataTarget.value.dlake_port,
            "dlusername": this.dataTarget.value.dlusername,
            "dlpassword": this.dataTarget.value.dlpassword?await this.helperService.encrypt(this.dataTarget.value.dlpassword):"",
            "ca_certs_path": this.dataTarget.value.dl_ca_certs_path,
            "index_name": `bizintel360-${this.dataTarget.value.index_name.trim()}`,
            "action_type": this.dataTarget.value.action_type,
            "primary_key": primary_key,
            "indexing_type": this.dataTarget.value.indexing_type,
            "target": "bizdata_dataset"
          }
        }
      }

    } else if (this.bridge_target_type == 4) {
      this.dataTarget.value.to = this.emailsTarTo;
      this.dataTarget.value.cc = this.emailsTarCc;
      this.dataTarget.value.bcc = this.emailsTarBcc;
      if (this.dataTarget.value.to != '' && this.dataTarget.value.to != undefined) {
        if (!Array.isArray(this.dataTarget.value.to)) {
          this.dataTarget.value.to = this.helperService.stringToObjectConverter("Array", this.dataTarget.value.to);
        } else {
          this.dataTarget.value.to = this.dataTarget.value.to;
        }
      } else {
        this.dataTarget.value.to = []
      }
      if (this.dataTarget.value.cc != '' && this.dataTarget.value.cc != undefined) {
        if (!Array.isArray(this.dataTarget.value.cc)) {
          this.dataTarget.value.cc = this.helperService.stringToObjectConverter("Array", this.dataTarget.value.cc);
        } else {
          this.dataTarget.value.cc = this.dataTarget.value.cc;
        }
      } else {
        this.dataTarget.value.cc = []
      }
      if (this.dataTarget.value.bcc != '' && this.dataTarget.value.bcc != undefined) {
        if (!Array.isArray(this.dataTarget.value.bcc)) {
          this.dataTarget.value.bcc = this.helperService.stringToObjectConverter("Array", this.dataTarget.value.bcc);
        } else {
          this.dataTarget.value.bcc = this.dataTarget.value.bcc;
        }
      } else {
        this.dataTarget.value.bcc = []
      }
      if (this.dataTarget.value.email_port_number == '' && this.dataTarget.value.email_port_number != undefined) {
        this.dataTarget.value.email_port_number = 465
      } else {
        this.dataTarget.value.email_port_number = +(this.dataTarget.value.email_port_number)
      }
      if (this.dataTarget.value.attachment == "" || this.dataTarget.value.attachment == undefined || this.dataTarget.value.attachment == "no") {
        this.dataTarget.value.attachment = "no"
        this.dataTarget.value.file_name = ""
      }
      if (this.dataTarget.value.body) {
        this.dataTarget.value.body = this.dataTarget.value.body.replaceAll(/&lt;/g, '<').replaceAll(/&gt;/g, '>').replaceAll(/&nbsp;/g, '').replaceAll(/&quot;/g, '"').replaceAll(/&#39;/g, "'").replaceAll(/<br \/>/g, "").replaceAll(/<\/p>\n\n<p>/g, "").replaceAll(/<\/p>\n<p>/g, "");
        let body = this.dataTarget.value.body.split("<p>")[1] || "";
        body = body.split("</p>")[0] || "";
        this.dataTarget.value.body = body.trim() ? "<html>" + body + "</html>" : "";
      }else {
        this.dataTarget.value.body = ""; 
      }
      let body = this.dataTarget.value.body; 
      
      target_postman_params = {
        "bizdata_ops_email": {
          "source": "bizdata_dataset",
          "From": this.dataTarget.value.From,
          "password": await this.helperService.encrypt(this.dataTarget.value.email_password),
          "mailserver": this.dataTarget.value.mailserver,
          "port_number": this.dataTarget.value.email_port_number,
          "to": this.dataTarget.value.to,
          "cc": this.dataTarget.value.cc,
          "bcc": this.dataTarget.value.bcc,
          "subject": this.dataTarget.value.subject,
          "source_key": this.dataTarget.value.source_key,
          "body": body?body:'',
          "attachment": this.targetAttachment,
          "file_name": this.dataTarget.value.file_name,
          "target": "bizdata_dataset"
        }
      }

    } else if (this.bridge_target_type == 5) {
      target_postman_params = {
      };
    }

    if (this.dataSource.value.min_number == null || this.dataSource.value.min_number == undefined) {
      this.dataSource.value.min_number = 0;
    }
    if (this.dataSource.value.max_number == null || this.dataSource.value.max_number == undefined) {
      this.dataSource.value.max_number = 1000;
    }

    let selectedSourceEnvironment = '';
    if (this.environmentForm.value.selected_environment != 'No Environment') {
      selectedSourceEnvironment = this.environmentForm.value.selected_environment;
    }

    let selectedTargetEnvironment = '';
    if (this.environmentTargetForm.value.selected_environment != 'No Environment') {
      selectedTargetEnvironment = this.environmentTargetForm.value.selected_environment;
    }

    let advance_settings = {
      "toggle": this.summary.value.toggle,
      "sbs": this.summary.value.sbs,
      "now": +(this.summary.value.now),
      "srwt": this.summary.value.srwt,
      "logs_size": this.summary.value.logsize
    }
    if (this.dataSource.value.bridge_source_type.id == 1 && this.selectPaginationType == 8) {
      this.dataSource.value.custom_pagination_script = this.helperService.isString(this.dataSource.value.custom_pagination_script)
      if (this.dataSource.value.custom_pagination_script.includes('\\t')) {
        this.dataSource.value.custom_pagination_script = this.dataSource.value.custom_pagination_script.replaceAll(/\\t/g, '\t').replaceAll(/\\\t/g, '\\t');
      }
      if (this.dataSource.value.custom_pagination_script.includes('\\r')) {
        this.dataSource.value.custom_pagination_script = this.dataSource.value.custom_pagination_script.replaceAll(/\\r/g, '\r').replaceAll(/\\\r/g, '\\r');
      }
    }

    let selectedSourcePayload = {
      selectedEnvironment      : sourcePostmanFormData?.sourceSelectedEnvironment || "",
      environmentList          : sourcePostmanFormData?.sourceEnvironmentList || [],
      environmentData          : sourcePostmanFormData?.sourceEnvironmentData || btoa(JSON.stringify([])),
      selectPaginationType     : sourcePostmanFormData?.sourceSelectPaginationType || "no_pagination",
      userKey                  : sourcePostmanFormData?.sourceUserKey || "",
      responseParameters       : sourcePostmanFormData?.sourceResponseParameters || "",
      paginationRetrySeconds   : sourcePostmanFormData?.sourcePaginationRetrySeconds || 5,
      anotherResponseParameter : sourcePostmanFormData?.sourceAnotherResponseParameter || "",
      keyNameToUpdate          : sourcePostmanFormData?.sourceKeyNameToUpdate || "",
      userKeyUrl               : sourcePostmanFormData?.sourceUserKeyUrl || "",
      customPaginationScript   : sourcePostmanFormData?.sourceCustomPaginationScript || "",
      minNum                   : sourcePostmanFormData?.sourceMinNum || 0,
      maxNum                   : sourcePostmanFormData?.sourceMaxNum || 1000,
      todayStr                 : sourcePostmanFormData?.sourceTodayStr || "%Y-%m-%dT00:00:01Z",
      yesterdayStr             : sourcePostmanFormData?.sourceYesterdayStr || "%Y-%m-%dT00:00:01Z",
      rollingTimeFormat        : sourcePostmanFormData?.sourceRollingTimeFormat || "%Y-%m-%dT%H:%M:00.000",
      rollingFrequency         : sourcePostmanFormData?.sourceRollingFrequency || 900,
      offsetValue              : sourcePostmanFormData?.sourceOffsetValue || 0
    }

    let selectedTargetPayload = {
      selectedEnvironment      : targetPostmanFormData?.targetSelectedEnvironment || "",
      environmentList          : targetPostmanFormData?.targetEnvironmentList || [],
      environmentData          : targetPostmanFormData?.targetEnvironmentData || btoa(JSON.stringify([]))
    }

    this.getStorage().then(async (res) => {
      let source_params = btoa(JSON.stringify(source_postman_params));
      let target_params = btoa(JSON.stringify(target_postman_params));
      let data_ops= btoa(JSON.stringify(await this.transformOpsJson()));
      source_params = btoa(JSON.stringify(source_params));
      target_params = btoa(JSON.stringify(target_params));
      data_ops= btoa(JSON.stringify(data_ops));
      source_params = await this.helperService.encryptpayload(source_params);
      target_params = await this.helperService.encryptpayload(target_params);
      data_ops = await this.helperService.encryptpayload(data_ops);
      let payload = {
        "source_params": source_params,
        "target_params": target_params,
        "integration_bridge_name": intBridgeName,
        "integration_bridge_description": intBridgeDescription,
        "created_by": res.userId,
        "created_ip_address": this.userIp ? this.userIp : "",
        "timer_type": this.timertypeval,
        "interval_in_seconds": this.summary.value.interval ? this.summary.value.interval : 60,
        "schedule": this.summary.value.schedule ? this.summary.value.schedule : "* * * * *",
        "time_zone": time_zone,
        "datalake_id": this.dataTarget.value.datalake_id,
        // "mapping": btoa(JSON.stringify(this.bridgeTargetResponseMapping))
        "mapping": "",
        "data_operations": data_ops,
        "pagination_style": selectedSourcePayload.selectPaginationType,
        "user_key_url": selectedSourcePayload.userKeyUrl,
        "response_parameters": selectedSourcePayload.responseParameters,
        "user_key": selectedSourcePayload.userKey,
        "key_name_to_update": selectedSourcePayload.keyNameToUpdate,
        "another_response_parameter": selectedSourcePayload.anotherResponseParameter,
        "pagination_retry_seconds": selectedSourcePayload.paginationRetrySeconds,
        "custom_pagination_script": selectedSourcePayload.customPaginationScript,
        "min_num": selectedSourcePayload.minNum,
        "max_num":selectedSourcePayload.maxNum,
        "today_str": selectedSourcePayload.todayStr,
        "yesterday_str": selectedSourcePayload.yesterdayStr,
        "rolling_time_format": selectedSourcePayload.rollingTimeFormat,
        "rolling_frequency": selectedSourcePayload.rollingFrequency,
        "offset_value": selectedSourcePayload.offsetValue,
        "source_selected_environment_name": selectedSourcePayload.selectedEnvironment,
        "source_environment_variables": selectedSourcePayload.environmentData,
        "target_selected_environment_name": selectedTargetPayload.selectedEnvironment,
        "target_environment_variables": selectedTargetPayload.environmentData,
        "source_type": this.dataSource.value.bridge_source_type.id,
        "target_type": this.dataTarget.value.bridge_target_type.id,
        "alert_emails": this.emails,
        "advance_settings": btoa(JSON.stringify(advance_settings)),
        // 'timer_type': 'interval',
        // 'interval_in_seconds': 10,
        // 'schedule':'',
      }

      if (this.dataTarget.value.bridge_target_type.id == 1) {
        payload["target_id"] = this.isNewTarget ? 0 : this.dataTarget.value.bridge_target_business_object.id;
        payload["tgt_business_obj_id"] = this.isNewTarget ? 0 : this.dataTarget.value.bridge_target_business_object.id;
        payload["target_business_obj"] = this.isNewTarget ? this.dataTarget.value.new_bridge_target_business_object : this.dataTarget.value.bridge_target_business_object.business_obj;
        payload["target_name"] = this.isNewTarget ? this.dataTarget.value.new_bridge_target : this.dataTarget.value.bridge_target;
      } else if (this.dataTarget.value.bridge_target_type.id == 2) {
        payload["target_id"] = 0;
        payload["tgt_business_obj_id"] = 0;
        payload["target_business_obj"] = "";
        payload["target_name"] = this.dataTarget.value.storage_name.storage_name;
      } else if (this.dataTarget.value.bridge_target_type.id == 3) {
        payload["target_id"] = 0;
        payload["tgt_business_obj_id"] = 0;
        payload["target_business_obj"] = "";
        payload["target_name"] = this.dataTarget.value.index_name;
      } else if (this.dataTarget.value.bridge_target_type.id == 4) {
        payload["target_id"] = 0;
        payload["tgt_business_obj_id"] = 0;
        payload["target_business_obj"] = "";
        payload["target_name"] = "Email";
      } else if (this.dataTarget.value.bridge_target_type.id == 5) {
        payload["target_id"] = 0;
        payload["tgt_business_obj_id"] = 0;
        payload["target_business_obj"] = null;
        payload["target_name"] = "No Target";
        payload["target_params"] = null;
      }

      if (this.dataSource.value.bridge_source_type.id == 1) {
        payload["source_id"] = this.isNewSource ? 0 : this.dataSource.value.bridge_source_business_object.id;
        payload["source_name"] = this.isNewSource ? this.dataSource.value.new_bridge_source : this.dataSource.value.bridge_source;
        payload["src_business_obj_id"] = this.isNewSource ? 0 : this.dataSource.value.bridge_source_business_object.id;
        payload["source_business_obj"] = this.isNewSource ? this.dataSource.value.new_bridge_source_business_object : this.dataSource.value.bridge_source_business_object.business_obj;
      } else if (this.dataSource.value.bridge_source_type.id == 2) {
        payload["source_id"] = 0;
        payload["source_name"] = this.dataSource.value.storage_name.storage_name;
        payload["src_business_obj_id"] = 0;
        payload["source_business_obj"] = "";
      } else if (this.dataSource.value.bridge_source_type.id == 3) {
        payload["source_id"] = 0;
        payload["source_name"] = this.dataSource.value.dlsource_index_name;
        payload["src_business_obj_id"] = 0;
        payload["source_business_obj"] = "";
      } else if (this.dataSource.value.bridge_source_type.id == 4) {
        payload["source_id"] = 0;
        payload["source_name"] = "Websocket";
        payload["src_business_obj_id"] = 0;
        payload["source_business_obj"] = "";
      } else if (this.dataSource.value.bridge_source_type.id == 5) {
        payload["source_id"] = 0;
        payload["source_name"] = "Email";
        payload["src_business_obj_id"] = 0;
        payload["source_business_obj"] = "";
      }



      // payload["source_id"] = this.isNewSource ? 0 : this.dataSource.value.bridge_source_business_object.id;
      // payload["source_name"] = this.isNewSource ? this.dataSource.value.new_bridge_source : this.dataSource.value.bridge_source;
      // payload["src_business_obj_id"] = this.isNewSource ? 0 : this.dataSource.value.bridge_source_business_object.id;
      // payload["source_business_obj"] = this.isNewSource ? this.dataSource.value.new_bridge_source_business_object : this.dataSource.value.bridge_source_business_object.business_obj;

      // payload["target_id"] = this.isNewTarget ? 0 : this.dataTarget.value.bridge_target_business_object.id;

      // payload["tgt_business_obj_id"] = this.isNewTarget ? 0 : this.dataTarget.value.bridge_target_business_object.id;
      // payload["target_business_obj"] = this.isNewTarget ? this.dataTarget.value.new_bridge_target_business_object : this.dataTarget.value.bridge_target_business_object.business_obj;
      // console.log(JSON.stringify(payload));
      // return;
      this.submitted = true; // Set the flag to true before making the API call
      this.getStorage().then(async (res) => {
        await this.helperService.loader();
      this.backendService.PostAPICall('createIntBridge', payload, res.token)
      .subscribe(
        data => {
        this.helperService.presentToast(data.msg, 2000);
        // this.apiCatalogForm.reset();
        this.helperService.closeLoader().then(() => {
        this.submitted = false; // Set the flag to false after successful submission
        this.router.navigate(['/baseapp/integration/list']);
      });
      // this.router.navigate(['/baseapp/integration/list']);
      },
      err => {
        //console.log(err);
        this.helperService.closeLoader();
        this.helperService.presentToast(err.error.detail, 2000);
        this.submitted = false; // Set the flag to false after error
      })
      })
    })
  }

  closebubblecross() {
    this.bubbleshow = false;
    this.businessobject = false;
    this.sorcename = false;
    this.businessobjectname = false;
    this.methodopt = false;
    this.requesturl = false;
    this.authorization = false;
    this.headers = false;
    this.testurl = false;
    this.shownext = false;
    this.bubbleshowoperation = false;
    this.bubbleshowtarget = false;
    this.targetname = false;
    this.businessobjecttargetname = false;
    this.businessobjecttarget = false;
    this.methodopttarget = false;
    this.requesturltarget = false;
    this.authorizationtarget = false;
    this.headerstarget = false;
    this.testurltarget = false;
    this.shownexttarget = false;
    this.bridgename = false;
    this.schedule = false;
    this.submitib = false;
    this.shownOpNext =false
  }

  closebubble() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.bubbleshow = false;
        this.businessobject = true;
        this.sorcename = true;
      }
    });
  }
  closesourcename() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.sorcename = false;
        this.businessobjectname = true;
      }
    });
  }
  closebusinessobj() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.businessobjectname = false;
        this.businessobject = false;
        this.methodopt = true;
      }
    });
  }
  closebusinessobjselect() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.businessobject = false;
        if(this.isFirstSourceBusinessObjectChange) {
          this.helperService.triggerChildNavigationHelpFunction();
          this.isFirstSourceBusinessObjectChange = false;
        }
      }
    });
  }
  closemethodopt() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.methodopt = false;
        this.requesturl = true;
      }
    });
  }
  closerequesturl() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.requesturl = false;
        this.authorization = true;
        this.indexSelection = 1;
      }
    });
  }
  // closeparams(){
  //   this.params = false;
  //   this.authorization = true;
  //   this.indexSelection = 1;
  // }
  closeauthorization() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.authorization = false;
        this.headers = true;
        this.indexSelection = 2;
      }
    });
  }
  closeheaders() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.headers = false;
        this.testurl = true;
        this.indexSelection = 3;
      }
    });
  }
  // closerequestbody(){
  //   this.requestbody = false;
  //   this.script = true;
  //   this.indexSelection = 4;
  // }
  // closescript(){
  //   this.script = false;
  //   this.testurl = true;
  // this.indexSelection = 4;
  // }
  closetesturl(data?: any) {
    if(data == "source") {
      this.storage.get('showDialog').then((value) => {
        if (value == 1) {
          this.testurl = false;
          this.shownext = true;
          // const element = document.getElementById("datasourceid");
          // element.scrollIntoView();
        }
      });
    }
  }
 
  closeshownext() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.shownext = false;
        this.bubbleshowoperation = true;
      }
    });
  }
  

  closebubbleoperation() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.bubbleshowoperation = false;
        this.shownOpNext = true;
        const dataOpNext = document.getElementById('dataOperationNext');
        dataOpNext.scrollIntoView();
      }
    });
  };

  closeShowNextOp(){
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.shownext = false;
        this.shownOpNext = false;
        this.bubbleshowtarget = true;
      }
    });
  };
  closebubbletarget() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.bubbleshowtarget = false;
        this.businessobjecttarget = true;
        this.targetname = true;
      }
    });
  }
  closetargetname() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.targetname = false;
        this.businessobjecttargetname = true;
      }
    });
  }
  closebusinessobjtarget() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.businessobjecttargetname = false;
        this.businessobjecttarget = false;
        this.methodopttarget = true;
      }
    });
  }
  closebusinessobjtargetSelect() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.businessobjecttarget = false;
        // this.testurltarget = true;
        if(this.isFirstTargetBusinessObjectChange) {
          this.helperService.triggerChildNavigationHelpFunction();
          this.isFirstTargetBusinessObjectChange = false;
        }
      }
    });
  }
  closemethodopttarget() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.methodopttarget = false;
        this.requesturltarget = true;
      }
    });
  }
  closerequesturltarget() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.requesturltarget = false;
        this.authorizationtarget = true;
        this.indexSelectionTarget = 1;
      }
    });
  }
  // closeparamstarget(){
  //   this.paramstarget = false;
  //   this.authorizationtarget = true;
  //   this.indexSelectionTarget = 1;
  // }
  closeauthorizationtarget() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.authorizationtarget = false;
        this.headerstarget = true;
        this.indexSelectionTarget = 2;
      }
    });
  }
  closeheaderstarget() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.headerstarget = false;
        this.testurltarget = true;
        this.indexSelectionTarget = 3;
      }
    });
  }
  // closerequestbodytarget(){
  //   this.requestbodytarget = false;
  //   this.scripttarget = true;
  //   this.indexSelectionTarget = 4;
  // }
  // closescripttarget(){
  //   this.scripttarget = false;
  //   this.testurltarget = true;
  //   // this.indexSelectionTarget = 4;
  // }
  closetesturltarget(data?: any) {
    if(data == "target") {
      this.storage.get('showDialog').then((value) => {
        if (value == 1) {
          this.testurltarget = false;
          this.shownexttarget = true;
          // const element = document.getElementById("datatargetid");
          // element.scrollIntoView();
        }
      });
    }
  }
  closeshownexttarget() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.shownexttarget = false;
        this.bridgename = true;
      }
    });
  }
  closebubblebridgename() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.bridgename = false;
        this.schedule = true;
      }
    });
  }
  closebubbleschedule() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.schedule = false;
        this.submitib = true;
      }
    });
  }
  closebubblesubmit() {
    this.storage.get('showDialog').then((value) => {
      if (value == 1) {
        this.submitib = false;
      }
    });
  }
  onChangeBusinessSource() {
    this.closebubblecross();
    this.closebubble();
  }

  onChangeSourceName() {
    this.closebubblecross();
    this.closesourcename();
  }

  onChangeBusinessSourceObject() {
    this.closebubblecross();
    this.closebusinessobj();
  }

  onSelectMethod() {
    this.closebubblecross();
    this.closemethodopt();
  }

  onChangeUrl() {
    this.closebubblecross();
    this.closerequesturl();
  }

  onChangeWsUrl() {
    this.closebubblecross();
    this.closerequesturl();
  }

  onChangeSourceAuthentication() {
    this.closebubblecross();
    this.closeauthorization();
  }

  onChangeHeaders() {
    this.closebubblecross();
    this.closeheaders();
  }

  onChangeWsHeaders() {
    this.closebubblecross();
    this.closeheaders();
  }

  onChangeBusinessTargetObject() {
    this.closebubblecross();
    this.closebusinessobjtarget();
  }

  onChangeBusinessTargetName() {
    this.closebubblecross();
    this.closetargetname();
  }

  onSelectMethodTarget() {
    this.closebubblecross();
    this.closemethodopttarget();
  }

  onChangeUrlTarget() {
    this.closebubblecross();
    this.closerequesturltarget();
  }

  onChangeTargetAuthentication() {
    this.closebubblecross();
    this.closeauthorizationtarget();
  }

  onChangeHeadersTarget() {
    this.closebubblecross();
    this.closeheaderstarget();
  }

  checkTokenSessionBeforeTestEmailApi(emailOpsForm) {
    this.type = 'email_operation';
    if(emailOpsForm.invalid){
      this.helperService.presentToast('Failed to connect to the mail server',1000)
      return;
    }
    this.getStorage().then(async (storage_data) => {
      await this.helperService.loader();
      this.pythonTokenForEmailOperation = storage_data.pytokenEmailOperation;
      if (storage_data.pytokenEmailOperation == null) {
        this.generateToken('email_operation').then((res: string) => {
          this.pythonTokenForEmailOperation = res;
          this.testEmailApi(emailOpsForm.value);
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testEmailApi(emailOpsForm.value);
          } else {
            this.generateToken('email_operation').then((res: string) => {
              this.pythonTokenForEmailOperation = res;
              this.testEmailApi(emailOpsForm.value);
            })
          }
        })
      }
    })
  }

  testEmailApi(data) {
    let portNumberTmp;
    if (data.port_number == '' || data.port_number == undefined) {
      portNumberTmp = 465;
    } else {
      portNumberTmp = data.port_number;
    }
    this.getStorage().then(async (res) => {
      let payload = {
        "mailserver": data.mailserver,
        "port_number": parseInt(portNumberTmp),
        "From": data.From,
        // "to": toTmp,
        "password": await this.helperService.encrypt(data.password)
      }
      // return;
      const api_endpoint = environment.python_api_base_url + '/email';
      this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForEmailOperation)
        .subscribe(
          data => {
            this.helperService.closeLoader();
            if(data.bizdata_dataset.bizdata_dataset_status == 200){
              this.helperService.presentToast(data.bizdata_dataset.bizdata_dataset_response, 2000);
            }else{
              this.helperService.presentToast(data.bizdata_dataset.bizdata_dataset_response, 2000);
            }
          },
          error => {
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }

  cancelOperationDatabaseSpinner() {
    this.operationDatabaseTestApi.unsubscribe();
    this.resetOperationDatabaseUIState();
  }

  resetOperationDatabaseUIState() {
    this.spinnerOperationDatabase = false;
    this.spinnerOperationDatabaseShow = false;
  }

  checkTokenSessionBeforeTestJdbc(formData, index) {
    this.spinnerOperationDatabase = true;
    this.spinnerOperationDatabaseShow = true;
    this.type = 'jdbc_operation';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForJdbcOperation = storage_data.pytokenJdbcOperation;
      if (storage_data.pytokenJdbcOperation == null) {
        this.generateToken('jdbc_operation').then((res: string) => {
          this.pythonTokenForJdbcOperation = res;
          this.testJdbc(formData, index);
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testJdbc(formData, index);
          } else {
            this.generateToken('jdbc_operation').then((res: string) => {
              this.pythonTokenForJdbcOperation = res;
              this.testJdbc(formData, index);
            })
          }
        })
      }
    })
  }

  testJdbc(formData, index) {
    this.spinnerOperationDatabase = true;
    if (formData.jdbc_string.includes('host_ip')) {
      formData.jdbc_string = formData.jdbc_string.replace('host_ip', formData.host_ip)
    }
    if (formData.jdbc_string.includes('port_number')) {
      formData.jdbc_string = formData.jdbc_string.replace('port_number', formData.port_number)
    }
    if (formData.jdbc_string.includes('schema_name')) {
      formData.jdbc_string = formData.jdbc_string.replace('schema_name', formData.schema_name)
    }
    if (formData.tuple_key == '' || formData.tuple_key == undefined) {
      formData.tuple_key = ""
    } else {
      formData.tuple_key = formData.tuple_key//this.helperService.stringToObjectConverter('Array', formData.tuple_key)
    }
    let query;
    if (formData.query == '' || formData.query == undefined) {
      this.helperService.presentToast("Please provide the SQL Query",1000)
      this.spinnerOperationDatabase     = false;
      this.spinnerOperationDatabaseShow = false;
      return;
    } else {
      // if(formData.query.includes('"""')){
      //   query = formData.query//this.helperService.stringToObjectConverter('Array', formData.query)//formData.query//
      // }else{
      //   query = formData.query.replace(/['"]+/g, '');
      // }
      // query = formData.query//this.helperService.stringToObjectConverter('Array', formData.query)//formData.query//
     
      query = [formData.query];
      query = [query[0].trim().replace(/^\"(.*)\"$/, "$1")]
    }
    // this.helperService.loader();
    this.getStorage().then(async (res) => {
      let payload = {
        "key_data": "",
        "batch_size": formData.batch_size,
        "jdbc_driver": formData.jdbc_driver,
        "jdbc_string": formData.jdbc_string,
        "username": formData.username,
        "password": await this.helperService.encrypt(formData.password),
        "jar_file": formData.jar_file,
        "tuple_key": formData.tuple_key,
        "query": query
      }
      const api_endpoint = environment.python_api_base_url + '/jdbc_ops';
      this.operationDatabaseTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForJdbcOperation)
        .subscribe(
          data => {
            (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['status'].setValue('200');
            if (typeof data == 'number') {
              (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['response'].setValue(data.toString());
              this.spinnerOperationDatabase = false;
              this.spinnerOperationDatabaseShow == false;
              this.resetOperationDatabaseUIState();
            } else {
              if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('error message')) {
                (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response['error message']);
              }
              if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('error_message')) {
                (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response.error_message);
              }
              if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('message')) {
                (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response.message);
              }
              if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('results')) {
                (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['response'].setValue(JSON.stringify(data.bizdata_dataset.bizdata_dataset_response.results));
              }
              if (data.hasOwnProperty('results')) {
                (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['response'].setValue(JSON.stringify(data.results));
              }
              if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('bizdata_dataset')) {
                (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['response'].setValue(JSON.stringify(data.bizdata_dataset.bizdata_dataset_response.bizdata_dataset));
              }else{
                (<UntypedFormGroup>this.jdbcoutputRows().at(index)).controls['response'].setValue(JSON.stringify(data.bizdata_dataset.bizdata_dataset_response));
              }
              this.spinnerOperationDatabase = false;
              this.spinnerOperationDatabaseShow == false;
              this.resetOperationDatabaseUIState();
            }
            this.spinnerOperationDatabase = false;
            this.spinnerOperationDatabaseShow == false;
            this.resetOperationDatabaseUIState();
            // this.helperService.closeLoader();
          },
          error => {
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }
  async openSchedular() {
    let data = this.summary.controls["schedule"].value;
    const modal = await this.modalCtrl.create({
      component: SchedularComponent,
      componentProps: {
        "Data": data
      },
      cssClass: 'my-custom-class',
      swipeToClose: true,
      backdropDismiss: true,
      presentingElement: this.routerOutlet.nativeEl
    });
    modal.onDidDismiss().then(res => {
      //console.log(res);

      if (res != undefined && res != null) {
        // //console.log(data.data)
        if (res.role != "backdrop") {
          this.summary.controls["schedule"].setValue(res.role);
        } else {
          this.summary.controls["schedule"].setValue(data);
        }

      }
    })
    return await modal.present();
  }


  searchStringMethod(message: string) {
    this.incomingSearchText$.next(message);
  }

  getSearchOnChange(event) {
    this.searchStringMethod(event);
  }
  searchOps(value) {
    let operationsFilter = [];
    //console.log(value);
    if (value != "") {
      this.searchFilter = true;
      this.operationsArrSearch = _.cloneDeep(this.operationsArr);
      let operations = [];
      this.operationsArrSearch.map((item) => {
        operations = item.blocks.filter(a => {
          if (a.title.toLowerCase().includes(value.toLowerCase())) {
            operationsFilter.push(a);
            return a.title.toLowerCase().includes(value.toLowerCase());
          }
        })
        item.blocks = operations;
      });
      this.operationsSearch = { 'blockArr': operationsFilter };
    } else {
      this.search = "";
      if (this.searchFilter == true && operationsFilter.length == 0) {
        this.operationLists();
        this.searchFilter = false;
      }
    }
  }
  clearSearch() {
    this.searchFilter = false;
    this.searchOperations = [];
    this.search = "";
    this.operationLists();
  }
  operationLists() {
    this.operationsArrSearch = _.cloneDeep(this.operationsArr);
    let operations = [];
    this.operationsArrSearch.map((item) => {
      let result = item.blocks.filter(
        (self, index) => index === item.blocks.findIndex(
          other => self.title === other.title
            && self.icon === other.icon
        ));
      operations.push(...result);
    })
    this.operationsSearch = { 'blockArr': operations };
  }
  sourcePostmanTabChange(tabChangeEvent: MatTabChangeEvent): void {
    this.onChangeSelectedEnvironment();
    if (tabChangeEvent.tab.textLabel == 'Body') {
      this._bodySourceEditor?.codeMirror?.refresh();
    }
    if (tabChangeEvent.tab.textLabel == 'Pre-request Script') {
      this._sourcePreRequestScriptEditor?.codeMirror?.refresh();
    }
    if (tabChangeEvent.tab.textLabel == 'Authorization') {
      this._sourcerefreshTokenHeaderScriptEditor?.codeMirror?.refresh();
      this._sourcerefreshTokenParamScriptEditor?.codeMirror?.refresh();
      this._sourcerefreshTokenBodyScriptEditor?.codeMirror?.refresh();
    }
    if (tabChangeEvent.tab.textLabel == 'Pagination') {
      this._sourceCustomPaginationScriptEditor.codeMirror.refresh();
    }
  }
  sourcePostmanWsTabChange(tabChangeEvent: MatTabChangeEvent): void {
  }
  targetPostmanTabChange(tabChangeEvent: MatTabChangeEvent): void {
    this.onChangeTargetSelectedEnvironment();
    if (tabChangeEvent.tab.textLabel == 'Body') {
      this._bodyTargetEditor.codeMirror.refresh();
    }
    if (tabChangeEvent.tab.textLabel == 'Pre-request Script') {
      this._targetPreRequestScriptEditor.codeMirror.refresh();
    }
    if (tabChangeEvent.tab.textLabel == 'Authorization') {
      this._targetrefreshTokenHeaderScriptEditor?.codeMirror.refresh();
      this._targetrefreshTokenParamScriptEditor?.codeMirror.refresh();
      this._targetrefreshTokenBodyScriptEditor?.codeMirror.refresh();
    }
  }

  autoResize(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  async postmanTabChangeROA(tabChangeEvent: MatTabChangeEvent, id,index) {
    if(tabChangeEvent.index == 1) {
      for (const component of this.postmanuiComponents.toArray()) {
        if (component.apiCatalogFormType === 'operation') {
          await component.onChangeSelectedEnvironment();
        }
      }
    }
    // this.onChildUiUpdate(index);
    // this._preRequestScriptEditorROA?.codeMirror.refresh();
    // if (id == this.selectedOperationId) {
    //   if(tabChangeEvent.index==1){
    //     let textarea=document.getElementById(`rest_api_url${index}`);
    //     textarea.addEventListener('focus', this.autoResize);
    //     textarea.addEventListener('input', this.autoResize);
    //     textarea.addEventListener("focusout",()=>{
    //       textarea.style.height = 24 + 'px';
    //     })
    //     }
    //   if (tabChangeEvent.tab.textLabel == 'Body') {
    //     this._bodyRestAPIEditor?.codeMirror.refresh();
    //   }
    //   if (tabChangeEvent.tab.textLabel == 'Pre-request Script') {
    //     this._preRequestScriptEditorROA?.codeMirror.refresh();
    //   }
    //   if (tabChangeEvent.tab.textLabel == 'Authorization') {
    //     this._refreshTokenHeaderScriptEditorROA?.codeMirror.refresh();
    //     this._refreshTokenParamScriptEditorROA?.codeMirror.refresh();
    //     this._refreshTokenBodyScriptEditorROA?.codeMirror.refresh();
    //   }
    // }
    // if((<UntypedFormGroup>this.restapiRows().at(index)).controls['bridge_target_endpoint_params_raw'] != undefined){
    //   let params = (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridge_target_endpoint_params_raw']!.value;
    //   if(params[0].bridge_target_paramKey != null && params[0].bridge_target_paramKey != ""){
    //     this.params_ops_raw[index] = params;
    //   }
    // }
    // if((<UntypedFormGroup>this.restapiRows().at(index)).controls['bridge_target_endpoint_headers'] != undefined){
    //   let headers = (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridge_target_endpoint_headers']!.value;
    //   if(headers[0].bridge_target_headerKey != null && headers[0].bridge_target_headerKey != "" ){
    //     this.headers_ops_raw[index] = headers;
    //   }
    // }
    // let selected_env = (<UntypedFormGroup>this.restapiRows().at(index)).controls['selected_environment']!.value;
    // this.contentDivOps =document.getElementById('contentDivOps'+index);
    // if(this.contentDivOps != null){
    //   if(this.endpoint_ops_url[index] != undefined){
    //     this.contentDivOps.innerHTML = this.endpoint_ops_url[index];
    //   }      
    // }    
    // this.onChangeSelectedOpsEnvironment(index,selected_env);
  } 

  cancelSourceDatabaseSpinner() {
    this.sourceDatabaseTestApi.unsubscribe();
    this.resetSourceDatabaseUIState();
  }

  resetSourceDatabaseUIState() {
    this.spinnerSourceDatabase = false;
    this.spinnerSourceDatabaseShow = false;
  }

  checkTokenSessionBeforeDataSourceJdbc() {
    this.spinnerSourceDatabase = true;
    this.spinnerSourceDatabaseShow = true;
    this.type = 'jdbc_operation';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForJdbcOperation = storage_data.pytokenJdbcOperation;
      if (storage_data.pytokenJdbcOperation == null) {
        this.generateToken('jdbc_operation').then((res: string) => {
          this.pythonTokenForJdbcOperation = res;
          this.testDataSourceJdbc();
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testDataSourceJdbc();
          } else {
            this.generateToken('jdbc_operation').then((res: string) => {
              this.pythonTokenForJdbcOperation = res;
              this.testDataSourceJdbc();
            })
          }
        })
      }
    })
  }

  async testDataSourceJdbc() {
    this.spinnerSourceDatabase = true;
    if (this.dataSource.value.jdbc_string.includes('host_ip')) {
      this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('host_ip', this.dataSource.value.host_ip)
    }
    if (this.dataSource.value.jdbc_string.includes('port_number')) {
      this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('port_number', this.dataSource.value.port_number)
    }
    if (this.dataSource.value.jdbc_string.includes('schema_name')) {
      this.dataSource.value.jdbc_string = this.dataSource.value.jdbc_string.replace('schema_name', this.dataSource.value.schema_name)
    }
    if (this.dataSource.value.query == undefined||this.dataSource.value.query == '') {
      this.helperService.presentToast("Please provide the SQL Query",1000)
      this.spinnerSourceDatabase     = false;
      this.spinnerSourceDatabaseShow = false;
      return;
    }
    // this.helperService.loader();
    this.getStorage().then(async (res) => {
      let payload = {
        "key_data": "",
        "chunks_size": 10,
        "jdbc_driver": this.dataSource.value.jdbc_driver,
        "jdbc_string": this.dataSource.value.jdbc_string,
        "username": this.dataSource.value.username,
        "password": await this.helperService.encrypt(this.dataSource.value.password),
        "jdbc_jar_file": this.dataSource.value.jdbc_jar_file,
        "response_parameter": this.dataSource.value.response_parameter,
        "query": this.dataSource.value.query,
      }
      const api_endpoint = environment.python_api_base_url + '/jdbc_source';
      this.sourceDatabaseTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForJdbcOperation)
        .subscribe(
          data => {
            // this.helperService.closeLoader();
            if (data != null && data != undefined) {
              if (data.bizdata_dataset != undefined) {
                if (data.bizdata_dataset.bizdata_dataset_status == 200) {
                  this.data_source_status = 200;

                  (<UntypedFormGroup>this.dataSource).controls['status'].setValue("200");
                  // this.dataSource.value.status.setValue('200');

                  if (typeof data == 'number') {
                    (<UntypedFormGroup>this.dataSource).controls['response'].setValue(data.toString());
                    this.spinnerSourceDatabase = false;
                    this.spinnerSourceDatabaseShow == false;
                    this.resetSourceDatabaseUIState();
                  } else {
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('error_message')) {
                      (<UntypedFormGroup>this.dataSource).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response.error_message);
                    }
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('message')) {
                      (<UntypedFormGroup>this.dataSource).controls['response'].setValue(res);
                    }
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('result')) {
                      (<UntypedFormGroup>this.dataSource).controls['response'].setValue(JSON.stringify(data.bizdata_dataset.bizdata_dataset_response.result));
                    }
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('bizdata_dataset')) {
                      (<UntypedFormGroup>this.dataSource).controls['response'].setValue(JSON.stringify(data.bizdata_dataset.bizdata_dataset_response.bizdata_dataset));
                    }
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('data')) {
                      (<UntypedFormGroup>this.dataSource).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response);
                    } else {
                      (<UntypedFormGroup>this.dataSource).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response);
                    }
                    this.spinnerSourceDatabase = false;
                    this.spinnerSourceDatabaseShow == false;
                    this.resetSourceDatabaseUIState();
                  }
                } else if (data.bizdata_dataset.bizdata_dataset_status != 200) {
                  this.data_source_status = data.bizdata_dataset.bizdata_dataset_status;
                  (<UntypedFormGroup>this.dataSource).controls['status'].setValue(data.bizdata_dataset.bizdata_dataset_status);
                  (<UntypedFormGroup>this.dataSource).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response);
                  this.spinnerSourceDatabase = false;
                  this.spinnerSourceDatabaseShow == false;
                  this.resetSourceDatabaseUIState();
                } else {
                  (<UntypedFormGroup>this.dataSource).controls['response'].setValue(data.error_message);
                  this.spinnerSourceDatabase = false;
                  this.spinnerSourceDatabaseShow == false;
                  this.resetSourceDatabaseUIState();
                }
              } else {
                (<UntypedFormGroup>this.dataSource).controls['response'].setValue(data.error_message);
                this.spinnerSourceDatabase = false;
                this.spinnerSourceDatabaseShow == false;
                this.resetSourceDatabaseUIState();
              }
            } else {
              (<UntypedFormGroup>this.dataSource).controls['response'].setValue(data);
              this.spinnerSourceDatabase = false;
              this.spinnerSourceDatabaseShow == false;
              this.resetSourceDatabaseUIState();
            }
            this.spinnerSourceDatabase = false;
            this.spinnerSourceDatabaseShow == false;
            this.resetSourceDatabaseUIState();
          },
          error => {
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }

  cancelTargetDatabaseSpinner() {
    this.targetDatabaseTestApi.unsubscribe();
    this.resetTargetDatabaseUIState();
  }

  resetTargetDatabaseUIState() {
    this.spinnerTargetDatabase = false;
    this.spinnerTargetDatabaseShow = false;
  }

  checkTokenSessionBeforeDataTargetJdbc() {
    this.spinnerTargetDatabase = true;
    this.spinnerTargetDatabaseShow = true;
    this.type = 'jdbc_operation';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForJdbcOperation = storage_data.pytokenJdbcOperation;
      if (storage_data.pytokenJdbcOperation == null) {
        this.generateToken('jdbc_operation').then((res: string) => {
          this.pythonTokenForJdbcOperation = res;
          this.testDataTargetJdbc();
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testDataTargetJdbc();
          } else {
            this.generateToken('jdbc_operation').then((res: string) => {
              this.pythonTokenForJdbcOperation = res;
              this.testDataTargetJdbc();
            })
          }
        })
      }
    })
  }

  testDataTargetJdbc() {
    this.spinnerTargetDatabase = true;
    if (this.dataTarget.value.jdbc_string.includes('host_ip')) {
      this.dataTarget.value.jdbc_string = this.dataTarget.value.jdbc_string.replace('host_ip', this.dataTarget.value.host_ip)
    }
    if (this.dataTarget.value.jdbc_string.includes('port_number')) {
      this.dataTarget.value.jdbc_string = this.dataTarget.value.jdbc_string.replace('port_number', this.dataTarget.value.port_number)
    }
    if (this.dataTarget.value.jdbc_string.includes('schema_name')) {
      this.dataTarget.value.jdbc_string = this.dataTarget.value.jdbc_string.replace('schema_name', this.dataTarget.value.schema_name)
    }
    if (this.dataTarget.value.tuple_key == '' || this.dataTarget.value.tuple_key == undefined) {
      this.dataTarget.value.tuple_key = ""
    } else {
      this.dataTarget.value.tuple_key = this.dataTarget.value.tuple_key//this.helperService.stringToObjectConverter('Array', this.dataTarget.value.tuple_key)
    }
    let query;
    if (this.dataTarget.value.query == '' || this.dataTarget.value.query == undefined) {
      this.helperService.presentToast("Please provide the SQL Query",1000)
      this.spinnerTargetDatabase     = false;
      this.spinnerTargetDatabaseShow = false;
      return;
    } else {
      query = this.helperService.stringToObjectConverter('Array', this.dataTarget.value.query)
    }
    // this.helperService.loader();
    this.getStorage().then(async (res) => {
      let payload = {
        // "key_data": "",
        "batch_size": this.dataTarget.value.batch_size,
        "jdbc_driver": this.dataTarget.value.jdbc_driver,
        "jdbc_string": this.dataTarget.value.jdbc_string,
        "username": this.dataTarget.value.username,
        "password": await this.helperService.encrypt(this.dataTarget.value.password),
        "jar_file": this.dataTarget.value.jar_file,
        "tuple_key": this.dataTarget.value.tuple_key,
        "query": query
      }
      const api_endpoint = environment.python_api_base_url + '/jdbc_ops';
      this.targetDatabaseTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForJdbcOperation)
        .subscribe(
          data => {
            this.helperService.closeLoader();
            if (data != null && data != undefined) {
              if (data.bizdata_dataset != undefined) {
                if (data.bizdata_dataset.bizdata_dataset_response != undefined) {
                  this.data_source_status = 200;

                  (<UntypedFormGroup>this.dataTarget).controls['status'].setValue("200");
                  // this.dataTarget.value.status.setValue('200');

                  if (typeof data == 'number') {
                    (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(data.toString());
                    this.spinnerTargetDatabase = false;
                    this.spinnerTargetDatabaseShow == false;
                    this.resetTargetDatabaseUIState();
                  } else {
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('error_message')) {
                      (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response.error_message);
                    }
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('message')) {
                      (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(res);
                    }
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('result')) {
                      (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(JSON.stringify(data.bizdata_dataset.bizdata_dataset_response.result));
                    }
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('bizdata_dataset')) {
                      (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(JSON.stringify(data.bizdata_dataset.bizdata_dataset_response.bizdata_dataset));
                    }
                    if (data.bizdata_dataset.bizdata_dataset_response.hasOwnProperty('data')) {
                      (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response);
                    } else {
                      (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response);
                    }
                    this.spinnerTargetDatabase = false;
                    this.spinnerTargetDatabaseShow == false;
                    this.resetTargetDatabaseUIState();
                  }
                } else if (data.bizdata_dataset.bizdata_dataset_status != undefined) {
                  this.data_source_status = data.bizdata_dataset.bizdata_dataset_status;
                  (<UntypedFormGroup>this.dataTarget).controls['status'].setValue(data.bizdata_dataset.bizdata_dataset_status);
                  (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(data.bizdata_dataset.bizdata_dataset_response);
                  this.spinnerTargetDatabase = false;
                  this.spinnerTargetDatabaseShow == false;
                  this.resetTargetDatabaseUIState();
                } else {
                  (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(data.error_message);
                  this.spinnerTargetDatabase = false;
                  this.spinnerTargetDatabaseShow == false;
                  this.resetTargetDatabaseUIState();
                }
              } else {
                (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(data.error_message);
                this.spinnerTargetDatabase = false;
                this.spinnerTargetDatabaseShow == false;
                this.resetTargetDatabaseUIState();
              }
            } else {
              (<UntypedFormGroup>this.dataTarget).controls['response'].setValue(data.error_message);
              this.spinnerTargetDatabase = false;
              this.spinnerTargetDatabaseShow == false;
              this.resetTargetDatabaseUIState();
            }
          },
          error => {
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }

  cancelSourceDatalakeSpinner() {
    this.sourceDatalakeTestApi?.unsubscribe();
    this.resetSourceDatalakeUIState();
  }

  resetSourceDatalakeUIState() {
    this.spinnerSourceDatalake = false;
    this.spinnerSourceDatalakeShow = false;
  }
  cancelSearchDatalakeSpinner() {
    this.searchDatalakeTestApi?.unsubscribe();
    this.resetSourceDatalakeUIState();
  }

  resetSearchDatalakeUIState() {
    this.spinnerSearchDatalake = false;
    this.spinnerSearchDatalakeShow = false;
  }

  checkTokenSessionBeforeTestDataLakeSource() {
    this.spinnerSourceDatalake = true;
    this.spinnerSourceDatalakeShow = true;
    this.type = 'jdbc_operation';
    // this.helperService.loader();
    this.getStorage().then((storage_data) => {
      this.pythonTokenForJdbcOperation = storage_data.pytokenJdbcOperation;
      if (storage_data.pytokenJdbcOperation == null) {
        this.generateToken('jdbc_operation').then((res: string) => {
          this.pythonTokenForJdbcOperation = res;
          this.testDataLakeSource();
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testDataLakeSource();
          } else {
            this.generateToken('jdbc_operation').then((res: string) => {
              this.pythonTokenForJdbcOperation = res;
              this.testDataLakeSource();
            })
          }
        })
      }
    })
  }

  checkTokenSessionBeforeTestDataLakeSearch() {
    this.spinnerSearchDatalake = true;
    this.spinnerSearchDatalakeShow = true;
    this.type = 'jdbc_operation';
    this.getStorage().then((storage_data) => {
      this.pythonTokenForJdbcOperation = storage_data.pytokenJdbcOperation;
      if (storage_data.pytokenJdbcOperation == null) {
        this.generateToken('jdbc_operation').then((res: string) => {
          this.pythonTokenForJdbcOperation = res;
          this.testDataLakeSearch();
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testDataLakeSearch();
          } else {
            this.generateToken('jdbc_operation').then((res: string) => {
              this.pythonTokenForJdbcOperation = res;
              this.testDataLakeSearch();
            })
          }
        })
      }
    })
  }

  testDataLakeSource() {
    this.spinnerSourceDatalake = true;
    this.dataSource.controls['dlsource_body_response'].reset();
    if (this.dataSource.value.dlsource_index_name == '' || this.dataSource.value.dlsource_index_name == undefined) {
      this.helperService.presentToast('Please provide valid Index/Table Name', 2000);
      this.spinnerSourceDatalake = false;
      this.spinnerSourceDatalakeShow == false;
      this.resetSourceDatalakeUIState();
      return
    }
    // this.helperService.loader();
    this.getStorage().then((res) => {
      let dlversion = this.dataSource.value.version;
      let source_name = "bizintel360-" + this.dataSource.value.dlsource_index_name;
      let payload = this.dataSource.value.dlsource_body;
      const api_endpoint = environment.python_api_base_url + "/search?" + "source_index_name=" + source_name + "&dlversion=" + dlversion.dlversion + "&optype=search";
      this.sourceDatalakeTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForJdbcOperation)
        .subscribe(data => {
          this.bridgeSourceResponse = data;
          //console.log(data);
          if (data != null) {
            if (data.bizdata_dataset) {
              this.dataSource.controls['dlsource_body_response'].setValue(data.bizdata_dataset.bizdata_dataset_response);
              // this.spinner = false;
              // this.spinnerShow == false;
              // this.cancelSourceDatalakeSpinner();
            } else {
              this.dataSource.controls['dlsource_body_response'].setValue(data.bizdata_dataset_response);
              this.spinnerSourceDatalake = false;
              this.spinnerSourceDatalakeShow == false;
              this.resetSourceDatalakeUIState();
            }
          } else {
            this.dataSource.controls['dlsource_body_response'].setValue(data);
          }
          this.spinnerSourceDatalake = false;
          this.spinnerSourceDatalakeShow == false;
          this.resetSourceDatalakeUIState();
          // this.helperService.closeLoader();
        },
          error => {
            this.spinnerSourceDatalake = false;
            this.spinnerSourceDatalakeShow == false;
            this.resetSourceDatalakeUIState();
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }

  testDataLakeSearch() {
    this.spinnerSearchDatalake = true;
    let dlsearchArr = this.dlsearchRows().value;
    for (let i = 0; i < dlsearchArr.length; i++) {
      let currentRow = dlsearchArr[i];
      if (currentRow.dlsearch_index_name == '' || currentRow.dlsearch_index_name == undefined) {
        this.helperService.presentToast('Please provide valid Index/Table Name', 2000);
        this.spinnerSearchDatalake = false;
        this.spinnerSearchDatalakeShow = false;
        this.resetSearchDatalakeUIState();
        return;
      }
      this.getStorage().then((res) => {
        let dlversion = currentRow.version;
        let source_name = "bizintel360-" + currentRow.dlsearch_index_name;
        let payload = currentRow.dlsearch_body;
        const api_endpoint = environment.python_api_base_url + "/search?" +"source_index_name=" + source_name +  "&dlversion=" + dlversion.dlversion + "&optype=search";
        this.searchDatalakeTestApi = this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForJdbcOperation)
          .subscribe(
            data => {
              this.bridgeResponse = data;
              if (data != null) {
                if (data.bizdata_dataset) {
                  this.dlsearchRows().controls[i].get('dlsearch_body_response').setValue(data.bizdata_dataset.bizdata_dataset_response);
                } else {
                  this.dlsearchRows().controls[i].get('dlsearch_body_response').setValue(data.bizdata_dataset_response);
                }
              } else {
                this.dlsearchRows().controls[i].get('dlsearch_body_response').setValue(data);
              }
              this.spinnerSearchDatalake = false;
              this.spinnerSearchDatalakeShow = false;
              this.resetSearchDatalakeUIState();
            },
            error => {
              this.spinnerSearchDatalake = false;
              this.spinnerSearchDatalakeShow = false;
              this.resetSearchDatalakeUIState();
              this.helperService.closeLoader();
              this.helperService.presentToast(error.error.detail, 2000);
            }
          );
      });
    }
  }
  


  OnChangeBridgeSourceType(e) {

    this.endpoint_url = "";
    this.params_key = [];
    this.params_value = [];
    this.headers_key = [];
    this.headers_value = [];
    this.source_auth = "";
    this.isPreviewRequestShow = false;
    this.bridge_source_type = e.value.id;
    if (this.bridge_source_type == 2) {
      this.dataSource.addControl('storage_name', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('db_version_list', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('db_version', new UntypedFormControl("", [Validators.required]));
      // this.dataSource.addControl('tuple_key', new UntypedFormControl("", []));
      this.dataSource.addControl('host_ip', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('port_number', new UntypedFormControl("3306", [Validators.required,Validators.pattern('^[0-9]*$')]));
      this.dataSource.addControl('schema_name', new UntypedFormControl("", []));
      // this.dataSource.addControl('batch_size', new UntypedFormControl("1000", []));
      this.dataSource.addControl('jdbc_driver', new UntypedFormControl("", []));
      this.dataSource.addControl('jdbc_string', new UntypedFormControl("", []));
      this.dataSource.addControl('jdbc_jar_file', new UntypedFormControl("", []));
      this.dataSource.addControl('username', new UntypedFormControl("", []));
      this.dataSource.addControl('password', new UntypedFormControl("", []));
      this.dataSource.addControl('query', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('status', new UntypedFormControl("", []));
      this.dataSource.addControl('response', new UntypedFormControl({}, []));
      // this.dataSource.addControl('unique_key', new UntypedFormControl("", []));
      this.dataSource.addControl('response_parameter', new UntypedFormControl("", []));
      this.dataSource.addControl('timer_type', new UntypedFormControl("", []));
      this.dataSource.addControl('interval_in_seconds', new UntypedFormControl("", []));
      this.dataSource.addControl('schedule', new UntypedFormControl("", []));
      this.dataSource.addControl('chunks_size', new UntypedFormControl(1000, [Validators.required]));
      this.dataSource.addControl('limit_query', new UntypedFormControl("", []));
      // this.dataSource.addControl('multiline', new UntypedFormControl("no", []));
      (<UntypedFormGroup>this.dataSource).controls['storage_name'].setValue(this.storageNameJDBCOList[0]);
      if (this.dataSource.value.storage_name != undefined && this.dataSource.value.storage_name != "") {
        this.getDataSourceDlVersionJDBCO(this.dataSource.value.storage_name)
      }
      this.bridge_summary_source_name = this.storageNameJDBCOList[0].storage_name;
      this.bridge_summary_source_bobj = "-";
    } else {
      this.dataSource.removeControl('storage_name');
      this.dataSource.removeControl('db_version_list');
      this.dataSource.removeControl('db_version');
      // this.dataSource.removeControl('tuple_key');
      this.dataSource.removeControl('host_ip');
      this.dataSource.removeControl('port_number');
      this.dataSource.removeControl('schema_name');
      // this.dataSource.removeControl('batch_size');
      this.dataSource.removeControl('jdbc_driver');
      this.dataSource.removeControl('jdbc_string');
      this.dataSource.removeControl('jdbc_jar_file');
      this.dataSource.removeControl('username');
      this.dataSource.removeControl('password');
      this.dataSource.removeControl('query');
      this.dataSource.removeControl('status');
      this.dataSource.removeControl('response');
      // this.dataSource.removeControl('unique_key');
      this.dataSource.removeControl('response_parameter');
      this.dataSource.removeControl('timer_type');
      this.dataSource.removeControl('interval_in_seconds');
      this.dataSource.removeControl('schedule');
      // this.dataSource.removeControl('multiline');
      this.dataSource.removeControl('chunks_size');
      this.dataSource.removeControl('limit_query');
    }
    if (this.bridge_source_type == 3) {
      this.dataSource.addControl('version', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('dlsource_host', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('dlsource_port', new UntypedFormControl(443, [Validators.required]));
      this.dataSource.addControl('dlsource_username', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('dlsource_password', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('dlsource_ca_certs_path', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('dlsource_index_name', new UntypedFormControl("", [Validators.required]));
      this.dataSource.addControl('scroll', new UntypedFormControl("2m", []));
      this.dataSource.addControl('dlsource_timeout', new UntypedFormControl(120, []));
      this.dataSource.addControl('dlsource_batch_size', new UntypedFormControl("1000", []));
      this.dataSource.addControl('dlsource_body', new UntypedFormControl('{"query": { "match_all": {} } }', []));
      this.dataSource.addControl('dlsource_body_response', new UntypedFormControl({}, []));
      // this.dataSource.addControl('timer_type', new UntypedFormControl("", []));
      // this.dataSource.addControl('interval_in_seconds', new UntypedFormControl("", []));
      // this.dataSource.addControl('schedule', new UntypedFormControl("", []));
      // this.dataSource.addControl('response', new UntypedFormControl("", []));
      if (this.sourceVerisonListDL.length > 0) {
        this.dataSource.patchValue({
          version: this.sourceVerisonListDL[0] 
        })
      }
      this.sourceDLListOpName = this.sourceVerisonListDL[0];
      let value = <UntypedFormGroup>this.dataSource.controls['version'].value.op_name;
      this.getStorage().then((res) => {
        let payload = {
          "dlversion": this.sourceVerisonListDL[0].dlversion,
          "op_name": this.sourceVerisonListDL[0].op_name,
          "op_type": 'source'
        }
        this.sourceDLListOpName = this.sourceVerisonListDL[0];
        this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
          (response) => {
            this.helperService.decryptpayload(response.data).then((records)=>{
            let data=JSON.parse(records);
            this.dataSourceDLIngestion = data;
            (<UntypedFormGroup>this.dataSource).controls['dlsource_host'].setValue(data.dlhost_name);
            (<UntypedFormGroup>this.dataSource).controls['dlsource_password'].setValue(data.dlpsw);
            (<UntypedFormGroup>this.dataSource).controls['dlsource_port'].setValue(+(data.dlport));
            (<UntypedFormGroup>this.dataSource).controls['dlsource_username'].setValue(data.dlusername);
            (<UntypedFormGroup>this.dataSource).controls['dlsource_ca_certs_path'].setValue(data.dl_ca_certs_path);
            });
          },
          (error) => {
            //console.log(error);
          }
        );
      })
      this.bridge_summary_source_name = this.dataSource.value.dlsource_index_name;//"Bizintel360 Data Lake Source";
      this.bridge_summary_source_bobj = "-"
      this.filteredOptions = this.dataSource.get('dlsource_index_name')!.valueChanges.pipe(
        startWith(''),
        map(value => this._IndexNamesOperationHeaderValue(value || '')),
      );
    } else {
      this.dataSource.removeControl('dlsource_host');
      this.dataSource.removeControl('dlsource_port');
      this.dataSource.removeControl('dlsource_username');
      this.dataSource.removeControl('dlsource_password');
      this.dataSource.removeControl('dlsource_ca_certs_path');
      this.dataSource.removeControl('dlsource_index_name');
      this.dataSource.removeControl('scroll');
      this.dataSource.removeControl('dlsource_timeout');
      this.dataSource.removeControl('dlsource_batch_size');
      this.dataSource.removeControl('dlsource_body');
      this.dataSource.removeControl('dlsource_body_response');
      // this.dataSource.removeControl('timer_type');
      // this.dataSource.removeControl('interval_in_seconds');
      // this.dataSource.removeControl('schedule');
      // this.dataSource.removeControl('response');
    }

    if (this.bridge_source_type == 1) {
      this.isPreviewRequestShow = true;
      this.enableDataSourceClearIcon = false;
      this.dataSource.addControl('bridge_source', new UntypedFormControl('', [Validators.required]));
      this.dataSource.addControl('bridge_source_business_object', new UntypedFormControl('', [Validators.required]));
      this.dataSource.addControl('bridge_source_endpoint_method', new UntypedFormControl('', []));
      this.dataSource.addControl('bridge_source_endpoint_url', new UntypedFormControl('', []));
      this.dataSource.addControl('bridge_source_endpoint_params_raw', new UntypedFormArray([]));
      this.dataSource.addControl('bridge_source_endpoint_headers', new UntypedFormArray([]));
      this.dataSource.addControl('bridge_source_endpoint_authentication_type', new UntypedFormControl("", []));
      this.dataSource.addControl('bridge_source_endpoint_body_raw', new UntypedFormControl("", []));
      this.dataSource.addControl('pre_request_script', new UntypedFormControl("", []));
      this.dataSource.addControl('bridge_source_response', new UntypedFormControl({}, []));

      this.dataSource.controls['bridge_source'].reset();
      this.dataSource.controls['bridge_source_business_object'].reset();
      this.dataSource.controls['bridge_source_endpoint_url'].reset();

      this.dataSource.controls['bridge_source_pagination_type'].setValue(this.paginationTypeOptions[0]);

      let bridge_endpoint_method = this.methodList.filter(function (entry) { return entry.id === 1 });
      this.dataSource.controls['bridge_source_endpoint_method'].setValue(bridge_endpoint_method[0]);

      let endpoint_authentication_type = this.authenticationSourceTypeOptions.filter(function (entry) { return entry.id === 1 });
      this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue(endpoint_authentication_type[0]);

      this.getStorage().then((res) => {
        // this.getMethod(res.token).then((method_list) => {
        //   this.methodList = method_list;
        //   // GET API AUTH TYPE
        //   this.getAuth(res.token).then((auth_list) => {
        //     this.authenticationSourceTypeOptions = auth_list;
        //     // this.authenticationTargetTypeOptions = auth_list;
        //   })
        // })
        // *************************
        // Load products with brand for source data
        // *************************
        this.getDataSource().then(res => {
          let data: [] = res as [];
          this.bridgeSourceList = data;
          this.bridgeSourceProduct$ = this.dataSource.get('bridge_source')!.valueChanges.pipe(
            startWith(''),
            map(value => {
              this.enableDataSourceClearIcon = value ? true : false;
              return this._filterMapSource(value || '')
            }),
          );
        });

      })

      this.addSourceParams(0);
      this.addSourceHeaders(0);

    } else {
      this.dataSource.removeControl('bridge_source');
      this.dataSource.removeControl('bridge_source_business_object');
      this.dataSource.removeControl('bridge_source_endpoint_method');
      this.dataSource.removeControl('bridge_source_endpoint_url');
      this.dataSource.removeControl('bridge_source_endpoint_params_raw');
      this.dataSource.removeControl('bridge_source_endpoint_headers');
      this.dataSource.removeControl('bridge_source_endpoint_authentication_type');
      this.dataSource.removeControl('bridge_source_endpoint_body_raw');
      this.dataSource.removeControl('pre_request_script');
      this.params_key = [];
      this.headers_key = [];
      this.params_value = [];
      this.headers_value = [];
    }
    if (this.bridge_source_type == 4) {
      // bridge_source_ws_endpoint_url
      this.dataSource.addControl('bridge_source_ws_endpoint_url', new UntypedFormControl('', [Validators.required]));
      this.dataSource.addControl('bridge_source_ws_endpoint_params_raw', new UntypedFormArray([]));
      this.dataSource.addControl('bridge_source_ws_endpoint_headers', new UntypedFormArray([]));
      this.dataSource.addControl('bridge_source_ws_message', new UntypedFormControl('', []));

      this.addSourceWsParams(0);
      this.addSourceWsHeaders(0);
      this.bridge_summary_source_name = "Websocket";
      this.bridge_summary_source_bobj = "-";
    } else {
      this.dataSource.removeControl('bridge_source_ws_endpoint_url');
      this.dataSource.removeControl('bridge_source_ws_message');
      this.dataSource.removeControl('bridge_source_ws_endpoint_params_raw');
      this.dataSource.removeControl('bridge_source_ws_endpoint_headers');
    }
    if (this.bridge_source_type == 5) {
      this.dataSource.addControl('user_email', new UntypedFormControl('', [Validators.required, Validators.email]));
      this.dataSource.addControl('email_password', new UntypedFormControl('', Validators.required));
      this.dataSource.addControl('mail_server', new UntypedFormControl('', [Validators.required,
         Validators.pattern(/^(?!\d+$).+/)]));
      this.dataSource.addControl('email_port_number', new UntypedFormControl('993', Validators.required));
      this.dataSource.addControl('out_type', new UntypedFormControl(this.email_out_types[0].value, Validators.required));
      this.bridge_summary_source_name = "Email";
      this.bridge_summary_source_bobj = "-";
    } else {
      this.dataSource.removeControl('user_email');
      this.dataSource.removeControl('email_password');
      this.dataSource.removeControl('mail_server');
      this.dataSource.removeControl('email_port_number');
      this.dataSource.removeControl('out_type');

    }
  }
  onChangeDataSourceStorageNameJDBCO(e) {
    this.bridge_summary_source_name = e.value.storage_name;
    this.bridge_summary_source_bobj = "-";
    this.getDataSourceDlVersionJDBCO(e.value);
  }
  dataSource_db_version_list;
  getDataSourceDlVersionJDBCO(obj) {
    this.getDlVersionJDBCOApi(obj.storage_name).then(res => {
      let data: [] = res as [];
      this.dataSource_db_version_list = data;
      (<UntypedFormGroup>this.dataSource).controls['db_version_list'].setValue(data);
      // if (loadFrom == 'fillNewRAO') {
      //   let bridge_target_business_object = data.filter(function (entry) { return entry.id == id; });
      //   (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridge_target_business_object'].setValue(bridge_target_business_object[0]);
      // }
      // this.helperService.closeLoader();
    });
  }
  onChangeDataSourceDlVersionJDBCO(e) {
    this.getStorage().then((res) => {
      let payload = {
        "storage_name": this.dataSource.value.storage_name.storage_name,
        "dbversion": e.value.dbversion
      }
      this.backendService.PostAPICall('getJDBCData', payload, res.token).subscribe(
        data => {
          (<UntypedFormGroup>this.dataSource).controls['jdbc_string'].setValue(data.data.jdbc_string);
          (<UntypedFormGroup>this.dataSource).controls['jdbc_jar_file'].setValue(data.data.jar_file_name);
          (<UntypedFormGroup>this.dataSource).controls['jdbc_driver'].setValue(data.data.jdbc_driver);
          (<UntypedFormGroup>this.dataSource).controls['limit_query'].setValue(data.data.limit_query);
        })
    })
  }
  OnChangeBridgeTargetType(e) {
    this.endpoint_target_url = "";
    this.params_target_key = [];
    this.params_target_value = [];
    this.headers_target_key = [];
    this.headers_target_value = [];
    this.target_auth = "";
    this.isPreviewRequestShow = false;

    this.bridge_target_type = e.value.id;
    if (this.bridge_target_type == 2) {
      this.dataTarget.addControl('storage_name', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('db_version_list', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('db_version', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('tuple_key', new UntypedFormControl("", []));
      this.dataTarget.addControl('host_ip', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('port_number', new UntypedFormControl("3306", [Validators.required,Validators.pattern('^[0-9]*$')]));
      this.dataTarget.addControl('schema_name', new UntypedFormControl("", []));
      this.dataTarget.addControl('batch_size', new UntypedFormControl("1000", []));
      this.dataTarget.addControl('jdbc_driver', new UntypedFormControl("", []));
      this.dataTarget.addControl('jdbc_string', new UntypedFormControl("", []));
      this.dataTarget.addControl('jar_file', new UntypedFormControl("", []));
      this.dataTarget.addControl('username', new UntypedFormControl("", []));
      this.dataTarget.addControl('password', new UntypedFormControl("", []));
      this.dataTarget.addControl('query', new UntypedFormControl("", []));
      this.dataTarget.addControl('status', new UntypedFormControl("", []));
      this.dataTarget.addControl('response', new UntypedFormControl({}, []));

      (<UntypedFormGroup>this.dataTarget).controls['storage_name'].setValue(this.storageNameJDBCOList[0]);
      if (this.dataTarget.value.storage_name != undefined && this.dataTarget.value.storage_name != "") {
        this.getDataTargetDlVersionJDBCO(this.dataTarget.value.storage_name)
      }
      this.bridge_summary_target_name = this.storageNameJDBCOList[0].storage_name;
      this.bridge_summary_target_bobj = "-";
    } else {
      this.dataTarget.removeControl('storage_name');
      this.dataTarget.removeControl('db_version_list');
      this.dataTarget.removeControl('db_version');
      this.dataTarget.removeControl('tuple_key');
      this.dataTarget.removeControl('host_ip');
      this.dataTarget.removeControl('port_number');
      this.dataTarget.removeControl('schema_name');
      this.dataTarget.removeControl('batch_size');
      this.dataTarget.removeControl('jdbc_driver');
      this.dataTarget.removeControl('jdbc_string');
      this.dataTarget.removeControl('jar_file');
      this.dataTarget.removeControl('username');
      this.dataTarget.removeControl('password');
      this.dataTarget.removeControl('query');
      this.dataTarget.removeControl('status');
      this.dataTarget.removeControl('response');
    }
    if (this.bridge_target_type == 3) {
      this.dataTarget.addControl('version', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('index_name', new UntypedFormControl(""));
      this.dataTarget.addControl('action_type', new UntypedFormControl("upsert", []));
      this.dataTarget.addControl('primary_key', new UntypedFormControl("", []));
      this.dataTarget.addControl('indexing_type', new UntypedFormControl("parallel_bulk", []));

      this.dataTarget.addControl('dl_ca_certs_path', new UntypedFormControl("", []));
      this.dataTarget.addControl('dlake_host', new UntypedFormControl("", []));
      this.dataTarget.addControl('dlake_port', new UntypedFormControl("", []));
      this.dataTarget.addControl('dlpassword', new UntypedFormControl("", []));
      this.dataTarget.addControl('dlusername', new UntypedFormControl("", []));
      this.dataTarget.addControl('dlversion', new UntypedFormControl("", []));
      if (this.targetVerisonListDL.length > 0) {
        this.dataTarget.patchValue({
          version: this.targetVerisonListDL[0]
        })
      }
      let value = <UntypedFormGroup>this.dataTarget.controls['version'].value.dlversion;
      this.getStorage().then((res) => {
        let payload = {
          "dlversion": this.targetVerisonListDL[0].dlversion,
          "op_name": this.targetVerisonListDL[0].op_name,
          "op_type": "ingestion"
        }
        this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
          (response) => {
            this.helperService.decryptpayload(response.data).then((records)=>{
            let data=JSON.parse(records);
            this.dataTargetDLIngestion = data;
            (<UntypedFormGroup>this.dataTarget).controls['dlake_host'].setValue(data.dlhost_name);
            (<UntypedFormGroup>this.dataTarget).controls['dlpassword'].setValue(data.dlpsw);
            (<UntypedFormGroup>this.dataTarget).controls['dlake_port'].setValue(+(data.dlport));
            (<UntypedFormGroup>this.dataTarget).controls['dlusername'].setValue(data.dlusername);
            (<UntypedFormGroup>this.dataTarget).controls['dl_ca_certs_path'].setValue(data.dl_ca_certs_path);
            (<UntypedFormGroup>this.dataTarget).controls['datalake_id'].setValue(data.id);
          });

          },
          (error) => {
            //console.log(error);
          }
        );
      })
      this.bridge_summary_target_name = this.dataTarget.value.index_name;//"Bizintel360 Data Lake Ingestion";
      this.bridge_summary_target_bobj = "-";
      this.filteredTargetOptions = this.dataTarget.get('index_name')!.valueChanges.pipe(
        startWith(''),
        map(value => this._IndexNamesOperationHeaderValue(value || '')),
      );
      
    } else {
      this.dataTarget.removeControl('version');
      this.dataTarget.removeControl('index_name');
      this.dataTarget.removeControl('action_type');
      this.dataTarget.removeControl('primary_key');
      this.dataTarget.removeControl('indexing_type');
      this.dataTarget.removeControl('dl_ca_certs_path');
      this.dataTarget.removeControl('dlake_host');
      this.dataTarget.removeControl('dlake_port');
      this.dataTarget.removeControl('dlpassword');
      this.dataTarget.removeControl('dlusername');
      this.dataTarget.removeControl('dlversion');
    }
    if (this.bridge_target_type == 4) {
      this.dataTarget.addControl('From', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('email_password', new UntypedFormControl("", [Validators.required]));
      this.dataTarget.addControl('mailserver', new UntypedFormControl("", [Validators.required,
         Validators.pattern(/^(?!\d+$).+/)]));
      this.dataTarget.addControl('email_port_number', new UntypedFormControl("465", [Validators.required]));
      this.dataTarget.addControl('to', new UntypedFormControl("", []));
      this.dataTarget.addControl('cc', new UntypedFormControl("", []));
      this.dataTarget.addControl('bcc', new UntypedFormControl("", []));
      this.dataTarget.addControl('subject', new UntypedFormControl("", []));
      this.dataTarget.addControl('source_key', new UntypedFormControl("", []));
      this.dataTarget.addControl('body', new UntypedFormControl("", []));
      this.dataTarget.addControl('attachment', new UntypedFormControl("", []));
      this.dataTarget.addControl('file_name', new UntypedFormControl("", []));
      this.bridge_summary_target_name = 'Email';
      this.bridge_summary_target_bobj = "-";
    } else {
      this.dataTarget.removeControl('From');
      this.dataTarget.removeControl('email_password');
      this.dataTarget.removeControl('mailserver');
      this.dataTarget.removeControl('email_port_number');
      this.dataTarget.removeControl('to');
      this.dataTarget.removeControl('cc');
      this.dataTarget.removeControl('bcc');
      this.dataTarget.removeControl('subject');
      this.dataTarget.removeControl('source_key');
      this.dataTarget.removeControl('body');
      this.dataTarget.removeControl('attachment');
      this.dataTarget.removeControl('file_name');
    }

    if (this.bridge_target_type == 5) {
      this.bridge_summary_target_name = 'No Target';
    }

    if (this.bridge_target_type == 1) {
      this.isPreviewRequestShow = true;
      this.dataTarget.addControl('bridge_target', new UntypedFormControl('', [Validators.required]));
      this.dataTarget.addControl('bridge_target_business_object', new UntypedFormControl('', [Validators.required]));
      this.dataTarget.addControl('bridge_target_endpoint_method', new UntypedFormControl("", []));
      this.dataTarget.addControl('bridge_target_endpoint_url', new UntypedFormControl("", []));
      this.dataTarget.addControl('bridge_target_endpoint_params_raw', new UntypedFormArray([]));
      this.dataTarget.addControl('bridge_target_endpoint_headers', new UntypedFormArray([]));
      this.dataTarget.addControl('bridge_target_endpoint_authentication_type', new UntypedFormControl("", []));
      this.dataTarget.addControl('bridge_target_endpoint_body_raw', new UntypedFormControl("", []));
      this.dataTarget.addControl('pre_request_script', new UntypedFormControl("", []));
      this.dataTarget.addControl('bridge_target_response', new UntypedFormControl({}, []));

      this.dataTarget.controls['bridge_target'].reset();
      this.dataTarget.controls['bridge_target_business_object'].reset();
      this.dataTarget.controls['bridge_target_endpoint_url'].reset();

      let bridge_endpoint_method = this.methodList.filter(function (entry) { return entry.id === 1 });
      this.dataTarget.controls['bridge_target_endpoint_method'].setValue(bridge_endpoint_method[0]);

      let endpoint_authentication_type = this.authenticationTargetTypeOptions.filter(function (entry) { return entry.id === 1 });
      this.dataTarget.controls['bridge_target_endpoint_authentication_type'].setValue(endpoint_authentication_type[0]);
      this.getStorage().then((res) => {
        // this.getMethod(res.token).then((method_list) => {
        //   this.methodList = method_list;
        //   // GET API AUTH TYPE
        //   this.getAuth(res.token).then((auth_list) => {
        //     // this.authenticationSourceTypeOptions = auth_list;
        //     this.authenticationTargetTypeOptions = auth_list;
        //   })
        // })
        // *************************
        // Load products with brand for target data
        // *************************
        this.getDataTarget().then(res => {
          let data: [] = res as [];
          this.bridgeTargetList = data;
          this.bridgeTarget$ = this.dataTarget.get('bridge_target')!.valueChanges.pipe(
            startWith(''),
            map(value => {
              this.enableDataTargetClearIcon = value ? true : false;
              return this._filterMapTarget(value || '')
            }),
          );
        });

      })
      this.addTargetParams(0);
      this.addTargetHeaders(0);

    } else {
      this.dataTarget.removeControl('bridge_target');
      this.dataTarget.removeControl('bridge_target_business_object');
      this.dataTarget.removeControl('bridge_target_endpoint_method');
      this.dataTarget.removeControl('bridge_target_endpoint_url');
      this.dataTarget.removeControl('bridge_target_endpoint_params_raw');
      this.dataTarget.removeControl('bridge_target_endpoint_headers');
      this.dataTarget.removeControl('bridge_target_endpoint_authentication_type');
      this.dataTarget.removeControl('bridge_target_endpoint_body_raw');
      this.dataTarget.removeControl('pre_request_script');
      this.dataTarget.removeControl('bridge_target_response');
      this.params_target_key = [];
      this.headers_target_key = [];
      this.params_target_value = [];
      this.headers_target_value = [];
    }
  }
  onChangeDataTargetStorageNameJDBCO(e) {
    this.bridge_summary_target_name = e.value.storage_name;
    this.bridge_summary_target_bobj = "-";
    this.getDataTargetDlVersionJDBCO(e.value);
  }

  dataTarget_db_version_list;
  getDataTargetDlVersionJDBCO(obj) {
    this.getDlVersionJDBCOApi(obj.storage_name).then(res => {
      let data: [] = res as [];
      //console.log(data);
      this.dataTarget_db_version_list = data;
      (<UntypedFormGroup>this.dataTarget).controls['db_version_list'].setValue(data);
      // if (loadFrom == 'fillNewRAO') {
      //   let bridge_target_business_object = data.filter(function (entry) { return entry.id == id; });
      //   (<FormGroup>this.restapiRows().at(index)).controls['bridge_target_business_object'].setValue(bridge_target_business_object[0]);
      // }
      // this.helperService.closeLoader();
    });
  }

  onChangeDataTargetDlVersionJDBCO(e) {
    this.getStorage().then((res) => {
      let payload = {
        "storage_name": this.dataTarget.value.storage_name.storage_name,
        "dbversion": e.value.dbversion
      }
      this.backendService.PostAPICall('getJDBCData', payload, res.token).subscribe(
        data => {
          (<UntypedFormGroup>this.dataTarget).controls['jdbc_string'].setValue(data.data.jdbc_string);
          (<UntypedFormGroup>this.dataTarget).controls['jar_file'].setValue(data.data.jar_file_name);
          (<UntypedFormGroup>this.dataTarget).controls['jdbc_driver'].setValue(data.data.jdbc_driver);
        })
    })
  }

  changeActionTypeList() {
    //console.log(this.dataTarget.value);
    this.datatarget_action_type = this.dataTarget.value.action_type;
  }

  onChangeDTGetDlversion(event) {
    let value = event.value.op_name
    this.getStorage().then((res) => {
      let payload = {
        "dlversion": event.value.dlversion,
        "op_name": value,
        "op_type": "ingestion"
      }
      this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
        (response) => {
          this.helperService.decryptpayload(response.data).then((records)=>{
          let data=JSON.parse(records);
          this.dataTargetDLIngestion = data;
          (<UntypedFormGroup>this.dataTarget).controls['dlake_host'].setValue(data.dlhost_name);
          (<UntypedFormGroup>this.dataTarget).controls['dlpassword'].setValue(data.dlpsw);
          (<UntypedFormGroup>this.dataTarget).controls['dlake_port'].setValue(+(data.dlport));
          (<UntypedFormGroup>this.dataTarget).controls['dlusername'].setValue(data.dlusername);
          (<UntypedFormGroup>this.dataTarget).controls['dl_ca_certs_path'].setValue(data.dl_ca_certs_path);
          (<UntypedFormGroup>this.dataTarget).controls['datalake_id'].setValue(data.id);
          });

        },
        (error) => {
          //console.log(error);
        }
      );
    })
  }

  onChangeDSGetDlversion(event) {
    let value = event.value.op_name
    this.getStorage().then((res) => {
      let payload = {
        "dlversion": event.value.dlversion,
        "op_name": value,
        "op_type": "source"
      }
      this.sourceDLListOpName = payload;
      this.backendService.PostAPICall('getDLData', payload, res.token).subscribe(
        (response) => {
          this.helperService.decryptpayload(response.data).then((records)=>{
          let data=JSON.parse(records);
          this.dataSourceDLIngestion = data;
          (<UntypedFormGroup>this.dataSource).controls['dlsource_host'].setValue(data.dlhost_name);
          (<UntypedFormGroup>this.dataSource).controls['dlsource_password'].setValue(data.dlpsw);
          (<UntypedFormGroup>this.dataSource).controls['dlsource_port'].setValue(+(data.dlport));
          (<UntypedFormGroup>this.dataSource).controls['dlsource_username'].setValue(data.dlusername);
          (<UntypedFormGroup>this.dataSource).controls['dlsource_ca_certs_path'].setValue(data.dl_ca_certs_path);
          });


        },
        (error) => {
          //console.log(error);
        }
      );
    })
  }

  //Email as data target type
  targetAttachment: any = 'no'
  isAttachmentToggleDT(event: any) {
    let isAttachment = 'no';
    if (event.checked == true) {
      isAttachment = 'yes'
    }
    this.targetAttachment = isAttachment;
  }

  checkTokenSessionBeforeTestEmailApiDT(data) {
    this.type = 'email_operation';
    if(this.dataTarget.invalid){
      this.helperService.presentToast('Failed to connect to the mail server',1000)
      return;
    }
    this.getStorage().then(async (storage_data) => {
      await this.helperService.loader();
      this.pythonTokenForEmailOperation = storage_data.pytokenEmailOperation;
      if (storage_data.pytokenEmailOperation == null) {
        this.generateToken('email_operation').then((res: string) => {
          this.pythonTokenForEmailOperation = res;
          this.testEmailApiDT(data);
        })
      } else {
        this.checkToken().then((res: Boolean) => {
          if (res) {
            this.testEmailApiDT(data);
          } else {
            this.generateToken('email_operation').then((res: string) => {
              this.pythonTokenForEmailOperation = res;
              this.testEmailApiDT(data);
            })
          }
        })
      }
    })
  }

  testEmailApiDT(data) {
    let portNumberTmp;
    if (data.email_port_number == '' || data.email_port_number == undefined) {
      portNumberTmp = 465;
    } else {
      portNumberTmp = data.email_port_number;
    }

    this.getStorage().then(async (res) => {
      let payload = {
        "mailserver": data.mailserver,
        "port_number": parseInt(portNumberTmp),
        "From": data.From,
        // "to": toTmp,
        "password": await this.helperService.encrypt(data.email_password),
      }
      // return;
      const api_endpoint = environment.python_api_base_url + '/email';
      this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForEmailOperation)
        .subscribe(
          data => {
            this.helperService.closeLoader();
            if(data.bizdata_dataset.bizdata_dataset_status == 200){
              this.helperService.presentToast(data.bizdata_dataset.bizdata_dataset_response, 2000);
            }else{
              this.helperService.presentToast(data.bizdata_dataset.bizdata_dataset_response, 2000);
            }
          },
          error => {
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }

  checkTokenSessionBeforeTestSourceEmailApi(data) {
    this.type = 'email_operation';
    if(this.dataSource.invalid){
      this.helperService.presentToast('Failed to connect to the mail server',1000)
      return;
    }
    this.getStorage().then(async (storage_data) => {
      await this.helperService.loader();
      this.pythonTokenForEmailOperation = storage_data.pytokenEmailOperation;
      if (storage_data.pytokenEmailOperation == null) {
        this.generateToken('email_operation').then(async (res: string) => {
          this.pythonTokenForEmailOperation = res;
          await this.testEmailApiSource(data);
        })
      } else {
        this.checkToken().then(async (res: Boolean) => {
          if (res) {
            await this.testEmailApiSource(data);
          } else {
            this.generateToken('email_operation').then(async (res: string) => {
              this.pythonTokenForEmailOperation = res;
              await this.testEmailApiSource(data);
            })
          }
        })
      }
    })
  }

  async testEmailApiSource(data) {
    let portNumberTmp;
    if (data.email_port_number == '' || data.email_port_number == undefined) {
      portNumberTmp = 465;
    } else {
      portNumberTmp = data.email_port_number;
    }
    // this.helperService.loader();
    this.getStorage().then(async (res) => {
      let payload = {
        "mailserver": data.mail_server,
        "port_number": parseInt(portNumberTmp),
        "From": data.user_email,
        "password": await this.helperService.encrypt(data.email_password),
        "out_type": data.out_type
      }
      // return;
      const api_endpoint = environment.python_api_base_url + '/email';
      this.backendService.PostExternalTokenUpdatedAPICall(api_endpoint, payload, this.pythonTokenForEmailOperation)
        .subscribe(
          data => {
            this.helperService.closeLoader();
            if(data.bizdata_dataset.bizdata_dataset_status == 200){
              this.helperService.presentToast(data.bizdata_dataset.bizdata_dataset_response, 2000);
            }else{
              this.helperService.presentToast(data.bizdata_dataset.bizdata_dataset_response, 2000);
            }
          },
          error => {
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }
  // closemapdata(){
  //   this.mapdata = false;
  // }

  // pickSourceColumn(element, index){
  //   //console.log(element);
  //   this.selectedSourceColumn = {"source_column": element.source_column, "source_value": element.source_value, "selected": element.selected, "type": element.type};
  //   this.isSourceColumnSelected = true;
  //   this.sourceColumnIndex = index;
  //   let source_ci = this.bridgeSourceResponseMapping.find((object)=>{
  //     return object.source_column == element.source_column
  //   })
  //   source_ci.selected = true;
  // }

  // mapToTargetColumn(element){
  //   //console.log(element);
  //   if(this.isSourceColumnSelected){
  //     if(element.isMapped == false){
  //       let mappedTarget = this.bridgeTargetResponseMapping.find((object)=>{
  //         return object.target_column == element.target_column
  //       })
  //       this.bridgeSourceResponseMapping.splice(this.sourceColumnIndex , 1);
  //       mappedTarget.mapping_source_column = this.selectedSourceColumn.source_column;
  //       mappedTarget.isMapped = true;
  //       mappedTarget.mapping_source_value = this.selectedSourceColumn.source_value;
  //       mappedTarget.datatype = this.selectedSourceColumn.type;
  //       delete this.selectedSourceColumn.source_column;
  //       this.selectedSourceColumn.selected = false;
  //       this.isSourceColumnSelected = false;
  //       //console.log(this.bridgeSourceResponseMapping);
  //     }
  //   }
  //   //console.log(this.bridgeTargetResponseMapping);
  // }

  // unmapSource(element){
  //   //console.log(element);
  //   let unmappedTarget = this.bridgeTargetResponseMapping.find((object)=>{
  //     return object.target_column == element.target_column
  //   })
  //   let sourceColumnRevert = {"source_column": element.mapping_source_column, "source_value": element.mapping_source_value, "type": element.datatype};
  //   this.bridgeSourceResponseMapping.push(sourceColumnRevert);
  //   unmappedTarget.mapping_source_column = "";
  //   unmappedTarget.isMapped = false;
  //   unmappedTarget.mapping_source_value = "";
  //   //console.log(this.bridgeSourceResponseMapping);
  //   //console.log(this.bridgeTargetResponseMapping);
  // }

  // navigationHelp(){
  //   this.storage.set('dataSource', this.dataSource.getRawValue());
  // }

  // setDefaultValue() {
  //   this.storage.get('dataSource').then((data)=> {
  //     if(data) {
  //       this.dataSource.controls['bridge_source'].setValue(data.bridge_source);
  //       this.dataSource.controls['bridge_source_business_object'].setValue
  //       this.dataSource.controls['bridge_source_endpoint_method'].setValue
  //       this.dataSource.controls['bridge_source_endpoint_url'].setValue
  //       this.dataSource.controls['bridge_source_endpoint_params_raw'].setValue
  //       this.dataSource.controls['bridge_source_endpoint_headers'].setValue
  //       this.dataSource.controls['bridge_source_endpoint_authentication_type'].setValue
  //       this.dataSource.controls['bridge_source_endpoint_body_raw'].setValue
  //       this.dataSource.controls['pre_request_script'].setValue
  //       this.dataSource.controls['bridge_source_response'].setValue
  //       this.dataSource.controls['bridge_source_pagination_type'].setValue
  //       this.dataSource.controls['user_key_url'].setValue
  //       this.dataSource.controls['response_parameters'].setValue
  //       this.dataSource.controls['key_name_to_update'].setValue
  //       this.dataSource.controls['another_response_parameter'].setValue
  //       this.dataSource.controls['user_key'].setValue
  //       this.dataSource.controls['min_number'].setValue
  //       this.dataSource.controls['yesterday_str'].setValue
  //       this.dataSource.controls['max_number'].setValue
  //       this.dataSource.controls['max_number'].setValue
  //       this.dataSource.controls['max_number'].setValue

  //     }
  //   });
  // }

  onChangeToggleButton(event, index) {
    let value = event.value;
    (<UntypedFormGroup>this.pdfextractorRows().at(index)).controls['pdfLocationToggle'].setValue(value);
  }

  async dataSourceModal(dataType: any, id?) {
    let componentPropsValue = {
      "dataType": dataType
    };
    if (dataType == 'source') {
      componentPropsValue["sourceCartId"] = this.sourceCartId;
    }
    if (dataType == 'operations') {
      const index = this.restapiRows().controls.findIndex((item) => item.value.id === id);
      this.opsCartId = (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridgeTargetCartIdRAO'].value;
      componentPropsValue["opsCartId"] = this.opsCartId;
    }
    if (dataType == 'target') {
      componentPropsValue["targetCartId"] = this.targetCartId;
    }
    const modal = await this.modalCtrl.create({
      component: CartListPage,
      componentProps: componentPropsValue,
      cssClass: 'cart-modal',
      swipeToClose: true,
      backdropDismiss: true,
      presentingElement: this.routerOutlet.nativeEl
    });

    modal.onDidDismiss().then((result) => {
      this.cartData = result.role;
      //console.log(this.cartData);
      if (this.cartData && this.cartData.data !== undefined) {
        if (dataType == 'source') {
          this.dataSource.controls["bridge_source"].setValue(this.cartData.data.api_product_name);
          this.getSourceTargetBusinessObject(this.cartData.data.api_product_name,'source').then((res)=>{
            let obj = res.find(o => o.id === this.cartData.data.ID);
            this.dataSource.get('bridge_source_business_object').setValue(obj);
          //   setTimeout(()=>{
          //     this.dataSource.get('bridge_source_business_object').setValue({
          //       id: this.cartData.data.ID,
          //       business_obj: this.cartData.data.api_business_object + ' (Version: ' + this.cartData.data.api_version + ') (Method: ' + this.cartData.data.method + ')' 
          //     });
          // },0)
          });
          this.sourceCartId = this.cartData.data.ID;
          this.sourceCatalogueId = this.cartData.data.ID;
          // this.getSourcePostmanDetails(this.cartData.data.ID);
          // setTimeout(() => {
          //   this.onChangeSelectedEnvironment()
          // }, 1000);
        }
        else if (dataType == 'operations') {
          const index = this.restapiRows().controls.findIndex((item) => item.value.id === id);
          this.restapiRows().at(index).patchValue({ bridge_target: this.cartData.data.api_product_name });
          let business_obj = [{
            "id": this.cartData.data.ID,
            "business_obj": this.cartData.data.api_business_object + ' (Version: ' + this.cartData.data.api_version + ') (Method: ' + this.cartData.data.method + ')'
          }];
          (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridgeTargetBusinessObjectRAO'].setValue(business_obj);
          (<UntypedFormGroup>this.restapiRows().at(index)).controls['bridgeTargetCartIdRAO'].setValue(this.cartData.data.ID);
          this.restapiRows().at(index).patchValue({
            bridge_target_business_object: business_obj[0]
          });
          this.opsCartId = this.cartData.data.ID;
          this.operationIndex = index;
          this.operationCatalogId = this.cartData.data.ID;
          this.getTargetPostmanDetailsRAO(this.cartData.data.ID, index);
          // setTimeout(() => {
          // //   this.onChangeSelectedOpsEnvironment(index,null)
          //   this.getTargetPostmanDetailsRAO(this.cartData.data.ID, index);
          // }, 500);
        }
        else if (dataType == 'target') {
          this.dataTarget.controls["bridge_target"].setValue(this.cartData.data.api_product_name);
          this.getSourceTargetBusinessObject(this.cartData.data.api_product_name,'target').then((res)=>{
            let obj = res.find(o => o.id === this.cartData.data.ID);
            this.dataTarget.get('bridge_target_business_object').setValue(obj);
          //   setTimeout(()=>{
          //     this.dataTarget.get('bridge_target_business_object').setValue({
          //       id: this.cartData.data.ID,
          //       business_obj: this.cartData.data.api_business_object + ' (Version: ' + this.cartData.data.api_version + ') (Method: ' + this.cartData.data.method + ')' 
          //     });
          // },0)
          });
          this.targetCartId = this.cartData.data.ID;
          this.targetCatalogueId = this.cartData.data.ID;
          // this.getTargetPostmanDetails(this.cartData.data.ID);
          // setTimeout(() => {
          //   this.onChangeTargetSelectedEnvironment();
          // }, 1000);
        }
      }
    })
    return await modal.present();
  }

  getTimeZone() {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getTimezones', res.token).subscribe(
        data => {
          this.timezoneList = data;
          this.summary.controls['time_zone'].setValue({ "timezone": "America/Los_Angeles" });
          this.timezones$ = this.summary.get('time_zone')!.valueChanges.pipe(
            startWith(''),
            map(value => {
              const timezone = typeof value === 'string' ? value : value?.timezone;
              this.enableTimeZoneClearIcon = value ? true : false;
              return timezone ? this._filterMapTimeZone(timezone as string) : this.timezoneList.slice();
            })
          )
        }
      );
    })
  }

  getSourceHeaderKeys(index) {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getHeaderKeys', res.token).subscribe(
        data => {
          this.sourceHeaderKeyList = data;
          var arrayControl = this.dataSource.get("bridge_source_endpoint_headers") as FormArray;
          //console.log('arrayControl', arrayControl)
          this.sourceHeaderKeys$[index] = arrayControl
            .at(index)
            .get("bridge_source_headerKey")
            .valueChanges.pipe(
              startWith<string | HeaderKey>(""),
              map(value => (typeof value === "string" ? value : value.header_key)),
              map(itemName =>
                itemName ? this._filterMapSourceHeaderkey(itemName) : this.sourceHeaderKeyList.slice()
              )
            );
        }
      );
    })
  }

  getSourceHeaderValue(index) {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getHeaderValues', res.token).subscribe(
        data => {
          this.sourceHeaderValueList = data;
          var arrayControl = this.dataSource.get("bridge_source_endpoint_headers") as FormArray;
          //console.log('arrayControl', arrayControl)
          this.sourceHeaderValues$[index] = arrayControl
            .at(index)
            .get("bridge_source_headerValue")
            .valueChanges.pipe(
              startWith<string | HeaderValue>(""),
              map(value => (typeof value === "string" ? value : value.header_value)),
              map(itemName =>
                itemName ? this._filterMapSourceHeaderValue(itemName) : this.sourceHeaderValueList.slice()
              )
            );
        }
      );
    })
  }

  getTargetHeaderKeys(index) {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getHeaderKeys', res.token).subscribe(
        data => {
          this.targetHeaderKeyList = data;
          var arrayControl = this.dataTarget.get("bridge_target_endpoint_headers") as FormArray;
          this.targetHeaderKeys$[index] = arrayControl
            .at(index)
            .get("bridge_target_headerKey")
            .valueChanges.pipe(
              startWith<string | HeaderKey>(""),
              map(value => (typeof value === "string" ? value : value.header_key)),
              map(itemName =>
                itemName ? this._filterMapTargetHeaderkey(itemName) : this.targetHeaderKeyList.slice()
              )
            );
        }
      );
    })
  }

  getTargetHeaderValue(index) {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getHeaderValues', res.token).subscribe(
        data => {
          this.targetHeaderValueList = data;
          var arrayControl = this.dataTarget.get("bridge_target_endpoint_headers") as FormArray;
          this.targetHeaderValues$[index] = arrayControl
            .at(index)
            .get("bridge_target_headerValue")
            .valueChanges.pipe(
              startWith<string | HeaderValue>(""),
              map(value => (typeof value === "string" ? value : value.header_value)),
              map(itemName =>
                itemName ? this._filterMapTargetHeaderValue(itemName) : this.targetHeaderValueList.slice()
              )
            );
        }
      );
    })
  }

  getAPIOperationHeaderKeys(pipeIndex, index) {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getHeaderKeys', res.token).subscribe(
        data => {
          this.apiOperationHeaderKeyList = data;
          console.log(this.apiOperationHeaderKeyList)
          var arrayControl = (<UntypedFormGroup>this.restapiRows().at(pipeIndex)).get("bridge_target_endpoint_headers") as FormArray;
          this.apiOperationHeaderKeys$[index] = arrayControl
            .at(index)
            .get("bridge_target_headerKey")
            .valueChanges.pipe(
              startWith<string | HeaderKey>(""),
              map(value => (typeof value === "string" ? value : value.header_key)),
              map(itemName =>
                itemName ? this._filterMapAPIOperationHeaderkey(itemName) : this.apiOperationHeaderKeyList.slice()
              )
            );
        }
      );
    })
  }

  getAPIOperationHeaderValue(pipeIndex, index) {
    this.getStorage().then((res) => {
      this.backendService.GetAPICall('getHeaderValues', res.token).subscribe(
        data => {
          this.apiOperationHeaderValueList = data;
          var arrayControl = (<UntypedFormGroup>this.restapiRows().at(pipeIndex)).get("bridge_target_endpoint_headers") as FormArray;
          this.apiOperationHeaderValues$[index] = arrayControl
            .at(index)
            .get("bridge_target_headerValue")
            .valueChanges.pipe(
              startWith<string | HeaderValue>(""),
              map(value => (typeof value === "string" ? value : value.header_value)),
              map(itemName =>
                itemName ? this._filterMapAPIOperationHeaderValue(itemName) : this.apiOperationHeaderValueList.slice()
              )
            );
        }
      );
    })
  }


  onChangeTimeZone(e) {
    //console.log(e)
  }

  clearTimeZone() {
    this.summary.controls['time_zone'].reset();
  }
  
  onEditSourceEndpointUrl(event, pos?) {
    var contenteditable = document.getElementById('contentDiv');
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      // let regex;
      if (text.includes("{{")) {
        let arrStr = this.source_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.endpoint_url = test.trim();
        let elem = document.getElementById('contentDiv');
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        let endpointUrlX = test.replace(/<[^>]*>/g, '');
        this.dataSource.controls['bridge_source_endpoint_url'].setValue(endpointUrlX.trim());

      } else {
        let elem = document.getElementById('contentDiv');
        elem.innerHTML = text;
        this.endpoint_url = text.trim();
        this.setCaretPosition(elem, pos);
        this.dataSource.controls['bridge_source_endpoint_url'].setValue(text.trim());
      }
    }
  }
  
  onEditTargetEndpointUrl(event, pos?) {
    var contenteditable = document.getElementById('contentDivTarget');
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      // let regex;
      if (text.includes("{{")) {
        let arrStr = this.target_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.endpoint_target_url = test.trim();
        let elem = document.getElementById('contentDivTarget');
        elem.innerHTML = this.endpoint_target_url;
        this.setCaretPosition(elem, pos);
        let endpointUrlX = this.endpoint_target_url.replace(/<[^>]*>/g, '');
        this.dataTarget.controls['bridge_target_endpoint_url'].setValue(endpointUrlX.trim());
      } else {
        let elem = document.getElementById('contentDivTarget');
        elem.innerHTML = text;
        this.endpoint_target_url = text.trim();
        this.setCaretPosition(elem, pos);
        this.dataTarget.controls['bridge_target_endpoint_url'].setValue(text.trim());
      }
    }

  }

  onEditSourceparamsKey(event, ind?, pos?) {
    var contenteditable = document.getElementById('contentDiv_params_key' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.source_environment;
        let test = this.helperService.endpointUrl(arrStr, text);        
        let elem = document.getElementById('contentDiv_params_key' + ind);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.params_key[ind] = test.replace(/<[^>]*>/g, '').trim();
      } else {
        let elem = document.getElementById('contentDiv_params_key' + ind);
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.params_key[ind] = text.replace(/<[^>]*>/g, '').trim();
      }
      let params = this.dataSource.value.bridge_source_endpoint_params_raw;
      for (let i = 0; i < params.length; i++) {
        if (i == ind) {
          params[i].bridge_source_paramKey = this.params_key[ind].trim();
          this.addSourceValueParams(params[i]);
        }
      }
    }
  }
  onEditSourceparamsValue(event, ind?, pos?) {
    var contenteditable = document.getElementById('contentDiv_params_value' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.source_environment;
        let test = this.helperService.endpointUrl(arrStr, text);        
        let elem = document.getElementById('contentDiv_params_value' + ind);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.params_value[ind] = test.replace(/<[^>]*>/g, '').trim();
        // this.params_value[ind] = this.params_value[ind].trim();
      } else {
        let elem = document.getElementById('contentDiv_params_value' + ind);
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.params_value[ind] = text.replace(/<[^>]*>/g, '').trim();
        // this.params_value[ind] = this.params_value[ind].trim();
      }
      let params = this.dataSource.value.bridge_source_endpoint_params_raw;
      for (let i = 0; i < params.length; i++) {
        if (i == ind) {
          params[i].bridge_source_paramValue = this.params_value[ind].trim();
          this.addSourceValueParams(params[i]);
        }
      }
    }
  }
  
  onEditTargetParamsKey(event, ind?, pos?) {
    var contenteditable = document.getElementById('contentDiv_target_params_key' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.target_environment;
        let test = this.helperService.endpointUrl(arrStr, text);        
        let elem = document.getElementById('contentDiv_target_params_key' + ind);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.params_target_key[ind] = test.replace(/<[^>]*>/g, '').trim();
        // this.params_target_key[ind] = this.params_target_key[ind].trim();
      } else {
        let elem = document.getElementById('contentDiv_target_params_key' + ind);
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.params_target_key[ind] = text.replace(/<[^>]*>/g, '').trim();
        // this.params_target_key[ind] = this.params_target_key[ind].trim();
      }
      let params = this.dataTarget.value.bridge_target_endpoint_params_raw;
      for (let i = 0; i < params.length; i++) {
        if (i == ind) {
          params[i].bridge_target_paramKey = this.params_target_key[ind].trim();
          this.addTargetValueParams(params[i]);
        }
      }

    }
  }
  
  onEditTargetParamsValue(event, ind?, pos?) {
    var contenteditable = document.getElementById('contentDiv_target_params_value' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.target_environment;
        let test = this.helperService.endpointUrl(arrStr, text);        
        let elem = document.getElementById('contentDiv_target_params_value' + ind);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.params_target_value[ind] = test.replace(/<[^>]*>/g, '').trim();
        // this.params_target_value[ind] = this.params_target_value[ind].trim();
      } else {
        let elem = document.getElementById('contentDiv_target_params_value' + ind);
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.params_target_value[ind] = text.replace(/<[^>]*>/g, '').trim();
        // this.params_target_value[ind] = this.params_target_value[ind].trim();
      }
      let params = this.dataTarget.value.bridge_target_endpoint_params_raw;
      for (let i = 0; i < params.length; i++) {
        if (i == ind) {
          params[i].bridge_target_paramValue = this.params_target_value[ind].trim();
          this.addTargetValueParams(params[i]);
        }
      }

    }
  }
  onEditSourceHeaderKey(event, ind?, pos?) {
    var contenteditable = document.getElementById('contentDevHeaderKey' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.source_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        let elem = document.getElementById('contentDevHeaderKey' + ind);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.headers_key[ind] = test.replace(/<[^>]*>/g, '').trim();
        // this.headers_key[ind] = this.headers_key[ind].trim();
      } else {
        let elem = document.getElementById('contentDevHeaderKey' + ind);
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.headers_key[ind] = text.replace(/<[^>]*>/g, '').trim();
        // this.headers_key[ind] = this.headers_key[ind].trim();
      }
    }
    let headers = this.dataSource.value.bridge_source_endpoint_headers;
    for (let i = 0; i < headers.length; i++) {
      if (i == ind) {
        headers[i].bridge_source_headerKey = this.headers_key[ind].trim();
        this.addSourceValueHeaders(headers[i]);
      }
    }
  }
  onEditSourceHeaderValue(event, ind?, pos?) {
    var contenteditable = document.getElementById('contentDevHeaderValue' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.source_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        let elem = document.getElementById('contentDevHeaderValue' + ind);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.headers_value[ind] = test.replace(/<[^>]*>/g, '').trim();
        // this.headers_value[ind] = this.headers_value[ind].trim();
      } else {
        let elem = document.getElementById('contentDevHeaderValue' + ind);
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.headers_value[ind] = text.replace(/<[^>]*>/g, '').trim();
        // this.headers_value[ind] = this.headers_value[ind].trim();
      }
    }
    let headers = this.dataSource.value.bridge_source_endpoint_headers;
    for (let i = 0; i < headers.length; i++) {
      if (i == ind) {
        headers[i].bridge_source_headerValue = this.headers_value[ind].trim();
        this.addSourceValueHeaders(headers[i]);
      }
    }
  }
  
  onEditTargetHeaderKey(event, ind?, pos?) {
    var contenteditable = document.getElementById('contentDevTargetHeaderKey' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      // //console.log(text);
      if (text.includes("{{")) {
        let arrStr = this.target_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        let elem = document.getElementById('contentDevTargetHeaderKey' + ind);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.headers_target_key[ind] = test.replace(/<[^>]*>/g, '').trim();
        // this.headers_target_key[ind] = this.headers_target_key[ind].trim();
      } else {
        let elem = document.getElementById('contentDevTargetHeaderKey' + ind);
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.headers_target_key[ind] = text.replace(/<[^>]*>/g, '').trim();
        // this.headers_target_key[ind] = this.headers_target_key[ind].trim();
      }
    }
    let headers = this.dataTarget.value.bridge_target_endpoint_headers;
    for (let i = 0; i < headers.length; i++) {
      if (i == ind) {
        headers[i].bridge_target_headerKey = this.headers_target_key[ind].trim();
        this.addTargetValueHeaders(headers[i]);
      }
    }
  }
  
  onEditTargetHeaderValue(event, ind?, pos?) {
    var contenteditable = document.getElementById('contentDevTargetHeaderValue' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      // //console.log(text);
      if (text.includes("{{")) {
        let arrStr = this.target_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        let elem = document.getElementById('contentDevTargetHeaderValue' + ind);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.headers_target_value[ind] = test.replace(/<[^>]*>/g, '').trim();
        // this.headers_target_value[ind] = this.headers_target_value[ind].trim();
      } else {
        let elem = document.getElementById('contentDevTargetHeaderValue' + ind);
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.headers_target_value[ind] = text.replace(/<[^>]*>/g, '').trim();
        // this.headers_target_value[ind] = this.headers_target_value[ind].trim();
      }
    }
    let headers = this.dataTarget.value.bridge_target_endpoint_headers;
    for (let i = 0; i < headers.length; i++) {
      if (i == ind) {
        headers[i].bridge_target_headerValue = this.headers_target_value[ind].trim();
        this.addTargetValueHeaders(headers[i]);
      }
    }
  };

  onEditSourceAuth(pos?) {
    var contenteditable = document.getElementById('contentDevSourceAuth');
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.source_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        let elem = document.getElementById('contentDevSourceAuth');
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.source_auth = test.replace(/<[^>]*>/g, '').trim();
        this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_url'].setValue(this.source_auth.trim());
      } else {
        let elem = document.getElementById('contentDevSourceAuth');
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.source_auth = text.replace(/<[^>]*>/g, '').trim();
        this.dataSource.controls['bridge_source_oauth_refresh_token_endpoint_url'].setValue(this.source_auth.trim());
      }
      let url=document.getElementById('contentDivSourceAuth')
      if(this.dataSource.get('bridge_source_oauth_refresh_token_endpoint_url').invalid){
        url.classList.add('passError');
      }
      else{
        url.classList.remove('passError')
      }
    }
  }
  onEditTargetAuth(pos?) {
    var contenteditable = document.getElementById('contentDevTargetAuth');
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.target_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        let elem = document.getElementById('contentDevTargetAuth');
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.target_auth = test.replace(/<[^>]*>/g, '');
        this.target_auth = this.target_auth.trim();
        this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(this.target_auth.trim());
      } else {
        let elem = document.getElementById('contentDevTargetAuth');
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.target_auth = text.replace(/<[^>]*>/g, '');
        this.target_auth =this.target_auth.trim();
        this.dataTarget.controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(this.target_auth.trim());
      }
      let url = document.getElementById('contentDivTargetAuth')
      if (this.dataTarget.get('bridge_target_oauth_refresh_token_endpoint_url').invalid) {
        url.classList.add('passError');
      }
      else {
        url.classList.remove('passError')
      }
    }
  }
  
  onEditSourceAuthUser(data?, pos?) {
    var contenteditable = document.getElementById('contentDevSourceAuthUser');
    if (contenteditable?.textContent != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      
      if (text.includes("{{")) {
        let arrStr = this.source_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.source_authUser = test;
        let elem = document.getElementById('contentDevSourceAuthUser');
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.source_authUser = test.replace(/<[^>]*>/g, '');
        this.dataSource.controls['bridge_source_authentication_username'].setValue(this.source_authUser);
      } else {
        let elem = document.getElementById('contentDevSourceAuthUser');
        elem.innerHTML = text;
        this.source_authUser = text;
        this.setCaretPosition(elem, pos);
        this.dataSource.controls['bridge_source_authentication_username'].setValue(text);
        if(this.source_authUser == "" && this.username == true){
          let dsusr=document.getElementById('contentDevSourceAuthUser');
          dsusr.setAttribute("style","-webkit-text-security:none");
        }
        if(this.dataSource.get('bridge_source_authentication_username').invalid){
          elem.setAttribute('class','userError')
        }
        else{
          elem.classList.remove('userError')
        }
      }
    }

  }

  onEditSourceAuthPassword(data?, pos?) {
    var contenteditable = document.getElementById('contentDevSourceAuthPassword');
    if (contenteditable?.textContent != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.source_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.source_authPassword = test;
        let elem = document.getElementById('contentDevSourceAuthPassword');
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.source_authPassword = test.replace(/<[^>]*>/g, '');
        this.dataSource.controls['bridge_source_authentication_password'].setValue(this.source_authPassword);

      } else {
        // this.source_authPassword = text;
        let elem = document.getElementById('contentDevSourceAuthPassword');
        elem.innerHTML = text;
        this.source_authPassword = text;
        this.setCaretPosition(elem, pos);
        this.dataSource.controls['bridge_source_authentication_password'].setValue(text);
        if(this.source_authPassword == "" && this.password == true){
          let dsusr=document.getElementById('contentDevSourceAuthPassword');
          dsusr.setAttribute("style","-webkit-text-security:none");
        }
        if(this.dataSource.get('bridge_source_authentication_password').invalid){
          elem.setAttribute('class','passError')
        }
        else{
          elem.classList.remove('passError')
        }
      }
    }

  }
  
  onEditTargetAuthUser(data?, pos?) {
    var contenteditable = document.getElementById('contentDevTargetAuthUser');
    if (contenteditable?.textContent != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.target_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.target_authUser = test;
        let elem = document.getElementById('contentDevTargetAuthUser');
        elem.innerHTML = test;
        this.setCaretPosition(elem,pos);
        this.target_authUser = test.replace(/<[^>]*>/g, '');
        this.dataTarget.controls['bridge_target_authentication_username'].setValue(this.target_authUser);
      } else {
        let elem = document.getElementById('contentDevTargetAuthUser');
        elem.innerHTML = text;
        this.target_authUser = text;
        this.setCaretPosition(elem,pos);
        this.dataTarget.controls['bridge_target_authentication_username'].setValue(text);
        if(this.target_authUser == "" && this.datatargetusername == true){
          let dsusr=document.getElementById('contentDevTargetAuthUser');
          dsusr.setAttribute("style","-webkit-text-security:none");
        }
         if(this.dataTarget.get('bridge_target_authentication_username').invalid){
          elem.setAttribute('class','userError')
        }
        else{
          elem.classList.remove('userError')
        }
      }
    }

  }
  
  onEditTargetAuthPassword(data?, pos?) {
    var contenteditable = document.getElementById('contentDevTargetAuthPassword');
    if (contenteditable?.textContent != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.target_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.target_authPassword = test;
        let elem = document.getElementById('contentDevTargetAuthPassword');
        elem.innerHTML = test;
        this.setCaretPosition(elem,pos);
        this.target_authPassword = test.replace(/<[^>]*>/g, '');
        this.dataTarget.controls['bridge_target_authentication_password'].setValue(this.target_authPassword);
      } else {
        let elem = document.getElementById('contentDevTargetAuthPassword');
        elem.innerHTML = text;
        this.target_authPassword = text;
        this.setCaretPosition(elem,pos);
        this.dataTarget.controls['bridge_target_authentication_password'].setValue(text);
        if(this.target_authPassword == "" && this.datatargetpassword == true){
          let dsusr=document.getElementById('contentDevTargetAuthPassword');
          dsusr.setAttribute("style","-webkit-text-security:none");
        }
        if(this.dataTarget.get('bridge_target_authentication_password').invalid){
          elem.setAttribute('class','passError')
        }
        else{
          elem.classList.remove('passError')
        }
      }
    }

  }

  setCaretPosition(el, pos) {
    // Loop through all child nodes
    for (var node of el.childNodes) {
      if (node.nodeType == 3) { // we have a text node
        if (node.length >= pos) {
          // finally add our range
          var range = document.createRange(),
            sel = window.getSelection();
          range.setStart(node, pos);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
          return -1; // we are done
        } else {
          pos -= node.length;
        }
      } else {
        pos = this.setCaretPosition(node, pos);
        if (pos == -1) {
          return -1; // no need to finish the for loop
        }
      }
    }
    return pos; // needed because of recursion stuff
  }

  onChangeSelectedEnvironment() {
    let contenteditable = document.getElementById('contentDiv');
    this.contentDiv = document.getElementById('contentDiv');
    this.source_environment = [];
    this.selectedSourceEnv();
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      this.endpoint_url = text;
      this.contentDiv.innerHTML = this.endpoint_url;
    }
    if(this.sourceCartId != null && this.sourceCartId != "" ){
      let dsusr=document.getElementById('contentDevSourceAuthUser');
      if(dsusr != null){
        dsusr.setAttribute("style","-webkit-text-security:disc");
      }
      let dpwd=document.getElementById('contentDevSourceAuthPassword');
      if(dpwd != null){
        dpwd.setAttribute("style","-webkit-text-security:disc");
      }
       
     }
    setTimeout(() => {
      this.onEditSourceEndpointUrl(null);
      let params = this.dataSource.value.bridge_source_endpoint_params_raw;
      for (let i = 0; i < params.length; i++) {
        let contenteditable_params_key = document.getElementById('contentDiv_params_key' + i);
        let contenteditable_params_value = document.getElementById('contentDiv_params_value' + i);
        if (contenteditable_params_key != null) {
          let text = contenteditable_params_key.textContent.replace(/<[^>]*>/g, '');
          this.params_key[i] = text;
          let elem = document.getElementById('contentDiv_params_key' + i);
          elem.innerHTML = this.params_key[i];
          this.onEditSourceparamsKey(null, i);
        }
        if (contenteditable_params_value != null) {
          let text = contenteditable_params_value.textContent.replace(/<[^>]*>/g, '');
          this.params_value[i] = text;
          let elem = document.getElementById('contentDiv_params_value' + i);
          elem.innerHTML = this.params_value[i];
          this.onEditSourceparamsValue(null, i, 0);
        }
      }
      let headers = this.dataSource.value.bridge_source_endpoint_headers;
      for (let i = 0; i < headers.length; i++) {
        let contenteditable_header_key = document.getElementById('contentDevHeaderKey' + i);
        if (contenteditable_header_key != null) {
          let text = contenteditable_header_key.textContent.replace(/<[^>]*>/g, '');
          this.headers_key[i] = text;
          let elem = document.getElementById('contentDevHeaderKey' + i);
          elem.innerHTML = this.headers_key[i];
          this.onEditSourceHeaderKey(null, i);
        }
        let contenteditable_header_value = document.getElementById('contentDevHeaderValue' + i);
        if (contenteditable_header_value != null) {
          let text = contenteditable_header_value.textContent.replace(/<[^>]*>/g, '');
          this.headers_value[i] = text;
          let elem = document.getElementById('contentDevHeaderValue' + i);
          elem.innerHTML = this.headers_value[i];
          this.onEditSourceHeaderValue(null, i);
        }
      }
    this.onEditSourceAuth();
    this.onEditSourceAuthUser();
    this.onEditSourceAuthPassword();
    }, 200);
  }

  onChangeTargetSelectedEnvironment() {
    this.contentDivTarget = document.getElementById('contentDivTarget');
    this.target_environment = [];
    this.selectedTargetEnv();
    if (this.contentDivTarget != null) {
      let text = this.contentDivTarget.textContent.replace(/<[^>]*>/g, '');
      this.endpoint_target_url = text;
      this.contentDivTarget.innerHTML = this.endpoint_target_url;
    }
    if(this.targetCartId != null && this.targetCartId != "" ){
      let dsusr=document.getElementById('contentDevTargetAuthUser');
      if(dsusr != null){
        dsusr.setAttribute("style","-webkit-text-security:disc");
      }
      let dpwd=document.getElementById('contentDevTargetAuthPassword');
      if(dpwd != null){
        dpwd.setAttribute("style","-webkit-text-security:disc");
      }
    
    }
    setTimeout(() => {
      this.onEditTargetEndpointUrl(null);
      let params = this.dataTarget.value.bridge_target_endpoint_params_raw;
      for (let i = 0; i < params.length; i++) {
        let contenteditable_params_key = document.getElementById('contentDiv_target_params_key' + i);
        if (contenteditable_params_key != null) {
          let text = contenteditable_params_key.textContent.replace(/<[^>]*>/g, '');
          this.params_target_key[i] = text;
          let elem = document.getElementById('contentDiv_target_params_key' + i);
          elem.innerHTML = this.params_target_key[i];
          this.onEditTargetParamsKey(null, i);
        }

        let contenteditable_params_value = document.getElementById('contentDiv_target_params_value' + i);
        if (contenteditable_params_value != null) {
          let text = contenteditable_params_value.textContent.replace(/<[^>]*>/g, '');
          this.params_target_value[i] = text;
          let elem = document.getElementById('contentDiv_target_params_value' + i);
          elem.innerHTML = this.params_target_value[i];
          this.onEditTargetParamsValue(null, i);
        }
      }
      let headers = this.dataTarget.value.bridge_target_endpoint_headers;
      for (let i = 0; i < headers.length; i++) {
        let contenteditable_header_key = document.getElementById('contentDevTargetHeaderKey' + i);
        let contenteditable_header_value = document.getElementById('contentDevTargetHeaderValue' + i);
        if (contenteditable_header_key != null) {
          let text = contenteditable_header_key.textContent.replace(/<[^>]*>/g, '');
          this.headers_target_key[i] = text;
          let elem = document.getElementById('contentDevTargetHeaderKey' + i);
          elem.innerHTML = this.headers_target_key[i];
          this.onEditTargetHeaderKey(null, i);

        }
        if (contenteditable_header_value != null) {
          let text = contenteditable_header_value.textContent.replace(/<[^>]*>/g, '');
          this.headers_target_value[i] = text;
          let elem = document.getElementById('contentDevTargetHeaderValue' + i);
          elem.innerHTML = this.headers_target_value[i];
          this.onEditTargetHeaderValue(null, i);
        }
      }
      this.onEditTargetAuth();
      this.onEditTargetAuthUser();
      this.onEditTargetAuthPassword();
    }, 200);
   
  }
  
  selectedTargetEnv() {
    this.target_environment = [];
    let target_environment_variables = this.environmentTargetForm.value.bridge_endpoint_environments_raw;
    let selectedEnvironment = this.environmentTargetForm.value.selected_environment;
    if (target_environment_variables.length > 0) {
      for (let i = 0; i < target_environment_variables.length; i++) {
        if (selectedEnvironment == target_environment_variables[i].env_name) {
          if (target_environment_variables[i].env_vars != undefined && target_environment_variables[i].env_vars.length > 0) {
            for (let x = 0; x < target_environment_variables[i].env_vars.length; x++) {
              this.target_environment.push("{{" + target_environment_variables[i].env_vars[x].variable + "}}")
            }
          }
        }
      }
    }
  }
  
  selectedSourceEnv() {
    this.source_environment = [];
    let source_environment_variables = this.environmentForm.value.bridge_endpoint_environments_raw;
    let selectedEnvironment = this.environmentForm.value.selected_environment;
    if (source_environment_variables.length > 0) {
      for (let i = 0; i < source_environment_variables.length; i++) {
        if (selectedEnvironment == source_environment_variables[i].env_name) {
          if (source_environment_variables[i].env_vars != undefined && source_environment_variables[i].env_vars.length > 0) {
            for (let x = 0; x < source_environment_variables[i].env_vars.length; x++) {
              this.source_environment.push("{{" + source_environment_variables[i].env_vars[x].variable + "}}")
            }
          }
        }
      }
    }

  }
  
  toggleAuthPassword(id: any, type, index?) {
    let elem = document.getElementById(id);
    let elem1 = elem.innerText.replace(/<[^>]*>/g, '');
    if (elem1.startsWith("•")) {
      if (type == 'source_user') {
        this.username = false;
        let dsusr = document.getElementById('contentDevSourceAuthUser');
        dsusr.setAttribute("style", "-webkit-text-security:none");
        // this.onEditSourceAuthUser(data);
      } else if (type == 'source_password') {
        this.password = false;
        let dspassw = document.getElementById('contentDevSourceAuthPassword');
        dspassw.setAttribute("style", "-webkit-text-security:none");
      } else if (type == 'target_user') {
        this.datatargetusername = false;
        let dtusr = document.getElementById('contentDevTargetAuthUser');
        dtusr.setAttribute("style", "-webkit-text-security:none");
      } else if (type == 'target_password') {
        this.datatargetpassword = false;
        let dtpassw = document.getElementById('contentDevTargetAuthPassword');
        dtpassw.setAttribute("style", "-webkit-text-security:none");
      } else if (type == 'ops_user'){
        this.targetusername = false;
        let dtusr = document.getElementById(id);
        dtusr.setAttribute("style", "-webkit-text-security:none");
      } else if (type == 'ops_password'){
        this.targetpassword = false;
        let dtusr = document.getElementById(id);
        dtusr.setAttribute("style", "-webkit-text-security:none");
      }
    } else {
      if (type == 'source_user') {
        // this.username = true;
        if (this.source_authUser == "" && this.username) {
          this.username = false;
          let dsusr = document.getElementById('contentDevSourceAuthUser');
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else if (this.source_authUser == "" && !this.username) {
          this.username = true;
          let dsuser = document.getElementById('contentDevSourceAuthUser');
          dsuser.setAttribute("style", "-webkit-text-security:none");
        } else {
          this.username = true;
          let dsuser = document.getElementById('contentDevSourceAuthUser');
          dsuser.setAttribute("style", "-webkit-text-security:disc");
        }
      } else if (type == 'source_password') {

        if (this.source_authPassword == "" && this.password) {
          this.password = false;
          let dsusr = document.getElementById('contentDevSourceAuthPassword');
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else if (this.source_authPassword == "" && !this.password) {
          this.password = true;
          let dsusr = document.getElementById('contentDevSourceAuthPassword');
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else {
          this.password = true;
          let dspassw = document.getElementById('contentDevSourceAuthPassword');
          dspassw.setAttribute("style", "-webkit-text-security:disc");
        }
      } else if (type == 'target_user') {
        if (this.target_authUser == "" && this.datatargetusername) {
          this.datatargetusername = false;
          let dsusr = document.getElementById('contentDevTargetAuthUser');
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else if (this.target_authUser == "" && !this.datatargetusername) {
          this.datatargetusername = true;
          let dsusr = document.getElementById('contentDevTargetAuthUser');
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else {
          this.datatargetusername = true;
          let dsuser = document.getElementById('contentDevTargetAuthUser');
          dsuser.setAttribute("style", "-webkit-text-security:disc");
        }
      } else if (type == 'target_password') {
        if (this.target_authPassword == "" && this.datatargetpassword) {
          this.datatargetpassword = false;
          let dsusr = document.getElementById('contentDevTargetAuthPassword');
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else if (this.target_authPassword == "" && !this.datatargetpassword) {
          this.datatargetpassword = true;
          let dsusr = document.getElementById('contentDevTargetAuthPassword');
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else {
          this.datatargetpassword = true;
          let dspassw = document.getElementById('contentDevTargetAuthPassword');
          dspassw.setAttribute("style", "-webkit-text-security:disc");
        }
      } else if (type == 'ops_user'){
        if (this.ops_authUser[index] == "" && this.targetusername) {
          this.targetusername = false;
          let dsusr = document.getElementById(id);
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else if (this.ops_authUser[index] == "" && !this.targetusername) {
          this.targetusername = true;
          let dsusr = document.getElementById(id);
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else {
          this.targetusername = true;
          let dsuser = document.getElementById(id);
          dsuser.setAttribute("style", "-webkit-text-security:disc");
        }
      } else if (type == 'ops_password'){
        if (this.ops_authPassword[index] == "" && this.targetpassword) {
          this.targetpassword = false;
          let dsusr = document.getElementById(id);
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else if (this.ops_authPassword[index] == "" && !this.targetpassword) {
          this.targetpassword = true;
          let dsusr = document.getElementById(id);
          dsusr.setAttribute("style", "-webkit-text-security:none");
        } else {
          this.targetpassword = true;
          let dspassw = document.getElementById(id);
          dspassw.setAttribute("style", "-webkit-text-security:disc");
        }
      }
    }
  }
  /* Environment highlight on keyup functions for data source */
  getCurrentPosCur(contentEle) {
    // let contentEle = document.getElementById("contentDiv");
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    const clonedRange = range.cloneRange();

    clonedRange.selectNodeContents(contentEle);
    clonedRange.setEnd(range.endContainer, range.endOffset);

    const cursorPosition = clonedRange.toString().length;
    return cursorPosition
  }
  onKeyupSEPUrl(event) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDiv');
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditSourceEndpointUrl(null, currPos);
        }
      }
    }
  }
  onKeyupSEPParamsKey(event, i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDiv_params_key' + i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditSourceparamsKey(null, i, currPos);
        }
      }
    }
  }
  onKeyupSEPParamsValue(event, i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDiv_params_value' + i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditSourceparamsValue(null, i, currPos);
        }
      }
    }
  }
  onKeyupSEPHeaderKey(event, i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDevHeaderKey' + i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditSourceHeaderKey(null, i, currPos);
        }
      }
    }
  }
  onKeyupSEPHeaderValue(event, i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDevHeaderValue' + i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditSourceHeaderValue(null, i, currPos);
        }
      }
    }
  }
  onKeyupSEPAuth(event) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDevSourceAuth');
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditSourceAuth(currPos);
        }
      }
    }
  }
  onKeyupSEPAuthUser(event) {
    let contentEle = document.getElementById('contentDevSourceAuthUser');
    if (event.ctrlKey && (event.code === "KeyA" || event.code === "KeyC")) {
      return;
    }
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      // if (event.code != "KeyA" && event.code != "KeyC") {
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          if(this.username == true){
            contentEle.setAttribute("style","-webkit-text-security:disc");
          }
          this.onEditSourceAuthUser(null, currPos);
        }
      // }
    }
  }
  onKeyupSEPAuthPassword(event) {
    let contentEle = document.getElementById('contentDevSourceAuthPassword');
    if (event.ctrlKey && (event.code === "KeyA" || event.code === "KeyC")) {
      return;
    }
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      // if (event.code != "KeyA" && event.code != "KeyC") {
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          if(this.password == true){
            contentEle.setAttribute("style","-webkit-text-security:disc");
          }
          this.onEditSourceAuthPassword(null, currPos);
        }
      // }
    }
  }
  /* Environment highlight on keyup functions for data target */
  onKeyupTEPUrl(event) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDivTarget');
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditTargetEndpointUrl(null, currPos);
        }
      }
    }
  }
  onKeyupTEPParamsKey(event, i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDiv_target_params_key' + i);
        if (contentEle) {
          this.params_target_key[i] = contentEle.innerText.trim(); // Update array
        }
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditTargetParamsKey(null, i, currPos);
        }
      }
    }
  }
  onKeyupTEPParamsValue(event, i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDiv_target_params_value' + i);
        if (contentEle) {
          this.params_target_value[i] = contentEle.innerText.trim(); // Update array
        }
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditTargetParamsValue(null, i, currPos);
        }
      }
    }
  }
  onKeyupTEPHeaderKey(event, i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDevTargetHeaderKey' + i);
        if (contentEle) {
          this.headers_target_key[i] = contentEle.innerText.trim(); // Update array
        }
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditTargetHeaderKey(null, i, currPos);
        }
      }
    }
  }
  onKeyupTEPHeaderValue(event, i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDevTargetHeaderValue' + i);
        if (contentEle) {
          this.headers_target_value[i] = contentEle.innerText.trim(); // Update array
        }
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditTargetHeaderValue(null, i, currPos);
        }
      }
    }
  }
  onKeyupTEPAuth(event) {

    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDevTargetAuth');
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditTargetAuth(currPos);
        }
      }
    }
  }
  onKeyupTEPAuthUser(event) {
    let contentEle = document.getElementById('contentDevTargetAuthUser');
    if (event.ctrlKey && (event.code === "KeyA" || event.code === "KeyC")) {
      return;
    }
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      // if (event.code != "KeyA" && event.code != "KeyC") {
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          if(this.datatargetusername == true){
            contentEle.setAttribute("style","-webkit-text-security:disc");
          }
          this.onEditTargetAuthUser(null, currPos);
        }
      // }
    }
  }
  
  
  onKeyupTEPAuthPassword(event) {
    let contentEle = document.getElementById('contentDevTargetAuthPassword');
    if (event.ctrlKey && (event.code === "KeyA" || event.code === "KeyC")) {
      return;
    }
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      // if (event.code != "KeyA" && event.code != "KeyC") {
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          if(this.datatargetpassword == true){
            contentEle.setAttribute("style","-webkit-text-security:disc");
          }
          this.onEditTargetAuthPassword(null, currPos);
        }
      }
  }
  /* Environment highlight on keyup functions for API Ops */
  onKeyupOpsEPUrl(event,i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDivOps'+i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditOpsEndpointUrl(null, currPos, i);
        }
      }
    }
  }
  onKeyupOpsParamsKey(event, i, opsInd) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDiv_ops_params_key' + i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditOpsparamsKey(null, i,opsInd, currPos);
        }
      }
    }
  }
  onKeyupOpsParamsValue(event, i, opsInd) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDiv_ops_params_value' + i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditOpsparamsValue(null, i, opsInd, currPos);
        } 
      }
    }
  }
  onKeyupOpsEPHeaderKey(event, i, opsInd) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      // if ((event.code != "KeyA" && !event.ctrlKey) ||( event.code != "KeyC" && !event.ctrlKey)){
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDevHeaderKeyOps' + i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditOpsHeaderKey(null, i, opsInd, currPos);
        }
      }
    }
  }
  onKeyupOpsEPHeaderValue(event, i, opsInd) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      // if ((event.code != "KeyA" && !event.ctrlKey) ||( event.code != "KeyC" && !event.ctrlKey)){
      if ((event.code != "KeyA") && ( event.code != "KeyC")){
        let contentEle = document.getElementById('contentDevHeaderValueOps' + i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditOpsHeaderValue(null, i, opsInd, currPos);
        }
      }
    }
  }
  onKeyupOpsEPAuth(event,i) {
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
      // if ((event.code != "KeyA" && !event.ctrlKey) ||( event.code != "KeyC" && !event.ctrlKey)){
      if (event.code != "KeyA" && event.code != "KeyC") {
        let contentEle = document.getElementById('contentDevOpsAuth'+i);
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          this.onEditOpsAuth(currPos,i);
        }
      }
    }
  }
  onKeyupOpsEPAuthUser(event,i) {
    let contentEle = document.getElementById('contentDevOpsAuthUser'+i);
    // if ((event.code != "KeyA" && !event.ctrlKey) ||( event.code != "KeyC" && !event.ctrlKey)){
    if (event.ctrlKey && (event.code === "KeyA" || event.code === "KeyC")) {
      return;
    }
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          if(this.targetusername == true){
            contentEle.setAttribute("style","-webkit-text-security:disc");
          }
          this.onEditOpsAuthUser(null, currPos,i);
        }
    }
  }
  
  onKeyupOpsEPAuthPassword(event,i) {
    let contentEle = document.getElementById('contentDevOpsAuthPassword'+i);
    if (event.ctrlKey && (event.code === "KeyA" || event.code === "KeyC")) {
      return;
    }
    if (event.key != "ArrowRight" && event.key != "ArrowLeft" && event.key != "Shift" && event.key != "Control") {
        let currPos = this.getCurrentPosCur(contentEle);
        if (event.keyCode != 13) {
          if(this.targetpassword == true){
            contentEle.setAttribute("style","-webkit-text-security:disc");
          }
          this.onEditOpsAuthPassword(null, currPos,i);
        }
      }
  }
  onEditOpsEndpointUrl(event, pos?, id?){
    var contenteditable = document.getElementById('contentDivOps'+id);    
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.ops_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.endpoint_ops_url[id] = test.trim();
        let elem = document.getElementById('contentDivOps'+id);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        let endpointUrlX = test.replace(/<[^>]*>/g, '');
        (<UntypedFormGroup>this.restapiRows().at(id)).controls['bridge_target_endpoint_url'].setValue(endpointUrlX);
        // this.dataSource.controls['bridge_source_endpoint_url'].setValue(endpointUrlX.trim());

      } else {
        if(text != undefined){
          let elem = document.getElementById('contentDivOps'+id);
          elem.innerHTML = text;
          this.endpoint_ops_url[id] = text.trim();
          this.setCaretPosition(elem, pos);
          (<UntypedFormGroup>this.restapiRows().at(id)).controls['bridge_target_endpoint_url'].setValue(text);
        }        
        // this.dataSource.controls['bridge_source_endpoint_url'].setValue(text.trim());
      }
    }
  }
  onEditOpsAuth(pos?,i?) {
    var contenteditable = document.getElementById('contentDevOpsAuth'+i);
    let elem = document.getElementById('contentDevOpsAuth'+i);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.ops_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.ops_auth[i] = test.replace(/<[^>]*>/g, '');
        this.ops_auth[i] = this.ops_auth[i].trim();
        (<UntypedFormGroup>this.restapiRows().at(i)).controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(text);        
      } else {
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.ops_auth[i] = text.replace(/<[^>]*>/g, '');
        this.ops_auth[i] =this.ops_auth[i].trim();
        (<UntypedFormGroup>this.restapiRows().at(i)).controls['bridge_target_oauth_refresh_token_endpoint_url'].setValue(text);        
      }
      let elem2=document.getElementById(`contentDevOpsAuthContainer${i}`)
      if(this.restapiRows().controls[i].get('bridge_target_oauth_refresh_token_endpoint_url').invalid){
        elem2.classList.add('userError');
      }
      else{
        elem2.classList.remove('userError');
      }
    }
  }
  onEditOpsAuthUser(data?, pos?,i?) {
    var contenteditable = document.getElementById('contentDevOpsAuthUser'+i);
    let elem = document.getElementById('contentDevOpsAuthUser'+i);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.ops_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.ops_authUser[i] = test;
        elem.innerHTML = test;
        this.setCaretPosition(elem,pos);
        this.ops_authUser[i] = test.replace(/<[^>]*>/g, '');
        (<UntypedFormGroup>this.restapiRows().at(i)).controls['bridge_target_authentication_username'].setValue(text);
      } else {
        elem.innerHTML = text;
        this.ops_authUser[i] = text;
        this.setCaretPosition(elem,pos);
        (<UntypedFormGroup>this.restapiRows().at(i)).controls['bridge_target_authentication_username'].setValue(text);
        if(this.ops_authUser[i] == "" && this.targetusername == true){
          let dsusr=document.getElementById('contentDevOpsAuthUser'+i);
          dsusr.setAttribute("style","-webkit-text-security:none");
        }
      }
    }
  }
  
  onEditOpsAuthPassword(data?, pos?,i?) {
    var contenteditable = document.getElementById('contentDevOpsAuthPassword'+i);
    let elem = document.getElementById('contentDevOpsAuthPassword'+i);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.ops_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        this.ops_authPassword[i] = test;
        elem.innerHTML = test;
        this.setCaretPosition(elem,pos);
        this.ops_authPassword[i] = test.replace(/<[^>]*>/g, '');
        (<UntypedFormGroup>this.restapiRows().at(i)).controls['bridge_target_authentication_password'].setValue(text);
      } else {
        elem.innerHTML = text;
        this.ops_authPassword[i] = text;
        this.setCaretPosition(elem,pos);
        (<UntypedFormGroup>this.restapiRows().at(i)).controls['bridge_target_authentication_password'].setValue(text);
        if(this.ops_authPassword[i] == "" && this.targetpassword == true){
          let dsusr=document.getElementById('contentDevOpsAuthPassword'+i);
          dsusr.setAttribute("style","-webkit-text-security:none");
        }
      }
    }
  }
  onEditOpsparamsKey(event, ind?,opsInd?, pos?) {
    var contenteditable = document.getElementById('contentDiv_ops_params_key' + ind);
    let elem = document.getElementById('contentDiv_ops_params_key' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.ops_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.params_ops_key[opsInd][ind] = test.replace(/<[^>]*>/g, '').trim();
      } else {
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.params_ops_key[opsInd][ind] = text.replace(/<[^>]*>/g, '').trim();
      }
      let params = (<UntypedFormGroup>this.restapiRows().at(opsInd)).controls['bridge_target_endpoint_params_raw']!.value;
      for (let i = 0; i < params.length; i++) {
        if (i == ind ) {
          params[i].bridge_target_paramKey = elem.textContent.replace(/<[^>]*>/g, '').trim();//this.params_ops_key[ind].trim();
          if(params[i].bridge_target_paramKey != ""){
            params[i].bridge_target_paramKey = this.params_ops_key[opsInd][ind];
            this.addRestAPiOperationValueParams(params[i]);
          }          
        }
      }

    }
  }
  
  onEditOpsparamsValue(event, ind?,opsInd?, pos?) {
    var contenteditable = document.getElementById('contentDiv_ops_params_value' + ind);
    let elem = document.getElementById('contentDiv_ops_params_value' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.ops_environment;
        let test = this.helperService.endpointUrl(arrStr, text);        
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.params_ops_value[opsInd][ind] = test.replace(/<[^>]*>/g, '').trim();
      } else {
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.params_ops_value[opsInd][ind] = text.replace(/<[^>]*>/g, '').trim();
      }
      let params = (<UntypedFormGroup>this.restapiRows().at(opsInd)).controls['bridge_target_endpoint_params_raw']!.value;
      for (let i = 0; i < params.length; i++) {
        if (i == ind) {
          params[i].bridge_target_paramValue = elem.textContent.replace(/<[^>]*>/g, '').trim();//this.params_ops_value[ind].trim();
          if(params[i].bridge_target_paramValue != ""){
            params[i].bridge_target_paramValue = this.params_ops_value[opsInd][ind];
            this.addRestAPiOperationValueParams(params[i]);
          }
          
        }
      }

    }
  }
  onEditOpsHeaderKey(event, ind?, opsInd?, pos?) {
    var contenteditable = document.getElementById('contentDevHeaderKeyOps'+ ind);
    let elem = document.getElementById('contentDevHeaderKeyOps' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.ops_environment;
        let test = this.helperService.endpointUrl(arrStr, text);        
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.headers_ops_key[opsInd][ind] = test.replace(/<[^>]*>/g, '').trim();
      } else {
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.headers_ops_key[opsInd][ind] = text.replace(/<[^>]*>/g, '').trim();
      }
    }
    let headers = (<UntypedFormGroup>this.restapiRows().at(opsInd)).controls['bridge_target_endpoint_headers']!.value;//this.dataTarget.value.bridge_target_endpoint_headers;
    for (let i = 0; i < headers.length; i++) {
      if (i == ind) {
        headers[i].bridge_target_headerKey = this.headers_ops_key[opsInd][ind].trim();
        this.addRestAPiOperationValueHeaders(headers[i])
      }
    }
  }
  
  onEditOpsHeaderValue(event, ind?,opsInd?, pos?) {
    var contenteditable = document.getElementById('contentDevHeaderValueOps' + ind);
    let elem = document.getElementById('contentDevHeaderValueOps' + ind);
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if (text.includes("{{")) {
        let arrStr = this.ops_environment;
        let test = this.helperService.endpointUrl(arrStr, text);
        elem.innerHTML = test;
        this.setCaretPosition(elem, pos);
        this.headers_ops_value[opsInd][ind] = test.replace(/<[^>]*>/g, '').trim();
      } else {
        elem.innerHTML = text;
        this.setCaretPosition(elem, pos);
        this.headers_ops_value[opsInd][ind] = text.replace(/<[^>]*>/g, '').trim();
      }
    }
    let headers = (<UntypedFormGroup>this.restapiRows().at(opsInd)).controls['bridge_target_endpoint_headers'].value;//this.dataTarget.value.bridge_target_endpoint_headers;
    for (let i = 0; i < headers.length; i++) {
      if (i == ind) {
        headers[i].bridge_target_headerValue = this.headers_ops_value[opsInd][ind].trim();
        this.addRestAPiOperationValueHeaders(headers[i])
      }
    }
  };
  
  onChangeSelectedOpsEnvironment(opsInd,selected) {
    let contenteditable = document.getElementById('contentDivOps'+opsInd);
    this.ops_environment = [];
    if(selected != undefined && selected != ""){
      this.selectedOpsEnv(opsInd,selected);
    }
    if (contenteditable != null) {
      let text = contenteditable.textContent.replace(/<[^>]*>/g, '');
      if(text != undefined){
        this.endpoint_ops_url[opsInd] = text;
      }      
    }
    if(this.opsCartId != null && this.opsCartId != ""){
      let dsusr=document.getElementById('contentDevOpsAuthUser'+opsInd);
      if(dsusr !=null){
        dsusr.setAttribute("style","-webkit-text-security:disc");
      }
      let dpwd=document.getElementById('contentDevOpsAuthPassword'+opsInd);
      if(dpwd !=null){
        dpwd.setAttribute("style","-webkit-text-security:disc");
      }
     }
    setTimeout(() => {
      this.onEditOpsEndpointUrl(null,null, opsInd);
      if (this.params_ops_raw[opsInd] != undefined && this.params_ops_raw[opsInd]?.length != 0) {
        if (this.params_ops_raw[opsInd][0]?.bridge_target_paramKey != undefined && this.params_ops_raw[opsInd][0]?.bridge_target_paramKey != "") {
          for (let j=0; j <= this.params_ops_raw[opsInd].length;j++) {
            this.params_ops_key[opsInd][j] = this.params_ops_raw[opsInd][j]?.bridge_target_paramKey;
            this.params_ops_value[opsInd][j] = this.params_ops_raw[opsInd][j]?.bridge_target_paramValue;
            this.addRestAPiOperationValueParams(this.params_ops_raw[opsInd][j]);
            // this.onEditOpsparamsKey(null, j, opsInd);
            // this.onEditOpsparamsValue(null, j, opsInd);
          }
        } else {
          this.params_ops_key[opsInd][0] = this.params_ops_raw[opsInd][0]?.bridge_target_paramKey;
          this.params_ops_value[opsInd][0] = this.params_ops_raw[opsInd][0]?.bridge_target_paramValue;
          this.addRestAPiOperationValueParams(this.params_ops_raw[opsInd][0]);
          // this.onEditOpsparamsKey(null, 0, opsInd);
          // this.onEditOpsparamsValue(null, 0, opsInd);
        }
      } else {
        // this.onEditOpsparamsKey(null, 0, opsInd);
        // this.onEditOpsparamsValue(null, 0, opsInd);
      }
      if (this.headers_ops_raw[opsInd] != undefined && this.headers_ops_raw[opsInd]?.length != 0) {
        if (this.headers_ops_raw[opsInd][0]?.bridge_target_headerKey != undefined && this.headers_ops_raw[opsInd][0]?.bridge_target_headerKey != "") {
          for (let j=0; j <= this.headers_ops_raw[opsInd].length;j++) {
            this.headers_ops_key[opsInd][j] = this.headers_ops_raw[opsInd][j]?.bridge_target_headerKey;
            this.headers_ops_value[opsInd][j] = this.headers_ops_raw[opsInd][j]?.bridge_target_headerValue;
            this.addRestAPiOperationValueHeaders(this.headers_ops_raw[opsInd][j]);
            this.onEditOpsHeaderKey(null, j, opsInd);
            this.onEditOpsHeaderValue(null, j, opsInd);
          }
        } else {
          this.headers_ops_key[opsInd][0] = this.headers_ops_raw[opsInd][0]?.bridge_target_headerKey;
          this.headers_ops_value[opsInd][0] = this.headers_ops_raw[opsInd][0]?.bridge_target_headerValue;
          this.addRestAPiOperationValueHeaders(this.headers_ops_raw[opsInd][0]);
          this.onEditOpsHeaderKey(null, 0, opsInd);
          this.onEditOpsHeaderValue(null, 0, opsInd);
        }
      } else {
        // this.onEditOpsHeaderKey(null, 0, opsInd);
        // this.onEditOpsHeaderValue(null, 0, opsInd);
      }
      this.onEditOpsAuth(null, opsInd);
      this.onEditOpsAuthUser(null, opsInd);
      this.onEditOpsAuthPassword(null, opsInd);
      }, 200);
  }
  
  selectedOpsEnv(index, selectedEnv){
    // let selectedEnvironment;
    let env_vars=[];
    for (let control of this.bridgeRAOEnvironments(index)?.controls) {
      env_vars.push(control.value);
    }
    // this.currentDisplayedEnvIndexRAO = env_vars.indexOf(selectedEnv);
    this.restapiRows().at(index).patchValue({
      selected_environment: selectedEnv,
    })
    let ops_environment_variables = this.bridgeRAOEnvironments(index)?.controls;//this.environmentForm.value.bridge_endpoint_environments_raw;
    // let selectedEnvironment = this.currentDisplayedEnvIndexRAO;
    if (env_vars.length > 0) {
      for (let i = 0; i < env_vars.length; i++) {
        if (selectedEnv == env_vars[i].env_name) {
          if (env_vars[i].env_vars != undefined && env_vars[i].env_vars.length > 0) {
            for (let x = 0; x < env_vars[i].env_vars.length; x++) {
              this.ops_environment.push("{{" + env_vars[i].env_vars[x].variable + "}}")
            }
          }
        }
      }
    }else{
      this.ops_environment = [];
    }
  }
  copyDescMessage(input, id, ops) {
    let input1 = 'copy_' + id + '_' + input;
    const innerHtmlContent = document.getElementById(input1).innerHTML;
    // const index = this.datatypesRows().controls.findIndex((item) => item.value.id === id);
    (<UntypedFormGroup>ops.at(id)).controls[input].setValue(innerHtmlContent);
    this.clipboard.copy(innerHtmlContent);
  }
  copySourceDescMessage(input,groupName,index?) {
    if(index!=undefined){
      groupName.controls[index].controls['query'].setValue(input)
    }else{
    groupName.controls['query'].setValue(input);
    this.clipboard.copy(input);
    }
  }
  copyInputMessage(input, i) {
    let input1 = 'copy1_' + i + "_" + input;
    // const innerHtmlContent = document.getElementById(input1).innerHTML;
    const innerHtmlContent = (document.getElementById(input1)) as HTMLInputElement;
    if (innerHtmlContent.value != undefined) {
      this.clipboard.copy(innerHtmlContent.value);
    } else {
      if (input == 'append') {
        const text = this._appendScriptEditor.codeMirror.getValue();
        // Copy the text to the clipboard
        navigator.clipboard.writeText(text);
      } else {
        this.clipboard.copy(innerHtmlContent.innerText);
      }
    }
    this._snackBar.open("Copied!", '', { duration: 2000 });
  }
  ngOnDestroy() {
    this.cancelLoading();
    if (this.bridge_source_type == 4) {
      if ((!this.wsconnect && this.wsconnectSpinner) || (this.wsconnect && !this.wsconnectSpinner)) {
        this.wsconnect = false;
        this.wsresponse = [];
        this.webSocketService.initializeWebSocket("close");
      }
    }
    if (this.alertController) {
      this.alertController.dismiss()
    }
    // openSchedular close
    if(this.modalCtrl){
      this.modalCtrl.dismiss();
    }    
    this.helperService.getFromPageReset(false);
    this.helperService.shareConsoleData([]);
    this.bottomSheet.dismiss(PostmanConsoleComponent);
    if (this?.parentNavigationHelpSubscription) {
      this.parentNavigationHelpSubscription.unsubscribe();
    }
    if (this?.sourcePostmanPreviewSubscription) {
      this.sourcePostmanPreviewSubscription.unsubscribe();
    }
    if (this?.targetPostmanPreviewSubscription) {
      this.targetPostmanPreviewSubscription.unsubscribe();
    }
  }

  onDropdownOpened(isOpen: boolean, dropdown: MatSelect | MatAutocompleteTrigger): void {
    this.helperService.removeDropdownListeners();
    const ionContentEl = this.ionContent?.el;
    if(isOpen && ionContentEl) {
      if (dropdown instanceof MatSelect) {
        this.helperService.addDropdownListeners(
          ionContentEl,
          () => this.onContentScroll(dropdown),
          () => this.onContentClick(dropdown)
        );
      } 
      else if (dropdown instanceof MatAutocompleteTrigger) {
        this.helperService.addDropdownListeners(
          ionContentEl,
          () => this.onContentScroll(dropdown)
        );
      }
    }
    this.helperService.handleDropdownOpen(isOpen);
    this.closeshownext();
    
  }

  onContentScroll(dropdown: MatSelect | MatAutocompleteTrigger): void {
    this.helperService.handleDropdownCloseOnScroll(dropdown);
  }

  onContentClick(dropdown: MatSelect | MatAutocompleteTrigger): void {
    this.helperService.handleDropdownCloseOnClick(dropdown);
  }


  //contentEditable

  onHeaderKeyInput(event: any, index: number) {
    const input = (event.target as HTMLDivElement).innerText.trim();
    if(event.target.innerHTML.includes('<br>')){
      event.target.innerHTML=event.target.innerHTML.replace('<br>','')}
    this.filteredHeaderKey[index] = this.filterOptions(input, 'key');
  }
  onHeaderValueInput(event: any, index: number) {
    const input = (event.target as HTMLDivElement).innerText.trim();
    if(event.target.innerHTML.includes('<br>')){
      event.target.innerHTML=event.target.innerHTML.replace('<br>','')}
    this.filteredHeaderValue[index] = this.filterOptions(input, 'value');
  }

  onDataTargetHeaderKeyInput(event: any, index: number) {
    const input = (event.target as HTMLDivElement).innerText.trim();
    if(event.target.innerHTML.includes('<br>')){
      event.target.innerHTML=event.target.innerHTML.replace('<br>','')}
    this.filteredDataTargetHeaderKey[index] = this.filterOptions(input, 'target_key');
  }
  onDataTargetHeaderValueInput(event: any, index: number) {
    const input = (event.target as HTMLDivElement).innerText.trim();
    if(event.target.innerHTML.includes('<br>')){
      event.target.innerHTML=event.target.innerHTML.replace('<br>','')}
    this.filteredDataTargetHeaderValue[index] = this.filterOptions(input, 'target_value');
  }

  onHeaderKeyFocus(index: number) {
    const input = this.contentEditableHeaderKeys.toArray()[index].nativeElement.innerText.trim();
    this.filteredHeaderKey[index] = this.filterOptions(input, 'key');
  }
  onHeaderValueFocus(index: number) {
    const input = this.contentEditableHeaderValues.toArray()[index].nativeElement.innerText.trim();
    this.filteredHeaderValue[index] = this.filterOptions(input, 'value');
  }

  onDataTargetHeaderKeyFocus(index: number) {
    const input = this.contentEditableDataTargetHeaderKeys.toArray()[index].nativeElement.innerText.trim();
    this.filteredDataTargetHeaderKey[index] = this.filterOptions(input, 'target_key');
  }
  onDataTargetHeaderValueFocus(index: number) {
    const input = this.contentEditableDataTargetHeaderValues.toArray()[index].nativeElement.innerText.trim();
    this.filteredDataTargetHeaderValue[index] = this.filterOptions(input, 'target_value');
  }
  filterOptions(data: string, type: 'key' | 'value' | 'target_key' | 'target_value' ): any[] {
    const filterValue = data.toLowerCase();
    if (type === 'key') {
      return this.sourceHeaderKeyList.filter(key => key.header_key.toLowerCase().includes(filterValue));
    } else if(type === 'value') {
      return this.sourceHeaderValueList.filter(value => value.header_value.toLowerCase().includes(filterValue));
    }else if (type === 'target_key') {
      return this.targetHeaderKeyList.filter(key => key.header_key.toLowerCase().includes(filterValue));
    } else if(type === 'target_value') {
      return this.targetHeaderValueList.filter(value => value.header_value.toLowerCase().includes(filterValue));
    }
  }

  hideHeaderKeyAutocomplete(index: number) {
    setTimeout(() => {
      this.filteredHeaderKey[index] = [];
    }, 100);
  }
  hideHeaderValueAutocomplete(index: number) {
    setTimeout(() => {
      this.filteredHeaderValue[index] = [];
    }, 100);
  }

  hideDataTargetHeaderKeyAutocomplete(index: number) {
    setTimeout(() => {
      this.filteredDataTargetHeaderKey[index] = [];
    }, 100);
  }
  hideDataTargetHeaderValueAutocomplete(index: number) {
    setTimeout(() => {
      this.filteredDataTargetHeaderValue[index] = [];
    }, 100);
  }

  onHeaderKeyOptionSelected(key: string, index: number) {
    this.contentEditableHeaderKeys.toArray()[index].nativeElement.innerText = key;
    this.headers_key[index] = key;
    this.filteredHeaderKey[index] = [];
  }
  onHeaderValueOptionSelected(value: string, index: number) {
    this.contentEditableHeaderValues.toArray()[index].nativeElement.innerText = value;
    this.headers_value[index] = value;
    this.filteredHeaderValue[index] = [];
  }
  onDataTargetHeaderKeyOptionSelected(key: string, index: number) {
    this.contentEditableDataTargetHeaderKeys.toArray()[index].nativeElement.innerText = key;
    this.headers_target_key[index] = key;
    this.filteredDataTargetHeaderKey[index] = [];
  }
  onDataTargetHeaderValueOptionSelected(value: string, index: number) {
    this.contentEditableDataTargetHeaderValues.toArray()[index].nativeElement.innerText = value;
    this.headers_target_value[index] = value;
    this.filteredDataTargetHeaderValue[index] = [];
  }
  onChildUiUpdate(i){
    // console.log(i, this.opsData);
    // this.updateIntBridgeOperationData = this.opsData;
  }
  addChild() {
    const componentFactory = this.cfr.resolveComponentFactory(PostmanuiComponent);
    const componentRef = this.viewContainerRef.createComponent(componentFactory);
    // Keep track of dynamic components
    this.dynamicChildren.push(componentRef);
    // this.postmanuiComponents.push(componentRef.instance);
    // console.log('Dynamic Children:', this.dynamicChildren);
  }
  updateChildProperty() {
    if (this.dynamicChildren.length > 0) {
      const childInstance = this.dynamicChildren[this.dynamicChildren.length - 1].instance;
      // Update the child component's property
      childInstance.updateProperty('Updated Dynamically');
      // console.log('Child property updated:', childInstance.childProperty);
    }
  }

  callChildMethod(id?) {
    if (this.dynamicChildren.length > 0) {
      const childInstance = this.dynamicChildren[this.dynamicChildren.length - 1].instance;
      // Call the child component's method
      childInstance.childMethod(id);
    }
  }
  aiOpsTabChange(evt){
    console.log(evt);
  }
  checkTokenSessionBeforeTestAIOpsRAO(i){
    this.type = 'data_operation';
    this.getStorage().then((storage_data) => {
      this.pythonTokenForDataOperation = storage_data.pytokenDataOperation;
      if (storage_data.pytokenDataOperation == null) {
        this.generateToken('data_operation', 'ai_ops').then(async (res: string) => {
          this.pythonTokenForDataOperation = res;
           await this.generateContent(i);
        })
      } else {
        this.checkToken().then(async (res: Boolean) => {
          if (res) {
            await this.generateContent(i);
          } else {
            this.generateToken('data_operation', 'ai_ops').then(async (res: string) => {
              this.pythonTokenForDataOperation = res;
              await this.generateContent(i);
            })
          }
        })
      }
    })
  }
  checkTokenSessionBeforeTestAIOpsTemplatesRAO(i){
    this.type = 'data_operation';
    this.getStorage().then((storage_data) => {
      this.pythonTokenForDataOperation = storage_data.pytokenDataOperation;
      if (storage_data.pytokenDataOperation == null) {
        this.generateToken('data_operation', 'ai_ops').then(async (res: string) => {
          this.pythonTokenForDataOperation = res;
           await this.generateContent(i);
        })
      } else {
        this.checkToken().then(async (res: Boolean) => {
          if (res) {
            await this.generateContent(i);
          } else {
            this.generateToken('data_operation', 'ai_ops').then(async (res: string) => {
              this.pythonTokenForDataOperation = res;
              await this.generateContent(i);
            })
          }
        })
      }
    })
  }
  // adjustTextarea(e): void{
  //   const lineCount=this.countLines(e);
  //   const textarea = document.querySelector('textarea');
  //   if(textarea){
  //     textarea.rows = lineCount
  //   }
  // }
  // countLines(str: string): number {
  //   return str.split(/\r\n|\r|\n/).length;
  // }
}